var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "CIUDAD DE MÉXICO": {
    "ÁLVARO OBREGÓN": {
      "01000": true,
      "01010": true,
      "01020": true,
      "01030": true,
      "01040": true,
      "01049": true,
      "01050": true,
      "01060": true,
      "01070": true,
      "01080": true,
      "01089": true,
      "01090": true,
      "01100": true,
      "01109": true,
      "01110": true,
      "01120": true,
      "01125": true,
      "01130": true,
      "01139": true,
      "01140": true,
      "01150": true,
      "01160": true,
      "01170": true,
      "01180": true,
      "01200": true,
      "01210": true,
      "01219": true,
      "01220": true,
      "01230": true,
      "01239": true,
      "01240": true,
      "01250": true,
      "01259": true,
      "01260": true,
      "01269": true,
      "01270": true,
      "01275": true,
      "01276": true,
      "01278": true,
      "01279": true,
      "01280": true,
      "01285": true,
      "01289": true,
      "01290": true,
      "01296": true,
      "01298": true,
      "01299": true,
      "01310": true,
      "01320": true,
      "01330": true,
      "01340": true,
      "01376": true,
      "01377": true,
      "01389": true,
      "01400": true,
      "01407": true,
      "01408": true,
      "01410": true,
      "01419": true,
      "01420": true,
      "01430": true,
      "01450": true,
      "01460": true,
      "01470": true,
      "01480": true,
      "01490": true,
      "01500": true,
      "01509": true,
      "01510": true,
      "01520": true,
      "01530": true,
      "01538": true,
      "01539": true,
      "01540": true,
      "01548": true,
      "01549": true,
      "01550": true,
      "01560": true,
      "01566": true,
      "01569": true,
      "01588": true,
      "01590": true,
      "01600": true,
      "01610": true,
      "01618": true,
      "01619": true,
      "01620": true,
      "01630": true,
      "01640": true,
      "01645": true,
      "01650": true,
      "01700": true,
      "01708": true,
      "01710": true,
      "01720": true,
      "01729": true,
      "01730": true,
      "01740": true,
      "01750": true,
      "01759": true,
      "01760": true,
      "01770": true,
      "01780": true,
      "01789": true,
      "01790": true,
      "01800": true,
      "01807": true,
      "01810": true,
      "01820": true,
      "01830": true,
      "01840": true,
      "01849": true,
      "01857": true,
      "01859": true,
      "01860": true,
      "01863": true,
      "01870": true,
      "01900": true,
      "01904": true
    },
    "AZCAPOTZALCO": {
      "02000": true,
      "02010": true,
      "02020": true,
      "02040": true,
      "02050": true,
      "02060": true,
      "02070": true,
      "02080": true,
      "02090": true,
      "02099": true,
      "02100": true,
      "02120": true,
      "02128": true,
      "02129": true,
      "02130": true,
      "02140": true,
      "02150": true,
      "02160": true,
      "02200": true,
      "02230": true,
      "02240": true,
      "02250": true,
      "02300": true,
      "02310": true,
      "02320": true,
      "02330": true,
      "02340": true,
      "02360": true,
      "02400": true,
      "02410": true,
      "02420": true,
      "02440": true,
      "02459": true,
      "02460": true,
      "02470": true,
      "02480": true,
      "02490": true,
      "02500": true,
      "02519": true,
      "02520": true,
      "02530": true,
      "02600": true,
      "02630": true,
      "02640": true,
      "02650": true,
      "02660": true,
      "02670": true,
      "02680": true,
      "02700": true,
      "02710": true,
      "02719": true,
      "02720": true,
      "02730": true,
      "02750": true,
      "02760": true,
      "02770": true,
      "02780": true,
      "02790": true,
      "02800": true,
      "02810": true,
      "02830": true,
      "02840": true,
      "02860": true,
      "02870": true,
      "02900": true,
      "02910": true,
      "02920": true,
      "02930": true,
      "02940": true,
      "02950": true,
      "02960": true,
      "02970": true,
      "02980": true,
      "02990": true
    },
    "BENITO JUÁREZ": {
      "03000": true,
      "03010": true,
      "03020": true,
      "03023": true,
      "03100": true,
      "03103": true,
      "03104": true,
      "03200": true,
      "03230": true,
      "03240": true,
      "03300": true,
      "03303": true,
      "03310": true,
      "03320": true,
      "03330": true,
      "03340": true,
      "03400": true,
      "03410": true,
      "03420": true,
      "03430": true,
      "03440": true,
      "03500": true,
      "03510": true,
      "03520": true,
      "03530": true,
      "03540": true,
      "03550": true,
      "03560": true,
      "03570": true,
      "03580": true,
      "03590": true,
      "03600": true,
      "03610": true,
      "03620": true,
      "03630": true,
      "03640": true,
      "03650": true,
      "03660": true,
      "03700": true,
      "03710": true,
      "03720": true,
      "03730": true,
      "03740": true,
      "03800": true,
      "03810": true,
      "03820": true,
      "03840": true,
      "03900": true,
      "03910": true,
      "03920": true,
      "03930": true,
      "03940": true,
      "04120": true,
      "04260": true,
      "04320": true,
      "04330": true,
      "04360": true,
      "04370": true,
      "04380": true,
      "04390": true,
      "04440": true
    },
    "COYOACÁN": {
      "04000": true,
      "04010": true,
      "04020": true,
      "04030": true,
      "04040": true,
      "04100": true,
      "04120": true,
      "04200": true,
      "04210": true,
      "04230": true,
      "04240": true,
      "04250": true,
      "04260": true,
      "04300": true,
      "04310": true,
      "04318": true,
      "04320": true,
      "04330": true,
      "04340": true,
      "04360": true,
      "04369": true,
      "04370": true,
      "04380": true,
      "04390": true,
      "04400": true,
      "04410": true,
      "04420": true,
      "04440": true,
      "04450": true,
      "04460": true,
      "04470": true,
      "04480": true,
      "04489": true,
      "04490": true,
      "04500": true,
      "04510": true,
      "04519": true,
      "04530": true,
      "04600": true,
      "04610": true,
      "04620": true,
      "04630": true,
      "04640": true,
      "04650": true,
      "04660": true,
      "04700": true,
      "04710": true,
      "04730": true,
      "04739": true,
      "04800": true,
      "04810": true,
      "04815": true,
      "04830": true,
      "04840": true,
      "04870": true,
      "04890": true,
      "04899": true,
      "04909": true,
      "04910": true,
      "04918": true,
      "04919": true,
      "04920": true,
      "04929": true,
      "04930": true,
      "04938": true,
      "04939": true,
      "04940": true,
      "04950": true,
      "04960": true,
      "04970": true,
      "04980": true
    },
    "CUAJIMALPA DE MORELOS": {
      "05000": true,
      "05010": true,
      "05020": true,
      "05030": true,
      "05050": true,
      "05100": true,
      "05110": true,
      "05118": true,
      "05119": true,
      "05120": true,
      "05129": true,
      "05200": true,
      "05219": true,
      "05220": true,
      "05230": true,
      "05240": true,
      "05260": true,
      "05269": true,
      "05270": true,
      "05280": true,
      "05310": true,
      "05320": true,
      "05330": true,
      "05348": true,
      "05360": true,
      "05370": true,
      "05379": true,
      "05400": true,
      "05410": true,
      "05500": true,
      "05520": true,
      "05530": true,
      "05600": true,
      "05610": true,
      "05700": true,
      "05710": true,
      "05730": true,
      "05750": true,
      "05760": true,
      "05780": true
    },
    "CUAUHTÉMOC": {
      "06000": true,
      "06010": true,
      "06020": true,
      "06030": true,
      "06040": true,
      "06050": true,
      "06060": true,
      "06070": true,
      "06080": true,
      "06090": true,
      "06100": true,
      "06140": true,
      "06170": true,
      "06200": true,
      "06220": true,
      "06240": true,
      "06250": true,
      "06270": true,
      "06280": true,
      "06300": true,
      "06350": true,
      "06400": true,
      "06430": true,
      "06450": true,
      "06470": true,
      "06500": true,
      "06600": true,
      "06700": true,
      "06720": true,
      "06760": true,
      "06780": true,
      "06800": true,
      "06820": true,
      "06840": true,
      "06850": true,
      "06860": true,
      "06870": true,
      "06880": true,
      "06890": true,
      "06900": true,
      "06920": true
    },
    "GUSTAVO A. MADERO": {
      "07000": true,
      "07010": true,
      "07020": true,
      "07040": true,
      "07050": true,
      "07058": true,
      "07060": true,
      "07069": true,
      "07070": true,
      "07080": true,
      "07089": true,
      "07090": true,
      "07100": true,
      "07109": true,
      "07110": true,
      "07119": true,
      "07130": true,
      "07140": true,
      "07144": true,
      "07149": true,
      "07150": true,
      "07160": true,
      "07164": true,
      "07170": true,
      "07180": true,
      "07183": true,
      "07187": true,
      "07188": true,
      "07189": true,
      "07190": true,
      "07199": true,
      "07200": true,
      "07207": true,
      "07209": true,
      "07210": true,
      "07214": true,
      "07220": true,
      "07224": true,
      "07230": true,
      "07239": true,
      "07240": true,
      "07250": true,
      "07259": true,
      "07268": true,
      "07270": true,
      "07279": true,
      "07280": true,
      "07290": true,
      "07300": true,
      "07310": true,
      "07320": true,
      "07330": true,
      "07340": true,
      "07350": true,
      "07359": true,
      "07360": true,
      "07369": true,
      "07370": true,
      "07380": true,
      "07400": true,
      "07410": true,
      "07420": true,
      "07430": true,
      "07440": true,
      "07450": true,
      "07455": true,
      "07456": true,
      "07460": true,
      "07469": true,
      "07470": true,
      "07480": true,
      "07500": true,
      "07509": true,
      "07510": true,
      "07520": true,
      "07530": true,
      "07540": true,
      "07550": true,
      "07560": true,
      "07570": true,
      "07580": true,
      "07600": true,
      "07620": true,
      "07630": true,
      "07640": true,
      "07650": true,
      "07670": true,
      "07680": true,
      "07700": true,
      "07707": true,
      "07708": true,
      "07720": true,
      "07730": true,
      "07739": true,
      "07740": true,
      "07750": true,
      "07754": true,
      "07755": true,
      "07760": true,
      "07770": true,
      "07780": true,
      "07790": true,
      "07800": true,
      "07810": true,
      "07820": true,
      "07830": true,
      "07838": true,
      "07839": true,
      "07840": true,
      "07850": true,
      "07858": true,
      "07859": true,
      "07860": true,
      "07869": true,
      "07870": true,
      "07880": true,
      "07889": true,
      "07890": true,
      "07899": true,
      "07900": true,
      "07910": true,
      "07918": true,
      "07919": true,
      "07920": true,
      "07930": true,
      "07939": true,
      "07940": true,
      "07950": true,
      "07960": true,
      "07969": true,
      "07970": true,
      "07979": true,
      "07980": true,
      "07990": true
    },
    "IZTACALCO": {
      "08000": true,
      "08010": true,
      "08020": true,
      "08030": true,
      "08040": true,
      "08100": true,
      "08200": true,
      "08210": true,
      "08220": true,
      "08230": true,
      "08240": true,
      "08300": true,
      "08310": true,
      "08320": true,
      "08400": true,
      "08420": true,
      "08500": true,
      "08510": true,
      "08600": true,
      "08610": true,
      "08620": true,
      "08650": true,
      "08700": true,
      "08710": true,
      "08720": true,
      "08730": true,
      "08760": true,
      "08770": true,
      "08800": true,
      "08810": true,
      "08830": true,
      "08840": true,
      "08900": true,
      "08910": true,
      "08920": true,
      "08930": true
    },
    "IZTAPALAPA": {
      "09000": true,
      "09010": true,
      "09020": true,
      "09030": true,
      "09040": true,
      "09060": true,
      "09070": true,
      "09080": true,
      "09089": true,
      "09090": true,
      "09099": true,
      "09100": true,
      "09130": true,
      "09140": true,
      "09180": true,
      "09200": true,
      "09208": true,
      "09209": true,
      "09210": true,
      "09220": true,
      "09230": true,
      "09239": true,
      "09240": true,
      "09250": true,
      "09260": true,
      "09270": true,
      "09280": true,
      "09290": true,
      "09300": true,
      "09310": true,
      "09319": true,
      "09320": true,
      "09350": true,
      "09359": true,
      "09360": true,
      "09400": true,
      "09410": true,
      "09420": true,
      "09429": true,
      "09430": true,
      "09438": true,
      "09440": true,
      "09450": true,
      "09460": true,
      "09470": true,
      "09479": true,
      "09480": true,
      "09500": true,
      "09510": true,
      "09520": true,
      "09530": true,
      "09550": true,
      "09560": true,
      "09570": true,
      "09578": true,
      "09600": true,
      "09608": true,
      "09609": true,
      "09620": true,
      "09630": true,
      "09637": true,
      "09638": true,
      "09640": true,
      "09648": true,
      "09660": true,
      "09670": true,
      "09680": true,
      "09689": true,
      "09690": true,
      "09696": true,
      "09698": true,
      "09700": true,
      "09704": true,
      "09705": true,
      "09706": true,
      "09708": true,
      "09709": true,
      "09710": true,
      "09720": true,
      "09730": true,
      "09740": true,
      "09750": true,
      "09760": true,
      "09769": true,
      "09770": true,
      "09780": true,
      "09790": true,
      "09800": true,
      "09810": true,
      "09819": true,
      "09820": true,
      "09828": true,
      "09829": true,
      "09830": true,
      "09837": true,
      "09838": true,
      "09839": true,
      "09840": true,
      "09849": true,
      "09850": true,
      "09856": true,
      "09858": true,
      "09859": true,
      "09860": true,
      "09868": true,
      "09870": true,
      "09880": true,
      "09890": true,
      "09897": true,
      "09900": true,
      "09910": true,
      "09920": true,
      "09930": true,
      "09940": true,
      "09960": true,
      "09969": true,
      "09970": true
    },
    "MIGUEL HIDALGO": {
      "11000": true,
      "11040": true,
      "11100": true,
      "11200": true,
      "11210": true,
      "11220": true,
      "11230": true,
      "11240": true,
      "11250": true,
      "11260": true,
      "11270": true,
      "11280": true,
      "11289": true,
      "11290": true,
      "11300": true,
      "11310": true,
      "11320": true,
      "11330": true,
      "11340": true,
      "11350": true,
      "11360": true,
      "11370": true,
      "11400": true,
      "11410": true,
      "11420": true,
      "11430": true,
      "11440": true,
      "11450": true,
      "11460": true,
      "11470": true,
      "11480": true,
      "11489": true,
      "11490": true,
      "11500": true,
      "11510": true,
      "11520": true,
      "11529": true,
      "11530": true,
      "11540": true,
      "11550": true,
      "11560": true,
      "11570": true,
      "11580": true,
      "11590": true,
      "11600": true,
      "11610": true,
      "11619": true,
      "11650": true,
      "11700": true,
      "11800": true,
      "11810": true,
      "11820": true,
      "11830": true,
      "11840": true,
      "11850": true,
      "11860": true,
      "11870": true,
      "11910": true,
      "11920": true,
      "11930": true,
      "11950": true
    },
    "MILPA ALTA": {
      "12070": true,
      "12080": true,
      "12100": true,
      "12110": true,
      "12200": true,
      "12300": true,
      "12400": true,
      "12410": true,
      "12500": true,
      "12600": true,
      "12700": true,
      "12800": true,
      "12910": true,
      "12920": true,
      "12930": true,
      "12940": true,
      "12950": true
    },
    "TLÁHUAC": {
      "13000": true,
      "13010": true,
      "13020": true,
      "13030": true,
      "13040": true,
      "13050": true,
      "13060": true,
      "13070": true,
      "13080": true,
      "13090": true,
      "13093": true,
      "13094": true,
      "13099": true,
      "13100": true,
      "13120": true,
      "13150": true,
      "13180": true,
      "13200": true,
      "13210": true,
      "13219": true,
      "13220": true,
      "13230": true,
      "13250": true,
      "13270": true,
      "13273": true,
      "13278": true,
      "13280": true,
      "13300": true,
      "13310": true,
      "13315": true,
      "13319": true,
      "13360": true,
      "13400": true,
      "13410": true,
      "13419": true,
      "13420": true,
      "13430": true,
      "13440": true,
      "13450": true,
      "13460": true,
      "13508": true,
      "13509": true,
      "13510": true,
      "13520": true,
      "13530": true,
      "13540": true,
      "13545": true,
      "13549": true,
      "13550": true,
      "13600": true,
      "13610": true,
      "13625": true,
      "13630": true,
      "13640": true,
      "13700": true
    },
    "TLALPAN": {
      "14000": true,
      "14010": true,
      "14020": true,
      "14030": true,
      "14039": true,
      "14040": true,
      "14049": true,
      "14050": true,
      "14060": true,
      "14070": true,
      "14080": true,
      "14090": true,
      "14100": true,
      "14108": true,
      "14110": true,
      "14120": true,
      "14140": true,
      "14150": true,
      "14160": true,
      "14200": true,
      "14208": true,
      "14209": true,
      "14210": true,
      "14219": true,
      "14220": true,
      "14230": true,
      "14239": true,
      "14240": true,
      "14248": true,
      "14250": true,
      "14260": true,
      "14266": true,
      "14267": true,
      "14268": true,
      "14269": true,
      "14270": true,
      "14275": true,
      "14300": true,
      "14308": true,
      "14310": true,
      "14320": true,
      "14325": true,
      "14326": true,
      "14330": true,
      "14340": true,
      "14350": true,
      "14357": true,
      "14360": true,
      "14370": true,
      "14376": true,
      "14377": true,
      "14380": true,
      "14386": true,
      "14387": true,
      "14388": true,
      "14389": true,
      "14390": true,
      "14400": true,
      "14406": true,
      "14408": true,
      "14409": true,
      "14410": true,
      "14420": true,
      "14426": true,
      "14427": true,
      "14429": true,
      "14430": true,
      "14438": true,
      "14439": true,
      "14440": true,
      "14449": true,
      "14456": true,
      "14460": true,
      "14470": true,
      "14476": true,
      "14479": true,
      "14480": true,
      "14490": true,
      "14500": true,
      "14600": true,
      "14608": true,
      "14609": true,
      "14610": true,
      "14620": true,
      "14629": true,
      "14630": true,
      "14640": true,
      "14643": true,
      "14646": true,
      "14647": true,
      "14650": true,
      "14653": true,
      "14654": true,
      "14655": true,
      "14657": true,
      "14658": true,
      "14659": true,
      "14700": true,
      "14710": true,
      "14720": true,
      "14730": true,
      "14734": true,
      "14735": true,
      "14737": true,
      "14738": true,
      "14739": true,
      "14740": true,
      "14748": true,
      "14749": true,
      "14760": true,
      "14900": true
    },
    "VENUSTIANO CARRANZA": {
      "15000": true,
      "15010": true,
      "15020": true,
      "15100": true,
      "15200": true,
      "15210": true,
      "15220": true,
      "15230": true,
      "15240": true,
      "15250": true,
      "15260": true,
      "15270": true,
      "15280": true,
      "15290": true,
      "15300": true,
      "15309": true,
      "15310": true,
      "15320": true,
      "15330": true,
      "15339": true,
      "15340": true,
      "15350": true,
      "15370": true,
      "15380": true,
      "15390": true,
      "15400": true,
      "15410": true,
      "15420": true,
      "15430": true,
      "15440": true,
      "15450": true,
      "15460": true,
      "15470": true,
      "15500": true,
      "15510": true,
      "15520": true,
      "15530": true,
      "15540": true,
      "15600": true,
      "15610": true,
      "15620": true,
      "15630": true,
      "15640": true,
      "15650": true,
      "15660": true,
      "15670": true,
      "15680": true,
      "15700": true,
      "15710": true,
      "15730": true,
      "15740": true,
      "15750": true,
      "15800": true,
      "15810": true,
      "15820": true,
      "15830": true,
      "15840": true,
      "15850": true,
      "15860": true,
      "15870": true,
      "15900": true,
      "15960": true,
      "15970": true,
      "15980": true,
      "15990": true
    },
    "XOCHIMILCO": {
      "16000": true,
      "16010": true,
      "16020": true,
      "16029": true,
      "16030": true,
      "16034": true,
      "16035": true,
      "16036": true,
      "16038": true,
      "16040": true,
      "16050": true,
      "16059": true,
      "16060": true,
      "16070": true,
      "16080": true,
      "16083": true,
      "16090": true,
      "16100": true,
      "16200": true,
      "16210": true,
      "16240": true,
      "16300": true,
      "16310": true,
      "16320": true,
      "16340": true,
      "16400": true,
      "16410": true,
      "16420": true,
      "16428": true,
      "16429": true,
      "16430": true,
      "16440": true,
      "16443": true,
      "16450": true,
      "16457": true,
      "16459": true,
      "16500": true,
      "16513": true,
      "16514": true,
      "16520": true,
      "16530": true,
      "16533": true,
      "16550": true,
      "16600": true,
      "16604": true,
      "16605": true,
      "16606": true,
      "16607": true,
      "16609": true,
      "16610": true,
      "16614": true,
      "16615": true,
      "16616": true,
      "16617": true,
      "16620": true,
      "16629": true,
      "16630": true,
      "16640": true,
      "16710": true,
      "16720": true,
      "16739": true,
      "16740": true,
      "16749": true,
      "16750": true,
      "16770": true,
      "16776": true,
      "16780": true,
      "16797": true,
      "16799": true,
      "16800": true,
      "16810": true,
      "16813": true,
      "16840": true,
      "16850": true,
      "16860": true,
      "16880": true,
      "16900": true
    }
  },
  "AGUASCALIENTES": {
    "AGUASCALIENTES": {
      "20000": true,
      "20001": true,
      "20002": true,
      "20003": true,
      "20004": true,
      "20005": true,
      "20006": true,
      "20007": true,
      "20008": true,
      "20009": true,
      "20010": true,
      "20011": true,
      "20012": true,
      "20013": true,
      "20014": true,
      "20015": true,
      "20016": true,
      "20017": true,
      "20018": true,
      "20019": true,
      "20020": true,
      "20021": true,
      "20022": true,
      "20023": true,
      "20024": true,
      "20025": true,
      "20026": true,
      "20027": true,
      "20028": true,
      "20029": true,
      "20030": true,
      "20031": true,
      "20032": true,
      "20033": true,
      "20034": true,
      "20035": true,
      "20036": true,
      "20037": true,
      "20038": true,
      "20039": true,
      "20040": true,
      "20041": true,
      "20042": true,
      "20043": true,
      "20044": true,
      "20045": true,
      "20046": true,
      "20047": true,
      "20048": true,
      "20049": true,
      "20050": true,
      "20051": true,
      "20052": true,
      "20053": true,
      "20054": true,
      "20055": true,
      "20056": true,
      "20057": true,
      "20058": true,
      "20059": true,
      "20060": true,
      "20061": true,
      "20062": true,
      "20063": true,
      "20064": true,
      "20065": true,
      "20066": true,
      "20067": true,
      "20068": true,
      "20069": true,
      "20070": true,
      "20071": true,
      "20072": true,
      "20073": true,
      "20074": true,
      "20075": true,
      "20076": true,
      "20077": true,
      "20078": true,
      "20079": true,
      "20080": true,
      "20081": true,
      "20082": true,
      "20083": true,
      "20084": true,
      "20085": true,
      "20086": true,
      "20087": true,
      "20088": true,
      "20089": true,
      "20090": true,
      "20091": true,
      "20092": true,
      "20093": true,
      "20094": true,
      "20095": true,
      "20096": true,
      "20097": true,
      "20098": true,
      "20099": true,
      "20100": true,
      "20101": true,
      "20102": true,
      "20103": true,
      "20104": true,
      "20105": true,
      "20106": true,
      "20107": true,
      "20108": true,
      "20109": true,
      "20110": true,
      "20111": true,
      "20112": true,
      "20113": true,
      "20114": true,
      "20115": true,
      "20116": true,
      "20117": true,
      "20118": true,
      "20119": true,
      "20120": true,
      "20121": true,
      "20122": true,
      "20123": true,
      "20124": true,
      "20125": true,
      "20126": true,
      "20127": true,
      "20128": true,
      "20129": true,
      "20130": true,
      "20131": true,
      "20132": true,
      "20133": true,
      "20134": true,
      "20135": true,
      "20136": true,
      "20137": true,
      "20138": true,
      "20139": true,
      "20140": true,
      "20141": true,
      "20142": true,
      "20143": true,
      "20144": true,
      "20145": true,
      "20146": true,
      "20147": true,
      "20148": true,
      "20149": true,
      "20150": true,
      "20151": true,
      "20152": true,
      "20153": true,
      "20154": true,
      "20155": true,
      "20156": true,
      "20157": true,
      "20158": true,
      "20159": true,
      "20160": true,
      "20161": true,
      "20162": true,
      "20163": true,
      "20164": true,
      "20165": true,
      "20166": true,
      "20167": true,
      "20168": true,
      "20169": true,
      "20170": true,
      "20171": true,
      "20172": true,
      "20173": true,
      "20174": true,
      "20175": true,
      "20176": true,
      "20177": true,
      "20178": true,
      "20179": true,
      "20180": true,
      "20181": true,
      "20182": true,
      "20183": true,
      "20184": true,
      "20185": true,
      "20186": true,
      "20187": true,
      "20188": true,
      "20189": true,
      "20190": true,
      "20191": true,
      "20192": true,
      "20193": true,
      "20194": true,
      "20195": true,
      "20196": true,
      "20197": true,
      "20198": true,
      "20199": true,
      "20200": true,
      "20201": true,
      "20202": true,
      "20203": true,
      "20204": true,
      "20205": true,
      "20206": true,
      "20207": true,
      "20208": true,
      "20209": true,
      "20210": true,
      "20211": true,
      "20212": true,
      "20213": true,
      "20214": true,
      "20215": true,
      "20216": true,
      "20217": true,
      "20218": true,
      "20219": true,
      "20220": true,
      "20221": true,
      "20222": true,
      "20223": true,
      "20224": true,
      "20225": true,
      "20226": true,
      "20227": true,
      "20228": true,
      "20229": true,
      "20230": true,
      "20231": true,
      "20232": true,
      "20233": true,
      "20234": true,
      "20235": true,
      "20236": true,
      "20237": true,
      "20238": true,
      "20239": true,
      "20240": true,
      "20241": true,
      "20242": true,
      "20243": true,
      "20244": true,
      "20245": true,
      "20246": true,
      "20247": true,
      "20248": true,
      "20249": true,
      "20250": true,
      "20251": true,
      "20252": true,
      "20253": true,
      "20254": true,
      "20255": true,
      "20256": true,
      "20257": true,
      "20258": true,
      "20259": true,
      "20260": true,
      "20261": true,
      "20262": true,
      "20263": true,
      "20264": true,
      "20265": true,
      "20266": true,
      "20267": true,
      "20268": true,
      "20269": true,
      "20270": true,
      "20271": true,
      "20272": true,
      "20273": true,
      "20274": true,
      "20275": true,
      "20276": true,
      "20277": true,
      "20278": true,
      "20279": true,
      "20280": true,
      "20281": true,
      "20282": true,
      "20283": true,
      "20284": true,
      "20285": true,
      "20286": true,
      "20287": true,
      "20288": true,
      "20289": true,
      "20290": true,
      "20291": true,
      "20292": true,
      "20293": true,
      "20294": true,
      "20295": true,
      "20296": true,
      "20297": true,
      "20298": true,
      "20299": true,
      "20310": true,
      "20311": true,
      "20312": true,
      "20313": true,
      "20314": true,
      "20315": true,
      "20316": true,
      "20317": true,
      "20318": true,
      "20319": true,
      "20320": true,
      "20321": true,
      "20322": true,
      "20323": true,
      "20324": true,
      "20325": true,
      "20326": true,
      "20327": true,
      "20328": true,
      "20329": true,
      "20340": true,
      "20341": true,
      "20342": true,
      "20343": true,
      "20344": true,
      "20345": true,
      "20346": true,
      "20347": true,
      "20348": true,
      "20349": true,
      "20363": true,
      "20364": true,
      "20365": true,
      "20366": true,
      "20367": true,
      "20368": true,
      "20369": true,
      "20370": true,
      "20371": true,
      "20372": true,
      "20373": true,
      "20374": true,
      "20375": true,
      "20376": true,
      "20377": true,
      "20378": true,
      "20379": true,
      "20380": true,
      "20381": true,
      "20382": true,
      "20383": true,
      "20384": true,
      "20385": true,
      "20386": true,
      "20387": true,
      "20388": true,
      "20389": true,
      "20390": true,
      "20391": true,
      "20392": true,
      "20393": true,
      "20394": true,
      "20395": true,
      "20396": true,
      "20397": true,
      "20398": true,
      "20399": true
    },
    "SAN FRANCISCO DE LOS ROMO": {
      "20300": true,
      "20301": true,
      "20302": true,
      "20303": true,
      "20304": true,
      "20305": true,
      "20306": true,
      "20307": true,
      "20308": true,
      "20309": true,
      "20350": true,
      "20351": true,
      "20352": true,
      "20353": true,
      "20354": true,
      "20355": true,
      "20356": true,
      "20357": true,
      "20358": true,
      "20359": true,
      "20360": true,
      "20361": true,
      "20362": true
    },
    "EL LLANO": {
      "20330": true,
      "20331": true,
      "20332": true,
      "20333": true,
      "20334": true,
      "20335": true,
      "20336": true,
      "20338": true,
      "20339": true
    },
    "RINCON DE ROMOS": {
      "20400": true,
      "20401": true,
      "20402": true,
      "20403": true,
      "20404": true,
      "20405": true,
      "20406": true,
      "20407": true,
      "20408": true,
      "20409": true,
      "20410": true,
      "20411": true,
      "20412": true,
      "20413": true,
      "20414": true,
      "20415": true,
      "20416": true,
      "20417": true,
      "20418": true,
      "20419": true,
      "20420": true,
      "20421": true,
      "20422": true,
      "20423": true,
      "20424": true,
      "20425": true,
      "20426": true,
      "20427": true,
      "20428": true,
      "20429": true,
      "20430": true,
      "20431": true,
      "20432": true,
      "20433": true,
      "20434": true,
      "20435": true,
      "20436": true,
      "20437": true,
      "20438": true,
      "20439": true,
      "20440": true,
      "20441": true,
      "20442": true,
      "20443": true,
      "20444": true,
      "20445": true,
      "20446": true,
      "20447": true,
      "20448": true,
      "20449": true,
      "20450": true,
      "20451": true,
      "20452": true,
      "20453": true
    },
    "COSIO": {
      "20460": true,
      "20461": true,
      "20462": true,
      "20463": true,
      "20464": true,
      "20465": true,
      "20466": true,
      "20467": true,
      "20468": true,
      "20469": true,
      "20470": true,
      "20471": true,
      "20472": true,
      "20473": true,
      "20474": true,
      "20475": true,
      "20476": true,
      "20477": true,
      "20478": true,
      "20479": true,
      "20480": true,
      "20481": true,
      "20482": true,
      "20483": true,
      "20484": true,
      "20485": true,
      "20486": true,
      "20487": true,
      "20488": true,
      "20489": true,
      "20490": true,
      "20491": true,
      "20492": true,
      "20493": true,
      "20494": true,
      "20495": true,
      "20496": true,
      "20497": true,
      "20498": true,
      "20499": true
    },
    "SAN JOSE DE GRACIA": {
      "20500": true,
      "20501": true,
      "20502": true,
      "20503": true,
      "20504": true,
      "20505": true,
      "20506": true,
      "20507": true,
      "20508": true,
      "20509": true,
      "20510": true,
      "20511": true,
      "20512": true,
      "20513": true,
      "20514": true,
      "20515": true,
      "20516": true,
      "20517": true,
      "20518": true,
      "20519": true,
      "20540": true,
      "20541": true,
      "20542": true,
      "20543": true,
      "20544": true,
      "20545": true,
      "20546": true,
      "20547": true,
      "20548": true,
      "20549": true,
      "20550": true,
      "20551": true,
      "20552": true,
      "20553": true,
      "20554": true,
      "20555": true,
      "20556": true,
      "20557": true,
      "20558": true,
      "20559": true,
      "20560": true,
      "20561": true,
      "20562": true,
      "20563": true,
      "20564": true,
      "20565": true,
      "20566": true,
      "20567": true,
      "20568": true,
      "20569": true,
      "20576": true,
      "20577": true,
      "20578": true,
      "20579": true,
      "20580": true,
      "20581": true,
      "20582": true,
      "20583": true,
      "20584": true,
      "20585": true,
      "20586": true,
      "20587": true,
      "20588": true,
      "20589": true,
      "20590": true,
      "20591": true,
      "20592": true,
      "20593": true,
      "20594": true,
      "20595": true,
      "20596": true,
      "20597": true,
      "20598": true,
      "20599": true
    },
    "TEPEZALA": {
      "20600": true,
      "20601": true,
      "20602": true,
      "20603": true,
      "20604": true,
      "20605": true,
      "20606": true,
      "20607": true,
      "20608": true,
      "20609": true,
      "20610": true,
      "20611": true,
      "20612": true,
      "20613": true,
      "20614": true,
      "20615": true,
      "20616": true,
      "20617": true,
      "20618": true,
      "20619": true,
      "20620": true,
      "20621": true,
      "20622": true,
      "20623": true,
      "20624": true,
      "20625": true,
      "20626": true,
      "20627": true,
      "20628": true,
      "20629": true,
      "20630": true,
      "20631": true,
      "20632": true,
      "20633": true,
      "20634": true,
      "20635": true,
      "20636": true,
      "20637": true,
      "20638": true,
      "20639": true,
      "20640": true,
      "20641": true,
      "20642": true,
      "20643": true,
      "20644": true,
      "20645": true,
      "20646": true,
      "20647": true,
      "20648": true,
      "20649": true,
      "20650": true,
      "20651": true,
      "20652": true,
      "20653": true,
      "20654": true,
      "20655": true,
      "20656": true,
      "20657": true,
      "20658": true,
      "20659": true,
      "20660": true,
      "20661": true,
      "20662": true
    },
    "PABELLON DE ARTEAGA": {
      "20663": true,
      "20664": true,
      "20665": true,
      "20666": true,
      "20667": true,
      "20668": true,
      "20669": true,
      "20670": true,
      "20671": true,
      "20672": true,
      "20673": true,
      "20674": true,
      "20675": true,
      "20676": true,
      "20677": true,
      "20678": true,
      "20679": true,
      "20680": true,
      "20681": true,
      "20682": true,
      "20683": true,
      "20684": true,
      "20685": true,
      "20686": true,
      "20687": true,
      "20688": true,
      "20689": true,
      "20690": true,
      "20691": true,
      "20692": true,
      "20693": true,
      "20694": true,
      "20695": true,
      "20696": true,
      "20697": true,
      "20698": true,
      "20699": true
    },
    "ASIENTOS": {
      "20700": true,
      "20701": true,
      "20702": true,
      "20703": true,
      "20704": true,
      "20705": true,
      "20706": true,
      "20707": true,
      "20708": true,
      "20709": true,
      "20710": true,
      "20711": true,
      "20712": true,
      "20713": true,
      "20714": true,
      "20715": true,
      "20716": true,
      "20717": true,
      "20718": true,
      "20719": true,
      "20720": true,
      "20721": true,
      "20722": true,
      "20723": true,
      "20724": true,
      "20725": true,
      "20726": true,
      "20727": true,
      "20728": true,
      "20729": true,
      "20730": true,
      "20731": true,
      "20732": true,
      "20733": true,
      "20734": true,
      "20735": true,
      "20736": true,
      "20737": true,
      "20738": true,
      "20739": true,
      "20740": true,
      "20741": true,
      "20742": true,
      "20743": true,
      "20744": true,
      "20745": true,
      "20746": true,
      "20747": true,
      "20748": true,
      "20749": true,
      "20750": true,
      "20751": true,
      "20752": true,
      "20753": true,
      "20754": true,
      "20755": true,
      "20756": true,
      "20757": true,
      "20758": true,
      "20759": true,
      "20760": true,
      "20761": true,
      "20762": true,
      "20763": true,
      "20764": true,
      "20765": true,
      "20766": true,
      "20767": true,
      "20768": true,
      "20769": true,
      "20770": true,
      "20771": true,
      "20772": true,
      "20773": true,
      "20774": true,
      "20775": true,
      "20776": true,
      "20777": true,
      "20778": true,
      "20779": true,
      "20780": true,
      "20781": true,
      "20782": true,
      "20783": true,
      "20784": true,
      "20785": true,
      "20786": true,
      "20787": true,
      "20788": true,
      "20789": true,
      "20790": true,
      "20791": true,
      "20792": true,
      "20793": true,
      "20794": true,
      "20795": true,
      "20796": true,
      "20797": true,
      "20798": true,
      "20799": true
    },
    "CALVILLO": {
      "20800": true,
      "20801": true,
      "20802": true,
      "20803": true,
      "20804": true,
      "20805": true,
      "20806": true,
      "20807": true,
      "20808": true,
      "20809": true,
      "20816": true,
      "20817": true,
      "20818": true,
      "20819": true,
      "20820": true,
      "20821": true,
      "20822": true,
      "20823": true,
      "20824": true,
      "20825": true,
      "20826": true,
      "20827": true,
      "20828": true,
      "20829": true,
      "20830": true,
      "20831": true,
      "20832": true,
      "20833": true,
      "20834": true,
      "20835": true,
      "20836": true,
      "20837": true,
      "20838": true,
      "20839": true,
      "20840": true,
      "20841": true,
      "20842": true,
      "20843": true,
      "20844": true,
      "20845": true,
      "20846": true,
      "20847": true,
      "20848": true,
      "20849": true,
      "20850": true,
      "20851": true,
      "20852": true,
      "20853": true,
      "20854": true,
      "20856": true,
      "20857": true,
      "20858": true,
      "20859": true,
      "20860": true,
      "20861": true,
      "20862": true,
      "20863": true,
      "20864": true,
      "20865": true,
      "20866": true,
      "20867": true,
      "20868": true,
      "20869": true,
      "20870": true,
      "20871": true,
      "20872": true,
      "20873": true,
      "20880": true,
      "20881": true,
      "20882": true,
      "20883": true,
      "20884": true,
      "20885": true,
      "20886": true,
      "20887": true,
      "20888": true,
      "20889": true,
      "20890": true,
      "20891": true,
      "20892": true,
      "20893": true,
      "20894": true,
      "20895": true,
      "20896": true,
      "20897": true,
      "20898": true,
      "20899": true
    },
    "JESÚS MARÍA": {
      "20900": true,
      "20905": true,
      "20907": true,
      "20908": true,
      "20920": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20983": true,
      "20984": true
    },
    "JESUS MARIA": {
      "20900": true,
      "20901": true,
      "20902": true,
      "20903": true,
      "20904": true,
      "20905": true,
      "20906": true,
      "20907": true,
      "20908": true,
      "20909": true,
      "20910": true,
      "20911": true,
      "20912": true,
      "20913": true,
      "20914": true,
      "20915": true,
      "20916": true,
      "20917": true,
      "20918": true,
      "20919": true,
      "20920": true,
      "20921": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20928": true,
      "20929": true,
      "20930": true,
      "20931": true,
      "20932": true,
      "20933": true,
      "20934": true,
      "20935": true,
      "20936": true,
      "20937": true,
      "20938": true,
      "20939": true,
      "20940": true,
      "20941": true,
      "20942": true,
      "20947": true,
      "20948": true,
      "20949": true,
      "20950": true,
      "20951": true,
      "20952": true,
      "20953": true,
      "20954": true,
      "20955": true,
      "20956": true,
      "20957": true,
      "20958": true,
      "20959": true,
      "20960": true,
      "20961": true,
      "20962": true,
      "20963": true,
      "20964": true,
      "20965": true,
      "20966": true,
      "20967": true,
      "20968": true,
      "20969": true,
      "20970": true,
      "20971": true,
      "20972": true,
      "20973": true,
      "20974": true,
      "20975": true,
      "20976": true,
      "20977": true,
      "20978": true,
      "20979": true,
      "20980": true,
      "20981": true,
      "20982": true,
      "20983": true,
      "20984": true,
      "20985": true,
      "20986": true,
      "20987": true,
      "20988": true,
      "20989": true,
      "20990": true,
      "20991": true,
      "20992": true,
      "20993": true,
      "20994": true,
      "20995": true,
      "20996": true,
      "20997": true,
      "20998": true,
      "20999": true
    }
  },
  "CAMPECHE": {
    "CAMPECHE": {
      "24000": true,
      "24001": true,
      "24002": true,
      "24003": true,
      "24004": true,
      "24005": true,
      "24006": true,
      "24007": true,
      "24008": true,
      "24009": true,
      "24010": true,
      "24011": true,
      "24012": true,
      "24013": true,
      "24014": true,
      "24015": true,
      "24016": true,
      "24017": true,
      "24018": true,
      "24019": true,
      "24020": true,
      "24021": true,
      "24022": true,
      "24023": true,
      "24024": true,
      "24025": true,
      "24026": true,
      "24027": true,
      "24028": true,
      "24029": true,
      "24030": true,
      "24031": true,
      "24032": true,
      "24033": true,
      "24034": true,
      "24035": true,
      "24036": true,
      "24037": true,
      "24038": true,
      "24039": true,
      "24040": true,
      "24041": true,
      "24042": true,
      "24043": true,
      "24044": true,
      "24045": true,
      "24046": true,
      "24047": true,
      "24048": true,
      "24049": true,
      "24050": true,
      "24051": true,
      "24052": true,
      "24053": true,
      "24054": true,
      "24055": true,
      "24056": true,
      "24057": true,
      "24058": true,
      "24059": true,
      "24060": true,
      "24061": true,
      "24062": true,
      "24063": true,
      "24064": true,
      "24065": true,
      "24066": true,
      "24067": true,
      "24068": true,
      "24069": true,
      "24070": true,
      "24071": true,
      "24072": true,
      "24073": true,
      "24074": true,
      "24075": true,
      "24076": true,
      "24077": true,
      "24078": true,
      "24079": true,
      "24080": true,
      "24081": true,
      "24082": true,
      "24083": true,
      "24084": true,
      "24085": true,
      "24086": true,
      "24087": true,
      "24088": true,
      "24089": true,
      "24090": true,
      "24091": true,
      "24092": true,
      "24093": true,
      "24094": true,
      "24095": true,
      "24096": true,
      "24097": true,
      "24098": true,
      "24099": true,
      "24500": true,
      "24501": true,
      "24502": true,
      "24503": true,
      "24504": true,
      "24505": true,
      "24506": true,
      "24507": true,
      "24508": true,
      "24509": true,
      "24510": true,
      "24511": true,
      "24512": true,
      "24513": true,
      "24514": true,
      "24515": true,
      "24516": true,
      "24517": true,
      "24518": true,
      "24519": true,
      "24520": true,
      "24521": true,
      "24522": true,
      "24523": true,
      "24524": true,
      "24525": true,
      "24526": true,
      "24527": true,
      "24528": true,
      "24529": true,
      "24530": true,
      "24531": true,
      "24532": true,
      "24533": true,
      "24534": true,
      "24535": true,
      "24536": true,
      "24537": true,
      "24538": true,
      "24539": true,
      "24540": true,
      "24541": true,
      "24542": true,
      "24543": true,
      "24544": true,
      "24545": true,
      "24546": true,
      "24547": true,
      "24548": true,
      "24549": true,
      "24550": true,
      "24551": true,
      "24552": true,
      "24553": true,
      "24554": true,
      "24555": true,
      "24556": true,
      "24557": true,
      "24558": true,
      "24559": true,
      "24560": true,
      "24561": true,
      "24562": true,
      "24563": true,
      "24564": true,
      "24565": true,
      "24566": true,
      "24567": true,
      "24568": true,
      "24569": true,
      "24570": true,
      "24571": true,
      "24572": true,
      "24573": true,
      "24574": true,
      "24575": true,
      "24576": true,
      "24577": true,
      "24578": true,
      "24579": true,
      "24580": true,
      "24581": true,
      "24582": true,
      "24583": true,
      "24584": true,
      "24585": true,
      "24586": true,
      "24587": true,
      "24588": true,
      "24589": true,
      "24590": true,
      "24591": true,
      "24592": true,
      "24593": true,
      "24594": true,
      "24595": true,
      "24596": true,
      "24597": true,
      "24598": true,
      "24599": true
    },
    "CARMEN": {
      "24100": true,
      "24101": true,
      "24102": true,
      "24103": true,
      "24104": true,
      "24105": true,
      "24106": true,
      "24107": true,
      "24108": true,
      "24109": true,
      "24110": true,
      "24111": true,
      "24112": true,
      "24113": true,
      "24114": true,
      "24115": true,
      "24116": true,
      "24117": true,
      "24118": true,
      "24119": true,
      "24120": true,
      "24121": true,
      "24122": true,
      "24123": true,
      "24124": true,
      "24125": true,
      "24126": true,
      "24127": true,
      "24128": true,
      "24129": true,
      "24130": true,
      "24131": true,
      "24132": true,
      "24133": true,
      "24134": true,
      "24135": true,
      "24136": true,
      "24137": true,
      "24138": true,
      "24139": true,
      "24140": true,
      "24141": true,
      "24142": true,
      "24143": true,
      "24144": true,
      "24145": true,
      "24146": true,
      "24147": true,
      "24148": true,
      "24149": true,
      "24150": true,
      "24151": true,
      "24152": true,
      "24153": true,
      "24154": true,
      "24155": true,
      "24156": true,
      "24157": true,
      "24158": true,
      "24159": true,
      "24160": true,
      "24161": true,
      "24162": true,
      "24163": true,
      "24164": true,
      "24165": true,
      "24166": true,
      "24167": true,
      "24168": true,
      "24169": true,
      "24170": true,
      "24171": true,
      "24172": true,
      "24173": true,
      "24174": true,
      "24175": true,
      "24176": true,
      "24177": true,
      "24178": true,
      "24179": true,
      "24180": true,
      "24181": true,
      "24182": true,
      "24183": true,
      "24184": true,
      "24185": true,
      "24186": true,
      "24187": true,
      "24188": true,
      "24189": true,
      "24190": true,
      "24191": true,
      "24192": true,
      "24193": true,
      "24194": true,
      "24195": true,
      "24196": true,
      "24197": true,
      "24198": true,
      "24199": true,
      "24315": true,
      "24316": true,
      "24320": true,
      "24321": true,
      "24322": true,
      "24325": true,
      "24327": true,
      "24328": true,
      "24329": true
    },
    "ESCARCEGA": {
      "24350": true,
      "24351": true,
      "24352": true,
      "24353": true,
      "24354": true,
      "24356": true,
      "24368": true,
      "24369": true,
      "24370": true,
      "24371": true,
      "24372": true,
      "24375": true,
      "24376": true,
      "24377": true,
      "24378": true,
      "24379": true,
      "24380": true,
      "24381": true,
      "24382": true,
      "24383": true,
      "24384": true,
      "24385": true,
      "24386": true,
      "24387": true,
      "24388": true,
      "24389": true,
      "24390": true,
      "24391": true,
      "24392": true,
      "24393": true,
      "24394": true,
      "24395": true,
      "24396": true,
      "24397": true,
      "24398": true,
      "24399": true
    },
    "CHAMPOTON": {
      "24400": true,
      "24401": true,
      "24402": true,
      "24403": true,
      "24404": true,
      "24405": true,
      "24406": true,
      "24407": true,
      "24408": true,
      "24409": true,
      "24416": true,
      "24417": true,
      "24418": true,
      "24420": true,
      "24440": true,
      "24443": true,
      "24444": true,
      "24445": true,
      "24446": true,
      "24447": true,
      "24448": true,
      "24449": true,
      "24450": true,
      "24451": true,
      "24452": true,
      "24453": true,
      "24454": true,
      "24455": true,
      "24456": true,
      "24457": true,
      "24458": true,
      "24459": true
    },
    "SEYBAPLAYA": {
      "24460": true,
      "24461": true,
      "24462": true,
      "24463": true,
      "24464": true,
      "24465": true,
      "24466": true,
      "24467": true,
      "24468": true,
      "24469": true,
      "24470": true,
      "24471": true,
      "24472": true,
      "24473": true,
      "24474": true,
      "24475": true,
      "24476": true,
      "24477": true,
      "24478": true,
      "24479": true,
      "24480": true,
      "24481": true,
      "24482": true,
      "24483": true,
      "24484": true,
      "24485": true,
      "24486": true,
      "24487": true,
      "24488": true,
      "24489": true,
      "24490": true,
      "24491": true,
      "24492": true,
      "24493": true,
      "24494": true,
      "24495": true,
      "24496": true,
      "24497": true,
      "24498": true,
      "24499": true
    },
    "HOPELCHEN": {
      "24600": true,
      "24601": true,
      "24602": true,
      "24603": true,
      "24604": true,
      "24605": true,
      "24606": true,
      "24609": true,
      "24612": true,
      "24615": true,
      "24616": true,
      "24617": true,
      "24618": true,
      "24619": true,
      "24663": true,
      "24664": true,
      "24665": true,
      "24666": true,
      "24667": true,
      "24670": true,
      "24671": true,
      "24672": true,
      "24673": true,
      "24674": true,
      "24675": true,
      "24676": true,
      "24677": true,
      "24678": true,
      "24679": true,
      "24680": true,
      "24681": true,
      "24682": true,
      "24683": true,
      "24684": true,
      "24685": true,
      "24686": true,
      "24687": true,
      "24688": true,
      "24689": true,
      "24690": true,
      "24691": true,
      "24692": true,
      "24693": true,
      "24694": true,
      "24695": true,
      "24696": true,
      "24697": true,
      "24698": true,
      "24699": true
    },
    "TENABO": {
      "24700": true,
      "24701": true,
      "24702": true,
      "24703": true,
      "24704": true,
      "24705": true,
      "24706": true,
      "24707": true,
      "24708": true,
      "24709": true,
      "24710": true,
      "24711": true,
      "24712": true,
      "24713": true,
      "24714": true,
      "24715": true,
      "24716": true,
      "24717": true,
      "24718": true,
      "24719": true,
      "24720": true,
      "24721": true,
      "24722": true,
      "24723": true,
      "24724": true,
      "24725": true,
      "24726": true,
      "24727": true,
      "24728": true,
      "24729": true,
      "24730": true,
      "24731": true,
      "24732": true,
      "24733": true,
      "24734": true,
      "24735": true,
      "24736": true,
      "24737": true,
      "24738": true,
      "24739": true,
      "24740": true,
      "24741": true,
      "24742": true,
      "24743": true,
      "24744": true,
      "24745": true,
      "24746": true,
      "24747": true,
      "24748": true,
      "24749": true,
      "24750": true,
      "24751": true,
      "24752": true,
      "24753": true,
      "24754": true,
      "24755": true,
      "24756": true,
      "24757": true,
      "24758": true,
      "24759": true,
      "24760": true,
      "24761": true,
      "24762": true,
      "24763": true,
      "24764": true,
      "24765": true,
      "24766": true,
      "24767": true,
      "24768": true,
      "24769": true,
      "24770": true,
      "24771": true,
      "24772": true,
      "24773": true,
      "24774": true,
      "24775": true,
      "24776": true,
      "24777": true,
      "24778": true,
      "24779": true,
      "24780": true,
      "24781": true,
      "24782": true,
      "24783": true,
      "24784": true,
      "24785": true,
      "24786": true,
      "24787": true,
      "24788": true,
      "24789": true,
      "24790": true,
      "24791": true,
      "24792": true,
      "24793": true,
      "24794": true,
      "24795": true,
      "24796": true,
      "24797": true,
      "24798": true,
      "24799": true
    },
    "HECELCHAKAN": {
      "24800": true,
      "24801": true,
      "24802": true,
      "24803": true,
      "24804": true,
      "24805": true,
      "24806": true,
      "24807": true,
      "24808": true,
      "24809": true,
      "24810": true,
      "24811": true,
      "24812": true,
      "24813": true,
      "24814": true,
      "24815": true,
      "24816": true,
      "24817": true,
      "24818": true,
      "24819": true,
      "24820": true,
      "24821": true,
      "24822": true,
      "24823": true,
      "24824": true,
      "24825": true,
      "24826": true,
      "24827": true,
      "24830": true,
      "24831": true,
      "24832": true,
      "24833": true,
      "24834": true,
      "24835": true,
      "24836": true,
      "24837": true,
      "24838": true,
      "24839": true,
      "24840": true,
      "24841": true,
      "24842": true,
      "24843": true,
      "24844": true,
      "24845": true,
      "24846": true,
      "24847": true,
      "24848": true,
      "24849": true,
      "24850": true,
      "24851": true,
      "24852": true,
      "24853": true,
      "24854": true,
      "24855": true,
      "24856": true,
      "24857": true,
      "24858": true,
      "24859": true,
      "24863": true,
      "24864": true,
      "24865": true,
      "24866": true,
      "24867": true,
      "24868": true,
      "24869": true,
      "24870": true,
      "24871": true,
      "24872": true,
      "24873": true,
      "24874": true,
      "24875": true,
      "24876": true,
      "24877": true,
      "24878": true,
      "24879": true,
      "24880": true,
      "24881": true,
      "24882": true,
      "24883": true,
      "24884": true,
      "24885": true,
      "24886": true,
      "24887": true,
      "24888": true,
      "24889": true,
      "24890": true,
      "24891": true,
      "24892": true,
      "24893": true,
      "24894": true,
      "24895": true,
      "24896": true,
      "24897": true,
      "24898": true,
      "24899": true
    },
    "CALKINI": {
      "24900": true,
      "24901": true,
      "24902": true,
      "24903": true,
      "24904": true,
      "24905": true,
      "24906": true,
      "24907": true,
      "24908": true,
      "24909": true,
      "24910": true,
      "24911": true,
      "24912": true,
      "24913": true,
      "24914": true,
      "24915": true,
      "24920": true,
      "24921": true,
      "24922": true,
      "24923": true,
      "24924": true,
      "24925": true,
      "24926": true,
      "24927": true,
      "24928": true,
      "24929": true,
      "24930": true,
      "24931": true,
      "24932": true,
      "24933": true,
      "24934": true,
      "24935": true,
      "24936": true,
      "24937": true,
      "24938": true,
      "24939": true,
      "24940": true,
      "24941": true,
      "24942": true,
      "24943": true,
      "24944": true,
      "24945": true,
      "24946": true,
      "24947": true,
      "24948": true,
      "24949": true,
      "24950": true,
      "24951": true,
      "24952": true,
      "24953": true,
      "24954": true,
      "24955": true,
      "24956": true,
      "24957": true,
      "24958": true,
      "24959": true,
      "24960": true,
      "24961": true,
      "24962": true,
      "24963": true,
      "24964": true,
      "24965": true,
      "24966": true,
      "24967": true,
      "24968": true,
      "24969": true,
      "24970": true,
      "24971": true,
      "24972": true,
      "24973": true,
      "24974": true,
      "24975": true,
      "24976": true,
      "24977": true,
      "24978": true,
      "24979": true,
      "24980": true,
      "24981": true,
      "24982": true,
      "24983": true,
      "24984": true,
      "24985": true,
      "24986": true,
      "24987": true,
      "24988": true,
      "24989": true,
      "24990": true,
      "24991": true,
      "24992": true,
      "24993": true,
      "24994": true,
      "24995": true,
      "24996": true,
      "24997": true,
      "24998": true,
      "24999": true
    }
  },
  "COAHUILA DE ZARAGOZA": {
    "SALTILLO": {
      "25000": true,
      "25001": true,
      "25002": true,
      "25003": true,
      "25004": true,
      "25005": true,
      "25006": true,
      "25007": true,
      "25008": true,
      "25009": true,
      "25010": true,
      "25011": true,
      "25012": true,
      "25013": true,
      "25014": true,
      "25015": true,
      "25016": true,
      "25017": true,
      "25018": true,
      "25019": true,
      "25020": true,
      "25021": true,
      "25022": true,
      "25023": true,
      "25024": true,
      "25025": true,
      "25026": true,
      "25027": true,
      "25028": true,
      "25029": true,
      "25030": true,
      "25031": true,
      "25032": true,
      "25033": true,
      "25034": true,
      "25035": true,
      "25036": true,
      "25037": true,
      "25038": true,
      "25039": true,
      "25040": true,
      "25041": true,
      "25042": true,
      "25043": true,
      "25044": true,
      "25045": true,
      "25046": true,
      "25047": true,
      "25048": true,
      "25049": true,
      "25050": true,
      "25051": true,
      "25052": true,
      "25053": true,
      "25054": true,
      "25055": true,
      "25056": true,
      "25057": true,
      "25058": true,
      "25059": true,
      "25060": true,
      "25061": true,
      "25062": true,
      "25063": true,
      "25064": true,
      "25065": true,
      "25066": true,
      "25067": true,
      "25068": true,
      "25069": true,
      "25070": true,
      "25071": true,
      "25072": true,
      "25073": true,
      "25074": true,
      "25075": true,
      "25076": true,
      "25077": true,
      "25078": true,
      "25079": true,
      "25080": true,
      "25081": true,
      "25082": true,
      "25083": true,
      "25084": true,
      "25085": true,
      "25086": true,
      "25087": true,
      "25088": true,
      "25089": true,
      "25090": true,
      "25091": true,
      "25092": true,
      "25093": true,
      "25094": true,
      "25095": true,
      "25096": true,
      "25097": true,
      "25098": true,
      "25099": true,
      "25100": true,
      "25101": true,
      "25102": true,
      "25103": true,
      "25104": true,
      "25105": true,
      "25106": true,
      "25107": true,
      "25108": true,
      "25109": true,
      "25110": true,
      "25111": true,
      "25112": true,
      "25113": true,
      "25114": true,
      "25115": true,
      "25116": true,
      "25117": true,
      "25118": true,
      "25119": true,
      "25120": true,
      "25121": true,
      "25122": true,
      "25123": true,
      "25124": true,
      "25125": true,
      "25126": true,
      "25127": true,
      "25128": true,
      "25129": true,
      "25130": true,
      "25131": true,
      "25132": true,
      "25133": true,
      "25134": true,
      "25135": true,
      "25136": true,
      "25137": true,
      "25138": true,
      "25139": true,
      "25140": true,
      "25141": true,
      "25142": true,
      "25143": true,
      "25144": true,
      "25145": true,
      "25146": true,
      "25147": true,
      "25148": true,
      "25149": true,
      "25150": true,
      "25151": true,
      "25152": true,
      "25153": true,
      "25154": true,
      "25155": true,
      "25156": true,
      "25157": true,
      "25158": true,
      "25159": true,
      "25160": true,
      "25161": true,
      "25162": true,
      "25163": true,
      "25164": true,
      "25165": true,
      "25166": true,
      "25167": true,
      "25168": true,
      "25169": true,
      "25170": true,
      "25171": true,
      "25172": true,
      "25173": true,
      "25174": true,
      "25175": true,
      "25176": true,
      "25177": true,
      "25178": true,
      "25179": true,
      "25180": true,
      "25181": true,
      "25182": true,
      "25183": true,
      "25184": true,
      "25185": true,
      "25186": true,
      "25187": true,
      "25188": true,
      "25189": true,
      "25190": true,
      "25191": true,
      "25192": true,
      "25193": true,
      "25194": true,
      "25195": true,
      "25196": true,
      "25197": true,
      "25198": true,
      "25199": true,
      "25200": true,
      "25201": true,
      "25202": true,
      "25203": true,
      "25204": true,
      "25205": true,
      "25206": true,
      "25207": true,
      "25208": true,
      "25209": true,
      "25210": true,
      "25211": true,
      "25212": true,
      "25213": true,
      "25214": true,
      "25215": true,
      "25216": true,
      "25217": true,
      "25218": true,
      "25219": true,
      "25220": true,
      "25221": true,
      "25222": true,
      "25223": true,
      "25224": true,
      "25225": true,
      "25226": true,
      "25227": true,
      "25228": true,
      "25229": true,
      "25230": true,
      "25231": true,
      "25232": true,
      "25233": true,
      "25234": true,
      "25235": true,
      "25236": true,
      "25237": true,
      "25238": true,
      "25239": true,
      "25240": true,
      "25241": true,
      "25242": true,
      "25243": true,
      "25244": true,
      "25245": true,
      "25246": true,
      "25247": true,
      "25248": true,
      "25249": true,
      "25250": true,
      "25251": true,
      "25252": true,
      "25253": true,
      "25254": true,
      "25255": true,
      "25256": true,
      "25257": true,
      "25258": true,
      "25259": true,
      "25260": true,
      "25261": true,
      "25262": true,
      "25263": true,
      "25264": true,
      "25265": true,
      "25266": true,
      "25267": true,
      "25268": true,
      "25269": true,
      "25270": true,
      "25271": true,
      "25272": true,
      "25273": true,
      "25274": true,
      "25275": true,
      "25276": true,
      "25277": true,
      "25278": true,
      "25279": true,
      "25280": true,
      "25281": true,
      "25282": true,
      "25283": true,
      "25284": true,
      "25285": true,
      "25286": true,
      "25287": true,
      "25288": true,
      "25289": true,
      "25290": true,
      "25291": true,
      "25292": true,
      "25293": true,
      "25294": true,
      "25295": true,
      "25296": true,
      "25297": true,
      "25298": true,
      "25299": true,
      "25300": true,
      "25301": true,
      "25302": true,
      "25303": true,
      "25304": true,
      "25305": true,
      "25306": true,
      "25307": true,
      "25308": true,
      "25309": true,
      "25310": true,
      "25311": true,
      "25312": true,
      "25313": true,
      "25314": true,
      "25315": true,
      "25316": true,
      "25317": true,
      "25318": true,
      "25319": true,
      "25320": true,
      "25321": true,
      "25322": true,
      "25323": true,
      "25324": true,
      "25325": true,
      "25326": true,
      "25327": true,
      "25328": true,
      "25329": true,
      "25330": true,
      "25331": true,
      "25332": true,
      "25333": true,
      "25334": true,
      "25335": true,
      "25336": true,
      "25337": true,
      "25338": true,
      "25339": true,
      "25340": true,
      "25341": true,
      "25342": true,
      "25343": true,
      "25344": true,
      "25345": true,
      "25346": true,
      "25347": true,
      "25348": true,
      "25349": true
    },
    "ARTEAGA": {
      "25350": true,
      "25351": true,
      "25352": true,
      "25353": true,
      "25354": true,
      "25355": true,
      "25356": true,
      "25357": true,
      "25358": true,
      "25359": true,
      "25360": true,
      "25361": true,
      "25362": true,
      "25363": true,
      "25364": true,
      "25365": true,
      "25366": true,
      "25367": true,
      "25368": true,
      "25369": true,
      "25370": true,
      "25371": true,
      "25372": true,
      "25373": true,
      "25374": true,
      "25375": true,
      "25376": true,
      "25377": true,
      "25378": true,
      "25379": true,
      "25380": true,
      "25381": true,
      "25382": true,
      "25383": true,
      "25384": true,
      "25385": true,
      "25386": true,
      "25387": true,
      "25388": true,
      "25389": true,
      "25390": true,
      "25391": true,
      "25392": true,
      "25393": true,
      "25394": true,
      "25395": true,
      "25396": true,
      "25397": true,
      "25398": true,
      "25399": true
    },
    "JUÁREZ": {
      "25400": true,
      "25401": true,
      "25402": true,
      "25403": true,
      "25404": true,
      "25405": true,
      "25406": true,
      "25407": true,
      "25408": true,
      "25409": true,
      "25410": true,
      "25411": true,
      "25412": true,
      "25413": true,
      "25414": true,
      "25415": true,
      "25416": true,
      "25417": true
    },
    "PROGRESO": {
      "25420": true,
      "25421": true,
      "25422": true,
      "25423": true,
      "25424": true,
      "25425": true,
      "25426": true,
      "25427": true,
      "25428": true,
      "25429": true,
      "25431": true,
      "25432": true,
      "25433": true,
      "25434": true,
      "25435": true,
      "25436": true,
      "25437": true,
      "25438": true,
      "25439": true,
      "25443": true,
      "25444": true,
      "25445": true,
      "25447": true,
      "25448": true,
      "25449": true,
      "25463": true,
      "25464": true,
      "25465": true,
      "25466": true,
      "25467": true,
      "25468": true,
      "25469": true
    },
    "ESCOBEDO": {
      "25470": true,
      "25471": true,
      "25472": true,
      "25473": true,
      "25474": true,
      "25475": true,
      "25476": true,
      "25477": true,
      "25478": true,
      "25479": true,
      "25490": true,
      "25491": true,
      "25492": true,
      "25493": true,
      "25494": true,
      "25495": true,
      "25496": true,
      "25497": true,
      "25498": true,
      "25499": true
    },
    "SAN BUENAVENTURA": {
      "25500": true,
      "25501": true,
      "25502": true,
      "25503": true,
      "25504": true,
      "25505": true,
      "25506": true,
      "25507": true,
      "25508": true,
      "25509": true,
      "25510": true,
      "25511": true,
      "25512": true,
      "25513": true,
      "25514": true,
      "25515": true,
      "25516": true,
      "25517": true,
      "25518": true,
      "25519": true,
      "25520": true,
      "25521": true,
      "25530": true,
      "25531": true,
      "25536": true,
      "25537": true,
      "25538": true,
      "25539": true
    },
    "ABASOLO": {
      "25540": true,
      "25541": true,
      "25542": true,
      "25543": true,
      "25544": true,
      "25545": true,
      "25546": true,
      "25547": true,
      "25548": true,
      "25549": true,
      "25550": true,
      "25551": true,
      "25552": true,
      "25553": true,
      "25554": true,
      "25555": true,
      "25556": true,
      "25557": true,
      "25558": true,
      "25559": true,
      "25567": true,
      "25568": true,
      "25569": true
    },
    "CANDELA": {
      "25570": true,
      "25571": true,
      "25572": true,
      "25573": true,
      "25574": true,
      "25575": true,
      "25576": true,
      "25577": true,
      "25578": true,
      "25579": true,
      "25580": true,
      "25581": true,
      "25582": true,
      "25583": true,
      "25584": true,
      "25585": true,
      "25586": true,
      "25587": true,
      "25588": true,
      "25589": true
    },
    "FRONTERA": {
      "25600": true,
      "25601": true,
      "25602": true,
      "25603": true,
      "25604": true,
      "25605": true,
      "25606": true,
      "25607": true,
      "25608": true,
      "25609": true,
      "25610": true,
      "25611": true,
      "25612": true,
      "25613": true,
      "25614": true,
      "25615": true,
      "25616": true,
      "25617": true,
      "25618": true,
      "25619": true,
      "25620": true,
      "25621": true,
      "25622": true,
      "25623": true,
      "25624": true,
      "25625": true,
      "25626": true,
      "25627": true,
      "25628": true,
      "25629": true,
      "25630": true,
      "25631": true,
      "25632": true,
      "25633": true,
      "25634": true,
      "25635": true,
      "25636": true,
      "25637": true,
      "25638": true,
      "25639": true,
      "25640": true,
      "25641": true,
      "25642": true,
      "25643": true,
      "25644": true,
      "25645": true,
      "25646": true,
      "25647": true,
      "25648": true,
      "25649": true,
      "25650": true,
      "25651": true,
      "25652": true,
      "25653": true,
      "25654": true,
      "25655": true,
      "25656": true,
      "25657": true,
      "25658": true,
      "25659": true,
      "25660": true,
      "25661": true,
      "25662": true,
      "25663": true,
      "25664": true,
      "25665": true,
      "25666": true,
      "25667": true,
      "25668": true,
      "25669": true,
      "25670": true,
      "25671": true,
      "25672": true,
      "25673": true,
      "25674": true,
      "25675": true,
      "25676": true,
      "25677": true,
      "25678": true,
      "25679": true,
      "25680": true,
      "25681": true,
      "25682": true,
      "25683": true,
      "25684": true,
      "25685": true,
      "25686": true,
      "25687": true,
      "25688": true,
      "25689": true,
      "25690": true,
      "25691": true,
      "25692": true,
      "25693": true,
      "25694": true,
      "25695": true,
      "25696": true,
      "25697": true,
      "25698": true,
      "25699": true,
      "25800": true,
      "25801": true,
      "25802": true,
      "25803": true,
      "25804": true,
      "25805": true,
      "25806": true,
      "25807": true,
      "25808": true,
      "25809": true,
      "25810": true,
      "25811": true,
      "25812": true,
      "25813": true,
      "25814": true,
      "25815": true,
      "25816": true,
      "25817": true,
      "25818": true,
      "25819": true,
      "25820": true,
      "25821": true,
      "25822": true,
      "25823": true,
      "25824": true,
      "25825": true,
      "25826": true,
      "25827": true,
      "25828": true,
      "25829": true
    },
    "MONCLOVA": {
      "25700": true,
      "25701": true,
      "25702": true,
      "25703": true,
      "25704": true,
      "25705": true,
      "25706": true,
      "25707": true,
      "25708": true,
      "25709": true,
      "25710": true,
      "25711": true,
      "25712": true,
      "25713": true,
      "25714": true,
      "25715": true,
      "25716": true,
      "25717": true,
      "25718": true,
      "25719": true,
      "25720": true,
      "25721": true,
      "25722": true,
      "25723": true,
      "25724": true,
      "25725": true,
      "25726": true,
      "25727": true,
      "25728": true,
      "25729": true,
      "25730": true,
      "25731": true,
      "25732": true,
      "25733": true,
      "25734": true,
      "25735": true,
      "25736": true,
      "25737": true,
      "25738": true,
      "25739": true,
      "25740": true,
      "25741": true,
      "25742": true,
      "25743": true,
      "25744": true,
      "25745": true,
      "25746": true,
      "25747": true,
      "25748": true,
      "25749": true,
      "25750": true,
      "25751": true,
      "25752": true,
      "25753": true,
      "25754": true,
      "25755": true,
      "25756": true,
      "25757": true,
      "25758": true,
      "25759": true,
      "25760": true,
      "25761": true,
      "25762": true,
      "25763": true,
      "25764": true,
      "25765": true,
      "25766": true,
      "25767": true,
      "25768": true,
      "25769": true,
      "25770": true,
      "25771": true,
      "25772": true,
      "25773": true,
      "25774": true,
      "25775": true,
      "25776": true,
      "25777": true,
      "25778": true,
      "25779": true,
      "25780": true,
      "25781": true,
      "25782": true,
      "25783": true,
      "25784": true,
      "25785": true,
      "25786": true,
      "25787": true,
      "25788": true,
      "25789": true,
      "25790": true,
      "25791": true,
      "25792": true,
      "25793": true,
      "25794": true,
      "25795": true,
      "25796": true,
      "25797": true,
      "25798": true,
      "25799": true,
      "25830": true,
      "25831": true,
      "25832": true,
      "25833": true,
      "25834": true,
      "25835": true,
      "25836": true,
      "25837": true,
      "25838": true,
      "25839": true,
      "25840": true,
      "25841": true,
      "25842": true,
      "25843": true,
      "25844": true,
      "25845": true,
      "25846": true,
      "25847": true,
      "25848": true,
      "25849": true,
      "25850": true,
      "25851": true,
      "25852": true,
      "25853": true,
      "25854": true,
      "25855": true,
      "25856": true,
      "25857": true,
      "25858": true,
      "25859": true,
      "25860": true,
      "25861": true,
      "25862": true,
      "25863": true,
      "25864": true,
      "25865": true,
      "25866": true,
      "25867": true,
      "25868": true,
      "25869": true
    },
    "CASTAÑOS": {
      "25870": true,
      "25871": true,
      "25872": true,
      "25873": true,
      "25874": true,
      "25875": true,
      "25876": true,
      "25879": true,
      "25884": true,
      "25886": true,
      "25887": true,
      "25888": true,
      "25889": true,
      "25896": true
    },
    "RAMOS ARIZPE": {
      "25900": true,
      "25901": true,
      "25902": true,
      "25903": true,
      "25904": true,
      "25905": true,
      "25906": true,
      "25907": true,
      "25908": true,
      "25909": true,
      "25910": true,
      "25911": true,
      "25912": true,
      "25913": true,
      "25914": true,
      "25915": true,
      "25916": true,
      "25917": true,
      "25918": true,
      "25919": true,
      "25920": true,
      "25921": true,
      "25922": true,
      "25923": true,
      "25924": true,
      "25925": true,
      "25926": true,
      "25927": true,
      "25928": true,
      "25929": true,
      "25930": true,
      "25931": true,
      "25932": true,
      "25933": true,
      "25934": true,
      "25935": true,
      "25936": true,
      "25937": true,
      "25938": true,
      "25939": true,
      "25940": true,
      "25941": true,
      "25942": true,
      "25943": true,
      "25944": true,
      "25945": true,
      "25946": true,
      "25947": true,
      "25948": true,
      "25949": true
    },
    "GENERAL CEPEDA": {
      "25950": true,
      "25951": true,
      "25953": true,
      "25954": true,
      "25955": true,
      "25956": true,
      "25957": true,
      "25958": true,
      "25959": true,
      "25974": true,
      "25975": true,
      "25976": true,
      "25977": true,
      "25978": true,
      "25979": true,
      "25987": true,
      "25988": true,
      "25990": true,
      "25991": true,
      "25992": true
    },
    "PIEDRAS NEGRAS": {
      "26000": true,
      "26001": true,
      "26002": true,
      "26003": true,
      "26004": true,
      "26005": true,
      "26006": true,
      "26007": true,
      "26008": true,
      "26009": true,
      "26010": true,
      "26011": true,
      "26012": true,
      "26013": true,
      "26014": true,
      "26015": true,
      "26016": true,
      "26017": true,
      "26018": true,
      "26019": true,
      "26020": true,
      "26021": true,
      "26022": true,
      "26023": true,
      "26024": true,
      "26025": true,
      "26026": true,
      "26027": true,
      "26028": true,
      "26029": true,
      "26030": true,
      "26031": true,
      "26032": true,
      "26033": true,
      "26034": true,
      "26035": true,
      "26036": true,
      "26037": true,
      "26038": true,
      "26039": true,
      "26040": true,
      "26041": true,
      "26042": true,
      "26043": true,
      "26044": true,
      "26045": true,
      "26046": true,
      "26047": true,
      "26048": true,
      "26049": true,
      "26050": true,
      "26051": true,
      "26052": true,
      "26053": true,
      "26054": true,
      "26055": true,
      "26056": true,
      "26057": true,
      "26058": true,
      "26059": true,
      "26060": true,
      "26061": true,
      "26062": true,
      "26063": true,
      "26064": true,
      "26065": true,
      "26066": true,
      "26067": true,
      "26068": true,
      "26069": true,
      "26070": true,
      "26071": true,
      "26072": true,
      "26073": true,
      "26074": true,
      "26075": true,
      "26076": true,
      "26077": true,
      "26078": true,
      "26079": true,
      "26080": true,
      "26081": true,
      "26082": true,
      "26083": true,
      "26084": true,
      "26085": true,
      "26086": true,
      "26087": true,
      "26088": true,
      "26089": true,
      "26090": true,
      "26091": true,
      "26092": true,
      "26093": true,
      "26094": true,
      "26095": true,
      "26096": true,
      "26097": true,
      "26098": true,
      "26099": true,
      "26100": true,
      "26101": true,
      "26102": true,
      "26103": true,
      "26104": true,
      "26105": true,
      "26106": true,
      "26107": true,
      "26108": true,
      "26109": true,
      "26110": true,
      "26111": true,
      "26112": true,
      "26113": true,
      "26114": true,
      "26115": true,
      "26116": true,
      "26117": true,
      "26118": true,
      "26119": true,
      "26120": true,
      "26121": true,
      "26122": true,
      "26123": true,
      "26124": true,
      "26125": true,
      "26126": true,
      "26127": true,
      "26128": true,
      "26129": true,
      "26130": true,
      "26131": true,
      "26132": true,
      "26133": true,
      "26134": true,
      "26135": true,
      "26136": true,
      "26137": true,
      "26138": true,
      "26139": true,
      "26140": true,
      "26141": true,
      "26142": true,
      "26143": true,
      "26144": true,
      "26145": true,
      "26146": true,
      "26147": true,
      "26148": true,
      "26149": true,
      "26150": true,
      "26151": true,
      "26152": true,
      "26153": true,
      "26154": true,
      "26155": true,
      "26156": true,
      "26157": true,
      "26158": true,
      "26159": true,
      "26160": true,
      "26161": true,
      "26162": true,
      "26163": true,
      "26164": true,
      "26165": true,
      "26166": true,
      "26167": true,
      "26168": true,
      "26169": true
    },
    "NAVA": {
      "26170": true,
      "26171": true,
      "26172": true,
      "26173": true,
      "26174": true,
      "26175": true,
      "26176": true,
      "26177": true,
      "26178": true,
      "26179": true,
      "26183": true,
      "26190": true,
      "26191": true,
      "26192": true,
      "26193": true,
      "26194": true,
      "26195": true,
      "26196": true,
      "26197": true,
      "26198": true,
      "26199": true
    },
    "ACUÑA": {
      "26200": true,
      "26201": true,
      "26202": true,
      "26203": true,
      "26204": true,
      "26205": true,
      "26206": true,
      "26207": true,
      "26208": true,
      "26209": true,
      "26210": true,
      "26211": true,
      "26212": true,
      "26213": true,
      "26214": true,
      "26215": true,
      "26216": true,
      "26217": true,
      "26218": true,
      "26219": true,
      "26220": true,
      "26221": true,
      "26222": true,
      "26223": true,
      "26224": true,
      "26225": true,
      "26226": true,
      "26227": true,
      "26228": true,
      "26229": true,
      "26230": true,
      "26231": true,
      "26232": true,
      "26233": true,
      "26234": true,
      "26235": true,
      "26236": true,
      "26237": true,
      "26238": true,
      "26239": true,
      "26240": true,
      "26241": true,
      "26242": true,
      "26243": true,
      "26244": true,
      "26245": true,
      "26246": true,
      "26247": true,
      "26248": true,
      "26249": true,
      "26250": true,
      "26251": true,
      "26252": true,
      "26253": true,
      "26254": true,
      "26255": true,
      "26256": true,
      "26257": true,
      "26258": true,
      "26259": true,
      "26260": true,
      "26261": true,
      "26262": true,
      "26263": true,
      "26264": true,
      "26265": true,
      "26266": true,
      "26267": true,
      "26268": true,
      "26269": true,
      "26270": true,
      "26271": true,
      "26272": true,
      "26273": true,
      "26274": true,
      "26275": true,
      "26276": true,
      "26277": true,
      "26278": true,
      "26279": true,
      "26280": true,
      "26281": true,
      "26282": true,
      "26283": true,
      "26284": true,
      "26285": true,
      "26286": true,
      "26287": true,
      "26288": true,
      "26289": true,
      "26290": true,
      "26291": true,
      "26292": true,
      "26293": true,
      "26294": true,
      "26295": true,
      "26296": true,
      "26297": true,
      "26298": true,
      "26299": true,
      "26300": true,
      "26301": true,
      "26302": true,
      "26303": true,
      "26308": true,
      "26309": true,
      "26328": true,
      "26329": true,
      "26330": true,
      "26331": true,
      "26332": true,
      "26333": true,
      "26334": true,
      "26335": true,
      "26336": true,
      "26337": true,
      "26338": true,
      "26339": true
    },
    "MUZQUIZ": {
      "26340": true,
      "26341": true,
      "26342": true,
      "26343": true,
      "26344": true,
      "26345": true,
      "26346": true,
      "26347": true,
      "26348": true,
      "26349": true,
      "26350": true,
      "26351": true,
      "26352": true,
      "26353": true,
      "26354": true,
      "26355": true,
      "26356": true,
      "26357": true,
      "26358": true,
      "26359": true,
      "26363": true,
      "26364": true,
      "26366": true,
      "26367": true,
      "26368": true,
      "26369": true,
      "26370": true,
      "26371": true,
      "26372": true,
      "26373": true,
      "26374": true,
      "26375": true,
      "26376": true,
      "26377": true,
      "26378": true,
      "26379": true,
      "26384": true,
      "26385": true,
      "26386": true,
      "26387": true,
      "26388": true,
      "26389": true,
      "26390": true,
      "26391": true,
      "26392": true,
      "26393": true,
      "26394": true,
      "26395": true,
      "26396": true,
      "26397": true,
      "26398": true,
      "26399": true
    },
    "JIMENEZ": {
      "26400": true,
      "26401": true,
      "26402": true,
      "26403": true,
      "26404": true,
      "26409": true,
      "26420": true,
      "26421": true,
      "26422": true,
      "26423": true,
      "26424": true,
      "26425": true,
      "26426": true,
      "26427": true,
      "26428": true,
      "26431": true,
      "26432": true,
      "26433": true,
      "26434": true,
      "26435": true,
      "26436": true,
      "26437": true,
      "26438": true,
      "26439": true,
      "26440": true,
      "26441": true,
      "26442": true,
      "26443": true,
      "26444": true,
      "26445": true,
      "26446": true,
      "26447": true,
      "26448": true,
      "26449": true
    },
    "ZARAGOZA": {
      "26450": true,
      "26451": true,
      "26452": true,
      "26453": true,
      "26454": true,
      "26455": true,
      "26456": true,
      "26457": true,
      "26458": true,
      "26459": true,
      "26463": true,
      "26464": true,
      "26467": true,
      "26468": true,
      "26469": true,
      "26470": true,
      "26471": true,
      "26472": true,
      "26473": true,
      "26474": true,
      "26475": true,
      "26476": true,
      "26485": true
    },
    "MORELOS": {
      "26500": true,
      "26501": true,
      "26502": true,
      "26503": true,
      "26504": true,
      "26505": true,
      "26506": true,
      "26507": true,
      "26508": true,
      "26509": true,
      "26510": true,
      "26511": true,
      "26512": true,
      "26513": true,
      "26516": true,
      "26517": true,
      "26518": true,
      "26519": true
    },
    "ALLENDE": {
      "26530": true,
      "26531": true,
      "26532": true,
      "26533": true,
      "26534": true,
      "26535": true,
      "26536": true,
      "26537": true,
      "26538": true,
      "26539": true,
      "26540": true,
      "26541": true,
      "26542": true,
      "26543": true,
      "26544": true,
      "26545": true,
      "26546": true,
      "26547": true,
      "26548": true,
      "26549": true,
      "26550": true,
      "26551": true,
      "26552": true,
      "26553": true,
      "26554": true,
      "26555": true,
      "26556": true,
      "26557": true,
      "26558": true,
      "26559": true,
      "26560": true,
      "26561": true,
      "26562": true,
      "26563": true,
      "26564": true,
      "26565": true,
      "26566": true,
      "26567": true,
      "26568": true,
      "26569": true,
      "26570": true,
      "26571": true,
      "26572": true,
      "26573": true,
      "26574": true,
      "26575": true,
      "26576": true,
      "26577": true,
      "26578": true,
      "26579": true,
      "26580": true,
      "26581": true,
      "26582": true,
      "26583": true,
      "26590": true,
      "26591": true,
      "26592": true,
      "26593": true,
      "26594": true,
      "26595": true
    },
    "VILLA UNION": {
      "26600": true,
      "26601": true,
      "26602": true,
      "26603": true,
      "26604": true,
      "26605": true,
      "26606": true,
      "26607": true,
      "26608": true,
      "26609": true,
      "26610": true,
      "26611": true,
      "26612": true,
      "26613": true,
      "26617": true,
      "26618": true,
      "26619": true,
      "26624": true,
      "26630": true,
      "26631": true,
      "26632": true,
      "26633": true,
      "26636": true
    },
    "GUERRERO": {
      "26640": true,
      "26641": true,
      "26642": true,
      "26643": true,
      "26644": true,
      "26645": true,
      "26646": true,
      "26647": true,
      "26648": true,
      "26649": true
    },
    "SABINAS": {
      "26700": true,
      "26701": true,
      "26702": true,
      "26703": true,
      "26704": true,
      "26705": true,
      "26706": true,
      "26707": true,
      "26708": true,
      "26709": true,
      "26710": true,
      "26711": true,
      "26712": true,
      "26713": true,
      "26714": true,
      "26715": true,
      "26716": true,
      "26717": true,
      "26718": true,
      "26719": true,
      "26720": true,
      "26721": true,
      "26722": true,
      "26723": true,
      "26724": true,
      "26725": true,
      "26726": true,
      "26727": true,
      "26728": true,
      "26729": true,
      "26730": true,
      "26731": true,
      "26732": true,
      "26733": true,
      "26734": true,
      "26735": true,
      "26736": true,
      "26737": true,
      "26738": true,
      "26739": true,
      "26740": true,
      "26741": true,
      "26742": true,
      "26743": true,
      "26744": true,
      "26745": true,
      "26746": true,
      "26747": true,
      "26748": true,
      "26749": true,
      "26750": true,
      "26751": true,
      "26752": true,
      "26753": true,
      "26754": true,
      "26755": true,
      "26756": true,
      "26757": true,
      "26758": true,
      "26759": true,
      "26760": true,
      "26761": true,
      "26762": true,
      "26763": true,
      "26764": true,
      "26765": true,
      "26766": true,
      "26767": true,
      "26768": true,
      "26769": true,
      "26770": true,
      "26771": true,
      "26772": true,
      "26773": true,
      "26774": true,
      "26775": true,
      "26776": true,
      "26777": true,
      "26778": true,
      "26779": true,
      "26780": true,
      "26781": true,
      "26782": true,
      "26783": true,
      "26784": true,
      "26785": true,
      "26786": true,
      "26787": true,
      "26788": true,
      "26789": true,
      "26790": true,
      "26791": true,
      "26792": true,
      "26793": true,
      "26794": true,
      "26795": true,
      "26796": true,
      "26797": true,
      "26798": true,
      "26799": true,
      "26950": true,
      "26951": true,
      "26952": true,
      "26953": true,
      "26959": true,
      "26960": true,
      "26961": true,
      "26962": true,
      "26963": true,
      "26980": true,
      "26981": true,
      "26982": true,
      "26983": true,
      "26984": true,
      "26985": true,
      "26986": true,
      "26987": true,
      "26988": true,
      "26989": true,
      "26990": true,
      "26991": true,
      "26992": true,
      "26993": true,
      "26994": true,
      "26995": true,
      "26996": true,
      "26997": true,
      "26998": true,
      "26999": true
    },
    "SAN JUAN DE SABINAS": {
      "26800": true,
      "26801": true,
      "26802": true,
      "26803": true,
      "26804": true,
      "26805": true,
      "26806": true,
      "26807": true,
      "26808": true,
      "26809": true,
      "26810": true,
      "26811": true,
      "26812": true,
      "26813": true,
      "26814": true,
      "26815": true,
      "26816": true,
      "26817": true,
      "26818": true,
      "26819": true,
      "26820": true,
      "26821": true,
      "26822": true,
      "26823": true,
      "26824": true,
      "26825": true,
      "26826": true,
      "26827": true,
      "26828": true,
      "26829": true,
      "26830": true,
      "26831": true,
      "26832": true,
      "26833": true,
      "26834": true,
      "26835": true,
      "26836": true,
      "26837": true,
      "26838": true,
      "26839": true,
      "26840": true,
      "26841": true,
      "26842": true,
      "26843": true,
      "26844": true,
      "26845": true,
      "26846": true,
      "26847": true,
      "26848": true,
      "26849": true,
      "26850": true,
      "26851": true,
      "26852": true,
      "26853": true,
      "26854": true,
      "26855": true,
      "26856": true,
      "26857": true,
      "26858": true,
      "26859": true,
      "26860": true,
      "26861": true,
      "26862": true,
      "26863": true,
      "26864": true,
      "26865": true,
      "26866": true,
      "26867": true,
      "26868": true,
      "26869": true,
      "26870": true,
      "26871": true,
      "26872": true,
      "26873": true,
      "26874": true,
      "26875": true,
      "26876": true,
      "26877": true,
      "26878": true,
      "26879": true,
      "26880": true,
      "26881": true,
      "26882": true,
      "26883": true,
      "26884": true,
      "26885": true,
      "26886": true,
      "26887": true,
      "26888": true,
      "26889": true,
      "26890": true,
      "26891": true,
      "26892": true,
      "26893": true,
      "26894": true,
      "26895": true,
      "26896": true,
      "26897": true,
      "26898": true,
      "26899": true,
      "26900": true,
      "26901": true,
      "26902": true,
      "26903": true,
      "26904": true,
      "26905": true,
      "26906": true,
      "26907": true,
      "26908": true,
      "26909": true,
      "26940": true,
      "26941": true,
      "26942": true
    },
    "TORREON": {
      "27000": true,
      "27001": true,
      "27002": true,
      "27003": true,
      "27004": true,
      "27005": true,
      "27006": true,
      "27007": true,
      "27008": true,
      "27009": true,
      "27010": true,
      "27011": true,
      "27012": true,
      "27013": true,
      "27014": true,
      "27015": true,
      "27016": true,
      "27017": true,
      "27018": true,
      "27019": true,
      "27020": true,
      "27021": true,
      "27022": true,
      "27023": true,
      "27024": true,
      "27025": true,
      "27026": true,
      "27027": true,
      "27028": true,
      "27029": true,
      "27030": true,
      "27031": true,
      "27032": true,
      "27033": true,
      "27034": true,
      "27035": true,
      "27036": true,
      "27037": true,
      "27038": true,
      "27039": true,
      "27040": true,
      "27041": true,
      "27042": true,
      "27043": true,
      "27044": true,
      "27045": true,
      "27046": true,
      "27047": true,
      "27048": true,
      "27049": true,
      "27050": true,
      "27051": true,
      "27052": true,
      "27053": true,
      "27054": true,
      "27055": true,
      "27056": true,
      "27057": true,
      "27058": true,
      "27059": true,
      "27060": true,
      "27061": true,
      "27062": true,
      "27063": true,
      "27064": true,
      "27065": true,
      "27066": true,
      "27067": true,
      "27068": true,
      "27069": true,
      "27070": true,
      "27071": true,
      "27072": true,
      "27073": true,
      "27074": true,
      "27075": true,
      "27076": true,
      "27077": true,
      "27078": true,
      "27079": true,
      "27080": true,
      "27081": true,
      "27082": true,
      "27083": true,
      "27084": true,
      "27085": true,
      "27086": true,
      "27087": true,
      "27088": true,
      "27089": true,
      "27090": true,
      "27091": true,
      "27092": true,
      "27093": true,
      "27094": true,
      "27095": true,
      "27096": true,
      "27097": true,
      "27098": true,
      "27099": true,
      "27100": true,
      "27101": true,
      "27102": true,
      "27103": true,
      "27104": true,
      "27105": true,
      "27106": true,
      "27107": true,
      "27108": true,
      "27109": true,
      "27110": true,
      "27111": true,
      "27112": true,
      "27113": true,
      "27114": true,
      "27115": true,
      "27116": true,
      "27117": true,
      "27118": true,
      "27119": true,
      "27120": true,
      "27121": true,
      "27122": true,
      "27123": true,
      "27124": true,
      "27125": true,
      "27126": true,
      "27127": true,
      "27128": true,
      "27129": true,
      "27130": true,
      "27131": true,
      "27132": true,
      "27133": true,
      "27134": true,
      "27135": true,
      "27136": true,
      "27137": true,
      "27138": true,
      "27139": true,
      "27140": true,
      "27141": true,
      "27142": true,
      "27143": true,
      "27144": true,
      "27145": true,
      "27146": true,
      "27147": true,
      "27148": true,
      "27149": true,
      "27150": true,
      "27151": true,
      "27152": true,
      "27153": true,
      "27154": true,
      "27155": true,
      "27156": true,
      "27157": true,
      "27158": true,
      "27159": true,
      "27160": true,
      "27161": true,
      "27162": true,
      "27163": true,
      "27164": true,
      "27165": true,
      "27166": true,
      "27167": true,
      "27168": true,
      "27169": true,
      "27170": true,
      "27171": true,
      "27172": true,
      "27173": true,
      "27174": true,
      "27175": true,
      "27176": true,
      "27177": true,
      "27178": true,
      "27179": true,
      "27180": true,
      "27181": true,
      "27182": true,
      "27183": true,
      "27184": true,
      "27185": true,
      "27186": true,
      "27187": true,
      "27188": true,
      "27189": true,
      "27190": true,
      "27191": true,
      "27192": true,
      "27193": true,
      "27194": true,
      "27195": true,
      "27196": true,
      "27197": true,
      "27198": true,
      "27199": true,
      "27200": true,
      "27201": true,
      "27202": true,
      "27203": true,
      "27204": true,
      "27205": true,
      "27206": true,
      "27207": true,
      "27208": true,
      "27209": true,
      "27210": true,
      "27211": true,
      "27212": true,
      "27213": true,
      "27214": true,
      "27215": true,
      "27216": true,
      "27217": true,
      "27218": true,
      "27219": true,
      "27220": true,
      "27221": true,
      "27222": true,
      "27223": true,
      "27224": true,
      "27225": true,
      "27226": true,
      "27227": true,
      "27228": true,
      "27229": true,
      "27230": true,
      "27231": true,
      "27232": true,
      "27233": true,
      "27234": true,
      "27235": true,
      "27236": true,
      "27237": true,
      "27238": true,
      "27239": true,
      "27240": true,
      "27241": true,
      "27242": true,
      "27243": true,
      "27244": true,
      "27245": true,
      "27246": true,
      "27247": true,
      "27248": true,
      "27249": true,
      "27250": true,
      "27251": true,
      "27252": true,
      "27253": true,
      "27254": true,
      "27255": true,
      "27256": true,
      "27257": true,
      "27258": true,
      "27259": true,
      "27260": true,
      "27261": true,
      "27262": true,
      "27263": true,
      "27264": true,
      "27265": true,
      "27266": true,
      "27267": true,
      "27268": true,
      "27269": true,
      "27270": true,
      "27271": true,
      "27272": true,
      "27273": true,
      "27274": true,
      "27275": true,
      "27276": true,
      "27277": true,
      "27278": true,
      "27279": true,
      "27280": true,
      "27281": true,
      "27282": true,
      "27283": true,
      "27284": true,
      "27285": true,
      "27286": true,
      "27287": true,
      "27288": true,
      "27289": true,
      "27290": true,
      "27291": true,
      "27292": true,
      "27293": true,
      "27294": true,
      "27295": true,
      "27296": true,
      "27297": true,
      "27298": true,
      "27299": true,
      "27300": true,
      "27301": true,
      "27302": true,
      "27303": true,
      "27304": true,
      "27305": true,
      "27306": true,
      "27307": true,
      "27308": true,
      "27309": true,
      "27310": true,
      "27311": true,
      "27312": true,
      "27313": true,
      "27314": true,
      "27315": true,
      "27316": true,
      "27317": true,
      "27318": true,
      "27319": true,
      "27320": true,
      "27321": true,
      "27322": true,
      "27323": true,
      "27324": true,
      "27325": true,
      "27326": true,
      "27327": true,
      "27328": true,
      "27329": true,
      "27330": true,
      "27331": true,
      "27332": true,
      "27333": true,
      "27334": true,
      "27335": true,
      "27336": true,
      "27337": true,
      "27338": true,
      "27339": true,
      "27340": true,
      "27341": true,
      "27342": true,
      "27343": true,
      "27344": true,
      "27345": true,
      "27346": true,
      "27347": true,
      "27348": true,
      "27349": true,
      "27350": true,
      "27351": true,
      "27352": true,
      "27353": true,
      "27354": true,
      "27355": true,
      "27356": true,
      "27357": true,
      "27358": true,
      "27359": true,
      "27360": true,
      "27361": true,
      "27362": true,
      "27363": true,
      "27364": true,
      "27365": true,
      "27366": true,
      "27367": true,
      "27368": true,
      "27369": true,
      "27370": true,
      "27371": true,
      "27372": true,
      "27373": true,
      "27374": true,
      "27375": true,
      "27376": true,
      "27377": true,
      "27378": true,
      "27379": true,
      "27380": true,
      "27381": true,
      "27382": true,
      "27383": true,
      "27384": true,
      "27385": true,
      "27386": true,
      "27387": true,
      "27388": true,
      "27389": true,
      "27390": true,
      "27391": true,
      "27392": true,
      "27393": true,
      "27394": true,
      "27395": true,
      "27396": true,
      "27397": true,
      "27398": true,
      "27399": true,
      "27400": true,
      "27401": true,
      "27402": true,
      "27403": true,
      "27404": true,
      "27405": true,
      "27406": true,
      "27407": true,
      "27408": true,
      "27409": true,
      "27410": true,
      "27411": true,
      "27412": true,
      "27413": true,
      "27414": true,
      "27415": true,
      "27416": true,
      "27417": true,
      "27418": true,
      "27419": true,
      "27420": true,
      "27421": true,
      "27422": true,
      "27423": true,
      "27424": true,
      "27425": true,
      "27426": true,
      "27427": true,
      "27428": true,
      "27429": true,
      "27430": true,
      "27431": true,
      "27432": true,
      "27433": true,
      "27434": true,
      "27435": true,
      "27436": true,
      "27437": true,
      "27438": true,
      "27439": true
    },
    "MATAMOROS": {
      "27440": true,
      "27441": true,
      "27442": true,
      "27443": true,
      "27444": true,
      "27445": true,
      "27446": true,
      "27447": true,
      "27448": true,
      "27449": true,
      "27450": true,
      "27451": true,
      "27453": true,
      "27454": true,
      "27455": true,
      "27456": true,
      "27457": true,
      "27458": true,
      "27459": true,
      "27460": true,
      "27461": true,
      "27462": true,
      "27463": true,
      "27464": true,
      "27465": true,
      "27466": true,
      "27467": true,
      "27468": true,
      "27469": true,
      "27470": true,
      "27471": true,
      "27472": true,
      "27473": true,
      "27475": true,
      "27477": true,
      "27478": true,
      "27479": true
    },
    "VIESCA": {
      "27480": true,
      "27481": true,
      "27482": true,
      "27483": true,
      "27485": true,
      "27487": true
    },
    "NADADORES": {
      "27550": true,
      "27551": true,
      "27552": true,
      "27553": true,
      "27554": true,
      "27555": true,
      "27556": true,
      "27557": true,
      "27558": true,
      "27559": true,
      "27560": true,
      "27561": true,
      "27562": true,
      "27563": true,
      "27564": true,
      "27565": true,
      "27566": true,
      "27567": true,
      "27568": true,
      "27569": true,
      "27575": true,
      "27576": true,
      "27577": true,
      "27578": true,
      "27588": true,
      "27589": true,
      "27590": true,
      "27591": true,
      "27592": true,
      "27593": true,
      "27594": true,
      "27595": true,
      "27596": true,
      "27597": true,
      "27598": true,
      "27599": true
    },
    "CUATRO CIENEGAS": {
      "27640": true,
      "27641": true,
      "27642": true,
      "27643": true,
      "27644": true,
      "27645": true,
      "27650": true,
      "27651": true,
      "27657": true,
      "27658": true,
      "27659": true,
      "27689": true,
      "27695": true,
      "27696": true,
      "27697": true,
      "27698": true,
      "27699": true
    },
    "LAMADRID": {
      "27700": true,
      "27701": true,
      "27702": true,
      "27703": true,
      "27704": true,
      "27705": true,
      "27706": true,
      "27707": true,
      "27708": true,
      "27709": true,
      "27710": true,
      "27711": true,
      "27712": true,
      "27713": true,
      "27714": true,
      "27715": true,
      "27716": true,
      "27717": true,
      "27718": true,
      "27719": true
    },
    "SACRAMENTO": {
      "27750": true,
      "27751": true,
      "27752": true,
      "27753": true,
      "27754": true,
      "27755": true,
      "27756": true,
      "27757": true,
      "27758": true,
      "27759": true,
      "27760": true,
      "27761": true,
      "27762": true,
      "27763": true,
      "27764": true,
      "27765": true,
      "27766": true,
      "27767": true,
      "27768": true,
      "27769": true,
      "27770": true,
      "27771": true,
      "27772": true,
      "27773": true,
      "27774": true,
      "27775": true,
      "27776": true,
      "27777": true,
      "27778": true,
      "27779": true,
      "27780": true,
      "27781": true,
      "27782": true,
      "27783": true,
      "27784": true,
      "27785": true,
      "27786": true,
      "27787": true,
      "27788": true,
      "27789": true,
      "27790": true,
      "27791": true,
      "27792": true,
      "27793": true,
      "27794": true,
      "27795": true,
      "27796": true,
      "27797": true,
      "27798": true,
      "27799": true
    },
    "SAN PEDRO": {
      "27800": true,
      "27801": true,
      "27802": true,
      "27803": true,
      "27804": true,
      "27805": true,
      "27806": true,
      "27807": true,
      "27808": true,
      "27809": true,
      "27810": true,
      "27811": true,
      "27812": true,
      "27813": true,
      "27814": true,
      "27815": true,
      "27816": true,
      "27817": true,
      "27818": true,
      "27819": true,
      "27820": true,
      "27821": true,
      "27822": true,
      "27823": true,
      "27824": true,
      "27825": true,
      "27826": true,
      "27827": true,
      "27828": true,
      "27829": true,
      "27830": true,
      "27831": true,
      "27832": true,
      "27833": true,
      "27834": true,
      "27835": true,
      "27836": true,
      "27837": true,
      "27838": true,
      "27839": true,
      "27840": true,
      "27841": true,
      "27842": true,
      "27843": true,
      "27844": true,
      "27845": true,
      "27846": true,
      "27847": true,
      "27848": true,
      "27849": true,
      "27850": true,
      "27851": true,
      "27852": true,
      "27853": true,
      "27854": true,
      "27855": true,
      "27856": true,
      "27857": true,
      "27858": true,
      "27859": true,
      "27860": true,
      "27861": true,
      "27862": true,
      "27863": true,
      "27864": true,
      "27865": true,
      "27866": true,
      "27867": true,
      "27868": true,
      "27869": true,
      "27870": true,
      "27871": true,
      "27872": true,
      "27873": true,
      "27874": true,
      "27875": true,
      "27876": true,
      "27877": true,
      "27878": true,
      "27879": true,
      "27880": true,
      "27881": true,
      "27882": true,
      "27883": true,
      "27884": true,
      "27885": true,
      "27886": true,
      "27887": true,
      "27888": true,
      "27889": true,
      "27890": true,
      "27891": true,
      "27892": true,
      "27893": true,
      "27894": true,
      "27895": true,
      "27896": true,
      "27897": true,
      "27898": true,
      "27899": true,
      "27940": true,
      "27941": true,
      "27942": true,
      "27943": true,
      "27944": true,
      "27945": true,
      "27946": true,
      "27947": true,
      "27950": true,
      "27951": true,
      "27952": true,
      "27953": true,
      "27954": true,
      "27955": true,
      "27956": true,
      "27957": true,
      "27958": true,
      "27959": true,
      "27960": true,
      "27961": true,
      "27962": true,
      "27963": true,
      "27964": true,
      "27966": true,
      "27970": true,
      "27971": true,
      "27972": true,
      "27973": true,
      "27974": true
    },
    "FRANCISCO I. MADERO": {
      "27900": true,
      "27901": true,
      "27902": true,
      "27903": true,
      "27904": true,
      "27905": true,
      "27906": true,
      "27907": true,
      "27908": true,
      "27909": true,
      "27910": true,
      "27911": true,
      "27912": true,
      "27913": true,
      "27914": true,
      "27915": true,
      "27916": true,
      "27917": true,
      "27918": true,
      "27919": true,
      "27923": true,
      "27924": true,
      "27925": true,
      "27926": true,
      "27933": true,
      "27935": true,
      "27937": true,
      "27938": true,
      "27939": true
    },
    "PARRAS": {
      "27980": true,
      "27981": true,
      "27982": true,
      "27983": true,
      "27984": true,
      "27985": true,
      "27986": true,
      "27987": true,
      "27988": true,
      "27989": true,
      "27990": true,
      "27992": true,
      "27995": true,
      "27996": true
    }
  },
  "COLIMA": {
    "COLIMA": {
      "28000": true,
      "28001": true,
      "28002": true,
      "28003": true,
      "28004": true,
      "28005": true,
      "28006": true,
      "28007": true,
      "28008": true,
      "28009": true,
      "28010": true,
      "28011": true,
      "28012": true,
      "28013": true,
      "28014": true,
      "28015": true,
      "28016": true,
      "28017": true,
      "28018": true,
      "28019": true,
      "28020": true,
      "28021": true,
      "28022": true,
      "28023": true,
      "28024": true,
      "28025": true,
      "28026": true,
      "28027": true,
      "28028": true,
      "28029": true,
      "28030": true,
      "28031": true,
      "28032": true,
      "28033": true,
      "28034": true,
      "28035": true,
      "28036": true,
      "28037": true,
      "28038": true,
      "28039": true,
      "28040": true,
      "28041": true,
      "28042": true,
      "28043": true,
      "28044": true,
      "28045": true,
      "28046": true,
      "28047": true,
      "28048": true,
      "28049": true,
      "28050": true,
      "28051": true,
      "28052": true,
      "28053": true,
      "28054": true,
      "28055": true,
      "28056": true,
      "28057": true,
      "28058": true,
      "28059": true,
      "28060": true,
      "28061": true,
      "28062": true,
      "28063": true,
      "28064": true,
      "28065": true,
      "28066": true,
      "28067": true,
      "28068": true,
      "28069": true,
      "28070": true,
      "28071": true,
      "28072": true,
      "28073": true,
      "28074": true,
      "28075": true,
      "28076": true,
      "28077": true,
      "28078": true,
      "28079": true,
      "28080": true,
      "28081": true,
      "28082": true,
      "28083": true,
      "28084": true,
      "28085": true,
      "28086": true,
      "28087": true,
      "28088": true,
      "28089": true,
      "28090": true,
      "28091": true,
      "28092": true,
      "28093": true,
      "28094": true,
      "28095": true,
      "28096": true,
      "28097": true,
      "28098": true,
      "28099": true,
      "28600": true,
      "28601": true,
      "28602": true,
      "28603": true,
      "28604": true,
      "28605": true,
      "28606": true,
      "28607": true,
      "28608": true,
      "28609": true,
      "28610": true,
      "28611": true,
      "28612": true,
      "28613": true,
      "28614": true,
      "28615": true,
      "28616": true,
      "28617": true,
      "28618": true,
      "28619": true,
      "28620": true,
      "28621": true,
      "28622": true,
      "28623": true,
      "28624": true,
      "28625": true,
      "28626": true,
      "28627": true,
      "28628": true,
      "28629": true,
      "28630": true,
      "28631": true,
      "28632": true,
      "28633": true,
      "28634": true,
      "28635": true,
      "28636": true,
      "28637": true,
      "28638": true,
      "28639": true,
      "28640": true,
      "28641": true,
      "28642": true,
      "28643": true,
      "28644": true,
      "28645": true,
      "28646": true,
      "28647": true,
      "28648": true,
      "28649": true,
      "28650": true,
      "28651": true,
      "28652": true,
      "28653": true,
      "28654": true,
      "28655": true,
      "28656": true,
      "28657": true,
      "28658": true,
      "28659": true,
      "28660": true,
      "28661": true,
      "28662": true,
      "28663": true,
      "28664": true,
      "28665": true,
      "28666": true,
      "28667": true,
      "28668": true,
      "28669": true,
      "28670": true,
      "28671": true,
      "28672": true,
      "28673": true,
      "28674": true,
      "28675": true,
      "28676": true,
      "28677": true,
      "28678": true,
      "28679": true,
      "28680": true,
      "28681": true,
      "28682": true,
      "28683": true,
      "28684": true,
      "28685": true,
      "28686": true,
      "28687": true,
      "28688": true,
      "28689": true,
      "28690": true,
      "28691": true,
      "28692": true,
      "28693": true,
      "28694": true,
      "28695": true,
      "28696": true,
      "28697": true,
      "28698": true,
      "28699": true
    },
    "TECOMAN": {
      "28100": true,
      "28101": true,
      "28102": true,
      "28103": true,
      "28104": true,
      "28105": true,
      "28106": true,
      "28107": true,
      "28108": true,
      "28109": true,
      "28110": true,
      "28111": true,
      "28112": true,
      "28113": true,
      "28114": true,
      "28115": true,
      "28116": true,
      "28117": true,
      "28118": true,
      "28119": true,
      "28120": true,
      "28121": true,
      "28122": true,
      "28123": true,
      "28124": true,
      "28125": true,
      "28126": true,
      "28127": true,
      "28128": true,
      "28129": true,
      "28130": true,
      "28131": true,
      "28132": true,
      "28133": true,
      "28134": true,
      "28135": true,
      "28136": true,
      "28137": true,
      "28138": true,
      "28139": true,
      "28140": true,
      "28141": true,
      "28142": true,
      "28143": true,
      "28144": true,
      "28145": true,
      "28146": true,
      "28147": true,
      "28148": true,
      "28149": true,
      "28150": true,
      "28151": true,
      "28152": true,
      "28153": true,
      "28154": true,
      "28155": true,
      "28156": true,
      "28157": true,
      "28158": true,
      "28159": true,
      "28160": true,
      "28161": true,
      "28162": true,
      "28163": true,
      "28164": true,
      "28165": true,
      "28166": true,
      "28167": true,
      "28168": true,
      "28169": true,
      "28170": true,
      "28171": true,
      "28172": true,
      "28173": true,
      "28174": true,
      "28175": true,
      "28176": true,
      "28177": true,
      "28178": true,
      "28179": true,
      "28180": true,
      "28181": true,
      "28182": true,
      "28183": true,
      "28184": true,
      "28185": true,
      "28186": true,
      "28187": true,
      "28188": true,
      "28189": true,
      "28190": true,
      "28191": true,
      "28192": true,
      "28193": true,
      "28194": true,
      "28195": true,
      "28196": true,
      "28197": true,
      "28198": true,
      "28199": true,
      "28900": true,
      "28901": true,
      "28902": true,
      "28903": true,
      "28904": true,
      "28905": true,
      "28906": true,
      "28907": true,
      "28908": true,
      "28909": true,
      "28910": true,
      "28911": true,
      "28912": true,
      "28913": true,
      "28914": true,
      "28915": true,
      "28916": true,
      "28917": true,
      "28918": true,
      "28919": true,
      "28920": true,
      "28921": true,
      "28922": true,
      "28930": true,
      "28931": true,
      "28932": true,
      "28933": true,
      "28934": true,
      "28935": true,
      "28936": true,
      "28937": true,
      "28938": true,
      "28939": true,
      "28944": true
    },
    "MANZANILLO": {
      "28200": true,
      "28201": true,
      "28202": true,
      "28203": true,
      "28204": true,
      "28205": true,
      "28206": true,
      "28207": true,
      "28208": true,
      "28218": true,
      "28219": true,
      "28220": true,
      "28221": true,
      "28222": true,
      "28223": true,
      "28224": true,
      "28225": true,
      "28226": true,
      "28227": true,
      "28228": true,
      "28229": true,
      "28230": true,
      "28231": true,
      "28232": true,
      "28233": true,
      "28234": true,
      "28235": true,
      "28236": true,
      "28237": true,
      "28238": true,
      "28239": true,
      "28240": true,
      "28241": true,
      "28242": true,
      "28243": true,
      "28244": true,
      "28245": true,
      "28246": true,
      "28247": true,
      "28248": true,
      "28249": true,
      "28250": true,
      "28251": true,
      "28252": true,
      "28253": true,
      "28254": true,
      "28255": true,
      "28256": true,
      "28257": true,
      "28258": true,
      "28259": true,
      "28260": true,
      "28261": true,
      "28262": true,
      "28263": true,
      "28264": true,
      "28265": true,
      "28266": true,
      "28267": true,
      "28268": true,
      "28269": true,
      "28270": true,
      "28271": true,
      "28272": true,
      "28273": true,
      "28274": true,
      "28275": true,
      "28276": true,
      "28277": true,
      "28278": true,
      "28279": true,
      "28280": true,
      "28281": true,
      "28282": true,
      "28283": true,
      "28284": true,
      "28285": true,
      "28286": true,
      "28287": true,
      "28288": true,
      "28289": true,
      "28290": true,
      "28291": true,
      "28292": true,
      "28293": true,
      "28294": true,
      "28295": true,
      "28296": true,
      "28297": true,
      "28298": true,
      "28299": true,
      "28800": true,
      "28801": true,
      "28802": true,
      "28803": true,
      "28804": true,
      "28805": true,
      "28806": true,
      "28808": true,
      "28809": true,
      "28820": true,
      "28821": true,
      "28822": true,
      "28823": true,
      "28824": true,
      "28825": true,
      "28830": true,
      "28831": true,
      "28832": true,
      "28836": true,
      "28837": true,
      "28840": true,
      "28841": true,
      "28842": true,
      "28843": true,
      "28844": true,
      "28845": true,
      "28846": true,
      "28847": true,
      "28848": true,
      "28849": true,
      "28860": true,
      "28861": true,
      "28862": true,
      "28863": true,
      "28864": true,
      "28865": true,
      "28866": true,
      "28867": true,
      "28868": true,
      "28869": true,
      "28870": true,
      "28871": true,
      "28872": true,
      "28873": true,
      "28874": true,
      "28875": true,
      "28876": true,
      "28877": true,
      "28878": true,
      "28879": true,
      "28880": true,
      "28881": true,
      "28882": true,
      "28883": true,
      "28884": true
    },
    "ARMERIA": {
      "28300": true,
      "28301": true,
      "28302": true,
      "28303": true,
      "28304": true,
      "28305": true,
      "28306": true,
      "28307": true,
      "28308": true,
      "28309": true,
      "28310": true,
      "28311": true,
      "28312": true,
      "28313": true,
      "28314": true,
      "28315": true,
      "28316": true,
      "28317": true,
      "28318": true,
      "28319": true,
      "28320": true,
      "28321": true,
      "28322": true,
      "28323": true,
      "28324": true,
      "28325": true,
      "28326": true,
      "28327": true,
      "28328": true,
      "28329": true,
      "28330": true,
      "28331": true,
      "28332": true,
      "28333": true,
      "28334": true,
      "28335": true,
      "28336": true,
      "28337": true,
      "28338": true,
      "28339": true,
      "28340": true,
      "28341": true,
      "28342": true,
      "28343": true,
      "28344": true,
      "28345": true,
      "28346": true,
      "28347": true,
      "28348": true,
      "28349": true,
      "28350": true,
      "28351": true,
      "28352": true,
      "28353": true,
      "28354": true,
      "28355": true,
      "28356": true,
      "28357": true,
      "28358": true,
      "28359": true,
      "28360": true,
      "28361": true,
      "28362": true,
      "28363": true,
      "28364": true,
      "28365": true,
      "28366": true,
      "28367": true,
      "28368": true,
      "28369": true,
      "28370": true,
      "28371": true,
      "28372": true,
      "28373": true,
      "28374": true,
      "28375": true,
      "28376": true,
      "28377": true,
      "28378": true,
      "28379": true,
      "28380": true,
      "28381": true,
      "28382": true,
      "28383": true,
      "28384": true,
      "28385": true,
      "28386": true,
      "28387": true,
      "28388": true,
      "28389": true,
      "28390": true,
      "28391": true,
      "28392": true,
      "28393": true,
      "28394": true,
      "28395": true,
      "28396": true,
      "28397": true,
      "28398": true,
      "28399": true
    },
    "COQUIMATLAN": {
      "28400": true,
      "28401": true,
      "28402": true,
      "28403": true,
      "28404": true,
      "28405": true,
      "28406": true,
      "28407": true,
      "28408": true,
      "28409": true,
      "28410": true,
      "28411": true,
      "28412": true,
      "28413": true,
      "28414": true,
      "28415": true,
      "28416": true,
      "28417": true,
      "28418": true,
      "28419": true,
      "28420": true,
      "28421": true,
      "28422": true,
      "28423": true,
      "28424": true,
      "28425": true,
      "28426": true,
      "28427": true,
      "28428": true,
      "28429": true,
      "28430": true,
      "28431": true,
      "28432": true,
      "28433": true,
      "28434": true,
      "28435": true,
      "28436": true,
      "28437": true,
      "28438": true,
      "28439": true,
      "28440": true,
      "28441": true,
      "28442": true,
      "28443": true,
      "28444": true,
      "28445": true,
      "28446": true,
      "28447": true,
      "28448": true,
      "28449": true
    },
    "COMALA": {
      "28450": true,
      "28451": true,
      "28452": true,
      "28453": true,
      "28454": true,
      "28455": true,
      "28456": true,
      "28457": true,
      "28458": true,
      "28459": true,
      "28460": true,
      "28461": true,
      "28462": true,
      "28463": true,
      "28464": true,
      "28465": true,
      "28466": true,
      "28467": true,
      "28468": true,
      "28469": true,
      "28470": true,
      "28471": true,
      "28472": true,
      "28473": true,
      "28474": true,
      "28475": true,
      "28476": true,
      "28477": true,
      "28478": true,
      "28479": true,
      "28480": true,
      "28481": true,
      "28482": true,
      "28483": true,
      "28484": true,
      "28485": true,
      "28486": true,
      "28487": true,
      "28488": true,
      "28489": true,
      "28490": true,
      "28491": true,
      "28492": true,
      "28493": true,
      "28494": true,
      "28495": true,
      "28496": true,
      "28497": true,
      "28498": true,
      "28499": true
    },
    "CUAUHTEMOC": {
      "28500": true,
      "28501": true,
      "28502": true,
      "28503": true,
      "28504": true,
      "28505": true,
      "28506": true,
      "28507": true,
      "28508": true,
      "28509": true,
      "28510": true,
      "28511": true,
      "28512": true,
      "28513": true,
      "28514": true,
      "28515": true,
      "28516": true,
      "28517": true,
      "28518": true,
      "28519": true,
      "28520": true,
      "28521": true,
      "28522": true,
      "28523": true,
      "28524": true,
      "28525": true,
      "28526": true,
      "28527": true,
      "28528": true,
      "28529": true,
      "28530": true,
      "28531": true,
      "28532": true,
      "28533": true,
      "28534": true,
      "28535": true,
      "28536": true,
      "28537": true,
      "28538": true,
      "28539": true,
      "28540": true,
      "28541": true,
      "28542": true,
      "28543": true,
      "28544": true,
      "28545": true,
      "28546": true,
      "28547": true,
      "28548": true,
      "28549": true,
      "28550": true,
      "28551": true,
      "28552": true,
      "28553": true,
      "28554": true,
      "28555": true,
      "28556": true,
      "28557": true,
      "28558": true,
      "28559": true,
      "28560": true,
      "28561": true,
      "28562": true,
      "28563": true,
      "28564": true,
      "28565": true,
      "28566": true,
      "28567": true,
      "28568": true,
      "28569": true,
      "28570": true,
      "28571": true,
      "28572": true,
      "28573": true,
      "28574": true,
      "28575": true,
      "28576": true,
      "28577": true,
      "28578": true,
      "28579": true,
      "28580": true,
      "28581": true,
      "28582": true,
      "28583": true,
      "28584": true,
      "28585": true,
      "28586": true,
      "28587": true,
      "28588": true,
      "28589": true,
      "28590": true,
      "28591": true,
      "28592": true,
      "28593": true,
      "28594": true,
      "28595": true,
      "28596": true,
      "28599": true
    },
    "IXTLAHUACAN": {
      "28700": true,
      "28701": true,
      "28702": true,
      "28703": true,
      "28704": true,
      "28705": true,
      "28706": true,
      "28707": true,
      "28708": true,
      "28709": true,
      "28710": true,
      "28711": true,
      "28712": true,
      "28713": true,
      "28714": true,
      "28715": true,
      "28716": true,
      "28717": true,
      "28718": true,
      "28719": true,
      "28720": true,
      "28721": true,
      "28722": true,
      "28723": true,
      "28724": true,
      "28725": true,
      "28726": true,
      "28727": true,
      "28728": true,
      "28729": true,
      "28730": true,
      "28731": true,
      "28732": true,
      "28735": true
    },
    "VILLA DE ALVAREZ": {
      "28950": true,
      "28951": true,
      "28952": true,
      "28953": true,
      "28954": true,
      "28955": true,
      "28956": true,
      "28957": true,
      "28958": true,
      "28959": true,
      "28960": true,
      "28961": true,
      "28962": true,
      "28963": true,
      "28964": true,
      "28965": true,
      "28966": true,
      "28967": true,
      "28968": true,
      "28969": true,
      "28970": true,
      "28971": true,
      "28972": true,
      "28973": true,
      "28974": true,
      "28975": true,
      "28976": true,
      "28977": true,
      "28978": true,
      "28979": true,
      "28980": true,
      "28981": true,
      "28982": true,
      "28983": true,
      "28984": true,
      "28985": true,
      "28986": true,
      "28987": true,
      "28988": true,
      "28989": true,
      "28990": true,
      "28991": true,
      "28992": true,
      "28993": true,
      "28994": true,
      "28995": true,
      "28996": true,
      "28997": true,
      "28998": true,
      "28999": true
    }
  },
  "CHIHUAHUA": {
    "CHIHUAHUA": {
      "31000": true,
      "31001": true,
      "31002": true,
      "31003": true,
      "31004": true,
      "31005": true,
      "31006": true,
      "31007": true,
      "31008": true,
      "31009": true,
      "31010": true,
      "31011": true,
      "31012": true,
      "31013": true,
      "31014": true,
      "31015": true,
      "31016": true,
      "31017": true,
      "31018": true,
      "31019": true,
      "31020": true,
      "31021": true,
      "31022": true,
      "31023": true,
      "31024": true,
      "31025": true,
      "31026": true,
      "31027": true,
      "31028": true,
      "31029": true,
      "31030": true,
      "31031": true,
      "31032": true,
      "31033": true,
      "31034": true,
      "31035": true,
      "31036": true,
      "31037": true,
      "31038": true,
      "31039": true,
      "31040": true,
      "31041": true,
      "31042": true,
      "31043": true,
      "31044": true,
      "31045": true,
      "31046": true,
      "31047": true,
      "31048": true,
      "31049": true,
      "31050": true,
      "31051": true,
      "31052": true,
      "31053": true,
      "31054": true,
      "31055": true,
      "31056": true,
      "31057": true,
      "31058": true,
      "31059": true,
      "31060": true,
      "31061": true,
      "31062": true,
      "31063": true,
      "31064": true,
      "31065": true,
      "31066": true,
      "31067": true,
      "31068": true,
      "31069": true,
      "31070": true,
      "31071": true,
      "31072": true,
      "31073": true,
      "31074": true,
      "31075": true,
      "31076": true,
      "31077": true,
      "31078": true,
      "31079": true,
      "31080": true,
      "31081": true,
      "31082": true,
      "31083": true,
      "31084": true,
      "31085": true,
      "31086": true,
      "31087": true,
      "31088": true,
      "31089": true,
      "31090": true,
      "31091": true,
      "31092": true,
      "31093": true,
      "31094": true,
      "31095": true,
      "31096": true,
      "31097": true,
      "31098": true,
      "31099": true,
      "31100": true,
      "31101": true,
      "31102": true,
      "31103": true,
      "31104": true,
      "31105": true,
      "31106": true,
      "31107": true,
      "31108": true,
      "31109": true,
      "31110": true,
      "31111": true,
      "31112": true,
      "31113": true,
      "31114": true,
      "31115": true,
      "31116": true,
      "31117": true,
      "31118": true,
      "31119": true,
      "31120": true,
      "31121": true,
      "31122": true,
      "31123": true,
      "31124": true,
      "31125": true,
      "31126": true,
      "31127": true,
      "31128": true,
      "31129": true,
      "31130": true,
      "31131": true,
      "31132": true,
      "31133": true,
      "31134": true,
      "31135": true,
      "31136": true,
      "31137": true,
      "31138": true,
      "31139": true,
      "31140": true,
      "31141": true,
      "31142": true,
      "31143": true,
      "31144": true,
      "31145": true,
      "31146": true,
      "31147": true,
      "31148": true,
      "31149": true,
      "31150": true,
      "31151": true,
      "31152": true,
      "31153": true,
      "31154": true,
      "31155": true,
      "31156": true,
      "31157": true,
      "31158": true,
      "31159": true,
      "31160": true,
      "31161": true,
      "31162": true,
      "31163": true,
      "31164": true,
      "31165": true,
      "31166": true,
      "31167": true,
      "31168": true,
      "31169": true,
      "31170": true,
      "31171": true,
      "31172": true,
      "31173": true,
      "31174": true,
      "31175": true,
      "31176": true,
      "31177": true,
      "31178": true,
      "31179": true,
      "31180": true,
      "31181": true,
      "31182": true,
      "31183": true,
      "31184": true,
      "31185": true,
      "31186": true,
      "31187": true,
      "31188": true,
      "31189": true,
      "31190": true,
      "31191": true,
      "31192": true,
      "31193": true,
      "31194": true,
      "31195": true,
      "31196": true,
      "31197": true,
      "31198": true,
      "31199": true,
      "31200": true,
      "31201": true,
      "31202": true,
      "31203": true,
      "31204": true,
      "31205": true,
      "31206": true,
      "31207": true,
      "31208": true,
      "31209": true,
      "31210": true,
      "31211": true,
      "31212": true,
      "31213": true,
      "31214": true,
      "31215": true,
      "31216": true,
      "31217": true,
      "31218": true,
      "31219": true,
      "31220": true,
      "31221": true,
      "31222": true,
      "31223": true,
      "31224": true,
      "31225": true,
      "31226": true,
      "31227": true,
      "31228": true,
      "31229": true,
      "31230": true,
      "31231": true,
      "31232": true,
      "31233": true,
      "31234": true,
      "31235": true,
      "31236": true,
      "31237": true,
      "31238": true,
      "31239": true,
      "31240": true,
      "31241": true,
      "31242": true,
      "31243": true,
      "31244": true,
      "31245": true,
      "31246": true,
      "31247": true,
      "31248": true,
      "31249": true,
      "31250": true,
      "31251": true,
      "31252": true,
      "31253": true,
      "31254": true,
      "31255": true,
      "31256": true,
      "31257": true,
      "31258": true,
      "31259": true,
      "31260": true,
      "31261": true,
      "31262": true,
      "31263": true,
      "31264": true,
      "31265": true,
      "31266": true,
      "31267": true,
      "31268": true,
      "31269": true,
      "31270": true,
      "31271": true,
      "31272": true,
      "31273": true,
      "31274": true,
      "31275": true,
      "31276": true,
      "31277": true,
      "31278": true,
      "31279": true,
      "31280": true,
      "31281": true,
      "31282": true,
      "31283": true,
      "31284": true,
      "31285": true,
      "31286": true,
      "31287": true,
      "31288": true,
      "31289": true,
      "31290": true,
      "31291": true,
      "31292": true,
      "31293": true,
      "31294": true,
      "31295": true,
      "31296": true,
      "31297": true,
      "31298": true,
      "31299": true,
      "31300": true,
      "31301": true,
      "31302": true,
      "31303": true,
      "31304": true,
      "31305": true,
      "31306": true,
      "31307": true,
      "31308": true,
      "31309": true,
      "31310": true,
      "31311": true,
      "31312": true,
      "31313": true,
      "31314": true,
      "31315": true,
      "31316": true,
      "31317": true,
      "31318": true,
      "31319": true,
      "31320": true,
      "31321": true,
      "31322": true,
      "31323": true,
      "31324": true,
      "31325": true,
      "31326": true,
      "31327": true,
      "31328": true,
      "31329": true,
      "31330": true,
      "31331": true,
      "31332": true,
      "31333": true,
      "31334": true,
      "31335": true,
      "31336": true,
      "31337": true,
      "31338": true,
      "31339": true,
      "31340": true,
      "31341": true,
      "31342": true,
      "31343": true,
      "31344": true,
      "31345": true,
      "31346": true,
      "31347": true,
      "31348": true,
      "31349": true,
      "31350": true,
      "31351": true,
      "31352": true,
      "31353": true,
      "31354": true,
      "31355": true,
      "31356": true,
      "31357": true,
      "31358": true,
      "31359": true,
      "31360": true,
      "31361": true,
      "31362": true,
      "31363": true,
      "31364": true,
      "31365": true,
      "31366": true,
      "31367": true,
      "31368": true,
      "31369": true,
      "31370": true,
      "31371": true,
      "31372": true,
      "31373": true,
      "31374": true,
      "31375": true,
      "31376": true,
      "31377": true,
      "31378": true,
      "31379": true,
      "31380": true,
      "31381": true,
      "31382": true,
      "31383": true,
      "31384": true,
      "31385": true,
      "31386": true,
      "31387": true,
      "31388": true,
      "31389": true,
      "31390": true,
      "31391": true,
      "31392": true,
      "31393": true,
      "31394": true,
      "31395": true,
      "31396": true,
      "31397": true,
      "31398": true,
      "31399": true,
      "31400": true,
      "31401": true,
      "31402": true,
      "31403": true,
      "31404": true,
      "31405": true,
      "31406": true,
      "31407": true,
      "31408": true,
      "31409": true,
      "31410": true,
      "31411": true,
      "31412": true,
      "31413": true,
      "31414": true,
      "31415": true,
      "31416": true,
      "31417": true,
      "31418": true,
      "31419": true,
      "31420": true,
      "31421": true,
      "31422": true,
      "31423": true,
      "31424": true,
      "31425": true,
      "31426": true,
      "31427": true,
      "31428": true,
      "31429": true,
      "31430": true,
      "31431": true,
      "31432": true,
      "31433": true,
      "31434": true,
      "31435": true,
      "31436": true,
      "31437": true,
      "31438": true,
      "31439": true,
      "31440": true,
      "31441": true,
      "31442": true,
      "31443": true,
      "31444": true,
      "31445": true,
      "31446": true,
      "31447": true,
      "31448": true,
      "31449": true,
      "31450": true,
      "31451": true,
      "31452": true,
      "31453": true,
      "31454": true,
      "31455": true,
      "31456": true,
      "31457": true,
      "31458": true,
      "31459": true,
      "31460": true,
      "31461": true,
      "31462": true,
      "31463": true,
      "31464": true,
      "31465": true,
      "31466": true,
      "31467": true,
      "31468": true,
      "31469": true,
      "31470": true,
      "31471": true,
      "31472": true,
      "31473": true,
      "31474": true,
      "31475": true,
      "31476": true,
      "31477": true,
      "31478": true,
      "31479": true,
      "31480": true,
      "31481": true,
      "31482": true,
      "31483": true,
      "31484": true,
      "31485": true,
      "31486": true,
      "31487": true,
      "31488": true,
      "31489": true,
      "31490": true,
      "31491": true,
      "31492": true,
      "31493": true,
      "31494": true,
      "31495": true,
      "31496": true,
      "31497": true,
      "31498": true,
      "31499": true,
      "31620": true,
      "31621": true,
      "31622": true,
      "31623": true,
      "31624": true,
      "31625": true,
      "31626": true,
      "31627": true,
      "31628": true,
      "31629": true,
      "31630": true,
      "31631": true,
      "31632": true,
      "31633": true,
      "31634": true,
      "31635": true,
      "31636": true,
      "31637": true,
      "31638": true,
      "31639": true
    },
    "CUAUHTEMOC": {
      "31500": true,
      "31501": true,
      "31502": true,
      "31503": true,
      "31504": true,
      "31505": true,
      "31506": true,
      "31507": true,
      "31508": true,
      "31509": true,
      "31510": true,
      "31511": true,
      "31512": true,
      "31513": true,
      "31514": true,
      "31515": true,
      "31516": true,
      "31517": true,
      "31518": true,
      "31519": true,
      "31520": true,
      "31521": true,
      "31522": true,
      "31523": true,
      "31524": true,
      "31525": true,
      "31526": true,
      "31527": true,
      "31528": true,
      "31529": true,
      "31530": true,
      "31531": true,
      "31532": true,
      "31533": true,
      "31534": true,
      "31535": true,
      "31536": true,
      "31537": true,
      "31538": true,
      "31539": true,
      "31540": true,
      "31541": true,
      "31542": true,
      "31543": true,
      "31544": true,
      "31545": true,
      "31546": true,
      "31547": true,
      "31548": true,
      "31549": true,
      "31550": true,
      "31551": true,
      "31552": true,
      "31553": true,
      "31554": true,
      "31555": true,
      "31556": true,
      "31557": true,
      "31558": true,
      "31559": true,
      "31560": true,
      "31561": true,
      "31562": true,
      "31563": true,
      "31564": true,
      "31565": true,
      "31566": true,
      "31567": true,
      "31568": true,
      "31569": true,
      "31570": true,
      "31571": true,
      "31572": true,
      "31573": true,
      "31574": true,
      "31575": true,
      "31576": true,
      "31577": true,
      "31578": true,
      "31579": true,
      "31580": true,
      "31581": true,
      "31582": true,
      "31583": true,
      "31584": true,
      "31585": true,
      "31586": true,
      "31587": true,
      "31588": true,
      "31589": true,
      "31590": true,
      "31591": true,
      "31592": true,
      "31593": true,
      "31594": true,
      "31595": true,
      "31596": true,
      "31597": true,
      "31598": true,
      "31599": true,
      "31600": true,
      "31601": true,
      "31602": true,
      "31603": true,
      "31604": true,
      "31605": true,
      "31606": true,
      "31607": true,
      "31608": true,
      "31609": true,
      "31610": true,
      "31613": true,
      "31614": true,
      "31615": true,
      "31616": true,
      "31617": true,
      "31618": true,
      "31619": true
    },
    "RIVA PALACIO": {
      "31640": true,
      "31641": true,
      "31642": true,
      "31644": true,
      "31645": true,
      "31646": true,
      "31647": true,
      "31648": true,
      "31649": true
    },
    "AQUILES SERDAN": {
      "31650": true,
      "31651": true,
      "31653": true,
      "31654": true,
      "31655": true,
      "31656": true,
      "31657": true,
      "31658": true,
      "31659": true
    },
    "GUERRERO": {
      "31680": true,
      "31681": true,
      "31682": true,
      "31684": true,
      "31685": true,
      "31686": true,
      "31687": true,
      "31688": true,
      "31689": true,
      "31690": true,
      "31691": true,
      "31692": true,
      "31693": true,
      "31696": true,
      "31698": true
    },
    "ASCENSION": {
      "31820": true,
      "31821": true,
      "31822": true,
      "31823": true,
      "31824": true,
      "31825": true,
      "31826": true,
      "31827": true,
      "31830": true,
      "31832": true,
      "31833": true,
      "31834": true,
      "31835": true,
      "31836": true,
      "31837": true,
      "31838": true,
      "31839": true
    },
    "BUENAVENTURA": {
      "31880": true,
      "31884": true,
      "31886": true,
      "31887": true,
      "31888": true,
      "31889": true,
      "31890": true,
      "31891": true,
      "31892": true,
      "31893": true,
      "31894": true,
      "31895": true,
      "31896": true,
      "31897": true,
      "31898": true,
      "31899": true
    },
    "MADERA": {
      "31940": true,
      "31941": true,
      "31942": true,
      "31943": true,
      "31953": true,
      "31955": true,
      "31957": true,
      "31958": true
    },
    "NAMIQUIPA": {
      "31960": true,
      "31961": true,
      "31963": true,
      "31964": true,
      "31967": true,
      "31968": true,
      "31969": true,
      "31975": true,
      "31978": true
    },
    "JUÁREZ": {
      "32000": true,
      "32001": true,
      "32002": true,
      "32003": true,
      "32004": true,
      "32005": true,
      "32006": true,
      "32007": true,
      "32008": true,
      "32009": true,
      "32010": true,
      "32011": true,
      "32012": true,
      "32013": true,
      "32014": true,
      "32015": true,
      "32016": true,
      "32017": true,
      "32018": true,
      "32019": true,
      "32020": true,
      "32021": true,
      "32022": true,
      "32023": true,
      "32024": true,
      "32025": true,
      "32026": true,
      "32027": true,
      "32028": true,
      "32029": true,
      "32030": true,
      "32031": true,
      "32032": true,
      "32033": true,
      "32034": true,
      "32035": true,
      "32036": true,
      "32037": true,
      "32038": true,
      "32039": true,
      "32040": true,
      "32041": true,
      "32042": true,
      "32043": true,
      "32044": true,
      "32045": true,
      "32046": true,
      "32047": true,
      "32048": true,
      "32049": true,
      "32050": true,
      "32051": true,
      "32052": true,
      "32053": true,
      "32054": true,
      "32055": true,
      "32056": true,
      "32057": true,
      "32058": true,
      "32059": true,
      "32060": true,
      "32061": true,
      "32062": true,
      "32063": true,
      "32064": true,
      "32065": true,
      "32066": true,
      "32067": true,
      "32068": true,
      "32069": true,
      "32070": true,
      "32071": true,
      "32072": true,
      "32073": true,
      "32074": true,
      "32075": true,
      "32076": true,
      "32077": true,
      "32078": true,
      "32079": true,
      "32080": true,
      "32081": true,
      "32082": true,
      "32083": true,
      "32084": true,
      "32085": true,
      "32086": true,
      "32087": true,
      "32088": true,
      "32089": true,
      "32090": true,
      "32091": true,
      "32092": true,
      "32093": true,
      "32094": true,
      "32095": true,
      "32096": true,
      "32097": true,
      "32098": true,
      "32099": true,
      "32100": true,
      "32101": true,
      "32102": true,
      "32103": true,
      "32104": true,
      "32105": true,
      "32106": true,
      "32107": true,
      "32108": true,
      "32109": true,
      "32110": true,
      "32111": true,
      "32112": true,
      "32113": true,
      "32114": true,
      "32115": true,
      "32116": true,
      "32117": true,
      "32118": true,
      "32119": true,
      "32120": true,
      "32121": true,
      "32122": true,
      "32123": true,
      "32124": true,
      "32125": true,
      "32126": true,
      "32127": true,
      "32128": true,
      "32129": true,
      "32130": true,
      "32131": true,
      "32132": true,
      "32133": true,
      "32134": true,
      "32135": true,
      "32136": true,
      "32137": true,
      "32138": true,
      "32139": true,
      "32140": true,
      "32141": true,
      "32142": true,
      "32143": true,
      "32144": true,
      "32145": true,
      "32146": true,
      "32147": true,
      "32148": true,
      "32149": true,
      "32150": true,
      "32151": true,
      "32152": true,
      "32153": true,
      "32154": true,
      "32155": true,
      "32156": true,
      "32157": true,
      "32158": true,
      "32159": true,
      "32160": true,
      "32161": true,
      "32162": true,
      "32163": true,
      "32164": true,
      "32165": true,
      "32166": true,
      "32167": true,
      "32168": true,
      "32169": true,
      "32170": true,
      "32171": true,
      "32172": true,
      "32173": true,
      "32174": true,
      "32175": true,
      "32176": true,
      "32177": true,
      "32178": true,
      "32179": true,
      "32180": true,
      "32181": true,
      "32182": true,
      "32183": true,
      "32184": true,
      "32185": true,
      "32186": true,
      "32187": true,
      "32188": true,
      "32189": true,
      "32190": true,
      "32191": true,
      "32192": true,
      "32193": true,
      "32194": true,
      "32195": true,
      "32196": true,
      "32197": true,
      "32198": true,
      "32199": true,
      "32200": true,
      "32201": true,
      "32202": true,
      "32203": true,
      "32204": true,
      "32205": true,
      "32206": true,
      "32207": true,
      "32208": true,
      "32209": true,
      "32210": true,
      "32211": true,
      "32212": true,
      "32213": true,
      "32214": true,
      "32215": true,
      "32216": true,
      "32217": true,
      "32218": true,
      "32219": true,
      "32220": true,
      "32221": true,
      "32222": true,
      "32223": true,
      "32224": true,
      "32225": true,
      "32226": true,
      "32227": true,
      "32228": true,
      "32229": true,
      "32230": true,
      "32231": true,
      "32232": true,
      "32233": true,
      "32234": true,
      "32235": true,
      "32236": true,
      "32237": true,
      "32238": true,
      "32239": true,
      "32240": true,
      "32241": true,
      "32242": true,
      "32243": true,
      "32244": true,
      "32245": true,
      "32246": true,
      "32247": true,
      "32248": true,
      "32249": true,
      "32250": true,
      "32251": true,
      "32252": true,
      "32253": true,
      "32254": true,
      "32255": true,
      "32256": true,
      "32257": true,
      "32258": true,
      "32259": true,
      "32260": true,
      "32261": true,
      "32262": true,
      "32263": true,
      "32264": true,
      "32265": true,
      "32266": true,
      "32267": true,
      "32268": true,
      "32269": true,
      "32270": true,
      "32271": true,
      "32272": true,
      "32273": true,
      "32274": true,
      "32275": true,
      "32276": true,
      "32277": true,
      "32278": true,
      "32279": true,
      "32280": true,
      "32281": true,
      "32282": true,
      "32283": true,
      "32284": true,
      "32285": true,
      "32286": true,
      "32287": true,
      "32288": true,
      "32289": true,
      "32290": true,
      "32291": true,
      "32292": true,
      "32293": true,
      "32294": true,
      "32295": true,
      "32296": true,
      "32297": true,
      "32298": true,
      "32299": true,
      "32300": true,
      "32301": true,
      "32302": true,
      "32303": true,
      "32304": true,
      "32305": true,
      "32306": true,
      "32307": true,
      "32308": true,
      "32309": true,
      "32310": true,
      "32311": true,
      "32312": true,
      "32313": true,
      "32314": true,
      "32315": true,
      "32316": true,
      "32317": true,
      "32318": true,
      "32319": true,
      "32320": true,
      "32321": true,
      "32322": true,
      "32323": true,
      "32324": true,
      "32325": true,
      "32326": true,
      "32327": true,
      "32328": true,
      "32329": true,
      "32330": true,
      "32331": true,
      "32332": true,
      "32333": true,
      "32334": true,
      "32335": true,
      "32336": true,
      "32337": true,
      "32338": true,
      "32339": true,
      "32340": true,
      "32341": true,
      "32342": true,
      "32343": true,
      "32344": true,
      "32345": true,
      "32346": true,
      "32347": true,
      "32348": true,
      "32349": true,
      "32350": true,
      "32351": true,
      "32352": true,
      "32353": true,
      "32354": true,
      "32355": true,
      "32356": true,
      "32357": true,
      "32358": true,
      "32359": true,
      "32360": true,
      "32361": true,
      "32362": true,
      "32363": true,
      "32364": true,
      "32365": true,
      "32366": true,
      "32367": true,
      "32368": true,
      "32369": true,
      "32370": true,
      "32371": true,
      "32372": true,
      "32373": true,
      "32374": true,
      "32375": true,
      "32376": true,
      "32377": true,
      "32378": true,
      "32379": true,
      "32380": true,
      "32381": true,
      "32382": true,
      "32383": true,
      "32384": true,
      "32385": true,
      "32386": true,
      "32387": true,
      "32388": true,
      "32389": true,
      "32390": true,
      "32391": true,
      "32392": true,
      "32393": true,
      "32394": true,
      "32395": true,
      "32396": true,
      "32397": true,
      "32398": true,
      "32399": true,
      "32400": true,
      "32401": true,
      "32402": true,
      "32403": true,
      "32404": true,
      "32405": true,
      "32406": true,
      "32407": true,
      "32408": true,
      "32409": true,
      "32410": true,
      "32411": true,
      "32412": true,
      "32413": true,
      "32414": true,
      "32415": true,
      "32416": true,
      "32417": true,
      "32418": true,
      "32419": true,
      "32420": true,
      "32421": true,
      "32422": true,
      "32423": true,
      "32424": true,
      "32425": true,
      "32426": true,
      "32427": true,
      "32428": true,
      "32429": true,
      "32430": true,
      "32431": true,
      "32432": true,
      "32433": true,
      "32434": true,
      "32435": true,
      "32436": true,
      "32437": true,
      "32438": true,
      "32439": true,
      "32440": true,
      "32441": true,
      "32442": true,
      "32443": true,
      "32444": true,
      "32445": true,
      "32446": true,
      "32447": true,
      "32448": true,
      "32449": true,
      "32450": true,
      "32451": true,
      "32452": true,
      "32453": true,
      "32454": true,
      "32455": true,
      "32456": true,
      "32457": true,
      "32458": true,
      "32459": true,
      "32460": true,
      "32461": true,
      "32462": true,
      "32463": true,
      "32464": true,
      "32465": true,
      "32466": true,
      "32467": true,
      "32468": true,
      "32469": true,
      "32470": true,
      "32471": true,
      "32472": true,
      "32473": true,
      "32474": true,
      "32475": true,
      "32476": true,
      "32477": true,
      "32478": true,
      "32479": true,
      "32480": true,
      "32481": true,
      "32482": true,
      "32483": true,
      "32484": true,
      "32485": true,
      "32486": true,
      "32487": true,
      "32488": true,
      "32489": true,
      "32490": true,
      "32491": true,
      "32492": true,
      "32493": true,
      "32494": true,
      "32495": true,
      "32496": true,
      "32497": true,
      "32498": true,
      "32499": true,
      "32500": true,
      "32501": true,
      "32502": true,
      "32503": true,
      "32504": true,
      "32505": true,
      "32506": true,
      "32507": true,
      "32508": true,
      "32509": true,
      "32510": true,
      "32511": true,
      "32512": true,
      "32513": true,
      "32514": true,
      "32515": true,
      "32516": true,
      "32517": true,
      "32518": true,
      "32519": true,
      "32520": true,
      "32521": true,
      "32522": true,
      "32523": true,
      "32524": true,
      "32525": true,
      "32526": true,
      "32527": true,
      "32528": true,
      "32529": true,
      "32530": true,
      "32531": true,
      "32532": true,
      "32533": true,
      "32534": true,
      "32535": true,
      "32536": true,
      "32537": true,
      "32538": true,
      "32539": true,
      "32540": true,
      "32541": true,
      "32542": true,
      "32543": true,
      "32544": true,
      "32545": true,
      "32546": true,
      "32547": true,
      "32548": true,
      "32549": true,
      "32550": true,
      "32551": true,
      "32552": true,
      "32553": true,
      "32554": true,
      "32555": true,
      "32556": true,
      "32557": true,
      "32558": true,
      "32559": true,
      "32560": true,
      "32561": true,
      "32562": true,
      "32563": true,
      "32564": true,
      "32565": true,
      "32566": true,
      "32567": true,
      "32568": true,
      "32569": true,
      "32570": true,
      "32571": true,
      "32572": true,
      "32573": true,
      "32574": true,
      "32575": true,
      "32576": true,
      "32577": true,
      "32578": true,
      "32579": true,
      "32580": true,
      "32581": true,
      "32582": true,
      "32583": true,
      "32584": true,
      "32585": true,
      "32586": true,
      "32587": true,
      "32588": true,
      "32589": true,
      "32590": true,
      "32591": true,
      "32592": true,
      "32593": true,
      "32594": true,
      "32595": true,
      "32596": true,
      "32597": true,
      "32598": true,
      "32599": true,
      "32600": true,
      "32601": true,
      "32602": true,
      "32603": true,
      "32604": true,
      "32605": true,
      "32606": true,
      "32607": true,
      "32608": true,
      "32609": true,
      "32610": true,
      "32611": true,
      "32612": true,
      "32613": true,
      "32614": true,
      "32615": true,
      "32616": true,
      "32617": true,
      "32618": true,
      "32619": true,
      "32620": true,
      "32621": true,
      "32622": true,
      "32623": true,
      "32624": true,
      "32625": true,
      "32626": true,
      "32627": true,
      "32628": true,
      "32629": true,
      "32630": true,
      "32631": true,
      "32632": true,
      "32633": true,
      "32634": true,
      "32635": true,
      "32636": true,
      "32637": true,
      "32638": true,
      "32639": true,
      "32640": true,
      "32641": true,
      "32642": true,
      "32643": true,
      "32644": true,
      "32645": true,
      "32646": true,
      "32647": true,
      "32648": true,
      "32649": true,
      "32650": true,
      "32651": true,
      "32652": true,
      "32653": true,
      "32654": true,
      "32655": true,
      "32656": true,
      "32657": true,
      "32658": true,
      "32659": true,
      "32660": true,
      "32661": true,
      "32662": true,
      "32663": true,
      "32664": true,
      "32665": true,
      "32666": true,
      "32667": true,
      "32668": true,
      "32669": true,
      "32670": true,
      "32671": true,
      "32672": true,
      "32673": true,
      "32674": true,
      "32675": true,
      "32676": true,
      "32677": true,
      "32678": true,
      "32679": true,
      "32680": true,
      "32681": true,
      "32682": true,
      "32683": true,
      "32684": true,
      "32685": true,
      "32686": true,
      "32687": true,
      "32688": true,
      "32689": true,
      "32690": true,
      "32691": true,
      "32692": true,
      "32693": true,
      "32694": true,
      "32695": true,
      "32696": true,
      "32697": true,
      "32698": true,
      "32699": true,
      "32700": true,
      "32701": true,
      "32702": true,
      "32703": true,
      "32704": true,
      "32705": true,
      "32706": true,
      "32707": true,
      "32708": true,
      "32709": true,
      "32710": true,
      "32711": true,
      "32712": true,
      "32713": true,
      "32714": true,
      "32715": true,
      "32716": true,
      "32717": true,
      "32718": true,
      "32719": true,
      "32720": true,
      "32721": true,
      "32722": true,
      "32723": true,
      "32724": true,
      "32725": true,
      "32726": true,
      "32727": true,
      "32728": true,
      "32729": true,
      "32730": true,
      "32731": true,
      "32732": true,
      "32733": true,
      "32734": true,
      "32735": true,
      "32736": true,
      "32737": true,
      "32738": true,
      "32739": true
    },
    "GUADALUPE": {
      "32740": true,
      "32741": true,
      "32742": true,
      "32743": true,
      "32744": true,
      "32745": true,
      "32746": true,
      "32747": true,
      "32748": true,
      "32749": true,
      "32767": true,
      "32768": true,
      "32769": true,
      "32776": true
    },
    "PRAXEDIS G. GUERRERO": {
      "32780": true,
      "32781": true,
      "32782": true,
      "32783": true,
      "32784": true,
      "32785": true,
      "32786": true,
      "32787": true,
      "32788": true,
      "32789": true,
      "32793": true,
      "32797": true,
      "32798": true,
      "32799": true
    },
    "AHUMADA": {
      "32800": true,
      "32801": true,
      "32802": true,
      "32803": true,
      "32804": true,
      "32805": true,
      "32806": true,
      "32807": true,
      "32808": true,
      "32809": true,
      "32810": true,
      "32812": true,
      "32814": true,
      "32815": true,
      "32820": true,
      "32821": true,
      "32822": true,
      "32832": true,
      "32833": true,
      "32834": true,
      "32835": true,
      "32836": true,
      "32837": true,
      "32838": true,
      "32839": true
    },
    "OJINAGA": {
      "32880": true,
      "32881": true,
      "32882": true,
      "32883": true,
      "32884": true,
      "32885": true,
      "32886": true,
      "32888": true,
      "32894": true,
      "32895": true,
      "32896": true,
      "32897": true,
      "32898": true,
      "32899": true
    },
    "ALDAMA": {
      "32900": true,
      "32901": true,
      "32902": true,
      "32903": true,
      "32904": true,
      "32905": true,
      "32906": true,
      "32910": true,
      "32911": true,
      "32912": true,
      "32913": true,
      "32914": true,
      "32915": true,
      "32916": true,
      "32917": true,
      "32918": true,
      "32919": true,
      "32930": true,
      "32931": true
    },
    "JULIMES": {
      "32950": true,
      "32951": true,
      "32952": true,
      "32953": true,
      "32954": true,
      "32955": true,
      "32956": true,
      "32957": true,
      "32958": true,
      "32959": true,
      "32960": true,
      "32961": true,
      "32962": true,
      "32963": true,
      "32964": true,
      "32965": true,
      "32966": true,
      "32967": true,
      "32968": true,
      "32969": true,
      "32970": true,
      "32971": true,
      "32972": true,
      "32973": true,
      "32974": true,
      "32975": true,
      "32976": true,
      "32977": true,
      "32978": true,
      "32979": true
    },
    "DELICIAS": {
      "33000": true,
      "33001": true,
      "33002": true,
      "33003": true,
      "33004": true,
      "33005": true,
      "33006": true,
      "33007": true,
      "33008": true,
      "33009": true,
      "33010": true,
      "33011": true,
      "33012": true,
      "33013": true,
      "33014": true,
      "33015": true,
      "33016": true,
      "33017": true,
      "33018": true,
      "33019": true,
      "33020": true,
      "33021": true,
      "33022": true,
      "33023": true,
      "33024": true,
      "33025": true,
      "33026": true,
      "33027": true,
      "33028": true,
      "33029": true,
      "33030": true,
      "33031": true,
      "33032": true,
      "33033": true,
      "33034": true,
      "33035": true,
      "33036": true,
      "33037": true,
      "33038": true,
      "33039": true,
      "33040": true,
      "33041": true,
      "33042": true,
      "33043": true,
      "33044": true,
      "33045": true,
      "33046": true,
      "33047": true,
      "33048": true,
      "33049": true,
      "33050": true,
      "33051": true,
      "33052": true,
      "33053": true,
      "33054": true,
      "33055": true,
      "33056": true,
      "33057": true,
      "33058": true,
      "33059": true,
      "33060": true,
      "33061": true,
      "33062": true,
      "33063": true,
      "33064": true,
      "33065": true,
      "33066": true,
      "33067": true,
      "33068": true,
      "33069": true,
      "33070": true,
      "33071": true,
      "33072": true,
      "33073": true,
      "33074": true,
      "33075": true,
      "33076": true,
      "33077": true,
      "33078": true,
      "33079": true,
      "33080": true,
      "33081": true,
      "33082": true,
      "33083": true,
      "33084": true,
      "33085": true,
      "33086": true,
      "33087": true,
      "33088": true,
      "33089": true,
      "33090": true,
      "33091": true,
      "33092": true,
      "33093": true,
      "33094": true,
      "33095": true,
      "33096": true,
      "33097": true,
      "33098": true,
      "33099": true,
      "33100": true,
      "33101": true,
      "33102": true,
      "33103": true,
      "33104": true,
      "33105": true,
      "33106": true,
      "33107": true,
      "33108": true,
      "33109": true,
      "33113": true,
      "33114": true,
      "33115": true,
      "33116": true
    },
    "ROSALES": {
      "33120": true,
      "33121": true,
      "33122": true,
      "33123": true,
      "33126": true,
      "33127": true,
      "33128": true,
      "33129": true
    },
    "GUACHOCHI": {
      "33180": true,
      "33181": true,
      "33182": true,
      "33183": true,
      "33184": true,
      "33185": true,
      "33186": true,
      "33187": true,
      "33197": true
    },
    "SANTA ISABEL": {
      "33270": true,
      "33271": true,
      "33272": true,
      "33273": true,
      "33274": true,
      "33275": true,
      "33276": true,
      "33277": true,
      "33278": true,
      "33279": true
    },
    "CAMARGO": {
      "33600": true,
      "33601": true,
      "33602": true,
      "33603": true,
      "33610": true,
      "33611": true,
      "33612": true,
      "33613": true,
      "33614": true,
      "33615": true,
      "33616": true,
      "33617": true,
      "33700": true,
      "33701": true,
      "33702": true,
      "33703": true,
      "33704": true,
      "33705": true,
      "33706": true,
      "33707": true,
      "33708": true,
      "33709": true,
      "33710": true,
      "33711": true,
      "33712": true,
      "33713": true,
      "33714": true,
      "33715": true,
      "33716": true,
      "33717": true,
      "33718": true,
      "33719": true,
      "33720": true,
      "33721": true,
      "33722": true,
      "33723": true,
      "33724": true,
      "33725": true,
      "33726": true,
      "33727": true,
      "33728": true,
      "33729": true,
      "33730": true,
      "33731": true,
      "33732": true,
      "33733": true,
      "33734": true,
      "33735": true,
      "33736": true,
      "33737": true,
      "33738": true,
      "33739": true,
      "33740": true,
      "33741": true,
      "33742": true,
      "33743": true,
      "33744": true,
      "33745": true,
      "33746": true,
      "33747": true,
      "33748": true,
      "33749": true,
      "33750": true,
      "33751": true,
      "33752": true,
      "33753": true,
      "33754": true,
      "33755": true,
      "33756": true,
      "33757": true,
      "33758": true,
      "33759": true,
      "33760": true,
      "33761": true,
      "33762": true,
      "33763": true,
      "33764": true,
      "33765": true,
      "33766": true,
      "33767": true,
      "33768": true,
      "33769": true,
      "33770": true,
      "33771": true,
      "33772": true,
      "33773": true,
      "33774": true,
      "33775": true,
      "33776": true,
      "33777": true,
      "33778": true,
      "33779": true,
      "33780": true,
      "33781": true,
      "33782": true,
      "33783": true,
      "33784": true,
      "33785": true,
      "33786": true,
      "33787": true,
      "33788": true,
      "33789": true,
      "33790": true,
      "33791": true,
      "33792": true,
      "33793": true,
      "33794": true,
      "33795": true,
      "33796": true,
      "33797": true,
      "33798": true,
      "33799": true
    },
    "SAUCILLO": {
      "33620": true,
      "33621": true,
      "33622": true,
      "33623": true,
      "33624": true,
      "33625": true,
      "33626": true,
      "33627": true,
      "33628": true,
      "33629": true,
      "33630": true,
      "33631": true,
      "33632": true,
      "33633": true,
      "33634": true,
      "33636": true,
      "33637": true,
      "33638": true,
      "33639": true,
      "33640": true,
      "33641": true,
      "33642": true,
      "33645": true,
      "33646": true
    },
    "HIDALGO DEL PARRAL": {
      "33800": true,
      "33801": true,
      "33802": true,
      "33803": true,
      "33804": true,
      "33805": true,
      "33806": true,
      "33807": true,
      "33808": true,
      "33809": true,
      "33810": true,
      "33811": true,
      "33812": true,
      "33813": true,
      "33814": true,
      "33815": true,
      "33816": true,
      "33817": true,
      "33818": true,
      "33819": true,
      "33820": true,
      "33821": true,
      "33822": true,
      "33823": true,
      "33824": true,
      "33825": true,
      "33826": true,
      "33827": true,
      "33828": true,
      "33829": true,
      "33830": true,
      "33831": true,
      "33832": true,
      "33833": true,
      "33834": true,
      "33835": true,
      "33836": true,
      "33837": true,
      "33838": true,
      "33839": true,
      "33840": true,
      "33841": true,
      "33842": true,
      "33843": true,
      "33844": true,
      "33845": true,
      "33846": true,
      "33847": true,
      "33848": true,
      "33849": true,
      "33850": true,
      "33851": true,
      "33852": true,
      "33853": true,
      "33854": true,
      "33855": true,
      "33856": true,
      "33857": true,
      "33858": true,
      "33859": true,
      "33860": true,
      "33861": true,
      "33862": true,
      "33863": true,
      "33864": true,
      "33865": true,
      "33866": true,
      "33867": true,
      "33868": true,
      "33869": true,
      "33870": true,
      "33871": true,
      "33872": true,
      "33873": true,
      "33874": true,
      "33875": true,
      "33876": true,
      "33877": true,
      "33878": true,
      "33879": true,
      "33880": true,
      "33881": true,
      "33882": true,
      "33883": true,
      "33884": true,
      "33885": true,
      "33886": true,
      "33887": true,
      "33888": true,
      "33889": true,
      "33890": true,
      "33891": true,
      "33892": true,
      "33893": true,
      "33894": true,
      "33895": true,
      "33896": true,
      "33897": true,
      "33898": true,
      "33899": true,
      "33900": true,
      "33901": true,
      "33902": true,
      "33903": true,
      "33905": true,
      "33906": true,
      "33907": true,
      "33908": true,
      "33909": true,
      "33913": true,
      "33914": true,
      "33917": true,
      "33918": true,
      "33919": true
    },
    "JIMENEZ": {
      "33970": true,
      "33971": true,
      "33972": true,
      "33974": true,
      "33976": true,
      "33980": true,
      "33981": true,
      "33982": true,
      "33983": true,
      "33984": true,
      "33985": true,
      "33986": true,
      "33987": true,
      "33988": true,
      "33989": true
    }
  },
  "DURANGO": {
    "DURANGO": {
      "34000": true,
      "34001": true,
      "34002": true,
      "34003": true,
      "34004": true,
      "34005": true,
      "34006": true,
      "34007": true,
      "34008": true,
      "34009": true,
      "34010": true,
      "34011": true,
      "34012": true,
      "34013": true,
      "34014": true,
      "34015": true,
      "34016": true,
      "34017": true,
      "34018": true,
      "34019": true,
      "34020": true,
      "34021": true,
      "34022": true,
      "34023": true,
      "34024": true,
      "34025": true,
      "34026": true,
      "34027": true,
      "34028": true,
      "34029": true,
      "34030": true,
      "34031": true,
      "34032": true,
      "34033": true,
      "34034": true,
      "34035": true,
      "34036": true,
      "34037": true,
      "34038": true,
      "34039": true,
      "34040": true,
      "34041": true,
      "34042": true,
      "34043": true,
      "34044": true,
      "34045": true,
      "34046": true,
      "34047": true,
      "34048": true,
      "34049": true,
      "34050": true,
      "34051": true,
      "34052": true,
      "34053": true,
      "34054": true,
      "34055": true,
      "34056": true,
      "34057": true,
      "34058": true,
      "34059": true,
      "34060": true,
      "34061": true,
      "34062": true,
      "34063": true,
      "34064": true,
      "34065": true,
      "34066": true,
      "34067": true,
      "34068": true,
      "34069": true,
      "34070": true,
      "34071": true,
      "34072": true,
      "34073": true,
      "34074": true,
      "34075": true,
      "34076": true,
      "34077": true,
      "34078": true,
      "34079": true,
      "34080": true,
      "34081": true,
      "34082": true,
      "34083": true,
      "34084": true,
      "34085": true,
      "34086": true,
      "34087": true,
      "34088": true,
      "34089": true,
      "34090": true,
      "34091": true,
      "34092": true,
      "34093": true,
      "34094": true,
      "34095": true,
      "34096": true,
      "34097": true,
      "34098": true,
      "34099": true,
      "34100": true,
      "34101": true,
      "34102": true,
      "34103": true,
      "34104": true,
      "34105": true,
      "34106": true,
      "34107": true,
      "34108": true,
      "34109": true,
      "34110": true,
      "34111": true,
      "34112": true,
      "34113": true,
      "34114": true,
      "34115": true,
      "34116": true,
      "34117": true,
      "34118": true,
      "34119": true,
      "34120": true,
      "34121": true,
      "34122": true,
      "34123": true,
      "34124": true,
      "34125": true,
      "34126": true,
      "34127": true,
      "34128": true,
      "34129": true,
      "34130": true,
      "34131": true,
      "34132": true,
      "34133": true,
      "34134": true,
      "34135": true,
      "34136": true,
      "34137": true,
      "34138": true,
      "34139": true,
      "34140": true,
      "34141": true,
      "34142": true,
      "34143": true,
      "34144": true,
      "34145": true,
      "34146": true,
      "34147": true,
      "34148": true,
      "34149": true,
      "34150": true,
      "34151": true,
      "34152": true,
      "34153": true,
      "34154": true,
      "34155": true,
      "34156": true,
      "34157": true,
      "34158": true,
      "34159": true,
      "34160": true,
      "34161": true,
      "34162": true,
      "34163": true,
      "34164": true,
      "34165": true,
      "34166": true,
      "34167": true,
      "34168": true,
      "34169": true,
      "34170": true,
      "34171": true,
      "34172": true,
      "34173": true,
      "34174": true,
      "34175": true,
      "34176": true,
      "34177": true,
      "34178": true,
      "34179": true,
      "34180": true,
      "34181": true,
      "34182": true,
      "34183": true,
      "34184": true,
      "34185": true,
      "34186": true,
      "34187": true,
      "34188": true,
      "34189": true,
      "34190": true,
      "34191": true,
      "34192": true,
      "34193": true,
      "34194": true,
      "34195": true,
      "34196": true,
      "34197": true,
      "34198": true,
      "34199": true,
      "34200": true,
      "34201": true,
      "34202": true,
      "34203": true,
      "34204": true,
      "34205": true,
      "34206": true,
      "34207": true,
      "34208": true,
      "34209": true,
      "34210": true,
      "34211": true,
      "34212": true,
      "34213": true,
      "34214": true,
      "34215": true,
      "34216": true,
      "34217": true,
      "34218": true,
      "34219": true,
      "34220": true,
      "34221": true,
      "34222": true,
      "34223": true,
      "34224": true,
      "34225": true,
      "34226": true,
      "34227": true,
      "34228": true,
      "34229": true,
      "34230": true,
      "34231": true,
      "34232": true,
      "34233": true,
      "34234": true,
      "34235": true,
      "34236": true,
      "34237": true,
      "34238": true,
      "34239": true,
      "34240": true,
      "34241": true,
      "34242": true,
      "34243": true,
      "34244": true,
      "34245": true,
      "34246": true,
      "34247": true,
      "34248": true,
      "34249": true,
      "34250": true,
      "34251": true,
      "34252": true,
      "34253": true,
      "34254": true,
      "34255": true,
      "34256": true,
      "34257": true,
      "34258": true,
      "34259": true,
      "34260": true,
      "34261": true,
      "34262": true,
      "34263": true,
      "34264": true,
      "34265": true,
      "34266": true,
      "34267": true,
      "34268": true,
      "34269": true,
      "34270": true,
      "34271": true,
      "34272": true,
      "34273": true,
      "34274": true,
      "34275": true,
      "34276": true,
      "34277": true,
      "34278": true,
      "34279": true,
      "34280": true,
      "34281": true,
      "34282": true,
      "34283": true,
      "34284": true,
      "34285": true,
      "34286": true,
      "34287": true,
      "34288": true,
      "34289": true,
      "34290": true,
      "34291": true,
      "34292": true,
      "34293": true,
      "34294": true,
      "34295": true,
      "34296": true,
      "34297": true,
      "34298": true,
      "34299": true,
      "34300": true,
      "34301": true,
      "34302": true,
      "34303": true,
      "34304": true,
      "34305": true,
      "34306": true,
      "34307": true,
      "34308": true,
      "34309": true,
      "34310": true,
      "34311": true,
      "34312": true,
      "34313": true,
      "34314": true,
      "34315": true,
      "34316": true,
      "34317": true,
      "34318": true,
      "34319": true,
      "34320": true,
      "34321": true,
      "34322": true,
      "34323": true,
      "34324": true,
      "34325": true,
      "34326": true,
      "34327": true,
      "34328": true,
      "34329": true,
      "34330": true,
      "34331": true,
      "34332": true,
      "34333": true,
      "34334": true,
      "34335": true,
      "34336": true,
      "34337": true,
      "34338": true,
      "34339": true,
      "34340": true,
      "34341": true,
      "34342": true,
      "34343": true,
      "34344": true,
      "34345": true,
      "34346": true,
      "34347": true,
      "34348": true,
      "34349": true,
      "34350": true,
      "34351": true,
      "34352": true,
      "34353": true,
      "34354": true,
      "34355": true,
      "34356": true,
      "34357": true,
      "34358": true,
      "34359": true,
      "34360": true,
      "34361": true,
      "34362": true,
      "34363": true,
      "34364": true,
      "34365": true,
      "34366": true,
      "34367": true,
      "34368": true,
      "34369": true,
      "34370": true,
      "34371": true,
      "34372": true,
      "34373": true,
      "34374": true,
      "34375": true,
      "34376": true,
      "34377": true,
      "34378": true,
      "34379": true,
      "34380": true,
      "34381": true,
      "34382": true,
      "34383": true,
      "34384": true,
      "34385": true,
      "34386": true,
      "34387": true,
      "34388": true,
      "34389": true,
      "34390": true,
      "34391": true,
      "34392": true,
      "34393": true,
      "34394": true,
      "34395": true,
      "34396": true,
      "34397": true,
      "34398": true,
      "34399": true
    },
    "CANATLAN": {
      "34400": true,
      "34401": true,
      "34402": true,
      "34405": true,
      "34406": true,
      "34407": true,
      "34408": true,
      "34409": true,
      "34444": true,
      "34446": true,
      "34447": true,
      "34448": true,
      "34449": true,
      "34450": true,
      "34451": true,
      "34452": true,
      "34453": true,
      "34454": true,
      "34455": true,
      "34456": true,
      "34457": true,
      "34458": true,
      "34459": true,
      "34460": true,
      "34461": true,
      "34462": true,
      "34464": true,
      "34465": true,
      "34466": true,
      "34467": true,
      "34468": true,
      "34469": true
    },
    "NUEVO IDEAL": {
      "34410": true,
      "34411": true,
      "34412": true,
      "34413": true,
      "34414": true,
      "34415": true,
      "34416": true,
      "34417": true,
      "34418": true,
      "34419": true,
      "34420": true,
      "34421": true,
      "34422": true,
      "34423": true,
      "34424": true,
      "34425": true,
      "34426": true,
      "34427": true,
      "34428": true,
      "34429": true,
      "34430": true,
      "34431": true,
      "34432": true,
      "34433": true,
      "34434": true,
      "34435": true,
      "34436": true
    },
    "SAN JUAN DEL RIO": {
      "34480": true,
      "34481": true,
      "34482": true,
      "34483": true,
      "34484": true,
      "34485": true,
      "34486": true,
      "34487": true,
      "34490": true,
      "34491": true,
      "34492": true,
      "34493": true,
      "34494": true,
      "34495": true,
      "34496": true,
      "34497": true,
      "34498": true,
      "34499": true
    },
    "SANTIAGO PAPASQUIARO": {
      "34600": true,
      "34601": true,
      "34602": true,
      "34605": true,
      "34606": true,
      "34607": true,
      "34608": true,
      "34609": true,
      "34610": true,
      "34611": true,
      "34612": true,
      "34614": true,
      "34630": true,
      "34631": true,
      "34632": true,
      "34633": true,
      "34634": true,
      "34635": true,
      "34636": true,
      "34637": true,
      "34638": true,
      "34639": true,
      "34640": true,
      "34641": true,
      "34642": true,
      "34643": true,
      "34644": true,
      "34645": true,
      "34646": true,
      "34647": true,
      "34648": true,
      "34649": true
    },
    "GUADALUPE VICTORIA": {
      "34700": true,
      "34701": true,
      "34702": true,
      "34703": true,
      "34704": true,
      "34705": true,
      "34706": true,
      "34707": true,
      "34708": true,
      "34709": true,
      "34710": true,
      "34711": true,
      "34712": true,
      "34713": true,
      "34715": true,
      "34716": true,
      "34720": true,
      "34721": true,
      "34722": true,
      "34723": true,
      "34724": true,
      "34725": true,
      "34726": true,
      "34727": true,
      "34728": true,
      "34729": true,
      "34733": true
    },
    "PANUCO DE CORONADO": {
      "34770": true,
      "34771": true,
      "34772": true,
      "34773": true,
      "34774": true,
      "34775": true,
      "34776": true,
      "34777": true,
      "34778": true,
      "34779": true,
      "34780": true,
      "34781": true,
      "34782": true,
      "34783": true,
      "34784": true,
      "34785": true,
      "34786": true,
      "34787": true,
      "34788": true,
      "34789": true,
      "34793": true
    },
    "POANAS": {
      "34800": true,
      "34801": true,
      "34802": true,
      "34803": true,
      "34810": true,
      "34811": true,
      "34812": true,
      "34813": true,
      "34814": true,
      "34815": true,
      "34816": true,
      "34817": true,
      "34818": true,
      "34819": true,
      "34820": true,
      "34821": true,
      "34822": true,
      "34823": true,
      "34824": true,
      "34825": true,
      "34826": true,
      "34827": true,
      "34828": true,
      "34829": true,
      "34830": true,
      "34831": true,
      "34832": true,
      "34833": true,
      "34834": true,
      "34835": true,
      "34836": true,
      "34837": true,
      "34838": true,
      "34839": true
    },
    "NOMBRE DE DIOS": {
      "34840": true,
      "34841": true,
      "34842": true,
      "34843": true,
      "34844": true,
      "34845": true,
      "34846": true,
      "34847": true,
      "34848": true,
      "34849": true,
      "34850": true,
      "34851": true,
      "34852": true,
      "34853": true,
      "34854": true,
      "34855": true,
      "34856": true,
      "34857": true,
      "34858": true,
      "34859": true,
      "34864": true,
      "34865": true,
      "34880": true,
      "34881": true,
      "34882": true,
      "34883": true,
      "34884": true,
      "34885": true,
      "34886": true,
      "34887": true,
      "34888": true,
      "34889": true
    },
    "VICENTE GUERRERO": {
      "34890": true,
      "34891": true,
      "34892": true,
      "34893": true,
      "34894": true,
      "34895": true,
      "34896": true,
      "34897": true,
      "34898": true,
      "34899": true
    },
    "SUCHIL": {
      "34900": true,
      "34901": true,
      "34902": true,
      "34903": true,
      "34904": true,
      "34905": true,
      "34906": true,
      "34907": true,
      "34908": true,
      "34909": true,
      "34910": true,
      "34911": true,
      "34912": true,
      "34913": true,
      "34914": true,
      "34915": true,
      "34916": true,
      "34917": true,
      "34918": true,
      "34919": true,
      "34923": true,
      "34924": true,
      "34925": true,
      "34926": true,
      "34927": true,
      "34928": true,
      "34929": true,
      "34935": true
    },
    "PUEBLO NUEVO": {
      "34940": true,
      "34941": true,
      "34942": true,
      "34943": true,
      "34944": true,
      "34945": true,
      "34946": true,
      "34947": true,
      "34948": true,
      "34949": true,
      "34950": true,
      "34951": true,
      "34952": true,
      "34953": true,
      "34957": true,
      "34958": true,
      "34959": true,
      "34960": true,
      "34961": true,
      "34962": true,
      "34965": true,
      "34966": true
    },
    "MEZQUITAL": {
      "34970": true,
      "34971": true,
      "34972": true,
      "34973": true,
      "34974": true,
      "34975": true,
      "34978": true,
      "34979": true,
      "34987": true,
      "34996": true
    },
    "GOMEZ PALACIO": {
      "35000": true,
      "35001": true,
      "35002": true,
      "35003": true,
      "35004": true,
      "35005": true,
      "35006": true,
      "35007": true,
      "35008": true,
      "35009": true,
      "35010": true,
      "35011": true,
      "35012": true,
      "35013": true,
      "35014": true,
      "35015": true,
      "35016": true,
      "35017": true,
      "35018": true,
      "35019": true,
      "35020": true,
      "35021": true,
      "35022": true,
      "35023": true,
      "35024": true,
      "35025": true,
      "35026": true,
      "35027": true,
      "35028": true,
      "35029": true,
      "35030": true,
      "35031": true,
      "35032": true,
      "35033": true,
      "35034": true,
      "35035": true,
      "35036": true,
      "35037": true,
      "35038": true,
      "35039": true,
      "35040": true,
      "35041": true,
      "35042": true,
      "35043": true,
      "35044": true,
      "35045": true,
      "35046": true,
      "35047": true,
      "35048": true,
      "35049": true,
      "35050": true,
      "35051": true,
      "35052": true,
      "35053": true,
      "35054": true,
      "35055": true,
      "35056": true,
      "35057": true,
      "35058": true,
      "35059": true,
      "35060": true,
      "35061": true,
      "35062": true,
      "35063": true,
      "35064": true,
      "35065": true,
      "35066": true,
      "35067": true,
      "35068": true,
      "35069": true,
      "35070": true,
      "35071": true,
      "35072": true,
      "35073": true,
      "35074": true,
      "35075": true,
      "35076": true,
      "35077": true,
      "35078": true,
      "35079": true,
      "35080": true,
      "35081": true,
      "35082": true,
      "35083": true,
      "35084": true,
      "35085": true,
      "35086": true,
      "35087": true,
      "35088": true,
      "35089": true,
      "35090": true,
      "35091": true,
      "35092": true,
      "35093": true,
      "35094": true,
      "35095": true,
      "35096": true,
      "35097": true,
      "35098": true,
      "35099": true,
      "35100": true,
      "35101": true,
      "35102": true,
      "35103": true,
      "35104": true,
      "35105": true,
      "35106": true,
      "35107": true,
      "35108": true,
      "35109": true,
      "35110": true,
      "35111": true,
      "35112": true,
      "35113": true,
      "35114": true,
      "35115": true,
      "35116": true,
      "35117": true,
      "35118": true,
      "35119": true,
      "35120": true,
      "35121": true,
      "35122": true,
      "35123": true,
      "35124": true,
      "35125": true,
      "35126": true,
      "35127": true,
      "35128": true,
      "35129": true,
      "35130": true,
      "35131": true,
      "35132": true,
      "35133": true,
      "35134": true,
      "35135": true,
      "35136": true,
      "35137": true,
      "35138": true,
      "35139": true,
      "35140": true,
      "35141": true,
      "35142": true,
      "35143": true,
      "35144": true,
      "35145": true,
      "35146": true,
      "35147": true,
      "35148": true,
      "35149": true
    },
    "LERDO": {
      "35150": true,
      "35151": true,
      "35152": true,
      "35153": true,
      "35154": true,
      "35155": true,
      "35156": true,
      "35157": true,
      "35158": true,
      "35159": true,
      "35160": true,
      "35161": true,
      "35162": true,
      "35163": true,
      "35164": true,
      "35165": true,
      "35166": true,
      "35167": true,
      "35168": true,
      "35169": true,
      "35170": true,
      "35179": true,
      "35180": true,
      "35181": true,
      "35185": true,
      "35186": true,
      "35187": true,
      "35188": true,
      "35189": true,
      "35190": true
    },
    "MAPIMI": {
      "35200": true,
      "35201": true,
      "35202": true,
      "35203": true,
      "35204": true,
      "35205": true,
      "35206": true,
      "35207": true,
      "35208": true,
      "35209": true,
      "35219": true,
      "35220": true,
      "35221": true,
      "35222": true,
      "35223": true,
      "35230": true,
      "35231": true,
      "35232": true,
      "35235": true,
      "35238": true,
      "35239": true,
      "35240": true
    },
    "TLAHUALILO": {
      "35250": true,
      "35251": true,
      "35252": true,
      "35253": true,
      "35254": true,
      "35255": true,
      "35256": true,
      "35257": true,
      "35258": true,
      "35259": true,
      "35260": true,
      "35261": true,
      "35262": true,
      "35263": true,
      "35264": true,
      "35265": true,
      "35266": true,
      "35270": true,
      "35271": true,
      "35272": true,
      "35273": true,
      "35274": true,
      "35280": true,
      "35281": true,
      "35282": true,
      "35283": true,
      "35284": true,
      "35285": true,
      "35286": true,
      "35287": true,
      "35288": true,
      "35289": true,
      "35290": true,
      "35291": true,
      "35292": true,
      "35296": true
    },
    "NAZAS": {
      "35700": true,
      "35701": true,
      "35702": true,
      "35703": true,
      "35704": true,
      "35705": true,
      "35706": true,
      "35707": true,
      "35708": true,
      "35709": true,
      "35710": true,
      "35711": true,
      "35712": true,
      "35713": true,
      "35714": true,
      "35715": true,
      "35716": true,
      "35717": true,
      "35718": true,
      "35719": true,
      "35720": true,
      "35721": true,
      "35722": true,
      "35724": true,
      "35725": true,
      "35726": true,
      "35727": true,
      "35728": true,
      "35729": true,
      "35730": true,
      "35731": true,
      "35732": true,
      "35733": true,
      "35734": true,
      "35735": true,
      "35736": true,
      "35737": true,
      "35738": true,
      "35739": true
    },
    "CUENCAME": {
      "35800": true,
      "35801": true,
      "35802": true,
      "35803": true,
      "35804": true,
      "35805": true,
      "35806": true,
      "35807": true,
      "35808": true,
      "35809": true,
      "35815": true,
      "35817": true,
      "35818": true,
      "35819": true,
      "35824": true,
      "35827": true,
      "35828": true,
      "35829": true,
      "35830": true,
      "35831": true,
      "35832": true,
      "35833": true,
      "35834": true,
      "35835": true,
      "35836": true,
      "35837": true,
      "35838": true,
      "35839": true
    }
  },
  "GUANAJUATO": {
    "GUANAJUATO": {
      "36000": true,
      "36001": true,
      "36002": true,
      "36003": true,
      "36004": true,
      "36005": true,
      "36006": true,
      "36007": true,
      "36008": true,
      "36009": true,
      "36010": true,
      "36011": true,
      "36012": true,
      "36013": true,
      "36014": true,
      "36015": true,
      "36016": true,
      "36017": true,
      "36018": true,
      "36019": true,
      "36020": true,
      "36021": true,
      "36022": true,
      "36023": true,
      "36024": true,
      "36025": true,
      "36026": true,
      "36027": true,
      "36028": true,
      "36029": true,
      "36030": true,
      "36031": true,
      "36032": true,
      "36033": true,
      "36034": true,
      "36035": true,
      "36036": true,
      "36037": true,
      "36038": true,
      "36039": true,
      "36040": true,
      "36041": true,
      "36042": true,
      "36043": true,
      "36044": true,
      "36045": true,
      "36046": true,
      "36047": true,
      "36048": true,
      "36049": true,
      "36050": true,
      "36051": true,
      "36052": true,
      "36053": true,
      "36054": true,
      "36055": true,
      "36056": true,
      "36057": true,
      "36058": true,
      "36059": true,
      "36060": true,
      "36061": true,
      "36062": true,
      "36063": true,
      "36064": true,
      "36065": true,
      "36066": true,
      "36067": true,
      "36068": true,
      "36069": true,
      "36070": true,
      "36071": true,
      "36072": true,
      "36073": true,
      "36074": true,
      "36075": true,
      "36076": true,
      "36077": true,
      "36078": true,
      "36079": true,
      "36080": true,
      "36081": true,
      "36082": true,
      "36083": true,
      "36084": true,
      "36085": true,
      "36086": true,
      "36087": true,
      "36088": true,
      "36089": true,
      "36090": true,
      "36091": true,
      "36092": true,
      "36093": true,
      "36094": true,
      "36095": true,
      "36096": true,
      "36097": true,
      "36098": true,
      "36099": true,
      "36220": true,
      "36221": true,
      "36222": true,
      "36223": true,
      "36224": true,
      "36225": true,
      "36226": true,
      "36227": true,
      "36228": true,
      "36229": true,
      "36230": true,
      "36231": true,
      "36232": true,
      "36235": true,
      "36236": true,
      "36237": true,
      "36238": true,
      "36239": true,
      "36240": true,
      "36241": true,
      "36242": true,
      "36243": true,
      "36244": true,
      "36246": true,
      "36247": true,
      "36248": true,
      "36249": true,
      "36250": true,
      "36251": true,
      "36252": true,
      "36253": true,
      "36254": true,
      "36255": true,
      "36256": true,
      "36257": true,
      "36258": true,
      "36259": true,
      "36260": true,
      "36261": true,
      "36262": true,
      "36263": true,
      "36264": true,
      "36265": true,
      "36266": true,
      "36267": true,
      "36268": true,
      "36269": true
    },
    "SILAO DE LA VICTORIA": {
      "36100": true,
      "36101": true,
      "36102": true,
      "36103": true,
      "36104": true,
      "36105": true,
      "36106": true,
      "36107": true,
      "36108": true,
      "36109": true,
      "36110": true,
      "36111": true,
      "36112": true,
      "36113": true,
      "36114": true,
      "36115": true,
      "36116": true,
      "36117": true,
      "36118": true,
      "36119": true,
      "36120": true,
      "36121": true,
      "36122": true,
      "36123": true,
      "36124": true,
      "36125": true,
      "36126": true,
      "36127": true,
      "36128": true,
      "36129": true,
      "36130": true,
      "36131": true,
      "36132": true,
      "36133": true,
      "36134": true,
      "36135": true,
      "36136": true,
      "36137": true,
      "36138": true,
      "36139": true,
      "36140": true,
      "36141": true,
      "36142": true,
      "36143": true,
      "36144": true,
      "36145": true,
      "36146": true,
      "36147": true,
      "36148": true,
      "36149": true,
      "36150": true,
      "36151": true,
      "36152": true,
      "36153": true,
      "36154": true,
      "36155": true,
      "36156": true,
      "36157": true,
      "36158": true,
      "36159": true,
      "36160": true,
      "36161": true,
      "36162": true,
      "36163": true,
      "36164": true,
      "36165": true,
      "36166": true,
      "36167": true,
      "36168": true,
      "36169": true,
      "36170": true,
      "36171": true,
      "36172": true,
      "36173": true,
      "36174": true,
      "36175": true,
      "36176": true,
      "36177": true,
      "36178": true,
      "36179": true,
      "36180": true,
      "36181": true,
      "36182": true,
      "36183": true,
      "36184": true,
      "36185": true,
      "36186": true,
      "36187": true,
      "36188": true,
      "36189": true,
      "36190": true,
      "36191": true,
      "36192": true,
      "36193": true,
      "36194": true,
      "36195": true,
      "36196": true,
      "36197": true,
      "36198": true,
      "36199": true,
      "36270": true,
      "36271": true,
      "36272": true,
      "36273": true,
      "36274": true,
      "36275": true,
      "36276": true,
      "36277": true,
      "36278": true,
      "36279": true,
      "36280": true,
      "36281": true,
      "36282": true,
      "36283": true,
      "36284": true,
      "36285": true,
      "36286": true,
      "36287": true,
      "36288": true,
      "36289": true,
      "36290": true,
      "36291": true,
      "36292": true,
      "36293": true,
      "36294": true,
      "36295": true,
      "36296": true,
      "36297": true,
      "36298": true,
      "36299": true
    },
    "ROMITA": {
      "36200": true,
      "36201": true,
      "36202": true,
      "36203": true,
      "36204": true,
      "36205": true,
      "36206": true,
      "36207": true,
      "36208": true,
      "36209": true,
      "36210": true,
      "36211": true,
      "36212": true,
      "36213": true,
      "36214": true,
      "36215": true,
      "36216": true,
      "36217": true,
      "36218": true,
      "36219": true
    },
    "SAN FRANCISCO DEL RINCON": {
      "36300": true,
      "36301": true,
      "36302": true,
      "36303": true,
      "36304": true,
      "36305": true,
      "36306": true,
      "36307": true,
      "36308": true,
      "36309": true,
      "36310": true,
      "36311": true,
      "36312": true,
      "36313": true,
      "36314": true,
      "36315": true,
      "36316": true,
      "36317": true,
      "36318": true,
      "36319": true,
      "36320": true,
      "36321": true,
      "36322": true,
      "36323": true,
      "36324": true,
      "36325": true,
      "36326": true,
      "36327": true,
      "36328": true,
      "36329": true,
      "36330": true,
      "36331": true,
      "36332": true,
      "36333": true,
      "36334": true,
      "36335": true,
      "36336": true,
      "36337": true,
      "36338": true,
      "36339": true,
      "36340": true,
      "36341": true,
      "36342": true,
      "36343": true,
      "36344": true,
      "36345": true,
      "36346": true,
      "36347": true,
      "36348": true,
      "36349": true,
      "36350": true,
      "36351": true,
      "36352": true,
      "36353": true,
      "36354": true,
      "36355": true,
      "36356": true,
      "36357": true,
      "36358": true,
      "36359": true,
      "36360": true,
      "36361": true,
      "36362": true,
      "36363": true,
      "36364": true,
      "36365": true,
      "36366": true,
      "36367": true,
      "36368": true,
      "36369": true,
      "36370": true,
      "36371": true,
      "36372": true,
      "36373": true,
      "36374": true,
      "36375": true,
      "36376": true,
      "36377": true,
      "36378": true,
      "36379": true,
      "36380": true,
      "36381": true,
      "36382": true,
      "36383": true,
      "36384": true,
      "36385": true,
      "36386": true,
      "36387": true,
      "36388": true,
      "36389": true,
      "36390": true,
      "36391": true,
      "36392": true,
      "36393": true,
      "36394": true,
      "36395": true,
      "36396": true,
      "36397": true,
      "36398": true,
      "36399": true,
      "36440": true,
      "36441": true,
      "36442": true,
      "36443": true,
      "36444": true,
      "36445": true,
      "36446": true,
      "36447": true,
      "36448": true,
      "36449": true,
      "36450": true,
      "36451": true,
      "36452": true,
      "36453": true,
      "36456": true,
      "36460": true,
      "36461": true,
      "36462": true,
      "36463": true,
      "36464": true,
      "36465": true,
      "36466": true,
      "36467": true,
      "36468": true,
      "36469": true
    },
    "PURISIMA DEL RINCON": {
      "36400": true,
      "36401": true,
      "36402": true,
      "36403": true,
      "36404": true,
      "36405": true,
      "36406": true,
      "36407": true,
      "36408": true,
      "36409": true,
      "36410": true,
      "36411": true,
      "36412": true,
      "36413": true,
      "36414": true,
      "36415": true,
      "36416": true,
      "36417": true,
      "36418": true,
      "36419": true,
      "36420": true,
      "36421": true,
      "36422": true,
      "36423": true,
      "36424": true,
      "36425": true,
      "36426": true,
      "36427": true,
      "36428": true,
      "36429": true,
      "36433": true,
      "36436": true
    },
    "MANUEL DOBLADO": {
      "36470": true,
      "36471": true,
      "36472": true,
      "36473": true,
      "36474": true,
      "36475": true,
      "36476": true,
      "36477": true,
      "36478": true,
      "36479": true,
      "36480": true,
      "36481": true,
      "36482": true,
      "36483": true,
      "36484": true,
      "36485": true,
      "36486": true,
      "36487": true,
      "36488": true,
      "36489": true,
      "36490": true,
      "36491": true,
      "36492": true,
      "36493": true,
      "36494": true,
      "36496": true,
      "36497": true,
      "36498": true,
      "36499": true
    },
    "SALAMANCA": {
      "36700": true,
      "36701": true,
      "36702": true,
      "36703": true,
      "36704": true,
      "36705": true,
      "36706": true,
      "36707": true,
      "36708": true,
      "36709": true,
      "36710": true,
      "36711": true,
      "36712": true,
      "36713": true,
      "36714": true,
      "36715": true,
      "36716": true,
      "36717": true,
      "36718": true,
      "36719": true,
      "36720": true,
      "36721": true,
      "36722": true,
      "36723": true,
      "36724": true,
      "36725": true,
      "36726": true,
      "36727": true,
      "36728": true,
      "36729": true,
      "36730": true,
      "36731": true,
      "36732": true,
      "36733": true,
      "36734": true,
      "36735": true,
      "36736": true,
      "36737": true,
      "36738": true,
      "36739": true,
      "36740": true,
      "36741": true,
      "36742": true,
      "36743": true,
      "36744": true,
      "36745": true,
      "36746": true,
      "36747": true,
      "36748": true,
      "36749": true,
      "36750": true,
      "36751": true,
      "36752": true,
      "36753": true,
      "36754": true,
      "36755": true,
      "36756": true,
      "36757": true,
      "36758": true,
      "36759": true,
      "36760": true,
      "36761": true,
      "36762": true,
      "36763": true,
      "36764": true,
      "36765": true,
      "36766": true,
      "36767": true,
      "36768": true,
      "36769": true,
      "36770": true,
      "36771": true,
      "36772": true,
      "36773": true,
      "36774": true,
      "36775": true,
      "36776": true,
      "36777": true,
      "36778": true,
      "36779": true,
      "36780": true,
      "36781": true,
      "36782": true,
      "36783": true,
      "36784": true,
      "36785": true,
      "36786": true,
      "36787": true,
      "36788": true,
      "36789": true,
      "36790": true,
      "36791": true,
      "36792": true,
      "36793": true,
      "36794": true,
      "36795": true,
      "36796": true,
      "36797": true,
      "36798": true,
      "36799": true,
      "36850": true,
      "36851": true,
      "36852": true,
      "36853": true,
      "36854": true,
      "36855": true,
      "36856": true,
      "36857": true,
      "36860": true,
      "36861": true,
      "36862": true,
      "36863": true,
      "36864": true,
      "36865": true,
      "36866": true,
      "36867": true,
      "36868": true,
      "36869": true,
      "36870": true,
      "36871": true,
      "36872": true,
      "36873": true,
      "36874": true,
      "36875": true,
      "36876": true,
      "36877": true,
      "36878": true,
      "36879": true,
      "36880": true,
      "36881": true,
      "36882": true,
      "36883": true,
      "36884": true,
      "36885": true,
      "36886": true,
      "36887": true,
      "36888": true,
      "36889": true
    },
    "PUEBLO NUEVO": {
      "36890": true,
      "36891": true,
      "36892": true,
      "36893": true,
      "36894": true,
      "36895": true,
      "36896": true,
      "36897": true,
      "36898": true,
      "36899": true
    },
    "PENJAMO": {
      "36900": true,
      "36901": true,
      "36902": true,
      "36903": true,
      "36904": true,
      "36905": true,
      "36906": true,
      "36907": true,
      "36908": true,
      "36909": true,
      "36910": true,
      "36911": true,
      "36912": true,
      "36923": true,
      "36924": true,
      "36925": true,
      "36926": true,
      "36927": true,
      "36928": true,
      "36929": true,
      "36930": true,
      "36931": true,
      "36932": true,
      "36933": true,
      "36935": true,
      "36936": true,
      "36937": true,
      "36938": true,
      "36939": true,
      "36943": true,
      "36946": true,
      "36947": true,
      "36948": true,
      "36949": true,
      "36950": true,
      "36951": true,
      "36952": true,
      "36953": true,
      "36954": true,
      "36955": true,
      "36956": true,
      "36957": true,
      "36958": true,
      "36959": true
    },
    "CUERAMARO": {
      "36960": true,
      "36961": true,
      "36962": true,
      "36963": true,
      "36964": true,
      "36965": true,
      "36966": true,
      "36967": true,
      "36968": true,
      "36969": true
    },
    "LEON": {
      "37000": true,
      "37001": true,
      "37002": true,
      "37003": true,
      "37004": true,
      "37005": true,
      "37006": true,
      "37007": true,
      "37008": true,
      "37009": true,
      "37010": true,
      "37011": true,
      "37012": true,
      "37013": true,
      "37014": true,
      "37015": true,
      "37016": true,
      "37017": true,
      "37018": true,
      "37019": true,
      "37020": true,
      "37021": true,
      "37022": true,
      "37023": true,
      "37024": true,
      "37025": true,
      "37026": true,
      "37027": true,
      "37028": true,
      "37029": true,
      "37030": true,
      "37031": true,
      "37032": true,
      "37033": true,
      "37034": true,
      "37035": true,
      "37036": true,
      "37037": true,
      "37038": true,
      "37039": true,
      "37040": true,
      "37041": true,
      "37042": true,
      "37043": true,
      "37044": true,
      "37045": true,
      "37046": true,
      "37047": true,
      "37048": true,
      "37049": true,
      "37050": true,
      "37051": true,
      "37052": true,
      "37053": true,
      "37054": true,
      "37055": true,
      "37056": true,
      "37057": true,
      "37058": true,
      "37059": true,
      "37060": true,
      "37061": true,
      "37062": true,
      "37063": true,
      "37064": true,
      "37065": true,
      "37066": true,
      "37067": true,
      "37068": true,
      "37069": true,
      "37070": true,
      "37071": true,
      "37072": true,
      "37073": true,
      "37074": true,
      "37075": true,
      "37076": true,
      "37077": true,
      "37078": true,
      "37079": true,
      "37080": true,
      "37081": true,
      "37082": true,
      "37083": true,
      "37084": true,
      "37085": true,
      "37086": true,
      "37087": true,
      "37088": true,
      "37089": true,
      "37090": true,
      "37091": true,
      "37092": true,
      "37093": true,
      "37094": true,
      "37095": true,
      "37096": true,
      "37097": true,
      "37098": true,
      "37099": true,
      "37100": true,
      "37101": true,
      "37102": true,
      "37103": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37111": true,
      "37112": true,
      "37113": true,
      "37114": true,
      "37115": true,
      "37116": true,
      "37117": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37121": true,
      "37122": true,
      "37123": true,
      "37124": true,
      "37125": true,
      "37126": true,
      "37127": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37131": true,
      "37132": true,
      "37133": true,
      "37134": true,
      "37135": true,
      "37136": true,
      "37137": true,
      "37138": true,
      "37139": true,
      "37140": true,
      "37141": true,
      "37142": true,
      "37143": true,
      "37144": true,
      "37145": true,
      "37146": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37151": true,
      "37152": true,
      "37153": true,
      "37154": true,
      "37155": true,
      "37156": true,
      "37157": true,
      "37158": true,
      "37159": true,
      "37160": true,
      "37161": true,
      "37162": true,
      "37163": true,
      "37164": true,
      "37165": true,
      "37166": true,
      "37167": true,
      "37168": true,
      "37169": true,
      "37170": true,
      "37171": true,
      "37172": true,
      "37173": true,
      "37174": true,
      "37175": true,
      "37176": true,
      "37177": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37181": true,
      "37182": true,
      "37183": true,
      "37184": true,
      "37185": true,
      "37186": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37191": true,
      "37192": true,
      "37193": true,
      "37194": true,
      "37195": true,
      "37196": true,
      "37197": true,
      "37198": true,
      "37199": true,
      "37200": true,
      "37201": true,
      "37202": true,
      "37203": true,
      "37204": true,
      "37205": true,
      "37206": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37211": true,
      "37212": true,
      "37213": true,
      "37214": true,
      "37215": true,
      "37216": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37221": true,
      "37222": true,
      "37223": true,
      "37224": true,
      "37225": true,
      "37226": true,
      "37227": true,
      "37228": true,
      "37229": true,
      "37230": true,
      "37231": true,
      "37232": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37241": true,
      "37242": true,
      "37243": true,
      "37244": true,
      "37245": true,
      "37246": true,
      "37247": true,
      "37248": true,
      "37249": true,
      "37250": true,
      "37251": true,
      "37252": true,
      "37253": true,
      "37254": true,
      "37255": true,
      "37256": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37261": true,
      "37262": true,
      "37263": true,
      "37264": true,
      "37265": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37271": true,
      "37272": true,
      "37273": true,
      "37274": true,
      "37275": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37281": true,
      "37282": true,
      "37283": true,
      "37284": true,
      "37285": true,
      "37286": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37291": true,
      "37292": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37301": true,
      "37302": true,
      "37303": true,
      "37304": true,
      "37305": true,
      "37306": true,
      "37307": true,
      "37308": true,
      "37309": true,
      "37310": true,
      "37311": true,
      "37312": true,
      "37313": true,
      "37314": true,
      "37315": true,
      "37316": true,
      "37317": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37321": true,
      "37322": true,
      "37323": true,
      "37324": true,
      "37325": true,
      "37326": true,
      "37327": true,
      "37328": true,
      "37329": true,
      "37330": true,
      "37331": true,
      "37332": true,
      "37333": true,
      "37334": true,
      "37335": true,
      "37336": true,
      "37337": true,
      "37338": true,
      "37339": true,
      "37340": true,
      "37341": true,
      "37342": true,
      "37343": true,
      "37344": true,
      "37345": true,
      "37346": true,
      "37347": true,
      "37348": true,
      "37349": true,
      "37350": true,
      "37351": true,
      "37352": true,
      "37353": true,
      "37354": true,
      "37355": true,
      "37356": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37361": true,
      "37362": true,
      "37363": true,
      "37364": true,
      "37365": true,
      "37366": true,
      "37367": true,
      "37368": true,
      "37369": true,
      "37370": true,
      "37371": true,
      "37372": true,
      "37373": true,
      "37374": true,
      "37375": true,
      "37376": true,
      "37377": true,
      "37378": true,
      "37379": true,
      "37380": true,
      "37381": true,
      "37382": true,
      "37383": true,
      "37384": true,
      "37385": true,
      "37386": true,
      "37387": true,
      "37388": true,
      "37389": true,
      "37390": true,
      "37391": true,
      "37392": true,
      "37393": true,
      "37394": true,
      "37395": true,
      "37396": true,
      "37397": true,
      "37398": true,
      "37399": true,
      "37400": true,
      "37401": true,
      "37402": true,
      "37403": true,
      "37404": true,
      "37405": true,
      "37406": true,
      "37407": true,
      "37408": true,
      "37409": true,
      "37410": true,
      "37411": true,
      "37412": true,
      "37413": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37418": true,
      "37419": true,
      "37420": true,
      "37421": true,
      "37422": true,
      "37423": true,
      "37424": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37429": true,
      "37430": true,
      "37431": true,
      "37432": true,
      "37433": true,
      "37434": true,
      "37435": true,
      "37436": true,
      "37437": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37441": true,
      "37442": true,
      "37443": true,
      "37444": true,
      "37445": true,
      "37446": true,
      "37447": true,
      "37448": true,
      "37449": true,
      "37450": true,
      "37451": true,
      "37452": true,
      "37453": true,
      "37454": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37461": true,
      "37462": true,
      "37463": true,
      "37464": true,
      "37465": true,
      "37466": true,
      "37467": true,
      "37468": true,
      "37469": true,
      "37470": true,
      "37471": true,
      "37472": true,
      "37473": true,
      "37474": true,
      "37475": true,
      "37476": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37481": true,
      "37482": true,
      "37483": true,
      "37484": true,
      "37485": true,
      "37486": true,
      "37487": true,
      "37488": true,
      "37489": true,
      "37490": true,
      "37491": true,
      "37492": true,
      "37493": true,
      "37494": true,
      "37495": true,
      "37496": true,
      "37497": true,
      "37498": true,
      "37499": true,
      "37500": true,
      "37501": true,
      "37502": true,
      "37503": true,
      "37504": true,
      "37505": true,
      "37506": true,
      "37507": true,
      "37508": true,
      "37509": true,
      "37510": true,
      "37511": true,
      "37512": true,
      "37513": true,
      "37514": true,
      "37515": true,
      "37516": true,
      "37517": true,
      "37518": true,
      "37519": true,
      "37520": true,
      "37521": true,
      "37522": true,
      "37523": true,
      "37524": true,
      "37525": true,
      "37526": true,
      "37527": true,
      "37528": true,
      "37529": true,
      "37530": true,
      "37531": true,
      "37532": true,
      "37533": true,
      "37534": true,
      "37535": true,
      "37536": true,
      "37537": true,
      "37538": true,
      "37539": true,
      "37540": true,
      "37541": true,
      "37542": true,
      "37543": true,
      "37544": true,
      "37545": true,
      "37546": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37551": true,
      "37552": true,
      "37553": true,
      "37554": true,
      "37555": true,
      "37556": true,
      "37557": true,
      "37558": true,
      "37559": true,
      "37560": true,
      "37561": true,
      "37562": true,
      "37563": true,
      "37564": true,
      "37565": true,
      "37566": true,
      "37567": true,
      "37568": true,
      "37569": true,
      "37570": true,
      "37571": true,
      "37572": true,
      "37573": true,
      "37574": true,
      "37575": true,
      "37576": true,
      "37577": true,
      "37578": true,
      "37579": true,
      "37580": true,
      "37581": true,
      "37582": true,
      "37583": true,
      "37584": true,
      "37585": true,
      "37586": true,
      "37587": true,
      "37588": true,
      "37589": true,
      "37590": true,
      "37591": true,
      "37592": true,
      "37593": true,
      "37594": true,
      "37595": true,
      "37596": true,
      "37597": true,
      "37598": true,
      "37599": true,
      "37650": true,
      "37651": true,
      "37652": true,
      "37653": true,
      "37654": true,
      "37655": true,
      "37656": true,
      "37657": true,
      "37658": true,
      "37659": true,
      "37660": true,
      "37661": true,
      "37662": true,
      "37663": true,
      "37664": true,
      "37665": true,
      "37666": true,
      "37667": true,
      "37668": true,
      "37669": true,
      "37670": true,
      "37671": true,
      "37672": true,
      "37673": true,
      "37674": true,
      "37675": true,
      "37676": true,
      "37677": true,
      "37678": true,
      "37679": true,
      "37680": true,
      "37681": true,
      "37682": true,
      "37683": true,
      "37684": true,
      "37685": true,
      "37686": true,
      "37687": true,
      "37688": true,
      "37689": true,
      "37690": true,
      "37691": true,
      "37692": true,
      "37693": true,
      "37694": true,
      "37695": true,
      "37696": true,
      "37697": true,
      "37698": true,
      "37699": true
    },
    "LEÓN": {
      "37000": true,
      "37004": true,
      "37010": true,
      "37020": true,
      "37100": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37123": true,
      "37125": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37134": true,
      "37138": true,
      "37140": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37156": true,
      "37157": true,
      "37160": true,
      "37168": true,
      "37170": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37199": true,
      "37200": true,
      "37204": true,
      "37205": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37225": true,
      "37227": true,
      "37230": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37249": true,
      "37250": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37306": true,
      "37310": true,
      "37315": true,
      "37316": true,
      "37317": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37327": true,
      "37328": true,
      "37330": true,
      "37340": true,
      "37350": true,
      "37353": true,
      "37355": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37364": true,
      "37366": true,
      "37368": true,
      "37369": true,
      "37380": true,
      "37390": true,
      "37399": true,
      "37400": true,
      "37407": true,
      "37408": true,
      "37410": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37418": true,
      "37419": true,
      "37420": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37430": true,
      "37433": true,
      "37434": true,
      "37436": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37443": true,
      "37444": true,
      "37446": true,
      "37448": true,
      "37450": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37468": true,
      "37470": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37487": true,
      "37490": true,
      "37500": true,
      "37510": true,
      "37520": true,
      "37526": true,
      "37530": true,
      "37536": true,
      "37538": true,
      "37539": true,
      "37544": true,
      "37545": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37555": true,
      "37557": true,
      "37560": true,
      "37564": true,
      "37566": true,
      "37570": true,
      "37580": true,
      "37590": true,
      "37669": true,
      "37677": true,
      "37680": true,
      "37684": true,
      "37685": true
    },
    "SAN FELIPE": {
      "37600": true,
      "37601": true,
      "37602": true,
      "37603": true,
      "37604": true,
      "37605": true,
      "37606": true,
      "37607": true,
      "37608": true,
      "37609": true,
      "37610": true,
      "37611": true,
      "37612": true,
      "37614": true,
      "37615": true,
      "37616": true,
      "37617": true,
      "37618": true,
      "37619": true
    },
    "OCAMPO": {
      "37630": true,
      "37631": true,
      "37632": true,
      "37633": true,
      "37634": true,
      "37636": true,
      "37637": true,
      "37638": true,
      "37639": true,
      "37642": true,
      "37645": true
    },
    "SAN MIGUEL DE ALLENDE": {
      "37700": true,
      "37701": true,
      "37702": true,
      "37703": true,
      "37704": true,
      "37705": true,
      "37706": true,
      "37707": true,
      "37708": true,
      "37709": true,
      "37710": true,
      "37711": true,
      "37712": true,
      "37713": true,
      "37714": true,
      "37715": true,
      "37716": true,
      "37717": true,
      "37718": true,
      "37719": true,
      "37720": true,
      "37721": true,
      "37722": true,
      "37723": true,
      "37724": true,
      "37725": true,
      "37726": true,
      "37727": true,
      "37728": true,
      "37729": true,
      "37730": true,
      "37731": true,
      "37732": true,
      "37733": true,
      "37734": true,
      "37735": true,
      "37736": true,
      "37737": true,
      "37738": true,
      "37739": true,
      "37740": true,
      "37741": true,
      "37742": true,
      "37743": true,
      "37744": true,
      "37745": true,
      "37746": true,
      "37747": true,
      "37748": true,
      "37749": true,
      "37750": true,
      "37751": true,
      "37752": true,
      "37753": true,
      "37754": true,
      "37755": true,
      "37756": true,
      "37757": true,
      "37758": true,
      "37759": true,
      "37760": true,
      "37761": true,
      "37762": true,
      "37763": true,
      "37764": true,
      "37765": true,
      "37766": true,
      "37767": true,
      "37768": true,
      "37769": true,
      "37770": true,
      "37771": true,
      "37772": true,
      "37773": true,
      "37774": true,
      "37775": true,
      "37776": true,
      "37777": true,
      "37778": true,
      "37779": true,
      "37780": true,
      "37781": true,
      "37782": true,
      "37783": true,
      "37784": true,
      "37785": true,
      "37786": true,
      "37787": true,
      "37788": true,
      "37789": true,
      "37790": true,
      "37791": true,
      "37792": true,
      "37793": true,
      "37794": true,
      "37795": true,
      "37796": true,
      "37797": true,
      "37798": true,
      "37799": true,
      "37880": true,
      "37881": true,
      "37882": true,
      "37883": true,
      "37884": true,
      "37885": true,
      "37886": true,
      "37887": true,
      "37888": true,
      "37889": true,
      "37890": true,
      "37891": true,
      "37892": true,
      "37893": true,
      "37894": true,
      "37896": true,
      "37897": true,
      "37898": true,
      "37899": true
    },
    "DOLORES HIDALGO CUNA DE LA INDEPENDENCIA NACIONAL": {
      "37800": true,
      "37801": true,
      "37802": true,
      "37803": true,
      "37804": true,
      "37805": true,
      "37806": true,
      "37807": true,
      "37808": true,
      "37809": true,
      "37810": true,
      "37811": true,
      "37812": true,
      "37814": true,
      "37815": true,
      "37816": true,
      "37817": true,
      "37818": true,
      "37821": true,
      "37822": true,
      "37825": true,
      "37828": true,
      "37829": true,
      "37830": true,
      "37831": true,
      "37832": true,
      "37833": true,
      "37834": true,
      "37835": true,
      "37836": true,
      "37837": true,
      "37840": true,
      "37841": true,
      "37842": true,
      "37843": true,
      "37844": true,
      "37845": true,
      "37846": true,
      "37847": true,
      "37848": true,
      "37849": true
    },
    "SAN LUIS DE LA PAZ": {
      "37900": true,
      "37901": true,
      "37902": true,
      "37903": true,
      "37904": true,
      "37905": true,
      "37906": true,
      "37907": true,
      "37908": true,
      "37909": true,
      "37910": true,
      "37911": true,
      "37912": true,
      "37914": true,
      "37915": true,
      "37917": true
    },
    "SAN JOSE ITURBIDE": {
      "37980": true,
      "37981": true,
      "37982": true,
      "37983": true,
      "37984": true,
      "37985": true,
      "37986": true,
      "37987": true,
      "37988": true,
      "37989": true,
      "37990": true,
      "37991": true,
      "37992": true,
      "37993": true,
      "37994": true,
      "37995": true,
      "37996": true,
      "37997": true,
      "37998": true,
      "37999": true
    },
    "CELAYA": {
      "38000": true,
      "38001": true,
      "38002": true,
      "38003": true,
      "38004": true,
      "38005": true,
      "38006": true,
      "38007": true,
      "38008": true,
      "38009": true,
      "38010": true,
      "38011": true,
      "38012": true,
      "38013": true,
      "38014": true,
      "38015": true,
      "38016": true,
      "38017": true,
      "38018": true,
      "38019": true,
      "38020": true,
      "38021": true,
      "38022": true,
      "38023": true,
      "38024": true,
      "38025": true,
      "38026": true,
      "38027": true,
      "38028": true,
      "38029": true,
      "38030": true,
      "38031": true,
      "38032": true,
      "38033": true,
      "38034": true,
      "38035": true,
      "38036": true,
      "38037": true,
      "38038": true,
      "38039": true,
      "38040": true,
      "38041": true,
      "38042": true,
      "38043": true,
      "38044": true,
      "38045": true,
      "38046": true,
      "38047": true,
      "38048": true,
      "38049": true,
      "38050": true,
      "38051": true,
      "38052": true,
      "38053": true,
      "38054": true,
      "38055": true,
      "38056": true,
      "38057": true,
      "38058": true,
      "38059": true,
      "38060": true,
      "38061": true,
      "38062": true,
      "38063": true,
      "38064": true,
      "38065": true,
      "38066": true,
      "38067": true,
      "38068": true,
      "38069": true,
      "38070": true,
      "38071": true,
      "38072": true,
      "38073": true,
      "38074": true,
      "38075": true,
      "38076": true,
      "38077": true,
      "38078": true,
      "38079": true,
      "38080": true,
      "38081": true,
      "38082": true,
      "38083": true,
      "38084": true,
      "38085": true,
      "38086": true,
      "38087": true,
      "38088": true,
      "38089": true,
      "38090": true,
      "38091": true,
      "38092": true,
      "38093": true,
      "38094": true,
      "38095": true,
      "38096": true,
      "38097": true,
      "38098": true,
      "38099": true,
      "38100": true,
      "38101": true,
      "38102": true,
      "38103": true,
      "38104": true,
      "38105": true,
      "38106": true,
      "38107": true,
      "38108": true,
      "38109": true,
      "38110": true,
      "38111": true,
      "38112": true,
      "38113": true,
      "38114": true,
      "38115": true,
      "38116": true,
      "38117": true,
      "38118": true,
      "38119": true,
      "38120": true,
      "38121": true,
      "38122": true,
      "38123": true,
      "38124": true,
      "38125": true,
      "38126": true,
      "38127": true,
      "38128": true,
      "38129": true,
      "38130": true,
      "38131": true,
      "38132": true,
      "38133": true,
      "38134": true,
      "38135": true,
      "38136": true,
      "38137": true,
      "38138": true,
      "38139": true,
      "38140": true,
      "38141": true,
      "38142": true,
      "38143": true,
      "38144": true,
      "38145": true,
      "38146": true,
      "38147": true,
      "38148": true,
      "38149": true,
      "38150": true,
      "38151": true,
      "38152": true,
      "38153": true,
      "38154": true,
      "38155": true,
      "38156": true,
      "38157": true,
      "38158": true,
      "38159": true
    },
    "APASEO EL GRANDE": {
      "38160": true,
      "38161": true,
      "38162": true,
      "38163": true,
      "38164": true,
      "38165": true,
      "38166": true,
      "38167": true,
      "38168": true,
      "38169": true,
      "38173": true,
      "38174": true,
      "38176": true,
      "38177": true,
      "38178": true,
      "38179": true,
      "38180": true,
      "38181": true,
      "38182": true,
      "38185": true,
      "38186": true,
      "38187": true,
      "38190": true,
      "38191": true,
      "38192": true,
      "38193": true,
      "38194": true,
      "38195": true,
      "38196": true,
      "38197": true,
      "38198": true,
      "38199": true
    },
    "COMONFORT": {
      "38200": true,
      "38201": true,
      "38202": true,
      "38203": true,
      "38204": true,
      "38205": true,
      "38206": true,
      "38207": true,
      "38208": true,
      "38209": true,
      "38210": true,
      "38211": true,
      "38212": true,
      "38213": true,
      "38214": true,
      "38215": true,
      "38216": true,
      "38217": true,
      "38218": true,
      "38219": true,
      "38220": true,
      "38221": true,
      "38222": true,
      "38223": true,
      "38224": true,
      "38225": true,
      "38227": true,
      "38228": true,
      "38229": true,
      "38230": true,
      "38231": true,
      "38232": true,
      "38233": true,
      "38234": true,
      "38235": true,
      "38236": true,
      "38237": true,
      "38238": true,
      "38239": true
    },
    "SANTA CRUZ DE JUVENTINO ROSAS": {
      "38240": true,
      "38241": true,
      "38242": true,
      "38243": true,
      "38244": true,
      "38245": true,
      "38246": true,
      "38247": true,
      "38248": true,
      "38249": true,
      "38250": true,
      "38251": true,
      "38252": true,
      "38253": true,
      "38254": true,
      "38255": true,
      "38256": true
    },
    "VILLAGRAN": {
      "38260": true,
      "38261": true,
      "38262": true,
      "38263": true,
      "38264": true,
      "38265": true,
      "38266": true,
      "38267": true,
      "38268": true,
      "38269": true,
      "38270": true,
      "38271": true,
      "38272": true,
      "38273": true,
      "38274": true,
      "38275": true,
      "38276": true,
      "38277": true,
      "38278": true,
      "38279": true,
      "38280": true,
      "38281": true,
      "38282": true,
      "38283": true,
      "38284": true,
      "38285": true,
      "38286": true,
      "38287": true,
      "38288": true,
      "38289": true,
      "38290": true,
      "38291": true,
      "38292": true,
      "38293": true,
      "38294": true,
      "38295": true,
      "38296": true,
      "38297": true,
      "38298": true,
      "38299": true
    },
    "CORTAZAR": {
      "38300": true,
      "38301": true,
      "38302": true,
      "38303": true,
      "38304": true,
      "38305": true,
      "38306": true,
      "38307": true,
      "38308": true,
      "38309": true,
      "38310": true,
      "38311": true,
      "38312": true,
      "38313": true,
      "38314": true,
      "38315": true,
      "38316": true,
      "38317": true,
      "38318": true,
      "38319": true,
      "38320": true,
      "38321": true,
      "38322": true,
      "38323": true,
      "38324": true,
      "38329": true,
      "38330": true,
      "38331": true,
      "38332": true,
      "38333": true,
      "38334": true,
      "38335": true,
      "38336": true,
      "38337": true,
      "38338": true,
      "38339": true,
      "38340": true,
      "38341": true,
      "38342": true,
      "38343": true,
      "38344": true,
      "38345": true,
      "38346": true,
      "38347": true,
      "38348": true,
      "38349": true,
      "38350": true,
      "38351": true,
      "38352": true,
      "38353": true,
      "38354": true,
      "38355": true,
      "38356": true,
      "38357": true,
      "38358": true,
      "38359": true,
      "38360": true,
      "38361": true,
      "38362": true,
      "38363": true,
      "38364": true,
      "38365": true,
      "38366": true,
      "38367": true,
      "38368": true,
      "38369": true,
      "38370": true,
      "38371": true,
      "38372": true,
      "38373": true,
      "38374": true,
      "38375": true,
      "38376": true,
      "38377": true,
      "38378": true,
      "38379": true,
      "38380": true,
      "38381": true,
      "38382": true,
      "38490": true,
      "38491": true,
      "38492": true,
      "38493": true,
      "38494": true,
      "38495": true,
      "38496": true,
      "38497": true,
      "38499": true
    },
    "VALLE DE SANTIAGO": {
      "38400": true,
      "38401": true,
      "38402": true,
      "38403": true,
      "38404": true,
      "38405": true,
      "38406": true,
      "38407": true,
      "38408": true,
      "38409": true,
      "38410": true,
      "38411": true,
      "38412": true,
      "38413": true,
      "38414": true,
      "38415": true,
      "38416": true,
      "38417": true,
      "38418": true,
      "38419": true,
      "38420": true,
      "38421": true,
      "38422": true,
      "38423": true,
      "38424": true,
      "38425": true,
      "38426": true,
      "38427": true,
      "38428": true,
      "38429": true,
      "38430": true,
      "38431": true,
      "38432": true,
      "38434": true,
      "38435": true,
      "38440": true,
      "38441": true,
      "38442": true,
      "38443": true,
      "38444": true,
      "38446": true,
      "38447": true,
      "38448": true,
      "38449": true,
      "38450": true,
      "38451": true,
      "38452": true,
      "38453": true,
      "38455": true,
      "38456": true,
      "38457": true,
      "38458": true,
      "38459": true,
      "38460": true,
      "38461": true,
      "38462": true,
      "38464": true
    },
    "JARAL DEL PROGRESO": {
      "38470": true,
      "38471": true,
      "38472": true,
      "38473": true,
      "38474": true,
      "38475": true,
      "38476": true,
      "38477": true,
      "38478": true,
      "38479": true,
      "38480": true,
      "38481": true,
      "38482": true,
      "38483": true,
      "38484": true,
      "38485": true,
      "38486": true,
      "38487": true,
      "38488": true,
      "38489": true
    },
    "APASEO EL ALTO": {
      "38500": true,
      "38501": true,
      "38502": true,
      "38503": true,
      "38504": true,
      "38505": true,
      "38506": true,
      "38507": true,
      "38508": true,
      "38509": true,
      "38510": true,
      "38511": true,
      "38512": true,
      "38513": true,
      "38514": true,
      "38515": true,
      "38517": true,
      "38518": true,
      "38519": true,
      "38520": true,
      "38521": true,
      "38522": true,
      "38523": true,
      "38524": true,
      "38525": true,
      "38526": true,
      "38527": true,
      "38528": true,
      "38529": true,
      "38530": true,
      "38531": true,
      "38532": true,
      "38534": true,
      "38535": true
    },
    "JERECUARO": {
      "38540": true,
      "38541": true,
      "38542": true,
      "38543": true,
      "38544": true,
      "38545": true,
      "38546": true,
      "38547": true,
      "38548": true,
      "38549": true,
      "38550": true,
      "38551": true,
      "38552": true,
      "38553": true,
      "38554": true,
      "38555": true,
      "38556": true,
      "38557": true,
      "38558": true,
      "38559": true,
      "38560": true,
      "38561": true,
      "38562": true,
      "38563": true,
      "38564": true,
      "38565": true,
      "38566": true,
      "38567": true,
      "38568": true,
      "38569": true,
      "38570": true,
      "38571": true,
      "38572": true,
      "38573": true,
      "38574": true,
      "38575": true,
      "38576": true,
      "38577": true,
      "38578": true,
      "38579": true,
      "38584": true,
      "38586": true,
      "38587": true,
      "38588": true,
      "38589": true
    },
    "ACAMBARO": {
      "38600": true,
      "38601": true,
      "38602": true,
      "38603": true,
      "38604": true,
      "38605": true,
      "38606": true,
      "38607": true,
      "38608": true,
      "38609": true,
      "38610": true,
      "38611": true,
      "38612": true,
      "38613": true,
      "38614": true,
      "38615": true,
      "38616": true,
      "38617": true,
      "38618": true,
      "38619": true,
      "38620": true,
      "38621": true,
      "38622": true,
      "38623": true,
      "38624": true,
      "38625": true,
      "38626": true,
      "38627": true,
      "38628": true,
      "38629": true,
      "38630": true,
      "38631": true,
      "38632": true,
      "38633": true,
      "38634": true,
      "38635": true,
      "38636": true,
      "38637": true,
      "38638": true,
      "38639": true,
      "38640": true,
      "38641": true,
      "38642": true,
      "38643": true,
      "38644": true,
      "38645": true,
      "38646": true,
      "38647": true,
      "38648": true,
      "38649": true,
      "38650": true,
      "38651": true,
      "38652": true,
      "38653": true,
      "38654": true,
      "38655": true,
      "38656": true,
      "38657": true,
      "38658": true,
      "38659": true,
      "38660": true,
      "38661": true,
      "38662": true,
      "38663": true,
      "38664": true,
      "38665": true,
      "38666": true,
      "38667": true,
      "38668": true,
      "38669": true,
      "38670": true,
      "38671": true,
      "38672": true,
      "38673": true,
      "38674": true,
      "38675": true,
      "38676": true,
      "38677": true,
      "38678": true,
      "38679": true,
      "38680": true,
      "38681": true,
      "38682": true,
      "38683": true,
      "38684": true,
      "38685": true,
      "38686": true,
      "38687": true,
      "38688": true,
      "38689": true,
      "38690": true,
      "38691": true,
      "38692": true,
      "38693": true,
      "38694": true,
      "38695": true,
      "38696": true,
      "38697": true,
      "38698": true,
      "38699": true,
      "38730": true,
      "38731": true,
      "38732": true,
      "38733": true,
      "38734": true,
      "38735": true,
      "38736": true,
      "38737": true,
      "38738": true,
      "38739": true,
      "38740": true,
      "38741": true,
      "38742": true,
      "38743": true,
      "38744": true,
      "38747": true,
      "38748": true,
      "38749": true,
      "38750": true,
      "38751": true,
      "38752": true,
      "38753": true,
      "38754": true,
      "38755": true,
      "38756": true,
      "38757": true,
      "38758": true,
      "38759": true,
      "38760": true,
      "38761": true,
      "38762": true,
      "38763": true,
      "38764": true,
      "38765": true,
      "38766": true,
      "38770": true,
      "38771": true,
      "38772": true,
      "38776": true,
      "38777": true,
      "38778": true,
      "38779": true,
      "38780": true,
      "38781": true,
      "38782": true,
      "38783": true,
      "38784": true,
      "38785": true,
      "38786": true,
      "38787": true,
      "38788": true,
      "38789": true
    },
    "TARIMORO": {
      "38700": true,
      "38701": true,
      "38702": true,
      "38703": true,
      "38704": true,
      "38705": true,
      "38706": true,
      "38707": true,
      "38708": true,
      "38709": true,
      "38710": true,
      "38711": true,
      "38714": true,
      "38715": true,
      "38716": true,
      "38717": true,
      "38718": true,
      "38719": true,
      "38720": true,
      "38721": true,
      "38722": true,
      "38723": true,
      "38724": true,
      "38725": true,
      "38726": true
    },
    "TARANDACUAO": {
      "38790": true,
      "38791": true,
      "38792": true,
      "38793": true,
      "38794": true,
      "38795": true,
      "38796": true,
      "38797": true,
      "38798": true,
      "38799": true
    },
    "MOROLEON": {
      "38800": true,
      "38801": true,
      "38802": true,
      "38803": true,
      "38804": true,
      "38805": true,
      "38806": true,
      "38807": true,
      "38808": true,
      "38809": true,
      "38810": true,
      "38811": true,
      "38812": true,
      "38813": true,
      "38814": true,
      "38815": true,
      "38816": true,
      "38817": true,
      "38818": true,
      "38819": true,
      "38820": true,
      "38821": true,
      "38822": true,
      "38823": true,
      "38824": true,
      "38825": true,
      "38826": true,
      "38827": true,
      "38828": true,
      "38829": true,
      "38830": true,
      "38831": true,
      "38832": true,
      "38833": true,
      "38834": true,
      "38835": true,
      "38836": true,
      "38837": true,
      "38838": true,
      "38839": true,
      "38840": true,
      "38841": true,
      "38842": true,
      "38843": true,
      "38844": true,
      "38845": true,
      "38846": true,
      "38847": true,
      "38848": true,
      "38849": true,
      "38850": true,
      "38851": true,
      "38852": true,
      "38853": true,
      "38854": true,
      "38855": true,
      "38856": true,
      "38857": true,
      "38858": true,
      "38859": true,
      "38860": true,
      "38861": true,
      "38862": true,
      "38863": true,
      "38864": true,
      "38865": true,
      "38866": true,
      "38867": true,
      "38868": true,
      "38869": true,
      "38870": true,
      "38871": true,
      "38872": true,
      "38873": true,
      "38874": true,
      "38875": true,
      "38876": true,
      "38877": true,
      "38878": true,
      "38879": true,
      "38880": true,
      "38881": true,
      "38882": true,
      "38883": true,
      "38884": true,
      "38885": true,
      "38886": true,
      "38887": true,
      "38888": true,
      "38889": true,
      "38890": true,
      "38891": true,
      "38892": true,
      "38893": true,
      "38894": true,
      "38895": true,
      "38896": true,
      "38897": true,
      "38898": true,
      "38899": true,
      "38990": true,
      "38991": true,
      "38992": true,
      "38993": true,
      "38994": true,
      "38995": true,
      "38996": true,
      "38997": true,
      "38998": true,
      "38999": true
    },
    "SALVATIERRA": {
      "38900": true,
      "38901": true,
      "38902": true,
      "38903": true,
      "38904": true,
      "38905": true,
      "38906": true,
      "38907": true,
      "38908": true,
      "38910": true,
      "38911": true,
      "38912": true,
      "38913": true,
      "38914": true,
      "38915": true,
      "38916": true,
      "38917": true,
      "38918": true,
      "38919": true,
      "38920": true,
      "38921": true,
      "38922": true,
      "38923": true,
      "38924": true,
      "38925": true,
      "38926": true,
      "38930": true,
      "38931": true,
      "38932": true,
      "38933": true,
      "38934": true,
      "38935": true,
      "38936": true,
      "38937": true,
      "38938": true,
      "38939": true
    },
    "YURIRIA": {
      "38940": true,
      "38941": true,
      "38942": true,
      "38943": true,
      "38944": true,
      "38945": true,
      "38946": true,
      "38947": true,
      "38948": true,
      "38949": true,
      "38950": true,
      "38951": true,
      "38952": true,
      "38953": true,
      "38954": true,
      "38955": true,
      "38956": true,
      "38957": true,
      "38960": true,
      "38961": true,
      "38962": true,
      "38963": true,
      "38964": true,
      "38965": true,
      "38966": true,
      "38967": true,
      "38968": true,
      "38969": true
    },
    "SANTIAGO MARAVATIO": {
      "38970": true,
      "38971": true,
      "38972": true,
      "38973": true,
      "38974": true,
      "38975": true,
      "38976": true,
      "38977": true,
      "38978": true,
      "38979": true
    },
    "URIANGATO": {
      "38980": true,
      "38981": true,
      "38982": true,
      "38983": true,
      "38984": true,
      "38985": true,
      "38986": true,
      "38987": true,
      "38988": true,
      "38989": true
    }
  },
  "GUERRERO": {
    "CHILPANCINGO DE LOS BRAVO": {
      "39000": true,
      "39001": true,
      "39002": true,
      "39003": true,
      "39004": true,
      "39005": true,
      "39006": true,
      "39007": true,
      "39008": true,
      "39009": true,
      "39010": true,
      "39011": true,
      "39012": true,
      "39013": true,
      "39014": true,
      "39015": true,
      "39016": true,
      "39017": true,
      "39018": true,
      "39019": true,
      "39020": true,
      "39021": true,
      "39022": true,
      "39023": true,
      "39024": true,
      "39025": true,
      "39026": true,
      "39027": true,
      "39028": true,
      "39029": true,
      "39030": true,
      "39031": true,
      "39032": true,
      "39033": true,
      "39034": true,
      "39035": true,
      "39036": true,
      "39037": true,
      "39038": true,
      "39039": true,
      "39040": true,
      "39041": true,
      "39042": true,
      "39043": true,
      "39044": true,
      "39045": true,
      "39046": true,
      "39047": true,
      "39048": true,
      "39049": true,
      "39050": true,
      "39051": true,
      "39052": true,
      "39053": true,
      "39054": true,
      "39055": true,
      "39056": true,
      "39057": true,
      "39058": true,
      "39059": true,
      "39060": true,
      "39061": true,
      "39062": true,
      "39063": true,
      "39064": true,
      "39065": true,
      "39066": true,
      "39067": true,
      "39068": true,
      "39069": true,
      "39070": true,
      "39071": true,
      "39072": true,
      "39073": true,
      "39074": true,
      "39075": true,
      "39076": true,
      "39077": true,
      "39078": true,
      "39079": true,
      "39080": true,
      "39081": true,
      "39082": true,
      "39083": true,
      "39084": true,
      "39085": true,
      "39086": true,
      "39087": true,
      "39088": true,
      "39089": true,
      "39090": true,
      "39091": true,
      "39092": true,
      "39093": true,
      "39094": true,
      "39095": true,
      "39096": true,
      "39097": true,
      "39098": true,
      "39099": true,
      "39100": true,
      "39101": true,
      "39102": true,
      "39103": true,
      "39104": true,
      "39105": true,
      "39106": true,
      "39107": true,
      "39108": true,
      "39109": true,
      "39110": true,
      "39111": true,
      "39112": true,
      "39113": true,
      "39114": true,
      "39115": true,
      "39116": true,
      "39117": true,
      "39118": true,
      "39119": true,
      "39120": true,
      "39121": true,
      "39122": true,
      "39123": true,
      "39124": true,
      "39125": true,
      "39126": true,
      "39127": true,
      "39128": true,
      "39129": true
    },
    "LEONARDO BRAVO": {
      "39150": true,
      "39151": true,
      "39152": true,
      "39153": true,
      "39154": true,
      "39159": true,
      "39163": true
    },
    "TIXTLA DE GUERRERO": {
      "39170": true,
      "39171": true,
      "39172": true,
      "39173": true,
      "39174": true,
      "39175": true,
      "39176": true,
      "39177": true,
      "39179": true,
      "39180": true,
      "39181": true,
      "39182": true,
      "39183": true,
      "39184": true,
      "39185": true,
      "39186": true,
      "39187": true,
      "39188": true,
      "39189": true,
      "39193": true,
      "39194": true,
      "39195": true,
      "39196": true
    },
    "AYUTLA DE LOS LIBRES": {
      "39200": true,
      "39201": true,
      "39202": true,
      "39203": true,
      "39204": true,
      "39205": true,
      "39207": true,
      "39208": true,
      "39212": true,
      "39213": true,
      "39215": true,
      "39217": true,
      "39220": true,
      "39221": true,
      "39222": true,
      "39223": true,
      "39225": true
    },
    "MOCHITLAN": {
      "39230": true,
      "39231": true,
      "39232": true,
      "39233": true,
      "39234": true,
      "39235": true,
      "39241": true,
      "39242": true,
      "39243": true,
      "39244": true,
      "39245": true,
      "39246": true,
      "39247": true,
      "39248": true
    },
    "QUECHULTENANGO": {
      "39250": true,
      "39251": true,
      "39252": true,
      "39253": true,
      "39254": true,
      "39255": true,
      "39256": true,
      "39260": true,
      "39261": true,
      "39262": true,
      "39263": true
    },
    "TECOANAPA": {
      "39270": true,
      "39271": true,
      "39272": true,
      "39273": true,
      "39274": true,
      "39275": true,
      "39276": true,
      "39277": true,
      "39278": true,
      "39279": true,
      "39280": true,
      "39281": true,
      "39282": true,
      "39283": true,
      "39286": true,
      "39287": true,
      "39294": true,
      "39295": true,
      "39296": true,
      "39297": true,
      "39298": true,
      "39299": true
    },
    "ACAPULCO DE JUAREZ": {
      "39300": true,
      "39301": true,
      "39302": true,
      "39303": true,
      "39304": true,
      "39305": true,
      "39306": true,
      "39307": true,
      "39308": true,
      "39309": true,
      "39310": true,
      "39311": true,
      "39312": true,
      "39313": true,
      "39314": true,
      "39315": true,
      "39316": true,
      "39317": true,
      "39318": true,
      "39319": true,
      "39320": true,
      "39321": true,
      "39322": true,
      "39323": true,
      "39324": true,
      "39325": true,
      "39326": true,
      "39327": true,
      "39328": true,
      "39329": true,
      "39330": true,
      "39331": true,
      "39332": true,
      "39333": true,
      "39334": true,
      "39335": true,
      "39336": true,
      "39337": true,
      "39338": true,
      "39339": true,
      "39340": true,
      "39341": true,
      "39342": true,
      "39343": true,
      "39344": true,
      "39345": true,
      "39346": true,
      "39347": true,
      "39348": true,
      "39349": true,
      "39350": true,
      "39351": true,
      "39352": true,
      "39353": true,
      "39354": true,
      "39355": true,
      "39356": true,
      "39357": true,
      "39358": true,
      "39359": true,
      "39360": true,
      "39361": true,
      "39362": true,
      "39363": true,
      "39364": true,
      "39365": true,
      "39366": true,
      "39367": true,
      "39368": true,
      "39369": true,
      "39370": true,
      "39371": true,
      "39372": true,
      "39373": true,
      "39374": true,
      "39375": true,
      "39376": true,
      "39377": true,
      "39378": true,
      "39379": true,
      "39380": true,
      "39381": true,
      "39382": true,
      "39383": true,
      "39384": true,
      "39385": true,
      "39386": true,
      "39387": true,
      "39388": true,
      "39389": true,
      "39390": true,
      "39391": true,
      "39392": true,
      "39393": true,
      "39394": true,
      "39395": true,
      "39396": true,
      "39397": true,
      "39398": true,
      "39399": true,
      "39400": true,
      "39401": true,
      "39402": true,
      "39403": true,
      "39404": true,
      "39405": true,
      "39406": true,
      "39407": true,
      "39408": true,
      "39409": true,
      "39410": true,
      "39411": true,
      "39412": true,
      "39413": true,
      "39414": true,
      "39415": true,
      "39416": true,
      "39417": true,
      "39418": true,
      "39419": true,
      "39420": true,
      "39421": true,
      "39422": true,
      "39423": true,
      "39424": true,
      "39425": true,
      "39426": true,
      "39427": true,
      "39428": true,
      "39429": true,
      "39430": true,
      "39431": true,
      "39432": true,
      "39433": true,
      "39434": true,
      "39435": true,
      "39436": true,
      "39437": true,
      "39438": true,
      "39439": true,
      "39440": true,
      "39441": true,
      "39442": true,
      "39443": true,
      "39444": true,
      "39445": true,
      "39446": true,
      "39447": true,
      "39448": true,
      "39449": true,
      "39450": true,
      "39451": true,
      "39452": true,
      "39453": true,
      "39454": true,
      "39455": true,
      "39456": true,
      "39457": true,
      "39458": true,
      "39459": true,
      "39460": true,
      "39461": true,
      "39462": true,
      "39463": true,
      "39464": true,
      "39465": true,
      "39466": true,
      "39467": true,
      "39468": true,
      "39469": true,
      "39470": true,
      "39471": true,
      "39472": true,
      "39473": true,
      "39474": true,
      "39475": true,
      "39476": true,
      "39477": true,
      "39478": true,
      "39479": true,
      "39480": true,
      "39481": true,
      "39482": true,
      "39483": true,
      "39484": true,
      "39485": true,
      "39486": true,
      "39487": true,
      "39488": true,
      "39489": true,
      "39490": true,
      "39491": true,
      "39492": true,
      "39493": true,
      "39494": true,
      "39495": true,
      "39496": true,
      "39497": true,
      "39498": true,
      "39499": true,
      "39500": true,
      "39501": true,
      "39502": true,
      "39503": true,
      "39504": true,
      "39505": true,
      "39506": true,
      "39507": true,
      "39508": true,
      "39509": true,
      "39510": true,
      "39528": true,
      "39529": true,
      "39530": true,
      "39531": true,
      "39532": true,
      "39533": true,
      "39534": true,
      "39535": true,
      "39536": true,
      "39537": true,
      "39538": true,
      "39539": true,
      "39540": true,
      "39541": true,
      "39542": true,
      "39543": true,
      "39544": true,
      "39545": true,
      "39546": true,
      "39547": true,
      "39548": true,
      "39549": true,
      "39550": true,
      "39551": true,
      "39552": true,
      "39553": true,
      "39554": true,
      "39555": true,
      "39556": true,
      "39557": true,
      "39558": true,
      "39559": true,
      "39560": true,
      "39561": true,
      "39562": true,
      "39563": true,
      "39564": true,
      "39565": true,
      "39566": true,
      "39567": true,
      "39568": true,
      "39569": true,
      "39570": true,
      "39571": true,
      "39572": true,
      "39573": true,
      "39574": true,
      "39575": true,
      "39576": true,
      "39577": true,
      "39578": true,
      "39579": true,
      "39580": true,
      "39581": true,
      "39582": true,
      "39583": true,
      "39584": true,
      "39585": true,
      "39586": true,
      "39587": true,
      "39588": true,
      "39589": true,
      "39590": true,
      "39591": true,
      "39592": true,
      "39593": true,
      "39594": true,
      "39595": true,
      "39596": true,
      "39597": true,
      "39598": true,
      "39599": true,
      "39600": true,
      "39601": true,
      "39602": true,
      "39603": true,
      "39604": true,
      "39605": true,
      "39606": true,
      "39607": true,
      "39608": true,
      "39609": true,
      "39610": true,
      "39611": true,
      "39612": true,
      "39613": true,
      "39614": true,
      "39615": true,
      "39616": true,
      "39617": true,
      "39618": true,
      "39619": true,
      "39620": true,
      "39621": true,
      "39622": true,
      "39623": true,
      "39624": true,
      "39625": true,
      "39626": true,
      "39627": true,
      "39628": true,
      "39629": true,
      "39630": true,
      "39631": true,
      "39632": true,
      "39633": true,
      "39634": true,
      "39635": true,
      "39636": true,
      "39637": true,
      "39638": true,
      "39639": true,
      "39640": true,
      "39641": true,
      "39642": true,
      "39643": true,
      "39644": true,
      "39645": true,
      "39646": true,
      "39647": true,
      "39648": true,
      "39649": true,
      "39650": true,
      "39651": true,
      "39652": true,
      "39653": true,
      "39654": true,
      "39655": true,
      "39656": true,
      "39657": true,
      "39658": true,
      "39659": true,
      "39660": true,
      "39661": true,
      "39662": true,
      "39663": true,
      "39664": true,
      "39665": true,
      "39666": true,
      "39667": true,
      "39668": true,
      "39669": true,
      "39670": true,
      "39671": true,
      "39672": true,
      "39673": true,
      "39674": true,
      "39675": true,
      "39676": true,
      "39677": true,
      "39678": true,
      "39679": true,
      "39680": true,
      "39681": true,
      "39682": true,
      "39683": true,
      "39684": true,
      "39685": true,
      "39686": true,
      "39687": true,
      "39688": true,
      "39689": true,
      "39690": true,
      "39691": true,
      "39692": true,
      "39693": true,
      "39694": true,
      "39695": true,
      "39696": true,
      "39697": true,
      "39698": true,
      "39699": true,
      "39700": true,
      "39701": true,
      "39702": true,
      "39703": true,
      "39704": true,
      "39705": true,
      "39706": true,
      "39707": true,
      "39708": true,
      "39709": true,
      "39710": true,
      "39711": true,
      "39712": true,
      "39713": true,
      "39714": true,
      "39715": true,
      "39716": true,
      "39717": true,
      "39718": true,
      "39719": true,
      "39720": true,
      "39721": true,
      "39722": true,
      "39723": true,
      "39724": true,
      "39725": true,
      "39726": true,
      "39727": true,
      "39728": true,
      "39729": true,
      "39730": true,
      "39731": true,
      "39732": true,
      "39733": true,
      "39734": true,
      "39735": true,
      "39736": true,
      "39737": true,
      "39738": true,
      "39739": true,
      "39740": true,
      "39741": true,
      "39742": true,
      "39743": true,
      "39744": true,
      "39745": true,
      "39746": true,
      "39747": true,
      "39748": true,
      "39749": true,
      "39750": true,
      "39751": true,
      "39752": true,
      "39753": true,
      "39754": true,
      "39755": true,
      "39756": true,
      "39757": true,
      "39758": true,
      "39759": true,
      "39760": true,
      "39761": true,
      "39762": true,
      "39763": true,
      "39764": true,
      "39765": true,
      "39766": true,
      "39767": true,
      "39768": true,
      "39769": true,
      "39770": true,
      "39771": true,
      "39772": true,
      "39773": true,
      "39774": true,
      "39775": true,
      "39776": true,
      "39777": true,
      "39778": true,
      "39779": true,
      "39780": true,
      "39781": true,
      "39782": true,
      "39783": true,
      "39784": true,
      "39785": true,
      "39786": true,
      "39787": true,
      "39788": true,
      "39789": true,
      "39790": true,
      "39791": true,
      "39792": true,
      "39793": true,
      "39794": true,
      "39795": true,
      "39796": true,
      "39797": true,
      "39798": true,
      "39799": true,
      "39800": true,
      "39801": true,
      "39802": true,
      "39803": true,
      "39804": true,
      "39805": true,
      "39806": true,
      "39807": true,
      "39808": true,
      "39809": true,
      "39810": true,
      "39811": true,
      "39812": true,
      "39813": true,
      "39814": true,
      "39815": true,
      "39816": true,
      "39817": true,
      "39818": true,
      "39819": true,
      "39820": true,
      "39821": true,
      "39822": true,
      "39823": true,
      "39824": true,
      "39825": true,
      "39826": true,
      "39827": true,
      "39828": true,
      "39829": true,
      "39830": true,
      "39831": true,
      "39832": true,
      "39833": true,
      "39834": true,
      "39835": true,
      "39836": true,
      "39837": true,
      "39838": true,
      "39839": true,
      "39840": true,
      "39841": true,
      "39842": true,
      "39843": true,
      "39844": true,
      "39845": true,
      "39846": true,
      "39847": true,
      "39848": true,
      "39849": true,
      "39850": true,
      "39851": true,
      "39852": true,
      "39853": true,
      "39854": true,
      "39855": true,
      "39856": true,
      "39857": true,
      "39858": true,
      "39859": true,
      "39860": true,
      "39861": true,
      "39862": true,
      "39863": true,
      "39864": true,
      "39865": true,
      "39866": true,
      "39867": true,
      "39868": true,
      "39869": true,
      "39870": true,
      "39871": true,
      "39872": true,
      "39873": true,
      "39874": true,
      "39875": true,
      "39876": true,
      "39877": true,
      "39878": true,
      "39879": true,
      "39880": true,
      "39881": true,
      "39882": true,
      "39883": true,
      "39884": true,
      "39885": true,
      "39886": true,
      "39887": true,
      "39888": true,
      "39889": true,
      "39890": true,
      "39891": true,
      "39892": true,
      "39893": true,
      "39894": true,
      "39895": true,
      "39896": true,
      "39897": true,
      "39898": true,
      "39899": true,
      "39900": true,
      "39901": true,
      "39902": true,
      "39903": true,
      "39904": true,
      "39905": true,
      "39906": true,
      "39907": true,
      "39908": true,
      "39909": true,
      "39910": true,
      "39911": true,
      "39912": true,
      "39913": true,
      "39914": true,
      "39915": true,
      "39916": true,
      "39917": true,
      "39918": true,
      "39919": true,
      "39920": true,
      "39921": true,
      "39922": true,
      "39923": true,
      "39924": true,
      "39925": true,
      "39926": true,
      "39927": true,
      "39928": true,
      "39929": true,
      "39930": true,
      "39931": true,
      "39932": true,
      "39933": true,
      "39934": true,
      "39935": true,
      "39936": true,
      "39937": true,
      "39938": true,
      "39939": true
    },
    "JUAN R. ESCUDERO": {
      "39940": true,
      "39941": true,
      "39942": true,
      "39943": true,
      "39944": true,
      "39945": true,
      "39946": true,
      "39947": true,
      "39956": true,
      "39957": true,
      "39958": true,
      "39959": true
    },
    "SAN MARCOS": {
      "39960": true,
      "39961": true,
      "39964": true,
      "39965": true,
      "39966": true,
      "39968": true,
      "39969": true,
      "39970": true,
      "39971": true,
      "39972": true,
      "39973": true,
      "39974": true,
      "39975": true,
      "39976": true,
      "39977": true,
      "39978": true,
      "39979": true,
      "39980": true,
      "39981": true,
      "39982": true,
      "39983": true,
      "39985": true,
      "39989": true,
      "39990": true,
      "39991": true,
      "39992": true,
      "39993": true,
      "39994": true,
      "39995": true,
      "39996": true
    },
    "IGUALA DE LA INDEPENDENCIA": {
      "40000": true,
      "40001": true,
      "40002": true,
      "40003": true,
      "40004": true,
      "40005": true,
      "40006": true,
      "40007": true,
      "40008": true,
      "40009": true,
      "40010": true,
      "40011": true,
      "40012": true,
      "40013": true,
      "40014": true,
      "40015": true,
      "40016": true,
      "40017": true,
      "40018": true,
      "40019": true,
      "40020": true,
      "40021": true,
      "40022": true,
      "40023": true,
      "40024": true,
      "40025": true,
      "40026": true,
      "40027": true,
      "40028": true,
      "40029": true,
      "40030": true,
      "40031": true,
      "40032": true,
      "40033": true,
      "40034": true,
      "40035": true,
      "40036": true,
      "40037": true,
      "40038": true,
      "40039": true,
      "40040": true,
      "40041": true,
      "40042": true,
      "40043": true,
      "40044": true,
      "40045": true,
      "40046": true,
      "40047": true,
      "40048": true,
      "40049": true,
      "40050": true,
      "40051": true,
      "40052": true,
      "40053": true,
      "40054": true,
      "40055": true,
      "40056": true,
      "40057": true,
      "40058": true,
      "40059": true,
      "40060": true,
      "40061": true,
      "40062": true,
      "40063": true,
      "40064": true,
      "40065": true,
      "40066": true,
      "40067": true,
      "40068": true,
      "40069": true,
      "40070": true,
      "40071": true,
      "40072": true,
      "40073": true,
      "40074": true,
      "40075": true,
      "40076": true,
      "40077": true,
      "40078": true,
      "40079": true,
      "40080": true,
      "40081": true,
      "40082": true,
      "40083": true,
      "40084": true,
      "40085": true,
      "40086": true,
      "40087": true,
      "40088": true,
      "40089": true,
      "40090": true,
      "40091": true,
      "40092": true,
      "40093": true,
      "40094": true,
      "40095": true,
      "40096": true,
      "40097": true,
      "40098": true,
      "40099": true,
      "40100": true,
      "40101": true,
      "40102": true,
      "40103": true,
      "40104": true,
      "40105": true,
      "40106": true,
      "40107": true,
      "40108": true,
      "40109": true,
      "40110": true,
      "40111": true,
      "40112": true,
      "40113": true,
      "40114": true,
      "40115": true,
      "40116": true,
      "40117": true
    },
    "HUITZUCO DE LOS FIGUEROA": {
      "40130": true,
      "40131": true,
      "40132": true,
      "40133": true,
      "40134": true,
      "40135": true,
      "40136": true,
      "40141": true,
      "40142": true
    },
    "TEPECOACUILCO DE TRUJANO": {
      "40160": true,
      "40161": true,
      "40162": true,
      "40164": true,
      "40165": true,
      "40166": true,
      "40167": true,
      "40168": true,
      "40169": true,
      "40174": true,
      "40175": true,
      "40176": true,
      "40177": true,
      "40178": true,
      "40179": true
    },
    "EDUARDO NERI": {
      "40180": true,
      "40181": true,
      "40182": true,
      "40183": true,
      "40184": true,
      "40185": true,
      "40186": true,
      "40187": true,
      "40188": true,
      "40189": true,
      "40190": true,
      "40191": true,
      "40192": true,
      "40193": true,
      "40194": true,
      "40195": true,
      "40196": true,
      "40197": true,
      "40198": true,
      "40199": true
    },
    "TAXCO DE ALARCON": {
      "40200": true,
      "40201": true,
      "40202": true,
      "40203": true,
      "40204": true,
      "40205": true,
      "40206": true,
      "40207": true,
      "40208": true,
      "40209": true,
      "40210": true,
      "40212": true,
      "40213": true,
      "40214": true,
      "40215": true,
      "40216": true,
      "40217": true,
      "40218": true,
      "40219": true,
      "40220": true,
      "40221": true,
      "40222": true,
      "40223": true,
      "40224": true,
      "40225": true,
      "40226": true,
      "40227": true,
      "40228": true,
      "40229": true,
      "40230": true,
      "40231": true,
      "40232": true,
      "40233": true,
      "40234": true,
      "40235": true,
      "40236": true,
      "40237": true,
      "40238": true,
      "40239": true,
      "40240": true,
      "40241": true,
      "40242": true,
      "40243": true,
      "40244": true,
      "40245": true,
      "40246": true,
      "40247": true,
      "40248": true,
      "40249": true,
      "40250": true,
      "40251": true,
      "40252": true,
      "40253": true,
      "40254": true,
      "40255": true,
      "40256": true,
      "40257": true,
      "40258": true,
      "40259": true,
      "40260": true,
      "40261": true,
      "40262": true,
      "40263": true,
      "40264": true,
      "40265": true,
      "40266": true,
      "40267": true,
      "40268": true,
      "40269": true,
      "40270": true,
      "40271": true,
      "40272": true,
      "40273": true,
      "40274": true,
      "40275": true,
      "40276": true,
      "40277": true,
      "40278": true,
      "40279": true,
      "40280": true,
      "40281": true,
      "40282": true,
      "40283": true,
      "40284": true,
      "40285": true,
      "40286": true,
      "40287": true,
      "40288": true,
      "40289": true,
      "40290": true,
      "40291": true,
      "40292": true,
      "40293": true,
      "40294": true,
      "40295": true,
      "40296": true,
      "40297": true,
      "40298": true,
      "40299": true,
      "40300": true,
      "40301": true,
      "40305": true,
      "40306": true,
      "40307": true,
      "40308": true,
      "40309": true,
      "40310": true,
      "40311": true,
      "40312": true,
      "40313": true,
      "40314": true,
      "40315": true,
      "40316": true,
      "40320": true,
      "40321": true,
      "40322": true,
      "40323": true,
      "40324": true,
      "40325": true,
      "40327": true,
      "40328": true,
      "40329": true
    },
    "BUENAVISTA DE CUELLAR": {
      "40330": true,
      "40331": true,
      "40332": true,
      "40333": true,
      "40334": true,
      "40335": true,
      "40336": true,
      "40337": true,
      "40338": true,
      "40339": true,
      "40341": true,
      "40342": true,
      "40343": true,
      "40344": true,
      "40345": true,
      "40346": true,
      "40348": true,
      "40349": true,
      "40350": true,
      "40351": true,
      "40352": true,
      "40353": true,
      "40354": true,
      "40355": true,
      "40356": true,
      "40357": true,
      "40358": true,
      "40359": true
    },
    "TELOLOAPAN": {
      "40400": true,
      "40401": true,
      "40402": true,
      "40406": true,
      "40410": true,
      "40411": true,
      "40413": true,
      "40418": true,
      "40419": true,
      "40420": true,
      "40421": true,
      "40422": true,
      "40425": true,
      "40428": true
    },
    "COCULA": {
      "40580": true,
      "40582": true,
      "40583": true,
      "40584": true,
      "40585": true,
      "40586": true,
      "40587": true,
      "40588": true,
      "40589": true,
      "40590": true,
      "40598": true,
      "40599": true
    },
    "PETATLAN": {
      "40830": true,
      "40831": true,
      "40832": true,
      "40833": true,
      "40837": true,
      "40838": true,
      "40839": true,
      "40840": true,
      "40841": true,
      "40842": true,
      "40847": true,
      "40848": true,
      "40849": true,
      "40850": true,
      "40851": true,
      "40852": true,
      "40853": true,
      "40854": true,
      "40855": true,
      "40856": true
    },
    "ZIHUATANEJO DE AZUETA": {
      "40880": true,
      "40881": true,
      "40882": true,
      "40883": true,
      "40884": true,
      "40886": true,
      "40887": true,
      "40888": true,
      "40889": true,
      "40890": true,
      "40891": true,
      "40893": true,
      "40894": true,
      "40895": true,
      "40896": true,
      "40897": true,
      "40898": true,
      "40899": true
    },
    "TECPAN DE GALEANA": {
      "40900": true,
      "40901": true,
      "40902": true,
      "40903": true,
      "40904": true,
      "40905": true,
      "40906": true,
      "40907": true,
      "40908": true,
      "40913": true,
      "40914": true,
      "40922": true,
      "40923": true,
      "40924": true,
      "40925": true,
      "40926": true,
      "40927": true,
      "40928": true,
      "40929": true
    },
    "ATOYAC DE ALVAREZ": {
      "40930": true,
      "40931": true,
      "40932": true,
      "40933": true,
      "40934": true,
      "40935": true,
      "40936": true,
      "40937": true,
      "40938": true,
      "40939": true,
      "40941": true,
      "40942": true,
      "40947": true,
      "40948": true,
      "40949": true,
      "40952": true,
      "40955": true
    },
    "BENITO JUÁREZ": {
      "40960": true,
      "40961": true,
      "40962": true,
      "40963": true,
      "40964": true,
      "40965": true,
      "40966": true,
      "40967": true,
      "40968": true,
      "40969": true
    },
    "COYUCA DE BENITEZ": {
      "40970": true,
      "40971": true,
      "40972": true,
      "40973": true,
      "40974": true,
      "40975": true,
      "40976": true,
      "40977": true,
      "40978": true,
      "40979": true,
      "40980": true,
      "40982": true,
      "40983": true,
      "40984": true,
      "40985": true,
      "40986": true,
      "40987": true,
      "40988": true,
      "40989": true
    },
    "CHILAPA DE ALVAREZ": {
      "41100": true,
      "41101": true,
      "41102": true,
      "41103": true,
      "41104": true,
      "41105": true,
      "41106": true,
      "41107": true,
      "41108": true,
      "41109": true,
      "41110": true,
      "41111": true,
      "41112": true,
      "41113": true,
      "41114": true,
      "41115": true,
      "41118": true,
      "41119": true
    },
    "JOSE JOAQUIN DE HERRERA": {
      "41120": true,
      "41121": true,
      "41122": true,
      "41123": true,
      "41124": true,
      "41125": true,
      "41126": true,
      "41127": true,
      "41128": true,
      "41129": true
    },
    "ZITLALA": {
      "41160": true,
      "41161": true,
      "41162": true,
      "41163": true,
      "41164": true,
      "41165": true,
      "41166": true,
      "41167": true,
      "41168": true,
      "41169": true,
      "41179": true
    },
    "MARTIR DE CUILAPAN": {
      "41180": true,
      "41181": true,
      "41182": true,
      "41183": true,
      "41184": true,
      "41185": true,
      "41186": true,
      "41187": true,
      "41188": true,
      "41189": true,
      "41191": true,
      "41192": true,
      "41193": true,
      "41194": true,
      "41195": true,
      "41196": true,
      "41197": true
    },
    "TLAPA DE COMONFORT": {
      "41300": true,
      "41301": true,
      "41302": true,
      "41303": true,
      "41304": true,
      "41305": true,
      "41306": true,
      "41307": true,
      "41308": true,
      "41309": true,
      "41320": true,
      "41321": true,
      "41322": true,
      "41323": true,
      "41324": true,
      "41325": true,
      "41326": true,
      "41327": true,
      "41328": true,
      "41329": true,
      "41330": true,
      "41347": true,
      "41349": true
    },
    "ILIATENCO": {
      "41530": true,
      "41531": true,
      "41532": true,
      "41533": true,
      "41534": true,
      "41535": true,
      "41536": true,
      "41537": true,
      "41538": true,
      "41539": true
    },
    "OMETEPEC": {
      "41700": true,
      "41701": true,
      "41702": true,
      "41703": true,
      "41704": true,
      "41705": true,
      "41706": true,
      "41707": true,
      "41708": true,
      "41709": true,
      "41710": true,
      "41711": true,
      "41712": true,
      "41713": true,
      "41714": true,
      "41715": true,
      "41716": true,
      "41717": true,
      "41718": true,
      "41719": true,
      "41725": true,
      "41730": true,
      "41731": true,
      "41732": true,
      "41733": true,
      "41734": true,
      "41735": true
    },
    "FLORENCIO VILLARREAL": {
      "41800": true,
      "41801": true,
      "41802": true,
      "41803": true,
      "41804": true,
      "41805": true,
      "41806": true,
      "41807": true,
      "41808": true,
      "41809": true,
      "41810": true,
      "41811": true,
      "41812": true,
      "41813": true,
      "41814": true,
      "41815": true,
      "41816": true,
      "41817": true,
      "41818": true,
      "41819": true,
      "41820": true,
      "41821": true,
      "41822": true,
      "41823": true,
      "41824": true,
      "41825": true,
      "41826": true,
      "41827": true,
      "41828": true,
      "41829": true,
      "41830": true,
      "41831": true,
      "41832": true,
      "41833": true,
      "41834": true,
      "41835": true,
      "41836": true,
      "41837": true,
      "41838": true,
      "41839": true
    },
    "COPALA": {
      "41870": true,
      "41871": true,
      "41872": true,
      "41873": true,
      "41874": true,
      "41875": true,
      "41876": true,
      "41877": true,
      "41878": true,
      "41879": true,
      "41880": true,
      "41881": true,
      "41882": true,
      "41883": true,
      "41884": true,
      "41885": true,
      "41886": true,
      "41887": true,
      "41888": true,
      "41889": true,
      "41890": true,
      "41891": true,
      "41892": true,
      "41893": true,
      "41894": true,
      "41895": true,
      "41896": true,
      "41897": true,
      "41898": true,
      "41899": true
    }
  },
  "HIDALGO": {
    "PACHUCA DE SOTO": {
      "42000": true,
      "42001": true,
      "42002": true,
      "42003": true,
      "42004": true,
      "42005": true,
      "42006": true,
      "42007": true,
      "42008": true,
      "42009": true,
      "42010": true,
      "42011": true,
      "42012": true,
      "42013": true,
      "42014": true,
      "42015": true,
      "42016": true,
      "42017": true,
      "42018": true,
      "42019": true,
      "42020": true,
      "42021": true,
      "42022": true,
      "42023": true,
      "42024": true,
      "42025": true,
      "42026": true,
      "42027": true,
      "42028": true,
      "42029": true,
      "42030": true,
      "42031": true,
      "42032": true,
      "42033": true,
      "42034": true,
      "42035": true,
      "42036": true,
      "42037": true,
      "42038": true,
      "42039": true,
      "42040": true,
      "42041": true,
      "42042": true,
      "42043": true,
      "42044": true,
      "42045": true,
      "42046": true,
      "42047": true,
      "42048": true,
      "42049": true,
      "42050": true,
      "42051": true,
      "42052": true,
      "42053": true,
      "42054": true,
      "42055": true,
      "42056": true,
      "42057": true,
      "42058": true,
      "42059": true,
      "42060": true,
      "42061": true,
      "42062": true,
      "42063": true,
      "42064": true,
      "42065": true,
      "42066": true,
      "42067": true,
      "42068": true,
      "42069": true,
      "42070": true,
      "42071": true,
      "42072": true,
      "42073": true,
      "42074": true,
      "42075": true,
      "42076": true,
      "42077": true,
      "42078": true,
      "42079": true,
      "42080": true,
      "42081": true,
      "42082": true,
      "42083": true,
      "42084": true,
      "42085": true,
      "42086": true,
      "42087": true,
      "42088": true,
      "42089": true,
      "42090": true,
      "42091": true,
      "42092": true,
      "42093": true,
      "42094": true,
      "42095": true,
      "42096": true,
      "42097": true,
      "42098": true,
      "42099": true,
      "42100": true,
      "42101": true,
      "42102": true,
      "42103": true,
      "42104": true,
      "42105": true,
      "42106": true,
      "42107": true,
      "42108": true,
      "42109": true,
      "42110": true,
      "42111": true,
      "42112": true,
      "42113": true,
      "42114": true,
      "42115": true,
      "42116": true,
      "42117": true,
      "42118": true,
      "42119": true
    },
    "MINERAL DEL MONTE": {
      "42130": true,
      "42131": true,
      "42132": true,
      "42133": true,
      "42134": true,
      "42135": true,
      "42136": true,
      "42137": true,
      "42138": true,
      "42139": true,
      "42140": true,
      "42141": true,
      "42142": true,
      "42143": true,
      "42144": true,
      "42145": true,
      "42146": true,
      "42147": true,
      "42148": true,
      "42149": true
    },
    "AJACUBA": {
      "42150": true,
      "42151": true,
      "42152": true,
      "42153": true,
      "42154": true,
      "42155": true,
      "42156": true,
      "42157": true,
      "42158": true,
      "42159": true
    },
    "SAN AGUSTIN TLAXIACA": {
      "42160": true,
      "42161": true,
      "42162": true,
      "42163": true,
      "42164": true,
      "42165": true,
      "42166": true,
      "42167": true,
      "42168": true,
      "42169": true,
      "42170": true,
      "42171": true,
      "42172": true,
      "42173": true,
      "42174": true,
      "42175": true,
      "42176": true,
      "42177": true,
      "42178": true,
      "42179": true
    },
    "MINERAL DE LA REFORMA": {
      "42180": true,
      "42181": true,
      "42182": true,
      "42183": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true,
      "42188": true,
      "42189": true
    },
    "ZAPOTLAN DE JUAREZ": {
      "42190": true,
      "42191": true,
      "42192": true,
      "42193": true,
      "42194": true,
      "42195": true,
      "42196": true,
      "42197": true,
      "42198": true,
      "42199": true
    },
    "IXMIQUILPAN": {
      "42300": true,
      "42301": true,
      "42302": true,
      "42303": true,
      "42304": true,
      "42305": true,
      "42306": true,
      "42307": true,
      "42308": true,
      "42309": true,
      "42310": true,
      "42311": true,
      "42312": true,
      "42313": true,
      "42314": true,
      "42315": true,
      "42320": true,
      "42321": true,
      "42322": true,
      "42323": true,
      "42324": true,
      "42325": true,
      "42326": true,
      "42327": true,
      "42328": true,
      "42329": true
    },
    "FRANCISCO I. MADERO": {
      "42660": true,
      "42661": true,
      "42662": true,
      "42663": true,
      "42664": true,
      "42665": true,
      "42666": true,
      "42667": true,
      "42668": true,
      "42669": true,
      "42670": true,
      "42671": true,
      "42672": true,
      "42673": true,
      "42674": true,
      "42675": true,
      "42676": true,
      "42677": true,
      "42678": true,
      "42679": true
    },
    "EL ARENAL": {
      "42680": true,
      "42681": true,
      "42682": true,
      "42683": true,
      "42684": true,
      "42685": true,
      "42686": true,
      "42687": true,
      "42688": true,
      "42689": true,
      "42690": true,
      "42691": true,
      "42692": true,
      "42693": true,
      "42694": true,
      "42695": true,
      "42696": true,
      "42697": true,
      "42698": true,
      "42699": true
    },
    "MIXQUIAHUALA DE JUAREZ": {
      "42700": true,
      "42701": true,
      "42702": true,
      "42703": true,
      "42704": true,
      "42705": true,
      "42706": true,
      "42707": true,
      "42708": true,
      "42709": true,
      "42710": true,
      "42711": true,
      "42712": true,
      "42713": true,
      "42714": true,
      "42715": true,
      "42716": true,
      "42717": true,
      "42718": true,
      "42719": true,
      "42720": true,
      "42721": true,
      "42722": true,
      "42723": true,
      "42724": true,
      "42725": true,
      "42726": true,
      "42727": true,
      "42728": true,
      "42729": true
    },
    "PROGRESO DE OBREGON": {
      "42730": true,
      "42731": true,
      "42732": true,
      "42733": true,
      "42734": true,
      "42735": true,
      "42736": true,
      "42737": true,
      "42738": true,
      "42739": true,
      "42740": true,
      "42741": true,
      "42742": true,
      "42743": true,
      "42744": true,
      "42745": true,
      "42746": true,
      "42747": true,
      "42748": true,
      "42749": true
    },
    "TULA DE ALLENDE": {
      "42800": true,
      "42801": true,
      "42802": true,
      "42803": true,
      "42804": true,
      "42805": true,
      "42806": true,
      "42807": true,
      "42808": true,
      "42809": true,
      "42810": true,
      "42811": true,
      "42812": true,
      "42813": true,
      "42814": true,
      "42815": true,
      "42816": true,
      "42817": true,
      "42818": true,
      "42819": true,
      "42820": true,
      "42821": true,
      "42822": true,
      "42823": true,
      "42824": true,
      "42825": true,
      "42826": true,
      "42827": true,
      "42828": true,
      "42829": true,
      "42830": true,
      "42831": true,
      "42832": true,
      "42833": true,
      "42834": true,
      "42835": true,
      "42836": true,
      "42837": true,
      "42838": true,
      "42839": true,
      "42840": true,
      "42841": true,
      "42842": true,
      "42843": true,
      "42844": true,
      "42845": true,
      "42846": true,
      "42847": true,
      "42848": true,
      "42849": true,
      "42850": true,
      "42851": true
    },
    "TEPEJI DEL RIO DE OCAMPO": {
      "42852": true,
      "42853": true,
      "42854": true,
      "42855": true,
      "42856": true,
      "42857": true,
      "42858": true,
      "42859": true,
      "42860": true,
      "42861": true,
      "42862": true,
      "42863": true,
      "42864": true,
      "42865": true,
      "42866": true,
      "42867": true,
      "42868": true,
      "42869": true,
      "42870": true,
      "42871": true,
      "42872": true,
      "42873": true,
      "42874": true,
      "42875": true,
      "42876": true,
      "42877": true,
      "42878": true,
      "42879": true,
      "42880": true,
      "42881": true,
      "42882": true,
      "42883": true,
      "42884": true,
      "42885": true,
      "42886": true,
      "42887": true,
      "42888": true,
      "42889": true,
      "42890": true,
      "42891": true,
      "42892": true,
      "42893": true,
      "42894": true,
      "42895": true,
      "42896": true,
      "42897": true,
      "42898": true,
      "42899": true
    },
    "TETEPANGO": {
      "42940": true,
      "42941": true,
      "42942": true,
      "42943": true,
      "42944": true,
      "42945": true,
      "42946": true,
      "42947": true,
      "42948": true,
      "42949": true
    },
    "ATOTONILCO DE TULA": {
      "42980": true,
      "42981": true,
      "42982": true,
      "42983": true,
      "42984": true,
      "42985": true,
      "42986": true,
      "42987": true,
      "42988": true,
      "42989": true,
      "42990": true,
      "42991": true,
      "42992": true,
      "42993": true,
      "42994": true,
      "42995": true,
      "42996": true,
      "42997": true,
      "42998": true,
      "42999": true
    },
    "HUEJUTLA DE REYES": {
      "43000": true,
      "43001": true,
      "43002": true,
      "43004": true,
      "43005": true,
      "43006": true,
      "43007": true,
      "43008": true,
      "43009": true,
      "43011": true,
      "43012": true,
      "43013": true,
      "43014": true,
      "43015": true,
      "43016": true,
      "43018": true,
      "43019": true
    },
    "JUAREZ HIDALGO": {
      "43190": true,
      "43191": true
    },
    "ATOTONILCO EL GRANDE": {
      "43300": true,
      "43301": true,
      "43302": true,
      "43303": true,
      "43304": true,
      "43305": true,
      "43306": true,
      "43307": true,
      "43308": true,
      "43309": true,
      "43310": true,
      "43313": true,
      "43314": true,
      "43315": true,
      "43316": true,
      "43317": true,
      "43318": true,
      "43319": true,
      "43320": true,
      "43321": true,
      "43322": true,
      "43324": true,
      "43325": true,
      "43328": true
    },
    "SAN AGUSTIN METZQUITITLAN": {
      "43380": true,
      "43381": true,
      "43382": true,
      "43383": true,
      "43384": true,
      "43385": true,
      "43386": true,
      "43387": true,
      "43388": true,
      "43389": true,
      "43391": true
    },
    "METEPEC": {
      "43400": true,
      "43401": true,
      "43402": true,
      "43403": true,
      "43404": true,
      "43405": true,
      "43406": true,
      "43407": true,
      "43408": true,
      "43409": true,
      "43410": true,
      "43411": true,
      "43412": true,
      "43413": true,
      "43414": true,
      "43415": true,
      "43416": true,
      "43417": true,
      "43418": true,
      "43419": true
    },
    "AGUA BLANCA DE ITURBIDE": {
      "43460": true,
      "43461": true,
      "43462": true,
      "43463": true,
      "43464": true,
      "43465": true,
      "43466": true,
      "43467": true,
      "43468": true,
      "43469": true,
      "43470": true,
      "43471": true,
      "43473": true,
      "43474": true,
      "43475": true,
      "43476": true,
      "43477": true,
      "43478": true,
      "43479": true
    },
    "HUASCA DE OCAMPO": {
      "43500": true,
      "43501": true,
      "43503": true,
      "43504": true,
      "43510": true,
      "43511": true,
      "43512": true,
      "43513": true,
      "43514": true,
      "43515": true,
      "43516": true,
      "43517": true,
      "43518": true,
      "43519": true,
      "43520": true,
      "43521": true,
      "43522": true,
      "43525": true,
      "43526": true
    },
    "ACATLAN": {
      "43540": true,
      "43541": true,
      "43542": true,
      "43543": true,
      "43544": true,
      "43545": true,
      "43547": true,
      "43548": true,
      "43549": true,
      "43550": true,
      "43551": true,
      "43552": true,
      "43553": true,
      "43554": true,
      "43555": true,
      "43556": true,
      "43557": true,
      "43558": true,
      "43559": true
    },
    "OMITLAN DE JUAREZ": {
      "43560": true,
      "43561": true,
      "43562": true,
      "43563": true,
      "43564": true,
      "43565": true,
      "43566": true,
      "43567": true,
      "43568": true,
      "43569": true,
      "43570": true,
      "43571": true,
      "43572": true,
      "43573": true,
      "43574": true,
      "43575": true,
      "43576": true,
      "43577": true,
      "43578": true,
      "43579": true
    },
    "TULANCINGO DE BRAVO": {
      "43600": true,
      "43601": true,
      "43602": true,
      "43603": true,
      "43604": true,
      "43605": true,
      "43606": true,
      "43607": true,
      "43608": true,
      "43609": true,
      "43610": true,
      "43611": true,
      "43612": true,
      "43613": true,
      "43614": true,
      "43615": true,
      "43616": true,
      "43617": true,
      "43618": true,
      "43619": true,
      "43620": true,
      "43621": true,
      "43622": true,
      "43623": true,
      "43624": true,
      "43625": true,
      "43626": true,
      "43627": true,
      "43628": true,
      "43629": true,
      "43630": true,
      "43631": true,
      "43632": true,
      "43633": true,
      "43634": true,
      "43635": true,
      "43636": true,
      "43637": true,
      "43638": true,
      "43639": true,
      "43640": true,
      "43641": true,
      "43642": true,
      "43643": true,
      "43644": true,
      "43645": true,
      "43646": true,
      "43647": true,
      "43648": true,
      "43649": true,
      "43650": true,
      "43651": true,
      "43652": true,
      "43653": true,
      "43654": true,
      "43655": true,
      "43656": true,
      "43657": true,
      "43658": true,
      "43659": true,
      "43660": true,
      "43661": true,
      "43662": true,
      "43663": true,
      "43664": true,
      "43665": true,
      "43666": true,
      "43667": true,
      "43668": true,
      "43669": true,
      "43670": true,
      "43671": true,
      "43672": true,
      "43673": true,
      "43674": true,
      "43675": true,
      "43676": true,
      "43677": true,
      "43678": true,
      "43679": true,
      "43680": true,
      "43681": true,
      "43682": true,
      "43683": true,
      "43684": true,
      "43685": true,
      "43686": true,
      "43687": true,
      "43688": true,
      "43689": true,
      "43690": true,
      "43691": true,
      "43692": true,
      "43693": true,
      "43694": true,
      "43695": true,
      "43696": true,
      "43697": true,
      "43698": true,
      "43699": true,
      "43700": true,
      "43701": true,
      "43702": true,
      "43703": true,
      "43704": true,
      "43705": true,
      "43706": true,
      "43707": true,
      "43708": true,
      "43709": true,
      "43710": true,
      "43711": true,
      "43712": true,
      "43715": true,
      "43716": true,
      "43717": true,
      "43718": true,
      "43719": true
    },
    "SANTIAGO TULANTEPEC DE LUGO GUERRERO": {
      "43760": true,
      "43761": true,
      "43762": true,
      "43763": true,
      "43764": true,
      "43765": true,
      "43766": true,
      "43767": true,
      "43768": true,
      "43769": true,
      "43770": true,
      "43771": true,
      "43772": true,
      "43773": true,
      "43774": true,
      "43775": true,
      "43776": true,
      "43777": true,
      "43778": true,
      "43779": true
    },
    "SINGUILUCAN": {
      "43780": true,
      "43781": true,
      "43782": true,
      "43783": true,
      "43784": true,
      "43785": true,
      "43786": true,
      "43787": true,
      "43788": true,
      "43789": true,
      "43790": true,
      "43791": true,
      "43792": true,
      "43793": true,
      "43794": true,
      "43795": true,
      "43796": true,
      "43797": true,
      "43798": true,
      "43799": true
    },
    "ZEMPOALA": {
      "43830": true,
      "43831": true,
      "43832": true,
      "43833": true,
      "43834": true,
      "43835": true,
      "43836": true,
      "43837": true,
      "43838": true,
      "43839": true,
      "43840": true,
      "43841": true,
      "43842": true,
      "43843": true,
      "43844": true,
      "43845": true,
      "43846": true,
      "43847": true,
      "43848": true,
      "43849": true,
      "43851": true,
      "43852": true,
      "43854": true,
      "43855": true,
      "43856": true,
      "43857": true,
      "43858": true,
      "43859": true
    },
    "APAN": {
      "43900": true,
      "43901": true,
      "43902": true,
      "43903": true,
      "43904": true,
      "43905": true,
      "43906": true,
      "43907": true,
      "43908": true,
      "43909": true,
      "43910": true,
      "43911": true,
      "43912": true,
      "43913": true,
      "43914": true,
      "43915": true,
      "43916": true,
      "43917": true,
      "43918": true,
      "43920": true,
      "43921": true,
      "43922": true,
      "43923": true,
      "43924": true,
      "43925": true,
      "43926": true,
      "43927": true,
      "43928": true,
      "43929": true
    },
    "TLANALAPA": {
      "43930": true,
      "43931": true,
      "43932": true,
      "43933": true,
      "43934": true,
      "43935": true,
      "43936": true,
      "43937": true,
      "43938": true,
      "43939": true
    },
    "ALMOLOYA": {
      "43940": true,
      "43943": true,
      "43944": true,
      "43945": true,
      "43946": true,
      "43947": true,
      "43950": true,
      "43951": true,
      "43952": true,
      "43953": true,
      "43954": true,
      "43955": true,
      "43956": true,
      "43957": true,
      "43958": true,
      "43959": true
    },
    "EMILIANO ZAPATA": {
      "43960": true,
      "43961": true,
      "43962": true,
      "43963": true,
      "43964": true,
      "43965": true,
      "43966": true,
      "43967": true,
      "43968": true,
      "43969": true
    },
    "TEPEAPULCO": {
      "43970": true,
      "43971": true,
      "43972": true,
      "43973": true,
      "43974": true,
      "43975": true,
      "43976": true,
      "43977": true,
      "43978": true,
      "43979": true,
      "43980": true,
      "43981": true,
      "43982": true,
      "43983": true,
      "43985": true,
      "43986": true,
      "43987": true,
      "43988": true,
      "43989": true,
      "43990": true,
      "43991": true,
      "43992": true,
      "43993": true,
      "43994": true,
      "43995": true,
      "43996": true,
      "43997": true,
      "43998": true,
      "43999": true
    }
  },
  "JALISCO": {
    "GUADALAJARA": {
      "44000": true,
      "44001": true,
      "44002": true,
      "44003": true,
      "44004": true,
      "44005": true,
      "44006": true,
      "44007": true,
      "44008": true,
      "44009": true,
      "44010": true,
      "44011": true,
      "44012": true,
      "44013": true,
      "44014": true,
      "44015": true,
      "44016": true,
      "44017": true,
      "44018": true,
      "44019": true,
      "44020": true,
      "44021": true,
      "44022": true,
      "44023": true,
      "44024": true,
      "44025": true,
      "44026": true,
      "44027": true,
      "44028": true,
      "44029": true,
      "44030": true,
      "44031": true,
      "44032": true,
      "44033": true,
      "44034": true,
      "44035": true,
      "44036": true,
      "44037": true,
      "44038": true,
      "44039": true,
      "44040": true,
      "44041": true,
      "44042": true,
      "44043": true,
      "44044": true,
      "44045": true,
      "44046": true,
      "44047": true,
      "44048": true,
      "44049": true,
      "44050": true,
      "44051": true,
      "44052": true,
      "44053": true,
      "44054": true,
      "44055": true,
      "44056": true,
      "44057": true,
      "44058": true,
      "44059": true,
      "44060": true,
      "44061": true,
      "44062": true,
      "44063": true,
      "44064": true,
      "44065": true,
      "44066": true,
      "44067": true,
      "44068": true,
      "44069": true,
      "44070": true,
      "44071": true,
      "44072": true,
      "44073": true,
      "44074": true,
      "44075": true,
      "44076": true,
      "44077": true,
      "44078": true,
      "44079": true,
      "44080": true,
      "44081": true,
      "44082": true,
      "44083": true,
      "44084": true,
      "44085": true,
      "44086": true,
      "44087": true,
      "44088": true,
      "44089": true,
      "44090": true,
      "44091": true,
      "44092": true,
      "44093": true,
      "44094": true,
      "44095": true,
      "44096": true,
      "44097": true,
      "44098": true,
      "44099": true,
      "44100": true,
      "44101": true,
      "44102": true,
      "44103": true,
      "44104": true,
      "44105": true,
      "44106": true,
      "44107": true,
      "44108": true,
      "44109": true,
      "44110": true,
      "44111": true,
      "44112": true,
      "44113": true,
      "44114": true,
      "44115": true,
      "44116": true,
      "44117": true,
      "44118": true,
      "44119": true,
      "44120": true,
      "44121": true,
      "44122": true,
      "44123": true,
      "44124": true,
      "44125": true,
      "44126": true,
      "44127": true,
      "44128": true,
      "44129": true,
      "44130": true,
      "44131": true,
      "44132": true,
      "44133": true,
      "44134": true,
      "44135": true,
      "44136": true,
      "44137": true,
      "44138": true,
      "44139": true,
      "44140": true,
      "44141": true,
      "44142": true,
      "44143": true,
      "44144": true,
      "44145": true,
      "44146": true,
      "44147": true,
      "44148": true,
      "44149": true,
      "44150": true,
      "44151": true,
      "44152": true,
      "44153": true,
      "44154": true,
      "44155": true,
      "44156": true,
      "44157": true,
      "44158": true,
      "44159": true,
      "44160": true,
      "44161": true,
      "44162": true,
      "44163": true,
      "44164": true,
      "44165": true,
      "44166": true,
      "44167": true,
      "44168": true,
      "44169": true,
      "44170": true,
      "44171": true,
      "44172": true,
      "44173": true,
      "44174": true,
      "44175": true,
      "44176": true,
      "44177": true,
      "44178": true,
      "44179": true,
      "44180": true,
      "44181": true,
      "44182": true,
      "44183": true,
      "44184": true,
      "44185": true,
      "44186": true,
      "44187": true,
      "44188": true,
      "44189": true,
      "44190": true,
      "44191": true,
      "44192": true,
      "44193": true,
      "44194": true,
      "44195": true,
      "44196": true,
      "44197": true,
      "44198": true,
      "44199": true,
      "44200": true,
      "44201": true,
      "44202": true,
      "44203": true,
      "44204": true,
      "44205": true,
      "44206": true,
      "44207": true,
      "44208": true,
      "44209": true,
      "44210": true,
      "44211": true,
      "44212": true,
      "44213": true,
      "44214": true,
      "44215": true,
      "44216": true,
      "44217": true,
      "44218": true,
      "44219": true,
      "44220": true,
      "44221": true,
      "44222": true,
      "44223": true,
      "44224": true,
      "44225": true,
      "44226": true,
      "44227": true,
      "44228": true,
      "44229": true,
      "44230": true,
      "44231": true,
      "44232": true,
      "44233": true,
      "44234": true,
      "44235": true,
      "44236": true,
      "44237": true,
      "44238": true,
      "44239": true,
      "44240": true,
      "44241": true,
      "44242": true,
      "44243": true,
      "44244": true,
      "44245": true,
      "44246": true,
      "44247": true,
      "44248": true,
      "44249": true,
      "44250": true,
      "44251": true,
      "44252": true,
      "44253": true,
      "44254": true,
      "44255": true,
      "44256": true,
      "44257": true,
      "44258": true,
      "44259": true,
      "44260": true,
      "44261": true,
      "44262": true,
      "44263": true,
      "44264": true,
      "44265": true,
      "44266": true,
      "44267": true,
      "44268": true,
      "44269": true,
      "44270": true,
      "44271": true,
      "44272": true,
      "44273": true,
      "44274": true,
      "44275": true,
      "44276": true,
      "44277": true,
      "44278": true,
      "44279": true,
      "44280": true,
      "44281": true,
      "44282": true,
      "44283": true,
      "44284": true,
      "44285": true,
      "44286": true,
      "44287": true,
      "44288": true,
      "44289": true,
      "44290": true,
      "44291": true,
      "44292": true,
      "44293": true,
      "44294": true,
      "44295": true,
      "44296": true,
      "44297": true,
      "44298": true,
      "44299": true,
      "44300": true,
      "44301": true,
      "44302": true,
      "44303": true,
      "44304": true,
      "44305": true,
      "44306": true,
      "44307": true,
      "44308": true,
      "44309": true,
      "44310": true,
      "44311": true,
      "44312": true,
      "44313": true,
      "44314": true,
      "44315": true,
      "44316": true,
      "44317": true,
      "44318": true,
      "44319": true,
      "44320": true,
      "44321": true,
      "44322": true,
      "44323": true,
      "44324": true,
      "44325": true,
      "44326": true,
      "44327": true,
      "44328": true,
      "44329": true,
      "44330": true,
      "44331": true,
      "44332": true,
      "44333": true,
      "44334": true,
      "44335": true,
      "44336": true,
      "44337": true,
      "44338": true,
      "44339": true,
      "44340": true,
      "44341": true,
      "44342": true,
      "44343": true,
      "44344": true,
      "44345": true,
      "44346": true,
      "44347": true,
      "44348": true,
      "44350": true,
      "44351": true,
      "44352": true,
      "44353": true,
      "44354": true,
      "44355": true,
      "44356": true,
      "44357": true,
      "44358": true,
      "44359": true,
      "44360": true,
      "44361": true,
      "44362": true,
      "44363": true,
      "44364": true,
      "44365": true,
      "44366": true,
      "44367": true,
      "44368": true,
      "44369": true,
      "44370": true,
      "44371": true,
      "44372": true,
      "44373": true,
      "44374": true,
      "44375": true,
      "44376": true,
      "44377": true,
      "44378": true,
      "44379": true,
      "44380": true,
      "44381": true,
      "44382": true,
      "44383": true,
      "44384": true,
      "44385": true,
      "44386": true,
      "44387": true,
      "44388": true,
      "44389": true,
      "44390": true,
      "44391": true,
      "44392": true,
      "44393": true,
      "44394": true,
      "44395": true,
      "44396": true,
      "44397": true,
      "44398": true,
      "44399": true,
      "44400": true,
      "44401": true,
      "44402": true,
      "44403": true,
      "44404": true,
      "44405": true,
      "44406": true,
      "44407": true,
      "44408": true,
      "44409": true,
      "44410": true,
      "44411": true,
      "44412": true,
      "44413": true,
      "44414": true,
      "44415": true,
      "44416": true,
      "44417": true,
      "44418": true,
      "44419": true,
      "44420": true,
      "44421": true,
      "44422": true,
      "44423": true,
      "44424": true,
      "44425": true,
      "44426": true,
      "44427": true,
      "44428": true,
      "44429": true,
      "44430": true,
      "44431": true,
      "44432": true,
      "44433": true,
      "44434": true,
      "44435": true,
      "44436": true,
      "44437": true,
      "44438": true,
      "44439": true,
      "44440": true,
      "44441": true,
      "44442": true,
      "44443": true,
      "44444": true,
      "44445": true,
      "44446": true,
      "44447": true,
      "44448": true,
      "44449": true,
      "44450": true,
      "44451": true,
      "44452": true,
      "44453": true,
      "44454": true,
      "44455": true,
      "44456": true,
      "44457": true,
      "44458": true,
      "44459": true,
      "44460": true,
      "44461": true,
      "44462": true,
      "44463": true,
      "44464": true,
      "44465": true,
      "44466": true,
      "44467": true,
      "44468": true,
      "44469": true,
      "44470": true,
      "44471": true,
      "44472": true,
      "44473": true,
      "44474": true,
      "44475": true,
      "44476": true,
      "44477": true,
      "44478": true,
      "44479": true,
      "44480": true,
      "44481": true,
      "44482": true,
      "44483": true,
      "44484": true,
      "44485": true,
      "44486": true,
      "44487": true,
      "44488": true,
      "44489": true,
      "44490": true,
      "44491": true,
      "44492": true,
      "44493": true,
      "44494": true,
      "44495": true,
      "44496": true,
      "44497": true,
      "44498": true,
      "44499": true,
      "44500": true,
      "44501": true,
      "44502": true,
      "44503": true,
      "44504": true,
      "44505": true,
      "44506": true,
      "44507": true,
      "44508": true,
      "44509": true,
      "44510": true,
      "44511": true,
      "44512": true,
      "44513": true,
      "44514": true,
      "44515": true,
      "44516": true,
      "44517": true,
      "44518": true,
      "44519": true,
      "44520": true,
      "44521": true,
      "44522": true,
      "44523": true,
      "44524": true,
      "44525": true,
      "44526": true,
      "44527": true,
      "44528": true,
      "44529": true,
      "44530": true,
      "44531": true,
      "44532": true,
      "44533": true,
      "44534": true,
      "44535": true,
      "44536": true,
      "44537": true,
      "44538": true,
      "44539": true,
      "44540": true,
      "44541": true,
      "44542": true,
      "44543": true,
      "44544": true,
      "44545": true,
      "44546": true,
      "44547": true,
      "44548": true,
      "44549": true,
      "44550": true,
      "44551": true,
      "44552": true,
      "44553": true,
      "44554": true,
      "44555": true,
      "44556": true,
      "44557": true,
      "44558": true,
      "44559": true,
      "44560": true,
      "44561": true,
      "44562": true,
      "44563": true,
      "44564": true,
      "44565": true,
      "44566": true,
      "44567": true,
      "44568": true,
      "44569": true,
      "44570": true,
      "44571": true,
      "44572": true,
      "44573": true,
      "44574": true,
      "44575": true,
      "44576": true,
      "44577": true,
      "44578": true,
      "44579": true,
      "44580": true,
      "44581": true,
      "44582": true,
      "44583": true,
      "44584": true,
      "44585": true,
      "44586": true,
      "44587": true,
      "44588": true,
      "44589": true,
      "44590": true,
      "44591": true,
      "44592": true,
      "44593": true,
      "44594": true,
      "44595": true,
      "44596": true,
      "44597": true,
      "44598": true,
      "44599": true,
      "44600": true,
      "44601": true,
      "44602": true,
      "44603": true,
      "44604": true,
      "44605": true,
      "44606": true,
      "44607": true,
      "44608": true,
      "44609": true,
      "44610": true,
      "44611": true,
      "44612": true,
      "44613": true,
      "44614": true,
      "44615": true,
      "44616": true,
      "44617": true,
      "44618": true,
      "44619": true,
      "44620": true,
      "44621": true,
      "44622": true,
      "44623": true,
      "44624": true,
      "44625": true,
      "44626": true,
      "44627": true,
      "44628": true,
      "44629": true,
      "44630": true,
      "44631": true,
      "44632": true,
      "44633": true,
      "44634": true,
      "44635": true,
      "44636": true,
      "44637": true,
      "44638": true,
      "44639": true,
      "44640": true,
      "44641": true,
      "44642": true,
      "44643": true,
      "44644": true,
      "44645": true,
      "44646": true,
      "44647": true,
      "44648": true,
      "44649": true,
      "44650": true,
      "44651": true,
      "44652": true,
      "44653": true,
      "44654": true,
      "44655": true,
      "44656": true,
      "44657": true,
      "44658": true,
      "44659": true,
      "44660": true,
      "44661": true,
      "44662": true,
      "44663": true,
      "44664": true,
      "44665": true,
      "44666": true,
      "44667": true,
      "44668": true,
      "44669": true,
      "44670": true,
      "44671": true,
      "44672": true,
      "44673": true,
      "44674": true,
      "44675": true,
      "44676": true,
      "44677": true,
      "44678": true,
      "44679": true,
      "44680": true,
      "44681": true,
      "44682": true,
      "44683": true,
      "44684": true,
      "44685": true,
      "44686": true,
      "44687": true,
      "44688": true,
      "44689": true,
      "44690": true,
      "44691": true,
      "44692": true,
      "44693": true,
      "44694": true,
      "44695": true,
      "44696": true,
      "44697": true,
      "44698": true,
      "44699": true,
      "44700": true,
      "44701": true,
      "44702": true,
      "44703": true,
      "44704": true,
      "44705": true,
      "44706": true,
      "44707": true,
      "44708": true,
      "44709": true,
      "44710": true,
      "44711": true,
      "44712": true,
      "44713": true,
      "44714": true,
      "44715": true,
      "44716": true,
      "44717": true,
      "44718": true,
      "44719": true,
      "44720": true,
      "44721": true,
      "44722": true,
      "44723": true,
      "44724": true,
      "44725": true,
      "44726": true,
      "44727": true,
      "44728": true,
      "44729": true,
      "44730": true,
      "44731": true,
      "44732": true,
      "44733": true,
      "44734": true,
      "44735": true,
      "44736": true,
      "44737": true,
      "44738": true,
      "44739": true,
      "44740": true,
      "44741": true,
      "44742": true,
      "44743": true,
      "44744": true,
      "44745": true,
      "44746": true,
      "44747": true,
      "44748": true,
      "44749": true,
      "44750": true,
      "44751": true,
      "44752": true,
      "44753": true,
      "44754": true,
      "44755": true,
      "44756": true,
      "44757": true,
      "44758": true,
      "44759": true,
      "44760": true,
      "44761": true,
      "44762": true,
      "44763": true,
      "44764": true,
      "44765": true,
      "44766": true,
      "44767": true,
      "44768": true,
      "44769": true,
      "44770": true,
      "44771": true,
      "44772": true,
      "44773": true,
      "44774": true,
      "44775": true,
      "44776": true,
      "44777": true,
      "44778": true,
      "44779": true,
      "44780": true,
      "44781": true,
      "44782": true,
      "44783": true,
      "44784": true,
      "44785": true,
      "44786": true,
      "44787": true,
      "44788": true,
      "44789": true,
      "44790": true,
      "44791": true,
      "44792": true,
      "44793": true,
      "44794": true,
      "44795": true,
      "44796": true,
      "44797": true,
      "44798": true,
      "44799": true,
      "44800": true,
      "44801": true,
      "44802": true,
      "44803": true,
      "44804": true,
      "44805": true,
      "44806": true,
      "44807": true,
      "44808": true,
      "44809": true,
      "44810": true,
      "44811": true,
      "44812": true,
      "44813": true,
      "44814": true,
      "44815": true,
      "44816": true,
      "44817": true,
      "44818": true,
      "44819": true,
      "44820": true,
      "44821": true,
      "44822": true,
      "44823": true,
      "44824": true,
      "44825": true,
      "44826": true,
      "44827": true,
      "44828": true,
      "44829": true,
      "44830": true,
      "44831": true,
      "44832": true,
      "44833": true,
      "44834": true,
      "44835": true,
      "44836": true,
      "44837": true,
      "44838": true,
      "44839": true,
      "44840": true,
      "44841": true,
      "44842": true,
      "44843": true,
      "44844": true,
      "44845": true,
      "44846": true,
      "44847": true,
      "44848": true,
      "44849": true,
      "44850": true,
      "44851": true,
      "44852": true,
      "44853": true,
      "44854": true,
      "44855": true,
      "44856": true,
      "44857": true,
      "44858": true,
      "44859": true,
      "44860": true,
      "44861": true,
      "44862": true,
      "44863": true,
      "44864": true,
      "44865": true,
      "44866": true,
      "44867": true,
      "44868": true,
      "44869": true,
      "44870": true,
      "44871": true,
      "44872": true,
      "44873": true,
      "44874": true,
      "44875": true,
      "44876": true,
      "44877": true,
      "44878": true,
      "44879": true,
      "44880": true,
      "44881": true,
      "44882": true,
      "44883": true,
      "44884": true,
      "44885": true,
      "44886": true,
      "44887": true,
      "44888": true,
      "44889": true,
      "44890": true,
      "44891": true,
      "44892": true,
      "44893": true,
      "44894": true,
      "44895": true,
      "44896": true,
      "44897": true,
      "44898": true,
      "44899": true,
      "44900": true,
      "44901": true,
      "44902": true,
      "44903": true,
      "44904": true,
      "44905": true,
      "44906": true,
      "44907": true,
      "44908": true,
      "44909": true,
      "44910": true,
      "44911": true,
      "44912": true,
      "44913": true,
      "44914": true,
      "44915": true,
      "44916": true,
      "44917": true,
      "44918": true,
      "44919": true,
      "44920": true,
      "44921": true,
      "44922": true,
      "44923": true,
      "44924": true,
      "44925": true,
      "44926": true,
      "44927": true,
      "44928": true,
      "44929": true,
      "44930": true,
      "44931": true,
      "44932": true,
      "44933": true,
      "44934": true,
      "44935": true,
      "44936": true,
      "44937": true,
      "44938": true,
      "44939": true,
      "44940": true,
      "44941": true,
      "44942": true,
      "44943": true,
      "44944": true,
      "44945": true,
      "44946": true,
      "44947": true,
      "44948": true,
      "44949": true,
      "44950": true,
      "44951": true,
      "44952": true,
      "44953": true,
      "44954": true,
      "44955": true,
      "44956": true,
      "44957": true,
      "44958": true,
      "44959": true,
      "44960": true,
      "44961": true,
      "44962": true,
      "44963": true,
      "44964": true,
      "44965": true,
      "44966": true,
      "44967": true,
      "44968": true,
      "44969": true,
      "44970": true,
      "44971": true,
      "44972": true,
      "44973": true,
      "44974": true,
      "44975": true,
      "44976": true,
      "44977": true,
      "44978": true,
      "44979": true,
      "44980": true,
      "44981": true,
      "44982": true,
      "44983": true,
      "44984": true,
      "44985": true,
      "44986": true,
      "44987": true,
      "44988": true,
      "44989": true,
      "44990": true,
      "44991": true,
      "44992": true,
      "44993": true,
      "44994": true,
      "44995": true,
      "44996": true,
      "44997": true,
      "44998": true,
      "44999": true,
      "45000": true,
      "45001": true,
      "45002": true,
      "45003": true,
      "45004": true,
      "45005": true,
      "45006": true,
      "45007": true,
      "45008": true,
      "45009": true
    },
    "ZAPOPAN": {
      "45010": true,
      "45011": true,
      "45012": true,
      "45013": true,
      "45014": true,
      "45015": true,
      "45016": true,
      "45017": true,
      "45018": true,
      "45019": true,
      "45020": true,
      "45021": true,
      "45022": true,
      "45023": true,
      "45024": true,
      "45025": true,
      "45026": true,
      "45027": true,
      "45028": true,
      "45029": true,
      "45030": true,
      "45031": true,
      "45032": true,
      "45033": true,
      "45034": true,
      "45035": true,
      "45036": true,
      "45037": true,
      "45038": true,
      "45039": true,
      "45040": true,
      "45041": true,
      "45042": true,
      "45043": true,
      "45044": true,
      "45045": true,
      "45046": true,
      "45047": true,
      "45048": true,
      "45049": true,
      "45050": true,
      "45051": true,
      "45052": true,
      "45053": true,
      "45054": true,
      "45055": true,
      "45056": true,
      "45057": true,
      "45058": true,
      "45059": true,
      "45060": true,
      "45061": true,
      "45062": true,
      "45063": true,
      "45064": true,
      "45065": true,
      "45066": true,
      "45067": true,
      "45068": true,
      "45069": true,
      "45070": true,
      "45071": true,
      "45072": true,
      "45073": true,
      "45074": true,
      "45075": true,
      "45076": true,
      "45077": true,
      "45078": true,
      "45079": true,
      "45080": true,
      "45081": true,
      "45082": true,
      "45083": true,
      "45084": true,
      "45085": true,
      "45086": true,
      "45087": true,
      "45088": true,
      "45089": true,
      "45090": true,
      "45091": true,
      "45092": true,
      "45093": true,
      "45094": true,
      "45095": true,
      "45096": true,
      "45097": true,
      "45098": true,
      "45099": true,
      "45100": true,
      "45101": true,
      "45102": true,
      "45103": true,
      "45104": true,
      "45105": true,
      "45106": true,
      "45107": true,
      "45108": true,
      "45109": true,
      "45110": true,
      "45111": true,
      "45112": true,
      "45113": true,
      "45114": true,
      "45115": true,
      "45116": true,
      "45117": true,
      "45118": true,
      "45119": true,
      "45120": true,
      "45121": true,
      "45122": true,
      "45123": true,
      "45124": true,
      "45125": true,
      "45126": true,
      "45127": true,
      "45128": true,
      "45129": true,
      "45130": true,
      "45131": true,
      "45132": true,
      "45133": true,
      "45134": true,
      "45135": true,
      "45136": true,
      "45137": true,
      "45138": true,
      "45139": true,
      "45140": true,
      "45141": true,
      "45142": true,
      "45143": true,
      "45144": true,
      "45145": true,
      "45146": true,
      "45147": true,
      "45148": true,
      "45149": true,
      "45150": true,
      "45151": true,
      "45152": true,
      "45153": true,
      "45154": true,
      "45155": true,
      "45156": true,
      "45157": true,
      "45158": true,
      "45159": true,
      "45160": true,
      "45161": true,
      "45162": true,
      "45163": true,
      "45164": true,
      "45165": true,
      "45166": true,
      "45167": true,
      "45168": true,
      "45169": true,
      "45170": true,
      "45171": true,
      "45172": true,
      "45173": true,
      "45174": true,
      "45175": true,
      "45176": true,
      "45177": true,
      "45178": true,
      "45179": true,
      "45180": true,
      "45181": true,
      "45182": true,
      "45183": true,
      "45184": true,
      "45185": true,
      "45186": true,
      "45187": true,
      "45188": true,
      "45189": true,
      "45190": true,
      "45191": true,
      "45192": true,
      "45193": true,
      "45194": true,
      "45195": true,
      "45196": true,
      "45197": true,
      "45198": true,
      "45199": true,
      "45200": true,
      "45201": true,
      "45202": true,
      "45203": true,
      "45204": true,
      "45205": true,
      "45206": true,
      "45207": true,
      "45208": true,
      "45209": true,
      "45210": true,
      "45211": true,
      "45212": true,
      "45213": true,
      "45214": true,
      "45215": true,
      "45216": true,
      "45217": true,
      "45218": true,
      "45219": true,
      "45220": true,
      "45221": true,
      "45222": true,
      "45223": true,
      "45224": true,
      "45225": true,
      "45226": true,
      "45227": true,
      "45228": true,
      "45229": true,
      "45230": true,
      "45231": true,
      "45232": true,
      "45233": true,
      "45234": true,
      "45235": true,
      "45236": true,
      "45237": true,
      "45238": true,
      "45239": true,
      "45240": true,
      "45241": true,
      "45242": true,
      "45243": true,
      "45244": true,
      "45245": true,
      "45246": true,
      "45247": true,
      "45248": true,
      "45249": true
    },
    "SAN CRISTOBAL DE LA BARRANCA": {
      "45250": true,
      "45251": true,
      "45252": true,
      "45253": true,
      "45254": true,
      "45255": true,
      "45256": true,
      "45259": true
    },
    "IXTLAHUACAN DEL RIO": {
      "45260": true,
      "45261": true,
      "45262": true,
      "45263": true,
      "45264": true,
      "45265": true,
      "45266": true,
      "45267": true,
      "45268": true,
      "45269": true,
      "45270": true,
      "45271": true,
      "45272": true,
      "45273": true,
      "45274": true,
      "45275": true,
      "45276": true,
      "45277": true,
      "45278": true,
      "45280": true,
      "45281": true,
      "45282": true,
      "45283": true,
      "45284": true,
      "45285": true,
      "45286": true,
      "45287": true,
      "45288": true,
      "45289": true,
      "45290": true,
      "45291": true,
      "45292": true,
      "45293": true,
      "45294": true,
      "45295": true,
      "45296": true,
      "45297": true,
      "45298": true,
      "45299": true
    },
    "TALA": {
      "45300": true,
      "45301": true,
      "45302": true,
      "45303": true,
      "45304": true,
      "45305": true,
      "45306": true,
      "45307": true,
      "45308": true,
      "45309": true,
      "45310": true,
      "45311": true,
      "45312": true,
      "45313": true,
      "45314": true,
      "45315": true,
      "45316": true,
      "45317": true,
      "45318": true,
      "45319": true,
      "45320": true,
      "45321": true,
      "45322": true,
      "45323": true,
      "45324": true,
      "45325": true,
      "45326": true,
      "45327": true,
      "45328": true,
      "45329": true,
      "45330": true,
      "45331": true,
      "45332": true,
      "45333": true,
      "45334": true,
      "45335": true,
      "45336": true,
      "45337": true,
      "45338": true,
      "45339": true,
      "45340": true,
      "45341": true,
      "45342": true,
      "45343": true,
      "45344": true,
      "45345": true,
      "45346": true,
      "45347": true,
      "45348": true,
      "45349": true
    },
    "EL ARENAL": {
      "45350": true,
      "45351": true,
      "45352": true,
      "45353": true,
      "45354": true,
      "45355": true,
      "45356": true,
      "45357": true,
      "45358": true,
      "45359": true,
      "45360": true,
      "45361": true,
      "45362": true,
      "45363": true,
      "45364": true,
      "45365": true,
      "45366": true,
      "45367": true,
      "45368": true,
      "45369": true,
      "45370": true,
      "45371": true,
      "45372": true,
      "45373": true,
      "45374": true,
      "45375": true,
      "45376": true,
      "45377": true,
      "45378": true,
      "45379": true
    },
    "AMATITAN": {
      "45380": true,
      "45381": true,
      "45382": true,
      "45383": true,
      "45384": true,
      "45385": true,
      "45386": true,
      "45387": true,
      "45388": true,
      "45389": true,
      "45390": true,
      "45391": true,
      "45392": true,
      "45393": true,
      "45394": true,
      "45395": true,
      "45396": true,
      "45397": true,
      "45398": true,
      "45399": true
    },
    "TONALA": {
      "45400": true,
      "45401": true,
      "45402": true,
      "45403": true,
      "45404": true,
      "45405": true,
      "45406": true,
      "45407": true,
      "45408": true,
      "45409": true,
      "45410": true,
      "45411": true,
      "45412": true,
      "45413": true,
      "45414": true,
      "45415": true,
      "45416": true,
      "45417": true,
      "45418": true,
      "45419": true,
      "45420": true,
      "45421": true,
      "45422": true,
      "45423": true,
      "45424": true,
      "45425": true,
      "45426": true,
      "45427": true,
      "45428": true,
      "45429": true
    },
    "TONALÁ": {
      "45400": true,
      "45402": true,
      "45428": true
    },
    "SAN PEDRO TLAQUEPAQUE": {
      "45403": true,
      "45500": true,
      "45501": true,
      "45502": true,
      "45503": true,
      "45504": true,
      "45505": true,
      "45506": true,
      "45507": true,
      "45508": true,
      "45509": true,
      "45510": true,
      "45511": true,
      "45512": true,
      "45513": true,
      "45514": true,
      "45515": true,
      "45516": true,
      "45517": true,
      "45518": true,
      "45519": true,
      "45520": true,
      "45521": true,
      "45522": true,
      "45523": true,
      "45524": true,
      "45525": true,
      "45526": true,
      "45527": true,
      "45528": true,
      "45529": true,
      "45530": true,
      "45531": true,
      "45532": true,
      "45533": true,
      "45534": true,
      "45535": true,
      "45536": true,
      "45537": true,
      "45538": true,
      "45539": true,
      "45540": true,
      "45541": true,
      "45542": true,
      "45543": true,
      "45544": true,
      "45545": true,
      "45546": true,
      "45547": true,
      "45548": true,
      "45549": true,
      "45550": true,
      "45551": true,
      "45552": true,
      "45553": true,
      "45554": true,
      "45555": true,
      "45556": true,
      "45557": true,
      "45558": true,
      "45559": true,
      "45560": true,
      "45561": true,
      "45562": true,
      "45563": true,
      "45564": true,
      "45565": true,
      "45566": true,
      "45567": true,
      "45568": true,
      "45569": true,
      "45570": true,
      "45571": true,
      "45572": true,
      "45573": true,
      "45574": true,
      "45575": true,
      "45576": true,
      "45577": true,
      "45578": true,
      "45579": true,
      "45580": true,
      "45581": true,
      "45582": true,
      "45583": true,
      "45584": true,
      "45585": true,
      "45586": true,
      "45587": true,
      "45588": true,
      "45589": true,
      "45590": true,
      "45591": true,
      "45592": true,
      "45593": true,
      "45594": true,
      "45595": true,
      "45596": true,
      "45597": true,
      "45598": true,
      "45599": true,
      "45600": true,
      "45601": true,
      "45602": true,
      "45603": true,
      "45604": true,
      "45605": true,
      "45606": true,
      "45607": true,
      "45608": true,
      "45609": true,
      "45610": true,
      "45611": true,
      "45612": true,
      "45613": true,
      "45614": true,
      "45615": true,
      "45616": true,
      "45617": true,
      "45618": true,
      "45619": true,
      "45620": true,
      "45621": true,
      "45622": true,
      "45623": true,
      "45624": true,
      "45625": true,
      "45626": true,
      "45627": true,
      "45628": true,
      "45629": true,
      "45630": true,
      "45631": true,
      "45632": true,
      "45633": true,
      "45634": true,
      "45635": true,
      "45636": true,
      "45637": true,
      "45638": true,
      "45639": true
    },
    "ZAPOTLANEJO": {
      "45430": true,
      "45431": true,
      "45432": true,
      "45433": true,
      "45434": true,
      "45435": true,
      "45437": true,
      "45438": true,
      "45440": true,
      "45441": true,
      "45442": true,
      "45443": true,
      "45444": true,
      "45445": true,
      "45446": true,
      "45447": true,
      "45448": true,
      "45449": true,
      "45450": true,
      "45451": true,
      "45453": true,
      "45454": true,
      "45455": true,
      "45456": true,
      "45457": true,
      "45458": true,
      "45459": true,
      "45460": true,
      "45461": true,
      "45462": true,
      "45463": true,
      "45464": true,
      "45465": true,
      "45466": true,
      "45467": true,
      "45468": true,
      "45469": true
    },
    "ACATIC": {
      "45470": true,
      "45471": true,
      "45472": true,
      "45473": true,
      "45474": true,
      "45475": true,
      "45476": true,
      "45477": true,
      "45478": true,
      "45479": true
    },
    "CUQUIO": {
      "45480": true,
      "45481": true,
      "45482": true,
      "45483": true,
      "45484": true,
      "45485": true,
      "45486": true,
      "45487": true,
      "45492": true,
      "45493": true,
      "45494": true,
      "45495": true,
      "45496": true,
      "45497": true,
      "45498": true,
      "45499": true
    },
    "TLAJOMULCO DE ZÚÑIGA": {
      "45640": true,
      "45641": true,
      "45642": true,
      "45643": true,
      "45644": true,
      "45645": true,
      "45646": true,
      "45647": true,
      "45648": true,
      "45649": true,
      "45650": true,
      "45651": true,
      "45652": true,
      "45653": true,
      "45654": true,
      "45655": true,
      "45656": true,
      "45657": true,
      "45658": true,
      "45659": true,
      "45660": true,
      "45661": true,
      "45662": true,
      "45663": true,
      "45664": true,
      "45665": true,
      "45666": true,
      "45667": true,
      "45668": true,
      "45669": true,
      "45670": true,
      "45671": true,
      "45672": true,
      "45673": true,
      "45674": true,
      "45675": true,
      "45676": true,
      "45677": true,
      "45678": true,
      "45679": true
    },
    "EL SALTO": {
      "45680": true,
      "45681": true,
      "45682": true,
      "45683": true,
      "45684": true,
      "45685": true,
      "45686": true,
      "45687": true,
      "45688": true,
      "45689": true,
      "45690": true,
      "45691": true,
      "45692": true,
      "45693": true,
      "45694": true,
      "45695": true,
      "45696": true,
      "45697": true,
      "45698": true,
      "45699": true
    },
    "ACATLAN DE JUAREZ": {
      "45700": true,
      "45701": true,
      "45702": true,
      "45703": true,
      "45704": true,
      "45705": true,
      "45706": true,
      "45707": true,
      "45708": true,
      "45709": true,
      "45710": true,
      "45711": true,
      "45712": true,
      "45713": true,
      "45714": true,
      "45715": true,
      "45716": true,
      "45717": true,
      "45718": true,
      "45719": true,
      "45720": true,
      "45721": true,
      "45722": true,
      "45723": true,
      "45724": true,
      "45725": true,
      "45726": true,
      "45727": true,
      "45728": true,
      "45729": true
    },
    "VILLA CORONA": {
      "45730": true,
      "45731": true,
      "45732": true,
      "45733": true,
      "45734": true,
      "45735": true,
      "45736": true,
      "45737": true,
      "45738": true,
      "45739": true,
      "45740": true,
      "45741": true,
      "45742": true,
      "45743": true,
      "45745": true,
      "45746": true,
      "45747": true,
      "45748": true,
      "45749": true
    },
    "ZACOALCO DE TORRES": {
      "45750": true,
      "45751": true,
      "45752": true,
      "45753": true,
      "45754": true,
      "45755": true,
      "45756": true,
      "45757": true,
      "45758": true,
      "45759": true,
      "45760": true,
      "45761": true,
      "45762": true,
      "45763": true,
      "45764": true,
      "45765": true,
      "45766": true,
      "45767": true,
      "45768": true,
      "45769": true,
      "45770": true,
      "45771": true,
      "45772": true,
      "45773": true,
      "45774": true,
      "45775": true,
      "45776": true,
      "45777": true,
      "45778": true,
      "45779": true,
      "45780": true,
      "45781": true,
      "45782": true,
      "45783": true,
      "45784": true,
      "45785": true,
      "45786": true,
      "45787": true,
      "45788": true,
      "45789": true
    },
    "JOCOTEPEC": {
      "45800": true,
      "45801": true,
      "45802": true,
      "45803": true,
      "45804": true,
      "45805": true,
      "45806": true,
      "45807": true,
      "45808": true,
      "45809": true,
      "45810": true,
      "45811": true,
      "45812": true,
      "45813": true,
      "45814": true,
      "45815": true,
      "45816": true,
      "45817": true,
      "45818": true,
      "45819": true,
      "45820": true,
      "45821": true,
      "45822": true,
      "45823": true,
      "45824": true,
      "45825": true,
      "45826": true,
      "45827": true,
      "45828": true,
      "45829": true,
      "45830": true,
      "45831": true,
      "45832": true,
      "45833": true,
      "45834": true,
      "45835": true,
      "45836": true,
      "45837": true,
      "45838": true,
      "45839": true,
      "45840": true,
      "45841": true,
      "45842": true,
      "45843": true,
      "45844": true,
      "45845": true,
      "45846": true,
      "45847": true,
      "45848": true,
      "45849": true
    },
    "IXTLAHUACAN DE LOS MEMBRILLOS": {
      "45850": true,
      "45851": true,
      "45852": true,
      "45853": true,
      "45854": true,
      "45855": true,
      "45856": true,
      "45857": true,
      "45858": true,
      "45859": true,
      "45860": true,
      "45861": true,
      "45862": true,
      "45863": true,
      "45864": true,
      "45865": true,
      "45866": true,
      "45867": true,
      "45868": true,
      "45869": true,
      "45870": true,
      "45871": true,
      "45872": true,
      "45873": true,
      "45874": true,
      "45875": true,
      "45876": true,
      "45877": true,
      "45878": true,
      "45879": true
    },
    "JUANACATLÁN": {
      "45880": true,
      "45881": true,
      "45882": true,
      "45883": true,
      "45884": true,
      "45885": true,
      "45886": true,
      "45887": true,
      "45888": true,
      "45889": true,
      "45899": true
    },
    "CHAPALA": {
      "45900": true,
      "45901": true,
      "45902": true,
      "45903": true,
      "45904": true,
      "45905": true,
      "45906": true,
      "45907": true,
      "45908": true,
      "45909": true,
      "45910": true,
      "45911": true,
      "45912": true,
      "45913": true,
      "45914": true,
      "45915": true,
      "45916": true,
      "45917": true,
      "45918": true,
      "45919": true,
      "45920": true,
      "45921": true,
      "45922": true,
      "45923": true,
      "45924": true,
      "45925": true,
      "45926": true,
      "45927": true,
      "45928": true,
      "45929": true,
      "45930": true,
      "45931": true,
      "45932": true,
      "45933": true,
      "45934": true,
      "45935": true,
      "45936": true,
      "45937": true,
      "45938": true,
      "45939": true,
      "45940": true,
      "45941": true,
      "45942": true,
      "45943": true,
      "45944": true,
      "45945": true,
      "45946": true,
      "45947": true,
      "45948": true,
      "45949": true
    },
    "PONCITLAN": {
      "45950": true,
      "45951": true,
      "45952": true,
      "45953": true,
      "45954": true,
      "45955": true,
      "45956": true,
      "45957": true,
      "45958": true,
      "45959": true,
      "45960": true,
      "45961": true,
      "45962": true,
      "45965": true,
      "45966": true,
      "45967": true,
      "45968": true,
      "45969": true,
      "45970": true,
      "45971": true,
      "45972": true,
      "45973": true,
      "45974": true,
      "45975": true,
      "45976": true,
      "45977": true,
      "45978": true,
      "45979": true
    },
    "ZAPOTLAN DEL REY": {
      "45980": true,
      "45981": true,
      "45982": true,
      "45983": true,
      "45986": true,
      "45987": true,
      "45988": true,
      "45989": true,
      "45990": true,
      "45991": true,
      "45992": true,
      "45993": true,
      "45994": true,
      "45995": true,
      "45996": true,
      "45997": true,
      "45998": true,
      "45999": true
    },
    "COLOTLAN": {
      "46200": true,
      "46201": true,
      "46202": true,
      "46203": true,
      "46204": true,
      "46205": true,
      "46206": true,
      "46207": true,
      "46208": true,
      "46209": true,
      "46225": true,
      "46226": true,
      "46227": true,
      "46228": true,
      "46229": true,
      "46230": true,
      "46231": true,
      "46232": true,
      "46233": true,
      "46235": true,
      "46236": true,
      "46237": true,
      "46238": true,
      "46239": true
    },
    "CHIMALTITAN": {
      "46300": true,
      "46301": true,
      "46302": true,
      "46303": true,
      "46304": true,
      "46305": true,
      "46306": true,
      "46307": true,
      "46308": true,
      "46309": true,
      "46330": true,
      "46331": true,
      "46332": true,
      "46333": true,
      "46334": true,
      "46335": true,
      "46336": true,
      "46337": true,
      "46338": true,
      "46339": true,
      "46340": true,
      "46341": true,
      "46342": true,
      "46343": true,
      "46344": true,
      "46345": true,
      "46346": true,
      "46347": true,
      "46348": true,
      "46349": true
    },
    "SAN MARTIN DE BOLANOS": {
      "46350": true,
      "46351": true,
      "46352": true,
      "46353": true,
      "46354": true,
      "46355": true,
      "46356": true,
      "46357": true,
      "46358": true,
      "46359": true,
      "46360": true,
      "46361": true,
      "46362": true,
      "46363": true,
      "46364": true,
      "46365": true,
      "46366": true,
      "46367": true,
      "46368": true,
      "46369": true,
      "46370": true,
      "46371": true,
      "46372": true,
      "46373": true,
      "46374": true,
      "46375": true,
      "46376": true,
      "46377": true,
      "46378": true,
      "46379": true,
      "46380": true,
      "46381": true,
      "46382": true,
      "46383": true,
      "46384": true,
      "46385": true,
      "46386": true,
      "46387": true,
      "46388": true,
      "46389": true,
      "46390": true,
      "46391": true,
      "46392": true,
      "46393": true,
      "46394": true,
      "46395": true,
      "46396": true,
      "46397": true,
      "46398": true,
      "46399": true
    },
    "TEQUILA": {
      "46400": true,
      "46401": true,
      "46402": true,
      "46403": true,
      "46404": true,
      "46405": true,
      "46406": true,
      "46407": true,
      "46409": true,
      "46410": true,
      "46411": true,
      "46412": true,
      "46413": true,
      "46414": true,
      "46415": true,
      "46416": true,
      "46417": true,
      "46418": true,
      "46419": true
    },
    "MAGDALENA": {
      "46470": true,
      "46471": true,
      "46472": true,
      "46473": true,
      "46474": true,
      "46475": true,
      "46476": true,
      "46477": true,
      "46478": true,
      "46479": true,
      "46480": true,
      "46481": true,
      "46482": true,
      "46483": true,
      "46484": true,
      "46485": true,
      "46486": true,
      "46487": true,
      "46488": true,
      "46489": true,
      "46490": true,
      "46491": true,
      "46492": true,
      "46493": true,
      "46494": true,
      "46495": true,
      "46496": true,
      "46497": true,
      "46498": true,
      "46499": true
    },
    "ETZATLAN": {
      "46500": true,
      "46501": true,
      "46502": true,
      "46503": true,
      "46504": true,
      "46505": true,
      "46506": true,
      "46507": true,
      "46508": true,
      "46509": true,
      "46510": true,
      "46511": true,
      "46512": true,
      "46513": true,
      "46514": true,
      "46515": true,
      "46516": true,
      "46517": true,
      "46518": true,
      "46519": true,
      "46520": true,
      "46521": true,
      "46522": true,
      "46523": true,
      "46524": true,
      "46525": true,
      "46526": true,
      "46527": true,
      "46528": true,
      "46529": true,
      "46530": true,
      "46531": true,
      "46532": true,
      "46533": true,
      "46534": true,
      "46535": true,
      "46536": true,
      "46537": true,
      "46538": true,
      "46539": true
    },
    "SAN JUANITO DE ESCOBEDO": {
      "46560": true,
      "46561": true,
      "46562": true,
      "46563": true,
      "46564": true,
      "46565": true,
      "46566": true,
      "46567": true,
      "46568": true,
      "46569": true,
      "46570": true,
      "46571": true,
      "46572": true,
      "46573": true,
      "46574": true,
      "46575": true,
      "46576": true,
      "46577": true,
      "46578": true,
      "46579": true,
      "46580": true,
      "46581": true,
      "46582": true,
      "46583": true,
      "46584": true,
      "46585": true,
      "46586": true,
      "46587": true,
      "46588": true,
      "46589": true,
      "46590": true,
      "46591": true,
      "46592": true,
      "46593": true,
      "46594": true,
      "46595": true,
      "46596": true,
      "46597": true,
      "46598": true,
      "46599": true
    },
    "AMECA": {
      "46600": true,
      "46601": true,
      "46602": true,
      "46603": true,
      "46604": true,
      "46605": true,
      "46606": true,
      "46607": true,
      "46608": true,
      "46609": true,
      "46610": true,
      "46611": true,
      "46612": true,
      "46613": true,
      "46614": true,
      "46615": true,
      "46616": true,
      "46617": true,
      "46618": true,
      "46619": true,
      "46620": true,
      "46621": true,
      "46622": true,
      "46623": true,
      "46624": true,
      "46625": true,
      "46626": true,
      "46627": true,
      "46628": true,
      "46629": true,
      "46630": true,
      "46631": true,
      "46632": true,
      "46633": true,
      "46634": true,
      "46635": true,
      "46636": true,
      "46637": true,
      "46638": true,
      "46639": true,
      "46640": true,
      "46641": true,
      "46642": true,
      "46643": true,
      "46644": true,
      "46645": true,
      "46646": true,
      "46647": true,
      "46648": true,
      "46649": true,
      "46650": true,
      "46651": true,
      "46652": true,
      "46653": true,
      "46654": true,
      "46655": true,
      "46656": true,
      "46657": true,
      "46658": true,
      "46659": true,
      "46660": true,
      "46661": true,
      "46662": true,
      "46663": true,
      "46664": true,
      "46665": true,
      "46666": true,
      "46667": true,
      "46668": true,
      "46669": true,
      "46670": true,
      "46671": true,
      "46672": true,
      "46673": true,
      "46674": true,
      "46675": true,
      "46676": true,
      "46677": true,
      "46678": true,
      "46679": true,
      "46680": true,
      "46681": true,
      "46682": true,
      "46683": true,
      "46684": true,
      "46685": true,
      "46686": true,
      "46687": true,
      "46688": true,
      "46689": true,
      "46690": true,
      "46691": true,
      "46692": true,
      "46693": true,
      "46694": true,
      "46695": true,
      "46696": true,
      "46697": true,
      "46698": true,
      "46699": true,
      "46700": true,
      "46701": true,
      "46702": true,
      "46703": true,
      "46704": true,
      "46705": true,
      "46706": true,
      "46707": true,
      "46708": true,
      "46709": true,
      "46710": true,
      "46711": true,
      "46712": true,
      "46713": true,
      "46714": true,
      "46715": true,
      "46716": true,
      "46718": true,
      "46720": true,
      "46721": true,
      "46722": true,
      "46723": true,
      "46724": true,
      "46725": true,
      "46726": true,
      "46727": true,
      "46728": true,
      "46729": true
    },
    "AHUALULCO DE MERCADO": {
      "46730": true,
      "46731": true,
      "46732": true,
      "46733": true,
      "46734": true,
      "46735": true,
      "46736": true,
      "46737": true,
      "46738": true,
      "46739": true,
      "46740": true,
      "46741": true,
      "46742": true,
      "46743": true,
      "46744": true,
      "46745": true,
      "46746": true,
      "46747": true,
      "46748": true,
      "46749": true,
      "46750": true,
      "46751": true,
      "46752": true,
      "46753": true,
      "46754": true,
      "46755": true,
      "46756": true,
      "46757": true,
      "46758": true,
      "46759": true
    },
    "TEUCHITLAN": {
      "46760": true,
      "46761": true,
      "46762": true,
      "46763": true,
      "46764": true,
      "46765": true,
      "46766": true,
      "46767": true,
      "46768": true,
      "46769": true
    },
    "SAN MARTIN HIDALGO": {
      "46770": true,
      "46771": true,
      "46772": true,
      "46773": true,
      "46774": true,
      "46775": true,
      "46776": true,
      "46777": true,
      "46778": true,
      "46779": true,
      "46780": true,
      "46781": true,
      "46782": true,
      "46783": true,
      "46784": true,
      "46785": true,
      "46786": true,
      "46787": true,
      "46788": true,
      "46789": true,
      "46790": true,
      "46791": true,
      "46792": true,
      "46793": true,
      "46794": true,
      "46795": true,
      "46796": true,
      "46797": true,
      "46798": true,
      "46799": true
    },
    "MASCOTA": {
      "46900": true,
      "46901": true,
      "46902": true,
      "46903": true,
      "46904": true,
      "46905": true,
      "46906": true,
      "46907": true,
      "46908": true,
      "46909": true,
      "46910": true,
      "46911": true,
      "46912": true,
      "46913": true,
      "46914": true,
      "46915": true,
      "46916": true,
      "46917": true,
      "46918": true,
      "46919": true,
      "46930": true,
      "46931": true,
      "46932": true,
      "46933": true,
      "46934": true,
      "46940": true,
      "46941": true,
      "46942": true,
      "46943": true,
      "46944": true
    },
    "SAN JUAN DE LOS LAGOS": {
      "47000": true,
      "47001": true,
      "47002": true,
      "47003": true,
      "47004": true,
      "47005": true,
      "47006": true,
      "47007": true,
      "47008": true,
      "47009": true,
      "47010": true,
      "47011": true,
      "47012": true,
      "47013": true,
      "47014": true,
      "47015": true,
      "47016": true,
      "47017": true,
      "47018": true,
      "47019": true,
      "47020": true,
      "47021": true,
      "47022": true,
      "47023": true,
      "47024": true,
      "47025": true,
      "47026": true,
      "47027": true,
      "47028": true,
      "47029": true,
      "47030": true,
      "47031": true,
      "47032": true,
      "47033": true,
      "47034": true,
      "47035": true,
      "47036": true,
      "47037": true,
      "47038": true,
      "47039": true,
      "47040": true,
      "47041": true,
      "47042": true,
      "47043": true,
      "47044": true,
      "47045": true,
      "47046": true,
      "47047": true,
      "47048": true,
      "47049": true,
      "47050": true,
      "47051": true,
      "47052": true,
      "47053": true,
      "47054": true,
      "47055": true,
      "47056": true,
      "47057": true,
      "47058": true,
      "47059": true,
      "47060": true,
      "47061": true,
      "47062": true,
      "47063": true,
      "47064": true,
      "47065": true,
      "47066": true,
      "47067": true,
      "47068": true,
      "47069": true,
      "47070": true,
      "47071": true,
      "47072": true,
      "47073": true,
      "47074": true,
      "47075": true,
      "47076": true,
      "47077": true,
      "47078": true,
      "47079": true,
      "47080": true,
      "47081": true,
      "47082": true,
      "47083": true,
      "47084": true,
      "47085": true,
      "47086": true,
      "47087": true,
      "47088": true,
      "47089": true,
      "47090": true,
      "47091": true,
      "47092": true,
      "47093": true,
      "47094": true,
      "47095": true,
      "47096": true,
      "47097": true,
      "47098": true,
      "47099": true,
      "47100": true,
      "47101": true,
      "47102": true,
      "47103": true,
      "47104": true,
      "47106": true,
      "47107": true,
      "47108": true,
      "47109": true,
      "47116": true,
      "47117": true,
      "47118": true
    },
    "JALOSTOTITLAN": {
      "47120": true,
      "47121": true,
      "47122": true,
      "47123": true,
      "47124": true,
      "47125": true,
      "47126": true,
      "47127": true,
      "47128": true,
      "47129": true,
      "47130": true,
      "47131": true,
      "47132": true,
      "47133": true,
      "47134": true,
      "47135": true,
      "47136": true,
      "47137": true,
      "47138": true,
      "47139": true
    },
    "SAN MIGUEL EL ALTO": {
      "47140": true,
      "47141": true,
      "47142": true,
      "47143": true,
      "47144": true,
      "47145": true,
      "47146": true,
      "47147": true,
      "47148": true,
      "47149": true,
      "47150": true,
      "47151": true,
      "47152": true,
      "47153": true,
      "47154": true,
      "47155": true,
      "47156": true,
      "47157": true,
      "47158": true,
      "47159": true,
      "47160": true,
      "47161": true,
      "47162": true,
      "47163": true,
      "47164": true,
      "47165": true,
      "47166": true,
      "47167": true,
      "47168": true,
      "47169": true
    },
    "SAN JULIAN": {
      "47170": true,
      "47171": true,
      "47172": true,
      "47173": true,
      "47174": true,
      "47175": true,
      "47176": true,
      "47177": true,
      "47178": true,
      "47179": true
    },
    "ARANDAS": {
      "47180": true,
      "47181": true,
      "47182": true,
      "47183": true,
      "47184": true,
      "47185": true,
      "47186": true,
      "47187": true,
      "47188": true,
      "47189": true,
      "47196": true,
      "47197": true,
      "47198": true,
      "47199": true
    },
    "TEOCALTICHE": {
      "47200": true,
      "47201": true,
      "47202": true,
      "47203": true,
      "47204": true,
      "47205": true,
      "47206": true,
      "47207": true,
      "47208": true,
      "47209": true,
      "47210": true,
      "47211": true,
      "47214": true,
      "47215": true,
      "47216": true,
      "47220": true,
      "47221": true,
      "47222": true,
      "47223": true,
      "47227": true,
      "47228": true,
      "47229": true,
      "47232": true,
      "47233": true,
      "47234": true,
      "47235": true,
      "47236": true,
      "47237": true,
      "47238": true,
      "47239": true,
      "47244": true,
      "47245": true,
      "47246": true,
      "47247": true,
      "47249": true
    },
    "VILLA HIDALGO": {
      "47250": true,
      "47251": true,
      "47252": true,
      "47253": true,
      "47254": true,
      "47255": true,
      "47256": true,
      "47257": true,
      "47258": true,
      "47259": true,
      "47260": true,
      "47261": true,
      "47262": true,
      "47263": true,
      "47264": true,
      "47265": true,
      "47266": true,
      "47267": true,
      "47268": true,
      "47269": true
    },
    "ENCARNACION DE DIAZ": {
      "47270": true,
      "47271": true,
      "47272": true,
      "47273": true,
      "47276": true,
      "47277": true,
      "47278": true,
      "47279": true,
      "47280": true,
      "47281": true,
      "47282": true,
      "47285": true,
      "47286": true,
      "47287": true,
      "47290": true,
      "47291": true,
      "47292": true,
      "47293": true,
      "47294": true,
      "47295": true,
      "47296": true,
      "47297": true,
      "47298": true,
      "47299": true
    },
    "YAHUALICA DE GONZALEZ GALLO": {
      "47300": true,
      "47301": true,
      "47302": true,
      "47303": true,
      "47304": true,
      "47305": true,
      "47306": true,
      "47307": true,
      "47308": true,
      "47309": true,
      "47310": true,
      "47311": true,
      "47312": true,
      "47314": true,
      "47315": true,
      "47316": true,
      "47317": true,
      "47318": true,
      "47319": true,
      "47320": true,
      "47321": true,
      "47322": true,
      "47323": true,
      "47324": true,
      "47325": true,
      "47326": true,
      "47327": true,
      "47328": true,
      "47329": true,
      "47330": true,
      "47331": true,
      "47332": true,
      "47333": true,
      "47335": true,
      "47336": true,
      "47337": true,
      "47338": true,
      "47339": true
    },
    "MEXTICACAN": {
      "47340": true,
      "47341": true,
      "47342": true,
      "47343": true,
      "47344": true,
      "47345": true,
      "47346": true,
      "47347": true,
      "47348": true,
      "47349": true,
      "47350": true,
      "47351": true,
      "47352": true,
      "47353": true,
      "47354": true,
      "47355": true,
      "47356": true,
      "47357": true,
      "47358": true,
      "47359": true
    },
    "CAÑADAS DE OBREGÓN": {
      "47360": true,
      "47361": true,
      "47362": true,
      "47363": true,
      "47364": true,
      "47365": true,
      "47366": true,
      "47367": true,
      "47369": true,
      "47370": true,
      "47371": true,
      "47372": true,
      "47373": true,
      "47374": true,
      "47375": true,
      "47376": true,
      "47377": true,
      "47378": true,
      "47379": true
    },
    "VALLE DE GUADALUPE": {
      "47380": true,
      "47381": true,
      "47382": true,
      "47383": true,
      "47384": true,
      "47385": true,
      "47386": true,
      "47387": true,
      "47388": true,
      "47389": true,
      "47390": true,
      "47391": true,
      "47392": true,
      "47393": true,
      "47394": true,
      "47395": true,
      "47396": true,
      "47397": true,
      "47398": true,
      "47399": true
    },
    "OJUELOS DE JALISCO": {
      "47540": true,
      "47541": true,
      "47542": true,
      "47543": true,
      "47544": true,
      "47547": true,
      "47548": true,
      "47549": true,
      "47550": true,
      "47551": true,
      "47552": true,
      "47553": true,
      "47554": true,
      "47555": true,
      "47556": true,
      "47557": true,
      "47558": true,
      "47559": true,
      "47560": true,
      "47561": true,
      "47562": true,
      "47563": true,
      "47564": true,
      "47566": true,
      "47567": true,
      "47568": true,
      "47569": true
    },
    "UNION DE SAN ANTONIO": {
      "47570": true,
      "47571": true,
      "47572": true,
      "47573": true,
      "47574": true,
      "47576": true,
      "47577": true,
      "47578": true,
      "47579": true,
      "47580": true,
      "47581": true,
      "47582": true,
      "47583": true,
      "47584": true,
      "47585": true,
      "47586": true,
      "47587": true
    },
    "SAN DIEGO DE ALEJANDRIA": {
      "47590": true,
      "47591": true,
      "47592": true,
      "47593": true,
      "47594": true,
      "47595": true,
      "47596": true,
      "47597": true,
      "47598": true,
      "47599": true
    },
    "TEPATITLAN DE MORELOS": {
      "47600": true,
      "47601": true,
      "47602": true,
      "47603": true,
      "47604": true,
      "47605": true,
      "47606": true,
      "47607": true,
      "47608": true,
      "47609": true,
      "47610": true,
      "47611": true,
      "47612": true,
      "47613": true,
      "47614": true,
      "47615": true,
      "47616": true,
      "47617": true,
      "47618": true,
      "47619": true,
      "47620": true,
      "47621": true,
      "47622": true,
      "47623": true,
      "47624": true,
      "47625": true,
      "47626": true,
      "47627": true,
      "47628": true,
      "47629": true,
      "47630": true,
      "47631": true,
      "47632": true,
      "47633": true,
      "47634": true,
      "47635": true,
      "47636": true,
      "47637": true,
      "47638": true,
      "47639": true,
      "47640": true,
      "47641": true,
      "47642": true,
      "47643": true,
      "47644": true,
      "47645": true,
      "47646": true,
      "47647": true,
      "47648": true,
      "47649": true,
      "47650": true,
      "47651": true,
      "47652": true,
      "47653": true,
      "47654": true,
      "47655": true,
      "47656": true,
      "47657": true,
      "47658": true,
      "47659": true,
      "47660": true,
      "47661": true,
      "47662": true,
      "47663": true,
      "47664": true,
      "47665": true,
      "47666": true,
      "47667": true,
      "47668": true,
      "47669": true,
      "47670": true,
      "47671": true,
      "47672": true,
      "47673": true,
      "47674": true,
      "47675": true,
      "47676": true,
      "47677": true,
      "47678": true,
      "47679": true,
      "47680": true,
      "47681": true,
      "47682": true,
      "47683": true,
      "47684": true,
      "47685": true,
      "47686": true,
      "47687": true,
      "47688": true,
      "47689": true,
      "47690": true,
      "47691": true,
      "47692": true,
      "47693": true,
      "47694": true,
      "47695": true,
      "47696": true,
      "47697": true,
      "47698": true,
      "47699": true,
      "47700": true,
      "47701": true,
      "47702": true,
      "47703": true,
      "47704": true,
      "47705": true,
      "47706": true,
      "47707": true,
      "47708": true,
      "47709": true,
      "47714": true,
      "47715": true,
      "47716": true,
      "47717": true,
      "47718": true,
      "47719": true,
      "47720": true,
      "47721": true,
      "47722": true,
      "47723": true,
      "47724": true,
      "47727": true,
      "47728": true,
      "47729": true
    },
    "TOTOTLAN": {
      "47730": true,
      "47731": true,
      "47732": true,
      "47733": true,
      "47734": true,
      "47735": true,
      "47736": true,
      "47737": true,
      "47738": true,
      "47739": true,
      "47740": true,
      "47741": true,
      "47742": true,
      "47743": true,
      "47746": true,
      "47748": true,
      "47749": true
    },
    "ATOTONILCO EL ALTO": {
      "47750": true,
      "47751": true,
      "47752": true,
      "47753": true,
      "47754": true,
      "47755": true,
      "47756": true,
      "47757": true,
      "47758": true,
      "47759": true,
      "47760": true,
      "47761": true,
      "47762": true,
      "47763": true,
      "47764": true,
      "47765": true,
      "47766": true,
      "47767": true,
      "47768": true,
      "47769": true,
      "47770": true,
      "47771": true,
      "47772": true,
      "47773": true,
      "47774": true,
      "47775": true,
      "47776": true,
      "47777": true,
      "47778": true,
      "47779": true
    },
    "OCOTLAN": {
      "47780": true,
      "47781": true,
      "47782": true,
      "47783": true,
      "47784": true,
      "47785": true,
      "47786": true,
      "47787": true,
      "47788": true,
      "47789": true,
      "47790": true,
      "47791": true,
      "47792": true,
      "47793": true,
      "47794": true,
      "47795": true,
      "47796": true,
      "47797": true,
      "47798": true,
      "47799": true,
      "47800": true,
      "47801": true,
      "47802": true,
      "47803": true,
      "47804": true,
      "47805": true,
      "47806": true,
      "47807": true,
      "47808": true,
      "47809": true,
      "47810": true,
      "47811": true,
      "47812": true,
      "47813": true,
      "47814": true,
      "47815": true,
      "47816": true,
      "47817": true,
      "47818": true,
      "47819": true,
      "47820": true,
      "47821": true,
      "47822": true,
      "47823": true,
      "47824": true,
      "47825": true,
      "47826": true,
      "47827": true,
      "47828": true,
      "47829": true,
      "47830": true,
      "47831": true,
      "47832": true,
      "47833": true,
      "47834": true,
      "47835": true,
      "47836": true,
      "47837": true,
      "47838": true,
      "47839": true,
      "47840": true,
      "47841": true,
      "47842": true,
      "47843": true,
      "47844": true,
      "47845": true,
      "47846": true,
      "47847": true,
      "47848": true,
      "47849": true,
      "47850": true,
      "47851": true,
      "47852": true,
      "47853": true,
      "47854": true,
      "47855": true,
      "47856": true,
      "47857": true,
      "47858": true,
      "47859": true,
      "47860": true,
      "47861": true,
      "47862": true,
      "47863": true,
      "47864": true,
      "47865": true,
      "47866": true,
      "47867": true,
      "47868": true,
      "47869": true,
      "47870": true,
      "47871": true,
      "47872": true,
      "47873": true,
      "47874": true,
      "47875": true,
      "47876": true,
      "47877": true,
      "47878": true,
      "47879": true,
      "47880": true,
      "47881": true,
      "47882": true,
      "47883": true,
      "47884": true,
      "47885": true,
      "47886": true,
      "47887": true,
      "47888": true,
      "47889": true,
      "47890": true,
      "47891": true,
      "47892": true,
      "47893": true,
      "47894": true,
      "47895": true,
      "47896": true,
      "47897": true,
      "47898": true,
      "47899": true
    },
    "JAMAY": {
      "47900": true,
      "47901": true,
      "47902": true,
      "47903": true,
      "47904": true,
      "47905": true,
      "47906": true,
      "47907": true,
      "47908": true,
      "47909": true
    },
    "LA BARCA": {
      "47910": true,
      "47911": true,
      "47912": true,
      "47913": true,
      "47914": true,
      "47915": true,
      "47916": true,
      "47917": true,
      "47918": true,
      "47919": true,
      "47920": true,
      "47921": true,
      "47922": true,
      "47923": true,
      "47924": true,
      "47925": true,
      "47926": true,
      "47927": true,
      "47928": true,
      "47929": true
    },
    "AYOTLAN": {
      "47930": true,
      "47931": true,
      "47932": true,
      "47933": true,
      "47934": true,
      "47935": true,
      "47936": true,
      "47938": true,
      "47940": true,
      "47941": true,
      "47942": true,
      "47943": true,
      "47944": true,
      "47945": true,
      "47947": true,
      "47948": true
    },
    "JESUS MARIA": {
      "47950": true,
      "47951": true,
      "47952": true,
      "47953": true,
      "47954": true,
      "47955": true,
      "47956": true,
      "47957": true,
      "47958": true,
      "47959": true,
      "47960": true,
      "47961": true,
      "47962": true,
      "47963": true,
      "47964": true,
      "47965": true,
      "47966": true,
      "47967": true,
      "47968": true,
      "47969": true,
      "47974": true,
      "47975": true,
      "47977": true,
      "47978": true,
      "47979": true
    },
    "DEGOLLADO": {
      "47980": true,
      "47981": true,
      "47982": true,
      "47983": true,
      "47984": true,
      "47985": true,
      "47986": true,
      "47987": true,
      "47988": true,
      "47989": true,
      "47990": true,
      "47991": true,
      "47992": true,
      "47993": true,
      "47995": true,
      "47996": true,
      "47997": true,
      "47998": true,
      "47999": true
    },
    "TALPA DE ALLENDE": {
      "48200": true,
      "48201": true,
      "48202": true,
      "48203": true,
      "48204": true,
      "48205": true,
      "48206": true,
      "48207": true,
      "48208": true,
      "48209": true,
      "48210": true,
      "48212": true,
      "48240": true,
      "48241": true,
      "48242": true,
      "48243": true,
      "48244": true,
      "48245": true,
      "48246": true,
      "48247": true,
      "48248": true,
      "48249": true
    },
    "PUERTO VALLARTA": {
      "48260": true,
      "48261": true,
      "48262": true,
      "48263": true,
      "48264": true,
      "48265": true,
      "48266": true,
      "48267": true,
      "48268": true,
      "48269": true,
      "48270": true,
      "48271": true,
      "48272": true,
      "48273": true,
      "48274": true,
      "48275": true,
      "48276": true,
      "48277": true,
      "48278": true,
      "48279": true,
      "48280": true,
      "48281": true,
      "48282": true,
      "48283": true,
      "48284": true,
      "48285": true,
      "48286": true,
      "48287": true,
      "48288": true,
      "48289": true,
      "48290": true,
      "48291": true,
      "48292": true,
      "48293": true,
      "48294": true,
      "48295": true,
      "48296": true,
      "48297": true,
      "48298": true,
      "48299": true,
      "48300": true,
      "48301": true,
      "48302": true,
      "48303": true,
      "48304": true,
      "48305": true,
      "48306": true,
      "48307": true,
      "48308": true,
      "48309": true,
      "48310": true,
      "48311": true,
      "48312": true,
      "48313": true,
      "48314": true,
      "48315": true,
      "48316": true,
      "48317": true,
      "48318": true,
      "48319": true,
      "48320": true,
      "48321": true,
      "48322": true,
      "48323": true,
      "48324": true,
      "48325": true,
      "48326": true,
      "48327": true,
      "48328": true,
      "48329": true,
      "48330": true,
      "48331": true,
      "48332": true,
      "48333": true,
      "48334": true,
      "48335": true,
      "48336": true,
      "48337": true,
      "48338": true,
      "48339": true,
      "48340": true,
      "48341": true,
      "48342": true,
      "48343": true,
      "48344": true,
      "48345": true,
      "48346": true,
      "48347": true,
      "48348": true,
      "48349": true,
      "48350": true,
      "48351": true,
      "48352": true,
      "48353": true,
      "48354": true,
      "48355": true,
      "48356": true,
      "48357": true,
      "48358": true,
      "48359": true,
      "48360": true,
      "48361": true,
      "48362": true,
      "48363": true,
      "48364": true,
      "48365": true,
      "48366": true,
      "48367": true,
      "48368": true,
      "48369": true,
      "48370": true,
      "48371": true,
      "48372": true,
      "48373": true,
      "48374": true,
      "48375": true,
      "48376": true,
      "48377": true,
      "48378": true,
      "48379": true,
      "48380": true,
      "48381": true,
      "48382": true,
      "48383": true,
      "48384": true,
      "48385": true,
      "48386": true,
      "48387": true,
      "48388": true,
      "48389": true,
      "48390": true,
      "48391": true,
      "48392": true,
      "48393": true,
      "48394": true,
      "48395": true,
      "48396": true,
      "48397": true,
      "48398": true,
      "48399": true
    },
    "CABO CORRIENTES": {
      "48400": true,
      "48401": true,
      "48402": true,
      "48403": true,
      "48404": true,
      "48405": true,
      "48406": true,
      "48407": true,
      "48408": true,
      "48409": true,
      "48413": true,
      "48424": true,
      "48426": true,
      "48428": true,
      "48429": true,
      "48430": true,
      "48431": true,
      "48432": true,
      "48445": true,
      "48446": true,
      "48447": true,
      "48448": true,
      "48449": true
    },
    "COCULA": {
      "48500": true,
      "48501": true,
      "48502": true,
      "48503": true,
      "48504": true,
      "48505": true,
      "48506": true,
      "48507": true,
      "48508": true,
      "48509": true,
      "48510": true,
      "48511": true,
      "48512": true,
      "48513": true,
      "48514": true,
      "48515": true,
      "48516": true,
      "48517": true,
      "48518": true,
      "48519": true,
      "48520": true,
      "48521": true,
      "48522": true,
      "48523": true,
      "48524": true,
      "48525": true,
      "48526": true,
      "48527": true,
      "48528": true,
      "48529": true,
      "48530": true,
      "48531": true,
      "48532": true,
      "48533": true,
      "48534": true,
      "48535": true,
      "48536": true,
      "48537": true,
      "48538": true,
      "48539": true
    },
    "TECOLOTLAN": {
      "48540": true,
      "48541": true,
      "48542": true,
      "48543": true,
      "48544": true,
      "48545": true,
      "48546": true,
      "48547": true,
      "48548": true,
      "48549": true,
      "48553": true,
      "48554": true,
      "48555": true,
      "48556": true,
      "48557": true,
      "48558": true,
      "48560": true,
      "48561": true,
      "48562": true,
      "48563": true,
      "48564": true,
      "48565": true,
      "48566": true,
      "48567": true,
      "48568": true,
      "48569": true
    },
    "EL GRULLO": {
      "48740": true,
      "48741": true,
      "48742": true,
      "48743": true,
      "48744": true,
      "48745": true,
      "48746": true,
      "48747": true,
      "48748": true,
      "48749": true,
      "48750": true,
      "48751": true,
      "48752": true,
      "48753": true,
      "48754": true,
      "48755": true,
      "48756": true,
      "48757": true,
      "48758": true,
      "48759": true
    },
    "VILLA PURIFICACION": {
      "48800": true,
      "48801": true,
      "48802": true,
      "48803": true,
      "48804": true,
      "48805": true,
      "48806": true,
      "48807": true,
      "48808": true,
      "48809": true,
      "48810": true,
      "48811": true,
      "48812": true,
      "48813": true,
      "48814": true,
      "48815": true,
      "48816": true,
      "48817": true,
      "48818": true,
      "48819": true,
      "48823": true
    },
    "AUTLAN DE NAVARRO": {
      "48900": true,
      "48901": true,
      "48902": true,
      "48903": true,
      "48904": true,
      "48905": true,
      "48906": true,
      "48907": true,
      "48908": true,
      "48909": true,
      "48910": true,
      "48911": true,
      "48912": true,
      "48913": true,
      "48914": true,
      "48915": true,
      "48916": true,
      "48917": true,
      "48918": true,
      "48919": true,
      "48920": true,
      "48921": true,
      "48922": true,
      "48923": true,
      "48924": true,
      "48925": true,
      "48926": true,
      "48927": true,
      "48928": true,
      "48929": true
    },
    "CASIMIRO CASTILLO": {
      "48930": true,
      "48931": true,
      "48932": true,
      "48933": true,
      "48934": true,
      "48935": true,
      "48936": true,
      "48937": true,
      "48938": true,
      "48939": true,
      "48940": true,
      "48941": true,
      "48942": true,
      "48943": true,
      "48944": true,
      "48945": true,
      "48946": true,
      "48947": true,
      "48948": true,
      "48949": true
    },
    "CUAUTITLAN DE GARCIA BARRAGAN": {
      "48950": true,
      "48951": true,
      "48952": true,
      "48953": true,
      "48954": true,
      "48955": true,
      "48956": true,
      "48957": true,
      "48958": true,
      "48959": true,
      "48962": true,
      "48963": true,
      "48965": true,
      "48966": true
    },
    "CIHUATLAN": {
      "48970": true,
      "48971": true,
      "48972": true,
      "48973": true,
      "48974": true,
      "48975": true,
      "48976": true,
      "48977": true,
      "48978": true,
      "48979": true,
      "48980": true,
      "48981": true,
      "48982": true,
      "48983": true,
      "48984": true,
      "48985": true,
      "48987": true,
      "48988": true,
      "48990": true,
      "48991": true,
      "48992": true,
      "48993": true,
      "48994": true,
      "48995": true,
      "48996": true,
      "48997": true,
      "48998": true,
      "48999": true
    },
    "ZAPOTLAN EL GRANDE": {
      "49000": true,
      "49001": true,
      "49002": true,
      "49003": true,
      "49004": true,
      "49005": true,
      "49006": true,
      "49007": true,
      "49008": true,
      "49009": true,
      "49010": true,
      "49011": true,
      "49012": true,
      "49013": true,
      "49014": true,
      "49015": true,
      "49016": true,
      "49017": true,
      "49018": true,
      "49019": true,
      "49020": true,
      "49021": true,
      "49022": true,
      "49023": true,
      "49024": true,
      "49025": true,
      "49026": true,
      "49027": true,
      "49028": true,
      "49029": true,
      "49030": true,
      "49031": true,
      "49032": true,
      "49033": true,
      "49034": true,
      "49035": true,
      "49036": true,
      "49037": true,
      "49038": true,
      "49039": true,
      "49040": true,
      "49041": true,
      "49042": true,
      "49043": true,
      "49044": true,
      "49045": true,
      "49046": true,
      "49047": true,
      "49048": true,
      "49049": true,
      "49050": true,
      "49051": true,
      "49052": true,
      "49053": true,
      "49054": true,
      "49055": true,
      "49056": true,
      "49057": true,
      "49058": true,
      "49059": true,
      "49060": true,
      "49061": true,
      "49062": true,
      "49063": true,
      "49064": true,
      "49065": true,
      "49066": true,
      "49067": true,
      "49068": true,
      "49069": true,
      "49070": true,
      "49071": true,
      "49072": true,
      "49073": true,
      "49074": true,
      "49075": true,
      "49076": true,
      "49077": true,
      "49078": true,
      "49079": true,
      "49080": true,
      "49081": true,
      "49082": true,
      "49083": true,
      "49084": true,
      "49085": true,
      "49086": true,
      "49087": true,
      "49088": true,
      "49089": true,
      "49090": true,
      "49091": true,
      "49092": true,
      "49093": true,
      "49094": true,
      "49095": true,
      "49096": true,
      "49097": true,
      "49098": true,
      "49099": true,
      "49100": true,
      "49101": true,
      "49102": true,
      "49103": true,
      "49104": true,
      "49105": true,
      "49106": true,
      "49107": true,
      "49108": true,
      "49109": true,
      "49110": true,
      "49111": true,
      "49112": true,
      "49113": true,
      "49114": true,
      "49115": true,
      "49116": true,
      "49117": true,
      "49118": true,
      "49119": true
    },
    "GOMEZ FARIAS": {
      "49120": true,
      "49121": true,
      "49122": true,
      "49123": true,
      "49124": true,
      "49125": true,
      "49126": true,
      "49127": true,
      "49128": true,
      "49129": true,
      "49130": true,
      "49131": true,
      "49132": true,
      "49133": true,
      "49134": true,
      "49135": true,
      "49136": true,
      "49137": true,
      "49138": true,
      "49139": true,
      "49140": true,
      "49141": true,
      "49142": true,
      "49143": true,
      "49144": true,
      "49145": true,
      "49146": true,
      "49147": true,
      "49148": true,
      "49149": true,
      "49150": true,
      "49151": true,
      "49152": true,
      "49153": true,
      "49154": true,
      "49155": true,
      "49156": true,
      "49157": true,
      "49158": true,
      "49159": true,
      "49160": true,
      "49161": true,
      "49162": true,
      "49163": true,
      "49164": true,
      "49165": true,
      "49166": true,
      "49167": true,
      "49168": true,
      "49169": true
    },
    "TECHALUTA DE MONTENEGRO": {
      "49230": true,
      "49231": true,
      "49232": true,
      "49233": true,
      "49234": true,
      "49235": true,
      "49239": true,
      "49240": true,
      "49241": true,
      "49242": true,
      "49243": true,
      "49244": true,
      "49245": true,
      "49246": true,
      "49247": true,
      "49248": true,
      "49249": true
    },
    "TEOCUITATLAN DE CORONA": {
      "49250": true,
      "49251": true,
      "49252": true,
      "49253": true,
      "49254": true,
      "49255": true,
      "49256": true,
      "49257": true,
      "49258": true,
      "49259": true,
      "49260": true,
      "49261": true,
      "49262": true,
      "49263": true,
      "49264": true,
      "49265": true,
      "49266": true,
      "49267": true,
      "49268": true,
      "49269": true,
      "49270": true,
      "49271": true,
      "49272": true,
      "49273": true,
      "49274": true,
      "49275": true,
      "49276": true,
      "49277": true,
      "49278": true,
      "49279": true,
      "49280": true,
      "49281": true,
      "49282": true,
      "49283": true,
      "49284": true,
      "49285": true,
      "49286": true,
      "49287": true,
      "49288": true,
      "49289": true,
      "49290": true,
      "49291": true,
      "49292": true,
      "49293": true,
      "49294": true,
      "49295": true,
      "49296": true,
      "49297": true,
      "49298": true,
      "49299": true
    },
    "SAYULA": {
      "49300": true,
      "49301": true,
      "49302": true,
      "49303": true,
      "49304": true,
      "49305": true,
      "49306": true,
      "49307": true,
      "49308": true,
      "49309": true,
      "49310": true,
      "49311": true,
      "49312": true,
      "49313": true,
      "49314": true,
      "49315": true,
      "49316": true,
      "49317": true,
      "49318": true,
      "49319": true,
      "49320": true,
      "49321": true,
      "49322": true,
      "49323": true,
      "49324": true,
      "49325": true,
      "49326": true,
      "49327": true,
      "49328": true,
      "49329": true,
      "49330": true,
      "49331": true,
      "49332": true,
      "49333": true,
      "49334": true,
      "49335": true,
      "49336": true,
      "49337": true,
      "49338": true,
      "49339": true
    },
    "TAPALPA": {
      "49340": true,
      "49341": true,
      "49342": true,
      "49343": true,
      "49344": true,
      "49345": true,
      "49346": true,
      "49347": true,
      "49348": true,
      "49349": true,
      "49350": true,
      "49351": true,
      "49352": true,
      "49353": true,
      "49354": true,
      "49355": true,
      "49356": true,
      "49357": true,
      "49358": true,
      "49359": true,
      "49360": true,
      "49361": true,
      "49362": true,
      "49363": true,
      "49364": true,
      "49365": true,
      "49366": true,
      "49367": true,
      "49368": true
    },
    "AMACUECA": {
      "49370": true,
      "49371": true,
      "49372": true,
      "49373": true,
      "49374": true,
      "49375": true,
      "49376": true,
      "49377": true,
      "49378": true,
      "49379": true,
      "49380": true,
      "49381": true,
      "49382": true,
      "49383": true,
      "49384": true,
      "49385": true,
      "49386": true,
      "49387": true,
      "49388": true,
      "49389": true,
      "49390": true,
      "49391": true,
      "49392": true,
      "49393": true,
      "49394": true,
      "49395": true,
      "49396": true,
      "49397": true,
      "49398": true,
      "49399": true
    },
    "TIZAPAN EL ALTO": {
      "49400": true,
      "49401": true,
      "49402": true,
      "49403": true,
      "49404": true,
      "49405": true,
      "49406": true,
      "49407": true,
      "49408": true,
      "49409": true,
      "49410": true,
      "49411": true,
      "49412": true,
      "49413": true,
      "49414": true,
      "49415": true,
      "49416": true,
      "49417": true,
      "49418": true,
      "49419": true,
      "49420": true,
      "49421": true,
      "49422": true,
      "49423": true,
      "49424": true,
      "49425": true,
      "49426": true,
      "49427": true,
      "49428": true,
      "49429": true
    },
    "TUXCUECA": {
      "49430": true,
      "49431": true,
      "49432": true,
      "49433": true,
      "49434": true,
      "49435": true,
      "49436": true,
      "49437": true,
      "49438": true,
      "49439": true,
      "49440": true,
      "49441": true,
      "49442": true,
      "49443": true,
      "49444": true,
      "49445": true,
      "49446": true,
      "49447": true,
      "49448": true,
      "49449": true
    },
    "LA MANZANILLA DE LA PAZ": {
      "49460": true,
      "49461": true,
      "49462": true,
      "49463": true,
      "49464": true,
      "49465": true,
      "49466": true,
      "49467": true,
      "49468": true,
      "49469": true,
      "49470": true,
      "49471": true,
      "49472": true,
      "49473": true,
      "49474": true,
      "49475": true,
      "49476": true,
      "49477": true,
      "49478": true,
      "49479": true,
      "49480": true,
      "49481": true,
      "49482": true,
      "49483": true,
      "49484": true,
      "49485": true,
      "49486": true,
      "49487": true,
      "49488": true,
      "49489": true,
      "49490": true,
      "49491": true,
      "49492": true,
      "49493": true,
      "49494": true,
      "49495": true,
      "49496": true,
      "49497": true,
      "49498": true,
      "49499": true
    },
    "MAZAMITLA": {
      "49500": true,
      "49501": true,
      "49502": true,
      "49503": true,
      "49504": true,
      "49505": true,
      "49506": true,
      "49507": true,
      "49508": true,
      "49509": true,
      "49510": true,
      "49511": true,
      "49512": true,
      "49513": true,
      "49514": true,
      "49515": true,
      "49516": true,
      "49517": true,
      "49518": true,
      "49519": true,
      "49520": true,
      "49521": true,
      "49522": true,
      "49523": true,
      "49524": true,
      "49525": true,
      "49526": true,
      "49527": true,
      "49528": true,
      "49529": true,
      "49530": true,
      "49531": true,
      "49532": true,
      "49533": true,
      "49534": true,
      "49535": true,
      "49536": true
    },
    "VALLE DE JUAREZ": {
      "49540": true,
      "49541": true,
      "49542": true,
      "49543": true,
      "49544": true,
      "49545": true,
      "49546": true,
      "49547": true,
      "49548": true,
      "49549": true,
      "49550": true,
      "49551": true,
      "49552": true,
      "49553": true,
      "49554": true,
      "49555": true,
      "49556": true,
      "49557": true,
      "49558": true,
      "49559": true,
      "49560": true,
      "49561": true,
      "49562": true,
      "49563": true,
      "49564": true,
      "49565": true,
      "49566": true,
      "49567": true,
      "49568": true,
      "49569": true
    },
    "ZAPOTILTIC": {
      "49600": true,
      "49601": true,
      "49602": true,
      "49603": true,
      "49604": true,
      "49605": true,
      "49606": true,
      "49608": true,
      "49609": true,
      "49610": true,
      "49611": true,
      "49612": true,
      "49613": true,
      "49614": true,
      "49615": true,
      "49616": true,
      "49617": true,
      "49618": true,
      "49619": true,
      "49620": true,
      "49621": true,
      "49622": true,
      "49623": true,
      "49624": true,
      "49625": true,
      "49626": true,
      "49627": true,
      "49628": true,
      "49629": true,
      "49630": true,
      "49631": true,
      "49632": true,
      "49633": true,
      "49634": true,
      "49635": true,
      "49636": true,
      "49637": true,
      "49638": true,
      "49639": true,
      "49640": true,
      "49641": true,
      "49642": true,
      "49643": true,
      "49644": true,
      "49645": true,
      "49646": true,
      "49647": true,
      "49648": true,
      "49649": true
    },
    "ZAPOTITLAN DE VADILLO": {
      "49770": true,
      "49771": true,
      "49772": true,
      "49773": true,
      "49774": true,
      "49775": true,
      "49776": true,
      "49777": true,
      "49778": true,
      "49779": true,
      "49783": true,
      "49784": true,
      "49785": true,
      "49786": true,
      "49787": true,
      "49788": true,
      "49789": true,
      "49790": true,
      "49791": true,
      "49792": true,
      "49793": true,
      "49794": true,
      "49795": true,
      "49796": true,
      "49797": true,
      "49798": true,
      "49799": true
    },
    "TUXPAN": {
      "49800": true,
      "49801": true,
      "49802": true,
      "49803": true,
      "49804": true,
      "49805": true,
      "49806": true,
      "49807": true,
      "49808": true,
      "49809": true,
      "49810": true,
      "49811": true,
      "49812": true,
      "49813": true,
      "49814": true,
      "49815": true,
      "49816": true,
      "49817": true,
      "49818": true,
      "49819": true,
      "49820": true,
      "49821": true,
      "49822": true,
      "49823": true,
      "49824": true,
      "49825": true,
      "49826": true,
      "49827": true,
      "49828": true,
      "49829": true,
      "49836": true
    },
    "TONILA": {
      "49840": true,
      "49841": true,
      "49842": true,
      "49843": true,
      "49844": true,
      "49845": true,
      "49846": true,
      "49847": true,
      "49848": true,
      "49849": true,
      "49850": true,
      "49851": true,
      "49852": true,
      "49853": true,
      "49854": true,
      "49855": true,
      "49856": true,
      "49857": true,
      "49858": true,
      "49859": true,
      "49860": true,
      "49861": true,
      "49862": true,
      "49863": true,
      "49864": true,
      "49865": true,
      "49866": true,
      "49867": true,
      "49868": true,
      "49869": true
    },
    "PIHUAMO": {
      "49870": true,
      "49871": true,
      "49872": true,
      "49873": true,
      "49874": true,
      "49875": true,
      "49876": true,
      "49877": true,
      "49878": true,
      "49879": true,
      "49880": true,
      "49881": true,
      "49882": true,
      "49885": true,
      "49886": true,
      "49887": true,
      "49888": true,
      "49889": true,
      "49890": true,
      "49891": true,
      "49892": true,
      "49896": true,
      "49897": true,
      "49898": true,
      "49899": true
    },
    "TECALITLAN": {
      "49900": true,
      "49901": true,
      "49902": true,
      "49903": true,
      "49904": true,
      "49905": true,
      "49906": true,
      "49907": true,
      "49908": true,
      "49909": true,
      "49910": true,
      "49911": true,
      "49912": true,
      "49913": true,
      "49914": true,
      "49915": true,
      "49916": true,
      "49917": true,
      "49918": true,
      "49919": true,
      "49920": true,
      "49921": true,
      "49922": true,
      "49923": true,
      "49924": true,
      "49925": true,
      "49926": true,
      "49927": true,
      "49928": true,
      "49929": true,
      "49930": true,
      "49931": true,
      "49932": true,
      "49933": true,
      "49934": true,
      "49935": true,
      "49936": true,
      "49937": true,
      "49938": true,
      "49939": true
    },
    "SANTA MARIA DEL ORO": {
      "49970": true,
      "49971": true,
      "49972": true,
      "49973": true,
      "49974": true,
      "49975": true,
      "49976": true,
      "49979": true,
      "49980": true,
      "49981": true,
      "49982": true,
      "49983": true,
      "49984": true,
      "49985": true,
      "49986": true,
      "49987": true,
      "49988": true,
      "49989": true,
      "49996": true,
      "49997": true,
      "49998": true,
      "49999": true
    }
  },
  "MÉXICO": {
    "TOLUCA": {
      "50000": true,
      "50010": true,
      "50016": true,
      "50017": true,
      "50018": true,
      "50019": true,
      "50020": true,
      "50026": true,
      "50030": true,
      "50039": true,
      "50040": true,
      "50050": true,
      "50060": true,
      "50069": true,
      "50070": true,
      "50071": true,
      "50075": true,
      "50076": true,
      "50080": true,
      "50090": true,
      "50100": true,
      "50103": true,
      "50110": true,
      "50115": true,
      "50120": true,
      "50122": true,
      "50123": true,
      "50130": true,
      "50140": true,
      "50150": true,
      "50160": true,
      "50168": true,
      "50170": true,
      "50180": true,
      "50190": true,
      "50200": true,
      "50203": true,
      "50205": true,
      "50206": true,
      "50209": true,
      "50210": true,
      "50214": true,
      "50220": true,
      "50223": true,
      "50225": true,
      "50226": true,
      "50227": true,
      "50228": true,
      "50230": true,
      "50233": true,
      "50235": true,
      "50236": true,
      "50240": true,
      "50245": true,
      "50246": true,
      "50250": true,
      "50253": true,
      "50254": true,
      "50255": true,
      "50256": true,
      "50257": true,
      "50258": true,
      "50260": true,
      "50263": true,
      "50264": true,
      "50265": true,
      "50266": true,
      "50270": true,
      "50273": true,
      "50274": true,
      "50280": true,
      "50283": true,
      "50284": true,
      "50285": true,
      "50286": true,
      "50290": true,
      "50293": true,
      "50294": true,
      "50295": true
    },
    "ALMOLOYA DE JUÁREZ": {
      "50900": true,
      "50903": true,
      "50904": true,
      "50906": true,
      "50907": true,
      "50910": true,
      "50920": true,
      "50924": true,
      "50925": true,
      "50926": true,
      "50927": true,
      "50930": true,
      "50933": true,
      "50934": true,
      "50935": true,
      "50940": true,
      "50943": true,
      "50944": true,
      "50945": true,
      "50946": true
    },
    "ZINACANTEPEC": {
      "51350": true,
      "51354": true,
      "51355": true,
      "51356": true,
      "51357": true,
      "51360": true,
      "51364": true,
      "51366": true,
      "51367": true,
      "51370": true,
      "51373": true,
      "51374": true,
      "51375": true,
      "51380": true,
      "51383": true,
      "51384": true,
      "51385": true,
      "51386": true,
      "51390": true,
      "51393": true
    },
    "LERMA": {
      "52000": true,
      "52004": true,
      "52005": true,
      "52006": true,
      "52010": true,
      "52020": true,
      "52030": true,
      "52040": true,
      "52043": true,
      "52044": true,
      "52045": true,
      "52046": true,
      "52047": true,
      "52050": true,
      "52054": true,
      "52055": true,
      "52059": true
    },
    "METEPEC": {
      "52140": true,
      "52143": true,
      "52144": true,
      "52145": true,
      "52146": true,
      "52147": true,
      "52148": true,
      "52149": true,
      "52150": true,
      "52154": true,
      "52155": true,
      "52156": true,
      "52157": true,
      "52158": true,
      "52159": true,
      "52160": true,
      "52161": true,
      "52164": true,
      "52165": true,
      "52166": true,
      "52167": true,
      "52168": true,
      "52169": true,
      "52170": true,
      "52172": true,
      "52175": true,
      "52176": true,
      "52177": true,
      "52178": true,
      "52179": true
    },
    "MEXICALTZINGO": {
      "52180": true,
      "52182": true,
      "52183": true,
      "52185": true,
      "52189": true
    },
    "CALIMAYA": {
      "52200": true,
      "52203": true,
      "52204": true,
      "52205": true,
      "52210": true,
      "52213": true,
      "52214": true,
      "52215": true,
      "52220": true,
      "52223": true,
      "52224": true,
      "52225": true,
      "52226": true,
      "52227": true,
      "52230": true,
      "52233": true,
      "52234": true,
      "52235": true,
      "52236": true
    },
    "CHAPULTEPEC": {
      "52240": true,
      "52243": true,
      "52244": true,
      "52250": true,
      "52254": true
    },
    "ATIZAPÁN DE ZARAGOZA": {
      "52500": true,
      "52503": true,
      "52504": true,
      "52505": true,
      "52506": true,
      "52900": true,
      "52910": true,
      "52915": true,
      "52916": true,
      "52918": true,
      "52919": true,
      "52920": true,
      "52923": true,
      "52924": true,
      "52925": true,
      "52926": true,
      "52927": true,
      "52928": true,
      "52929": true,
      "52930": true,
      "52934": true,
      "52936": true,
      "52937": true,
      "52938": true,
      "52940": true,
      "52945": true,
      "52946": true,
      "52947": true,
      "52948": true,
      "52949": true,
      "52950": true,
      "52953": true,
      "52957": true,
      "52959": true,
      "52960": true,
      "52965": true,
      "52966": true,
      "52967": true,
      "52968": true,
      "52970": true,
      "52975": true,
      "52976": true,
      "52977": true,
      "52978": true,
      "52979": true,
      "52980": true,
      "52985": true,
      "52986": true,
      "52987": true,
      "52988": true,
      "52989": true,
      "52990": true,
      "52994": true,
      "52995": true,
      "52996": true,
      "52997": true,
      "52998": true
    },
    "HUIXQUILUCAN": {
      "52760": true,
      "52763": true,
      "52764": true,
      "52765": true,
      "52766": true,
      "52767": true,
      "52768": true,
      "52769": true,
      "52770": true,
      "52773": true,
      "52774": true,
      "52775": true,
      "52776": true,
      "52777": true,
      "52778": true,
      "52779": true,
      "52780": true,
      "52783": true,
      "52784": true,
      "52785": true,
      "52786": true,
      "52787": true,
      "52788": true,
      "52789": true,
      "52790": true,
      "52793": true,
      "52794": true,
      "52795": true,
      "52796": true,
      "52797": true,
      "52798": true,
      "52799": true
    },
    "NAUCALPAN DE JUÁREZ": {
      "53000": true,
      "53010": true,
      "53030": true,
      "53040": true,
      "53050": true,
      "53060": true,
      "53070": true,
      "53100": true,
      "53110": true,
      "53115": true,
      "53116": true,
      "53117": true,
      "53119": true,
      "53120": true,
      "53124": true,
      "53125": true,
      "53126": true,
      "53127": true,
      "53128": true,
      "53129": true,
      "53130": true,
      "53138": true,
      "53140": true,
      "53150": true,
      "53160": true,
      "53170": true,
      "53177": true,
      "53178": true,
      "53179": true,
      "53200": true,
      "53215": true,
      "53216": true,
      "53217": true,
      "53218": true,
      "53219": true,
      "53220": true,
      "53224": true,
      "53227": true,
      "53228": true,
      "53229": true,
      "53230": true,
      "53237": true,
      "53239": true,
      "53240": true,
      "53247": true,
      "53248": true,
      "53250": true,
      "53260": true,
      "53270": true,
      "53278": true,
      "53279": true,
      "53280": true,
      "53283": true,
      "53290": true,
      "53296": true,
      "53297": true,
      "53298": true,
      "53300": true,
      "53309": true,
      "53310": true,
      "53320": true,
      "53329": true,
      "53330": true,
      "53338": true,
      "53339": true,
      "53340": true,
      "53348": true,
      "53350": true,
      "53370": true,
      "53378": true,
      "53390": true,
      "53398": true,
      "53400": true,
      "53410": true,
      "53420": true,
      "53425": true,
      "53426": true,
      "53427": true,
      "53428": true,
      "53430": true,
      "53440": true,
      "53450": true,
      "53458": true,
      "53459": true,
      "53460": true,
      "53470": true,
      "53489": true,
      "53490": true,
      "53500": true,
      "53519": true,
      "53520": true,
      "53529": true,
      "53530": true,
      "53533": true,
      "53550": true,
      "53560": true,
      "53569": true,
      "53570": true,
      "53580": true,
      "53598": true,
      "53640": true,
      "53650": true,
      "53658": true,
      "53659": true,
      "53660": true,
      "53664": true,
      "53670": true,
      "53680": true,
      "53687": true,
      "53688": true,
      "53689": true,
      "53690": true,
      "53694": true,
      "53695": true,
      "53696": true,
      "53697": true,
      "53698": true,
      "53700": true,
      "53708": true,
      "53710": true,
      "53713": true,
      "53714": true,
      "53716": true,
      "53717": true,
      "53718": true,
      "53719": true,
      "53730": true,
      "53760": true,
      "53770": true,
      "53780": true,
      "53787": true,
      "53788": true,
      "53790": true,
      "53798": true,
      "53799": true,
      "53800": true,
      "53809": true,
      "53810": true,
      "53819": true,
      "53820": true,
      "53830": true,
      "53839": true,
      "53840": true,
      "53900": true,
      "53909": true,
      "53910": true,
      "53930": true,
      "53940": true,
      "53950": true,
      "53960": true,
      "53970": true
    },
    "TLALNEPANTLA DE BAZ": {
      "54000": true,
      "54009": true,
      "54010": true,
      "54015": true,
      "54016": true,
      "54017": true,
      "54020": true,
      "54021": true,
      "54022": true,
      "54023": true,
      "54025": true,
      "54026": true,
      "54028": true,
      "54030": true,
      "54033": true,
      "54037": true,
      "54038": true,
      "54040": true,
      "54049": true,
      "54050": true,
      "54054": true,
      "54055": true,
      "54057": true,
      "54059": true,
      "54060": true,
      "54063": true,
      "54067": true,
      "54068": true,
      "54069": true,
      "54070": true,
      "54073": true,
      "54075": true,
      "54076": true,
      "54080": true,
      "54090": true,
      "54092": true,
      "54093": true,
      "54094": true,
      "54098": true,
      "54100": true,
      "54108": true,
      "54109": true,
      "54110": true,
      "54118": true,
      "54119": true,
      "54120": true,
      "54124": true,
      "54126": true,
      "54127": true,
      "54128": true,
      "54130": true,
      "54134": true,
      "54135": true,
      "54136": true,
      "54140": true,
      "54142": true,
      "54143": true,
      "54145": true,
      "54146": true,
      "54147": true,
      "54149": true,
      "54150": true,
      "54152": true,
      "54158": true,
      "54160": true,
      "54162": true,
      "54168": true,
      "54170": true,
      "54172": true,
      "54173": true,
      "54180": true,
      "54187": true,
      "54189": true,
      "54190": true,
      "54193": true,
      "54195": true,
      "54196": true,
      "54197": true,
      "54198": true
    },
    "CUAUTITLÁN IZCALLI": {
      "54700": true,
      "54710": true,
      "54712": true,
      "54713": true,
      "54714": true,
      "54715": true,
      "54716": true,
      "54719": true,
      "54720": true,
      "54725": true,
      "54729": true,
      "54730": true,
      "54740": true,
      "54743": true,
      "54744": true,
      "54745": true,
      "54750": true,
      "54753": true,
      "54759": true,
      "54760": true,
      "54763": true,
      "54764": true,
      "54765": true,
      "54766": true,
      "54767": true,
      "54769": true
    },
    "CUAUTITLÁN": {
      "54800": true,
      "54803": true,
      "54804": true,
      "54805": true,
      "54807": true,
      "54830": true,
      "54831": true,
      "54834": true,
      "54835": true,
      "54836": true,
      "54840": true,
      "54850": true,
      "54855": true,
      "54857": true,
      "54858": true,
      "54860": true,
      "54870": true,
      "54875": true,
      "54877": true,
      "54878": true,
      "54879": true
    },
    "MELCHOR OCAMPO": {
      "54880": true,
      "54882": true,
      "54883": true,
      "54884": true,
      "54890": true,
      "54893": true,
      "54894": true
    },
    "TULTITLÁN": {
      "54900": true,
      "54910": true,
      "54913": true,
      "54914": true,
      "54915": true,
      "54916": true,
      "54918": true,
      "54920": true,
      "54924": true,
      "54925": true,
      "54926": true,
      "54927": true,
      "54929": true,
      "54930": true,
      "54932": true,
      "54933": true,
      "54934": true,
      "54935": true,
      "54938": true,
      "54939": true,
      "54940": true,
      "54942": true,
      "54943": true,
      "54944": true,
      "54945": true,
      "54946": true,
      "54947": true,
      "54948": true,
      "54949": true,
      "54950": true,
      "54954": true,
      "54955": true,
      "54957": true,
      "54958": true,
      "54959": true
    },
    "TULTEPEC": {
      "54960": true,
      "54962": true,
      "54963": true,
      "54964": true,
      "54965": true,
      "54966": true,
      "54967": true,
      "54970": true,
      "54972": true,
      "54974": true,
      "54975": true,
      "54976": true,
      "54977": true,
      "54980": true,
      "54983": true,
      "54984": true,
      "54985": true,
      "54986": true,
      "54987": true,
      "54990": true
    },
    "ECATEPEC DE MORELOS": {
      "55000": true,
      "55010": true,
      "55014": true,
      "55016": true,
      "55017": true,
      "55018": true,
      "55020": true,
      "55023": true,
      "55024": true,
      "55025": true,
      "55027": true,
      "55028": true,
      "55029": true,
      "55030": true,
      "55036": true,
      "55037": true,
      "55038": true,
      "55039": true,
      "55040": true,
      "55050": true,
      "55055": true,
      "55056": true,
      "55059": true,
      "55060": true,
      "55063": true,
      "55064": true,
      "55065": true,
      "55066": true,
      "55067": true,
      "55068": true,
      "55069": true,
      "55070": true,
      "55074": true,
      "55075": true,
      "55076": true,
      "55080": true,
      "55084": true,
      "55085": true,
      "55087": true,
      "55090": true,
      "55094": true,
      "55095": true,
      "55100": true,
      "55104": true,
      "55105": true,
      "55107": true,
      "55114": true,
      "55115": true,
      "55117": true,
      "55118": true,
      "55119": true,
      "55120": true,
      "55125": true,
      "55126": true,
      "55127": true,
      "55128": true,
      "55129": true,
      "55130": true,
      "55135": true,
      "55137": true,
      "55138": true,
      "55139": true,
      "55140": true,
      "55146": true,
      "55147": true,
      "55148": true,
      "55149": true,
      "55158": true,
      "55170": true,
      "55176": true,
      "55180": true,
      "55187": true,
      "55188": true,
      "55189": true,
      "55190": true,
      "55200": true,
      "55210": true,
      "55218": true,
      "55220": true,
      "55230": true,
      "55234": true,
      "55235": true,
      "55236": true,
      "55237": true,
      "55238": true,
      "55240": true,
      "55242": true,
      "55243": true,
      "55244": true,
      "55245": true,
      "55246": true,
      "55247": true,
      "55248": true,
      "55249": true,
      "55260": true,
      "55264": true,
      "55266": true,
      "55267": true,
      "55268": true,
      "55269": true,
      "55270": true,
      "55280": true,
      "55284": true,
      "55287": true,
      "55288": true,
      "55289": true,
      "55290": true,
      "55294": true,
      "55295": true,
      "55296": true,
      "55297": true,
      "55298": true,
      "55299": true,
      "55300": true,
      "55308": true,
      "55310": true,
      "55316": true,
      "55317": true,
      "55320": true,
      "55330": true,
      "55338": true,
      "55339": true,
      "55340": true,
      "55347": true,
      "55348": true,
      "55349": true,
      "55360": true,
      "55369": true,
      "55390": true,
      "55400": true,
      "55404": true,
      "55405": true,
      "55407": true,
      "55410": true,
      "55414": true,
      "55415": true,
      "55416": true,
      "55417": true,
      "55418": true,
      "55419": true,
      "55420": true,
      "55425": true,
      "55429": true,
      "55430": true,
      "55450": true,
      "55458": true,
      "55459": true,
      "55490": true,
      "55498": true,
      "55500": true,
      "55506": true,
      "55507": true,
      "55508": true,
      "55509": true,
      "55510": true,
      "55515": true,
      "55516": true,
      "55517": true,
      "55518": true,
      "55519": true,
      "55520": true,
      "55530": true,
      "55540": true,
      "55547": true,
      "55548": true,
      "55549": true
    },
    "COACALCO DE BERRIOZÁBAL": {
      "55700": true,
      "55705": true,
      "55707": true,
      "55708": true,
      "55709": true,
      "55710": true,
      "55712": true,
      "55713": true,
      "55714": true,
      "55715": true,
      "55716": true,
      "55717": true,
      "55718": true,
      "55719": true,
      "55720": true,
      "55726": true,
      "55728": true,
      "55729": true,
      "55730": true,
      "55736": true,
      "55737": true,
      "55738": true,
      "55739": true
    },
    "TECÁMAC": {
      "55740": true,
      "55743": true,
      "55744": true,
      "55745": true,
      "55746": true,
      "55747": true,
      "55748": true,
      "55749": true,
      "55750": true,
      "55752": true,
      "55754": true,
      "55755": true,
      "55757": true,
      "55758": true,
      "55760": true,
      "55763": true,
      "55764": true,
      "55765": true,
      "55766": true,
      "55767": true,
      "55768": true,
      "55770": true,
      "55773": true,
      "55776": true,
      "55778": true
    },
    "TEXCOCO": {
      "56100": true,
      "56105": true,
      "56106": true,
      "56110": true,
      "56120": true,
      "56130": true,
      "56140": true,
      "56150": true,
      "56160": true,
      "56170": true,
      "56200": true,
      "56203": true,
      "56204": true,
      "56205": true,
      "56207": true,
      "56208": true,
      "56210": true,
      "56213": true,
      "56214": true,
      "56215": true,
      "56216": true,
      "56217": true,
      "56220": true,
      "56223": true,
      "56224": true,
      "56225": true,
      "56226": true,
      "56227": true,
      "56230": true,
      "56233": true,
      "56235": true,
      "56236": true,
      "56237": true,
      "56240": true,
      "56243": true,
      "56244": true,
      "56245": true,
      "56246": true,
      "56247": true,
      "56250": true,
      "56253": true,
      "56254": true,
      "56255": true,
      "56256": true,
      "56257": true,
      "56260": true,
      "56263": true,
      "56264": true,
      "56265": true,
      "56266": true,
      "56267": true,
      "56268": true
    },
    "CHIMALHUACÁN": {
      "56330": true,
      "56334": true,
      "56335": true,
      "56337": true,
      "56338": true,
      "56340": true,
      "56343": true,
      "56344": true,
      "56346": true,
      "56350": true,
      "56353": true,
      "56356": true,
      "56360": true,
      "56363": true,
      "56366": true
    },
    "CHICOLOAPAN": {
      "56370": true,
      "56373": true,
      "56375": true,
      "56376": true,
      "56377": true,
      "56380": true,
      "56383": true,
      "56384": true,
      "56386": true,
      "56390": true,
      "56395": true,
      "56396": true
    },
    "LA PAZ": {
      "56400": true,
      "56410": true,
      "56420": true,
      "56428": true,
      "56429": true,
      "56430": true,
      "56440": true,
      "56490": true,
      "56495": true,
      "56500": true,
      "56505": true,
      "56507": true,
      "56508": true,
      "56509": true,
      "56510": true,
      "56512": true,
      "56513": true,
      "56514": true,
      "56515": true,
      "56516": true,
      "56520": true,
      "56524": true,
      "56525": true,
      "56526": true,
      "56527": true,
      "56528": true,
      "56529": true
    },
    "IXTAPALUCA": {
      "56530": true,
      "56535": true,
      "56536": true,
      "56537": true,
      "56538": true,
      "56539": true,
      "56540": true,
      "56550": true,
      "56553": true,
      "56555": true,
      "56556": true,
      "56558": true,
      "56560": true,
      "56563": true,
      "56564": true,
      "56565": true,
      "56566": true,
      "56567": true,
      "56568": true,
      "56569": true,
      "56570": true,
      "56576": true,
      "56577": true,
      "56579": true,
      "56580": true,
      "56584": true,
      "56585": true,
      "56586": true,
      "56587": true,
      "56588": true,
      "56589": true,
      "56590": true,
      "56599": true
    },
    "VALLE DE CHALCO SOLIDARIDAD": {
      "56610": true,
      "56613": true,
      "56614": true,
      "56615": true,
      "56616": true,
      "56617": true,
      "56618": true,
      "56619": true
    },
    "NEZAHUALCÓYOTL": {
      "57000": true,
      "57100": true,
      "57103": true,
      "57120": true,
      "57129": true,
      "57130": true,
      "57138": true,
      "57139": true,
      "57140": true,
      "57150": true,
      "57158": true,
      "57170": true,
      "57171": true,
      "57178": true,
      "57179": true,
      "57180": true,
      "57185": true,
      "57188": true,
      "57189": true,
      "57200": true,
      "57205": true,
      "57210": true,
      "57300": true,
      "57310": true,
      "57400": true,
      "57410": true,
      "57420": true,
      "57430": true,
      "57440": true,
      "57450": true,
      "57460": true,
      "57500": true,
      "57510": true,
      "57520": true,
      "57530": true,
      "57600": true,
      "57610": true,
      "57620": true,
      "57630": true,
      "57700": true,
      "57708": true,
      "57709": true,
      "57710": true,
      "57718": true,
      "57719": true,
      "57720": true,
      "57730": true,
      "57739": true,
      "57740": true,
      "57750": true,
      "57760": true,
      "57800": true,
      "57809": true,
      "57810": true,
      "57819": true,
      "57820": true,
      "57830": true,
      "57840": true,
      "57849": true,
      "57900": true,
      "57910": true,
      "57920": true,
      "57930": true,
      "57940": true,
      "57950": true
    }
  },
  "MICHOACÁN DE OCAMPO": {
    "MORELIA": {
      "58000": true,
      "58001": true,
      "58002": true,
      "58003": true,
      "58004": true,
      "58005": true,
      "58006": true,
      "58007": true,
      "58008": true,
      "58009": true,
      "58010": true,
      "58011": true,
      "58012": true,
      "58013": true,
      "58014": true,
      "58015": true,
      "58016": true,
      "58017": true,
      "58018": true,
      "58019": true,
      "58020": true,
      "58021": true,
      "58022": true,
      "58023": true,
      "58024": true,
      "58025": true,
      "58026": true,
      "58027": true,
      "58028": true,
      "58029": true,
      "58030": true,
      "58031": true,
      "58032": true,
      "58033": true,
      "58034": true,
      "58035": true,
      "58036": true,
      "58037": true,
      "58038": true,
      "58039": true,
      "58040": true,
      "58041": true,
      "58042": true,
      "58043": true,
      "58044": true,
      "58045": true,
      "58046": true,
      "58047": true,
      "58048": true,
      "58049": true,
      "58050": true,
      "58051": true,
      "58052": true,
      "58053": true,
      "58054": true,
      "58055": true,
      "58056": true,
      "58057": true,
      "58058": true,
      "58059": true,
      "58060": true,
      "58061": true,
      "58062": true,
      "58063": true,
      "58064": true,
      "58065": true,
      "58066": true,
      "58067": true,
      "58068": true,
      "58069": true,
      "58070": true,
      "58071": true,
      "58072": true,
      "58073": true,
      "58074": true,
      "58075": true,
      "58076": true,
      "58077": true,
      "58078": true,
      "58079": true,
      "58080": true,
      "58081": true,
      "58082": true,
      "58083": true,
      "58084": true,
      "58085": true,
      "58086": true,
      "58087": true,
      "58088": true,
      "58089": true,
      "58090": true,
      "58091": true,
      "58092": true,
      "58093": true,
      "58094": true,
      "58095": true,
      "58096": true,
      "58097": true,
      "58098": true,
      "58099": true,
      "58100": true,
      "58101": true,
      "58102": true,
      "58103": true,
      "58104": true,
      "58105": true,
      "58106": true,
      "58107": true,
      "58108": true,
      "58109": true,
      "58110": true,
      "58111": true,
      "58112": true,
      "58113": true,
      "58114": true,
      "58115": true,
      "58116": true,
      "58117": true,
      "58118": true,
      "58119": true,
      "58120": true,
      "58121": true,
      "58122": true,
      "58123": true,
      "58124": true,
      "58125": true,
      "58126": true,
      "58127": true,
      "58128": true,
      "58129": true,
      "58130": true,
      "58131": true,
      "58132": true,
      "58133": true,
      "58134": true,
      "58135": true,
      "58136": true,
      "58137": true,
      "58138": true,
      "58139": true,
      "58140": true,
      "58141": true,
      "58142": true,
      "58143": true,
      "58144": true,
      "58145": true,
      "58146": true,
      "58147": true,
      "58148": true,
      "58149": true,
      "58150": true,
      "58151": true,
      "58152": true,
      "58153": true,
      "58154": true,
      "58155": true,
      "58156": true,
      "58157": true,
      "58158": true,
      "58159": true,
      "58160": true,
      "58161": true,
      "58162": true,
      "58163": true,
      "58164": true,
      "58165": true,
      "58166": true,
      "58167": true,
      "58168": true,
      "58169": true,
      "58170": true,
      "58171": true,
      "58172": true,
      "58173": true,
      "58174": true,
      "58175": true,
      "58176": true,
      "58177": true,
      "58178": true,
      "58179": true,
      "58180": true,
      "58181": true,
      "58182": true,
      "58183": true,
      "58184": true,
      "58185": true,
      "58186": true,
      "58187": true,
      "58188": true,
      "58189": true,
      "58190": true,
      "58191": true,
      "58192": true,
      "58193": true,
      "58194": true,
      "58195": true,
      "58196": true,
      "58197": true,
      "58198": true,
      "58199": true,
      "58200": true,
      "58201": true,
      "58202": true,
      "58203": true,
      "58204": true,
      "58205": true,
      "58206": true,
      "58207": true,
      "58208": true,
      "58209": true,
      "58210": true,
      "58211": true,
      "58212": true,
      "58213": true,
      "58214": true,
      "58215": true,
      "58216": true,
      "58217": true,
      "58218": true,
      "58219": true,
      "58220": true,
      "58221": true,
      "58222": true,
      "58223": true,
      "58224": true,
      "58225": true,
      "58226": true,
      "58227": true,
      "58228": true,
      "58229": true,
      "58230": true,
      "58231": true,
      "58232": true,
      "58233": true,
      "58234": true,
      "58235": true,
      "58236": true,
      "58237": true,
      "58238": true,
      "58239": true,
      "58240": true,
      "58241": true,
      "58242": true,
      "58243": true,
      "58244": true,
      "58245": true,
      "58246": true,
      "58247": true,
      "58248": true,
      "58249": true,
      "58250": true,
      "58251": true,
      "58252": true,
      "58253": true,
      "58254": true,
      "58255": true,
      "58256": true,
      "58257": true,
      "58258": true,
      "58259": true,
      "58260": true,
      "58261": true,
      "58262": true,
      "58263": true,
      "58264": true,
      "58265": true,
      "58266": true,
      "58267": true,
      "58268": true,
      "58269": true,
      "58270": true,
      "58271": true,
      "58272": true,
      "58273": true,
      "58274": true,
      "58275": true,
      "58276": true,
      "58277": true,
      "58278": true,
      "58279": true,
      "58280": true,
      "58281": true,
      "58282": true,
      "58283": true,
      "58284": true,
      "58285": true,
      "58286": true,
      "58287": true,
      "58288": true,
      "58289": true,
      "58290": true,
      "58291": true,
      "58292": true,
      "58293": true,
      "58294": true,
      "58295": true,
      "58296": true,
      "58297": true,
      "58298": true,
      "58299": true,
      "58300": true,
      "58301": true,
      "58302": true,
      "58303": true,
      "58304": true,
      "58305": true,
      "58306": true,
      "58307": true,
      "58308": true,
      "58309": true,
      "58310": true,
      "58311": true,
      "58312": true,
      "58313": true,
      "58314": true,
      "58315": true,
      "58316": true,
      "58317": true,
      "58318": true,
      "58319": true,
      "58320": true,
      "58321": true,
      "58322": true,
      "58323": true,
      "58324": true,
      "58325": true,
      "58326": true,
      "58327": true,
      "58328": true,
      "58329": true,
      "58330": true,
      "58331": true,
      "58332": true,
      "58333": true,
      "58334": true,
      "58335": true,
      "58336": true,
      "58337": true,
      "58338": true,
      "58339": true,
      "58340": true,
      "58341": true,
      "58342": true,
      "58343": true,
      "58344": true,
      "58345": true,
      "58346": true,
      "58347": true,
      "58348": true,
      "58349": true,
      "58350": true,
      "58351": true,
      "58352": true,
      "58353": true,
      "58354": true,
      "58355": true,
      "58356": true,
      "58357": true,
      "58358": true,
      "58359": true
    },
    "HUANIQUEO": {
      "58360": true,
      "58361": true,
      "58362": true,
      "58363": true,
      "58364": true,
      "58365": true,
      "58366": true,
      "58367": true,
      "58368": true,
      "58369": true,
      "58370": true,
      "58371": true,
      "58372": true,
      "58373": true,
      "58374": true,
      "58375": true,
      "58376": true,
      "58377": true,
      "58378": true,
      "58379": true,
      "58380": true,
      "58381": true,
      "58382": true,
      "58383": true,
      "58384": true,
      "58385": true,
      "58386": true,
      "58387": true,
      "58388": true,
      "58389": true,
      "58390": true,
      "58391": true,
      "58392": true,
      "58393": true,
      "58394": true,
      "58395": true,
      "58396": true,
      "58397": true,
      "58398": true,
      "58399": true
    },
    "COENEO": {
      "58400": true,
      "58401": true,
      "58402": true,
      "58406": true,
      "58407": true,
      "58408": true,
      "58409": true
    },
    "QUIROGA": {
      "58420": true,
      "58421": true,
      "58422": true,
      "58423": true,
      "58424": true,
      "58425": true,
      "58426": true,
      "58427": true,
      "58428": true,
      "58429": true,
      "58430": true,
      "58431": true,
      "58432": true,
      "58433": true,
      "58434": true,
      "58435": true
    },
    "TZINTZUNTZAN": {
      "58440": true,
      "58441": true,
      "58443": true,
      "58444": true,
      "58445": true,
      "58446": true,
      "58448": true,
      "58449": true
    },
    "LAGUNILLAS": {
      "58450": true,
      "58451": true,
      "58452": true,
      "58453": true,
      "58454": true,
      "58455": true,
      "58456": true,
      "58457": true,
      "58458": true,
      "58459": true
    },
    "ACUITZIO": {
      "58460": true,
      "58461": true,
      "58462": true,
      "58463": true,
      "58464": true,
      "58465": true,
      "58466": true,
      "58467": true,
      "58468": true,
      "58469": true,
      "58470": true,
      "58471": true,
      "58472": true,
      "58473": true,
      "58474": true,
      "58475": true,
      "58476": true,
      "58477": true,
      "58478": true,
      "58479": true
    },
    "MADERO": {
      "58480": true,
      "58481": true,
      "58482": true,
      "58483": true,
      "58486": true,
      "58487": true,
      "58488": true,
      "58489": true,
      "58497": true,
      "58498": true,
      "58499": true
    },
    "PURUANDIRO": {
      "58500": true,
      "58501": true,
      "58502": true,
      "58503": true,
      "58504": true,
      "58505": true,
      "58506": true,
      "58507": true,
      "58508": true,
      "58509": true,
      "58510": true,
      "58511": true,
      "58512": true,
      "58513": true,
      "58514": true,
      "58515": true,
      "58516": true,
      "58517": true,
      "58518": true,
      "58519": true,
      "58520": true,
      "58521": true,
      "58522": true,
      "58523": true,
      "58524": true,
      "58525": true,
      "58526": true,
      "58527": true,
      "58528": true,
      "58529": true,
      "58530": true,
      "58531": true,
      "58532": true,
      "58533": true,
      "58534": true,
      "58535": true,
      "58536": true,
      "58537": true,
      "58538": true,
      "58539": true
    },
    "ANGAMACUTIRO": {
      "58550": true,
      "58551": true,
      "58552": true,
      "58553": true,
      "58554": true,
      "58555": true,
      "58556": true,
      "58557": true,
      "58558": true,
      "58559": true,
      "58560": true,
      "58561": true,
      "58562": true,
      "58563": true,
      "58564": true,
      "58565": true,
      "58566": true,
      "58567": true,
      "58568": true,
      "58569": true
    },
    "PANINDICUARO": {
      "58570": true,
      "58571": true,
      "58572": true,
      "58573": true,
      "58574": true,
      "58575": true,
      "58576": true,
      "58577": true,
      "58578": true,
      "58579": true,
      "58580": true,
      "58581": true,
      "58582": true,
      "58583": true,
      "58584": true,
      "58585": true,
      "58586": true,
      "58587": true,
      "58588": true,
      "58589": true,
      "58590": true,
      "58591": true,
      "58592": true,
      "58593": true,
      "58594": true,
      "58595": true,
      "58596": true,
      "58597": true,
      "58598": true,
      "58599": true
    },
    "ZACAPU": {
      "58600": true,
      "58601": true,
      "58602": true,
      "58603": true,
      "58604": true,
      "58605": true,
      "58606": true,
      "58607": true,
      "58608": true,
      "58609": true,
      "58610": true,
      "58611": true,
      "58612": true,
      "58613": true,
      "58614": true,
      "58615": true,
      "58616": true,
      "58617": true,
      "58618": true,
      "58619": true,
      "58620": true,
      "58621": true,
      "58622": true,
      "58623": true,
      "58624": true,
      "58625": true,
      "58626": true,
      "58627": true,
      "58628": true,
      "58629": true,
      "58630": true,
      "58631": true,
      "58632": true,
      "58633": true,
      "58634": true,
      "58635": true,
      "58636": true,
      "58637": true,
      "58638": true,
      "58639": true,
      "58640": true,
      "58641": true,
      "58642": true,
      "58643": true,
      "58644": true,
      "58645": true,
      "58646": true,
      "58647": true,
      "58648": true,
      "58649": true,
      "58650": true,
      "58651": true,
      "58652": true,
      "58653": true,
      "58654": true,
      "58655": true,
      "58656": true,
      "58657": true,
      "58658": true,
      "58659": true,
      "58660": true,
      "58661": true,
      "58662": true,
      "58663": true,
      "58664": true,
      "58665": true,
      "58666": true,
      "58667": true,
      "58668": true,
      "58669": true,
      "58670": true,
      "58671": true,
      "58672": true,
      "58673": true,
      "58674": true,
      "58675": true,
      "58676": true,
      "58677": true,
      "58678": true,
      "58679": true,
      "58680": true,
      "58681": true,
      "58682": true,
      "58683": true,
      "58684": true,
      "58685": true,
      "58686": true,
      "58687": true,
      "58688": true,
      "58689": true,
      "58690": true,
      "58691": true,
      "58692": true,
      "58693": true,
      "58694": true,
      "58695": true,
      "58696": true,
      "58697": true,
      "58698": true,
      "58699": true,
      "58700": true,
      "58701": true,
      "58702": true,
      "58703": true,
      "58704": true,
      "58705": true,
      "58706": true,
      "58707": true,
      "58708": true,
      "58709": true,
      "58710": true,
      "58716": true,
      "58717": true,
      "58718": true,
      "58719": true,
      "58720": true,
      "58721": true,
      "58722": true,
      "58723": true,
      "58724": true,
      "58725": true,
      "58726": true,
      "58728": true,
      "58729": true,
      "58730": true,
      "58731": true,
      "58732": true,
      "58733": true,
      "58734": true,
      "58735": true,
      "58736": true,
      "58737": true,
      "58738": true,
      "58739": true
    },
    "TLAZAZALCA": {
      "58740": true,
      "58741": true,
      "58742": true,
      "58743": true,
      "58744": true,
      "58745": true,
      "58746": true,
      "58747": true,
      "58748": true,
      "58749": true,
      "58750": true,
      "58751": true,
      "58752": true,
      "58754": true,
      "58755": true,
      "58756": true,
      "58757": true,
      "58758": true,
      "58759": true
    },
    "PUREPERO": {
      "58760": true,
      "58761": true,
      "58762": true,
      "58763": true,
      "58764": true,
      "58765": true,
      "58766": true,
      "58767": true,
      "58768": true,
      "58769": true,
      "58770": true,
      "58771": true,
      "58772": true,
      "58773": true,
      "58774": true,
      "58775": true,
      "58776": true,
      "58777": true,
      "58778": true,
      "58779": true
    },
    "JIMENEZ": {
      "58780": true,
      "58781": true,
      "58782": true,
      "58783": true,
      "58784": true,
      "58785": true,
      "58786": true,
      "58787": true,
      "58790": true,
      "58791": true,
      "58792": true,
      "58794": true,
      "58795": true,
      "58796": true,
      "58797": true,
      "58798": true,
      "58799": true
    },
    "MORELOS": {
      "58800": true,
      "58801": true,
      "58802": true,
      "58803": true,
      "58804": true,
      "58805": true
    },
    "HUANDACAREO": {
      "58820": true,
      "58821": true,
      "58822": true,
      "58823": true,
      "58824": true,
      "58825": true,
      "58826": true,
      "58827": true,
      "58828": true,
      "58829": true,
      "58830": true,
      "58831": true,
      "58832": true,
      "58833": true,
      "58834": true,
      "58835": true,
      "58836": true,
      "58837": true,
      "58838": true,
      "58839": true
    },
    "CUITZEO": {
      "58840": true,
      "58841": true,
      "58842": true,
      "58843": true,
      "58844": true,
      "58845": true,
      "58846": true,
      "58847": true,
      "58848": true,
      "58849": true,
      "58850": true,
      "58851": true,
      "58852": true,
      "58853": true,
      "58854": true,
      "58855": true,
      "58856": true,
      "58857": true,
      "58858": true,
      "58859": true
    },
    "CHUCANDIRO": {
      "58860": true,
      "58861": true,
      "58862": true,
      "58863": true,
      "58864": true,
      "58866": true,
      "58867": true,
      "58868": true,
      "58869": true
    },
    "COPANDARO": {
      "58870": true,
      "58871": true,
      "58873": true,
      "58874": true,
      "58875": true,
      "58876": true,
      "58877": true,
      "58878": true,
      "58879": true
    },
    "TARIMBARO": {
      "58880": true,
      "58881": true,
      "58882": true,
      "58883": true,
      "58884": true,
      "58885": true,
      "58886": true,
      "58887": true,
      "58888": true,
      "58889": true,
      "58890": true,
      "58891": true,
      "58892": true,
      "58893": true,
      "58894": true,
      "58895": true,
      "58896": true,
      "58897": true,
      "58898": true,
      "58899": true
    },
    "SANTA ANA MAYA": {
      "58900": true,
      "58901": true,
      "58902": true,
      "58903": true,
      "58904": true,
      "58905": true,
      "58906": true,
      "58907": true,
      "58908": true,
      "58909": true,
      "58910": true,
      "58911": true,
      "58912": true,
      "58913": true,
      "58914": true,
      "58915": true,
      "58916": true,
      "58917": true,
      "58918": true,
      "58919": true
    },
    "ÁLVARO OBREGÓN": {
      "58920": true,
      "58921": true,
      "58922": true,
      "58923": true,
      "58924": true,
      "58925": true,
      "58926": true,
      "58927": true,
      "58928": true,
      "58929": true
    },
    "ZINAPECUARO": {
      "58930": true,
      "58931": true,
      "58932": true,
      "58933": true,
      "58934": true,
      "58935": true,
      "58936": true,
      "58937": true,
      "58938": true,
      "58939": true,
      "58940": true,
      "58941": true,
      "58942": true,
      "58943": true,
      "58944": true,
      "58945": true,
      "58946": true,
      "58947": true,
      "58948": true,
      "58949": true,
      "58950": true,
      "58951": true,
      "58952": true,
      "58953": true,
      "58954": true,
      "58955": true,
      "58956": true,
      "58957": true,
      "58958": true,
      "58959": true,
      "58962": true,
      "58963": true
    },
    "INDAPARAPEO": {
      "58970": true,
      "58971": true,
      "58972": true,
      "58973": true,
      "58974": true,
      "58975": true,
      "58976": true,
      "58977": true,
      "58978": true,
      "58979": true
    },
    "SAHUAYO": {
      "59000": true,
      "59001": true,
      "59002": true,
      "59003": true,
      "59004": true,
      "59005": true,
      "59006": true,
      "59007": true,
      "59008": true,
      "59009": true,
      "59010": true,
      "59011": true,
      "59012": true,
      "59013": true,
      "59014": true,
      "59015": true,
      "59016": true,
      "59017": true,
      "59018": true,
      "59019": true,
      "59020": true,
      "59021": true,
      "59022": true,
      "59023": true,
      "59024": true,
      "59025": true,
      "59026": true,
      "59027": true,
      "59028": true,
      "59029": true,
      "59030": true,
      "59031": true,
      "59032": true,
      "59033": true,
      "59034": true,
      "59035": true,
      "59036": true,
      "59037": true,
      "59038": true,
      "59039": true,
      "59040": true,
      "59041": true,
      "59042": true,
      "59043": true,
      "59044": true,
      "59045": true,
      "59046": true,
      "59047": true,
      "59048": true,
      "59049": true,
      "59050": true,
      "59051": true,
      "59052": true,
      "59053": true,
      "59054": true,
      "59055": true,
      "59056": true,
      "59057": true,
      "59058": true,
      "59059": true,
      "59060": true,
      "59061": true,
      "59062": true,
      "59063": true,
      "59064": true,
      "59065": true,
      "59066": true,
      "59067": true,
      "59068": true,
      "59069": true,
      "59070": true,
      "59071": true,
      "59072": true,
      "59073": true,
      "59074": true,
      "59075": true,
      "59076": true,
      "59077": true,
      "59078": true,
      "59079": true,
      "59080": true,
      "59081": true,
      "59082": true,
      "59083": true,
      "59084": true,
      "59085": true,
      "59086": true,
      "59087": true,
      "59088": true,
      "59089": true,
      "59090": true,
      "59091": true,
      "59092": true,
      "59093": true,
      "59094": true,
      "59095": true,
      "59096": true,
      "59097": true,
      "59098": true,
      "59099": true,
      "59100": true,
      "59101": true,
      "59102": true,
      "59103": true,
      "59104": true,
      "59105": true,
      "59106": true,
      "59107": true,
      "59108": true,
      "59109": true,
      "59110": true,
      "59111": true,
      "59112": true,
      "59113": true,
      "59114": true,
      "59115": true,
      "59116": true,
      "59117": true,
      "59118": true,
      "59119": true
    },
    "BRISENAS": {
      "59120": true,
      "59124": true,
      "59125": true
    },
    "COJUMATLAN DE REGULES": {
      "59140": true,
      "59141": true,
      "59142": true,
      "59143": true,
      "59144": true,
      "59145": true,
      "59146": true,
      "59147": true,
      "59148": true,
      "59149": true,
      "59150": true,
      "59151": true,
      "59152": true,
      "59153": true,
      "59154": true,
      "59155": true,
      "59156": true,
      "59157": true,
      "59158": true,
      "59159": true
    },
    "VENUSTIANO CARRANZA": {
      "59160": true,
      "59161": true,
      "59162": true,
      "59163": true,
      "59164": true,
      "59165": true,
      "59166": true,
      "59167": true,
      "59168": true,
      "59169": true
    },
    "PAJACUARAN": {
      "59180": true,
      "59181": true,
      "59182": true,
      "59184": true,
      "59185": true,
      "59186": true,
      "59187": true,
      "59188": true,
      "59189": true,
      "59190": true,
      "59191": true,
      "59192": true,
      "59193": true,
      "59194": true,
      "59195": true,
      "59196": true,
      "59197": true,
      "59198": true,
      "59199": true
    },
    "VISTA HERMOSA": {
      "59200": true,
      "59201": true,
      "59202": true,
      "59203": true,
      "59204": true,
      "59205": true,
      "59206": true,
      "59207": true,
      "59208": true,
      "59209": true,
      "59210": true,
      "59211": true,
      "59212": true,
      "59213": true,
      "59214": true,
      "59215": true,
      "59216": true,
      "59217": true,
      "59218": true,
      "59219": true,
      "59220": true,
      "59221": true,
      "59222": true,
      "59223": true,
      "59224": true,
      "59225": true,
      "59226": true,
      "59227": true,
      "59228": true,
      "59229": true
    },
    "TANHUATO": {
      "59230": true,
      "59231": true,
      "59232": true,
      "59235": true,
      "59236": true,
      "59237": true,
      "59238": true,
      "59239": true,
      "59240": true,
      "59241": true,
      "59242": true,
      "59243": true,
      "59244": true,
      "59245": true,
      "59246": true,
      "59247": true,
      "59248": true,
      "59249": true
    },
    "YURECUARO": {
      "59250": true,
      "59251": true,
      "59252": true,
      "59253": true,
      "59254": true,
      "59255": true,
      "59256": true,
      "59257": true,
      "59258": true,
      "59259": true,
      "59260": true,
      "59261": true,
      "59265": true,
      "59266": true
    },
    "IXTLAN": {
      "59280": true,
      "59281": true,
      "59282": true,
      "59283": true,
      "59284": true,
      "59285": true,
      "59286": true,
      "59287": true,
      "59288": true,
      "59289": true,
      "59290": true,
      "59291": true,
      "59292": true,
      "59293": true,
      "59294": true,
      "59295": true,
      "59296": true,
      "59297": true,
      "59298": true,
      "59299": true
    },
    "LA PIEDAD": {
      "59300": true,
      "59301": true,
      "59302": true,
      "59303": true,
      "59304": true,
      "59305": true,
      "59306": true,
      "59307": true,
      "59308": true,
      "59309": true,
      "59310": true,
      "59311": true,
      "59312": true,
      "59313": true,
      "59314": true,
      "59315": true,
      "59316": true,
      "59317": true,
      "59318": true,
      "59319": true,
      "59320": true,
      "59321": true,
      "59322": true,
      "59323": true,
      "59324": true,
      "59325": true,
      "59326": true,
      "59327": true,
      "59328": true,
      "59329": true,
      "59330": true,
      "59331": true,
      "59332": true,
      "59333": true,
      "59334": true,
      "59335": true,
      "59336": true,
      "59337": true,
      "59338": true,
      "59339": true,
      "59340": true,
      "59341": true,
      "59342": true,
      "59343": true,
      "59344": true,
      "59345": true,
      "59346": true,
      "59347": true,
      "59348": true,
      "59349": true,
      "59350": true,
      "59351": true,
      "59352": true,
      "59353": true,
      "59354": true,
      "59355": true,
      "59356": true,
      "59357": true,
      "59358": true,
      "59359": true,
      "59360": true,
      "59361": true,
      "59362": true,
      "59363": true,
      "59364": true,
      "59365": true,
      "59366": true,
      "59367": true,
      "59368": true,
      "59369": true,
      "59370": true,
      "59371": true,
      "59372": true,
      "59373": true,
      "59374": true,
      "59375": true,
      "59376": true,
      "59377": true,
      "59378": true,
      "59379": true,
      "59380": true,
      "59381": true,
      "59382": true,
      "59383": true,
      "59384": true,
      "59385": true,
      "59386": true,
      "59387": true,
      "59388": true,
      "59389": true,
      "59390": true,
      "59391": true,
      "59392": true,
      "59393": true,
      "59394": true,
      "59395": true,
      "59396": true,
      "59397": true,
      "59398": true,
      "59399": true,
      "59400": true,
      "59401": true,
      "59402": true,
      "59403": true,
      "59404": true,
      "59405": true,
      "59406": true,
      "59407": true,
      "59408": true,
      "59409": true,
      "59410": true,
      "59411": true,
      "59412": true,
      "59413": true,
      "59414": true,
      "59415": true,
      "59416": true,
      "59417": true,
      "59418": true,
      "59419": true,
      "59420": true,
      "59421": true,
      "59422": true,
      "59423": true,
      "59424": true,
      "59425": true,
      "59426": true,
      "59427": true,
      "59428": true,
      "59429": true
    },
    "NUMARAN": {
      "59430": true,
      "59431": true,
      "59432": true,
      "59433": true,
      "59434": true,
      "59435": true,
      "59436": true,
      "59437": true,
      "59438": true,
      "59439": true
    },
    "CHURINTZIO": {
      "59440": true,
      "59441": true,
      "59442": true,
      "59443": true,
      "59444": true,
      "59445": true,
      "59446": true,
      "59447": true,
      "59448": true,
      "59449": true,
      "59450": true,
      "59451": true,
      "59452": true,
      "59453": true,
      "59454": true,
      "59455": true,
      "59456": true,
      "59457": true,
      "59458": true,
      "59459": true
    },
    "ZINAPARO": {
      "59460": true,
      "59461": true,
      "59462": true,
      "59463": true,
      "59464": true,
      "59465": true,
      "59466": true,
      "59467": true,
      "59468": true,
      "59469": true
    },
    "PENJAMILLO": {
      "59470": true,
      "59471": true,
      "59472": true,
      "59473": true,
      "59474": true,
      "59475": true,
      "59476": true,
      "59477": true,
      "59482": true,
      "59483": true,
      "59484": true,
      "59485": true,
      "59486": true,
      "59487": true,
      "59488": true,
      "59489": true,
      "59490": true,
      "59491": true,
      "59492": true,
      "59493": true,
      "59494": true,
      "59495": true,
      "59496": true,
      "59497": true,
      "59498": true,
      "59499": true
    },
    "JIQUILPAN": {
      "59510": true,
      "59511": true,
      "59512": true,
      "59513": true,
      "59514": true,
      "59515": true,
      "59516": true,
      "59517": true,
      "59518": true,
      "59519": true,
      "59520": true,
      "59521": true,
      "59522": true,
      "59523": true,
      "59524": true,
      "59525": true,
      "59526": true,
      "59527": true,
      "59528": true,
      "59529": true,
      "59530": true,
      "59531": true,
      "59532": true,
      "59533": true,
      "59534": true,
      "59535": true,
      "59536": true,
      "59537": true,
      "59538": true,
      "59539": true,
      "59540": true,
      "59541": true,
      "59542": true,
      "59543": true,
      "59544": true,
      "59546": true,
      "59547": true,
      "59548": true,
      "59549": true
    },
    "VILLAMAR": {
      "59550": true,
      "59551": true,
      "59552": true,
      "59553": true,
      "59554": true,
      "59555": true,
      "59556": true,
      "59557": true,
      "59558": true,
      "59559": true,
      "59560": true,
      "59561": true,
      "59562": true,
      "59563": true,
      "59564": true,
      "59565": true,
      "59566": true,
      "59567": true,
      "59568": true,
      "59569": true,
      "59570": true,
      "59571": true,
      "59572": true,
      "59573": true,
      "59574": true,
      "59575": true,
      "59576": true,
      "59577": true,
      "59578": true,
      "59579": true
    },
    "CHAVINDA": {
      "59580": true,
      "59581": true,
      "59582": true,
      "59583": true,
      "59584": true,
      "59585": true,
      "59586": true,
      "59587": true,
      "59588": true,
      "59589": true,
      "59590": true,
      "59591": true,
      "59592": true,
      "59593": true,
      "59594": true,
      "59595": true,
      "59596": true,
      "59597": true,
      "59598": true,
      "59599": true
    },
    "ZAMORA": {
      "59600": true,
      "59601": true,
      "59602": true,
      "59603": true,
      "59604": true,
      "59605": true,
      "59606": true,
      "59607": true,
      "59608": true,
      "59609": true,
      "59610": true,
      "59611": true,
      "59612": true,
      "59613": true,
      "59614": true,
      "59615": true,
      "59616": true,
      "59617": true,
      "59618": true,
      "59619": true,
      "59620": true,
      "59621": true,
      "59622": true,
      "59623": true,
      "59624": true,
      "59625": true,
      "59626": true,
      "59627": true,
      "59628": true,
      "59629": true,
      "59630": true,
      "59631": true,
      "59632": true,
      "59633": true,
      "59634": true,
      "59635": true,
      "59636": true,
      "59637": true,
      "59638": true,
      "59639": true,
      "59640": true,
      "59641": true,
      "59642": true,
      "59643": true,
      "59644": true,
      "59645": true,
      "59646": true,
      "59647": true,
      "59648": true,
      "59649": true,
      "59650": true,
      "59651": true,
      "59652": true,
      "59653": true,
      "59654": true,
      "59655": true,
      "59656": true,
      "59657": true,
      "59658": true,
      "59659": true,
      "59660": true,
      "59661": true,
      "59662": true,
      "59663": true,
      "59664": true,
      "59665": true,
      "59666": true,
      "59667": true,
      "59668": true,
      "59669": true,
      "59670": true,
      "59671": true,
      "59672": true,
      "59673": true,
      "59674": true,
      "59675": true,
      "59676": true,
      "59677": true,
      "59678": true,
      "59679": true,
      "59680": true,
      "59681": true,
      "59682": true,
      "59683": true,
      "59684": true,
      "59685": true,
      "59686": true,
      "59687": true,
      "59688": true,
      "59689": true,
      "59690": true,
      "59691": true,
      "59692": true,
      "59693": true,
      "59694": true,
      "59695": true,
      "59696": true,
      "59697": true,
      "59698": true,
      "59699": true,
      "59700": true,
      "59701": true,
      "59702": true,
      "59703": true,
      "59704": true,
      "59705": true,
      "59706": true,
      "59707": true,
      "59708": true,
      "59709": true,
      "59710": true,
      "59711": true,
      "59712": true,
      "59713": true,
      "59714": true,
      "59715": true,
      "59716": true,
      "59717": true,
      "59718": true,
      "59719": true,
      "59720": true,
      "59721": true,
      "59722": true,
      "59723": true,
      "59724": true,
      "59725": true,
      "59726": true,
      "59727": true,
      "59728": true,
      "59729": true
    },
    "ECUANDUREO": {
      "59730": true,
      "59731": true,
      "59732": true,
      "59733": true,
      "59734": true,
      "59735": true,
      "59736": true,
      "59737": true,
      "59738": true,
      "59739": true,
      "59740": true,
      "59741": true,
      "59742": true,
      "59743": true,
      "59744": true,
      "59745": true,
      "59746": true,
      "59747": true,
      "59748": true,
      "59749": true
    },
    "TANGANCICUARO": {
      "59750": true,
      "59751": true,
      "59752": true,
      "59753": true,
      "59754": true,
      "59755": true,
      "59756": true,
      "59757": true,
      "59758": true,
      "59759": true,
      "59760": true,
      "59761": true,
      "59762": true,
      "59763": true,
      "59764": true,
      "59765": true,
      "59766": true,
      "59767": true,
      "59768": true,
      "59769": true,
      "59770": true,
      "59771": true,
      "59772": true,
      "59773": true,
      "59774": true,
      "59775": true
    },
    "CHILCHOTA": {
      "59780": true,
      "59781": true,
      "59782": true,
      "59783": true,
      "59784": true,
      "59785": true,
      "59786": true,
      "59787": true,
      "59788": true,
      "59789": true,
      "59790": true,
      "59791": true,
      "59792": true,
      "59793": true,
      "59794": true,
      "59795": true,
      "59796": true,
      "59797": true,
      "59798": true,
      "59799": true
    },
    "JACONA": {
      "59800": true,
      "59801": true,
      "59802": true,
      "59803": true,
      "59804": true,
      "59805": true,
      "59806": true,
      "59807": true,
      "59808": true,
      "59809": true,
      "59810": true,
      "59811": true,
      "59812": true,
      "59813": true,
      "59814": true,
      "59815": true,
      "59816": true,
      "59817": true,
      "59818": true,
      "59819": true,
      "59820": true,
      "59821": true,
      "59822": true,
      "59823": true,
      "59824": true,
      "59825": true,
      "59826": true,
      "59827": true,
      "59828": true,
      "59829": true,
      "59830": true,
      "59831": true,
      "59832": true,
      "59833": true,
      "59834": true,
      "59835": true,
      "59836": true,
      "59837": true,
      "59838": true,
      "59839": true,
      "59840": true,
      "59841": true,
      "59842": true,
      "59843": true,
      "59844": true,
      "59845": true,
      "59846": true,
      "59847": true,
      "59848": true,
      "59849": true,
      "59850": true,
      "59851": true,
      "59852": true,
      "59853": true,
      "59854": true,
      "59855": true,
      "59856": true,
      "59857": true,
      "59858": true,
      "59859": true,
      "59860": true,
      "59861": true,
      "59862": true,
      "59863": true,
      "59864": true,
      "59865": true,
      "59866": true,
      "59867": true,
      "59868": true,
      "59869": true,
      "59870": true,
      "59871": true,
      "59872": true,
      "59873": true,
      "59874": true,
      "59875": true,
      "59876": true,
      "59877": true,
      "59878": true,
      "59879": true,
      "59880": true,
      "59881": true,
      "59882": true,
      "59883": true,
      "59884": true,
      "59885": true,
      "59886": true,
      "59887": true,
      "59888": true,
      "59889": true,
      "59890": true,
      "59891": true,
      "59892": true,
      "59893": true,
      "59894": true,
      "59895": true,
      "59896": true,
      "59897": true,
      "59898": true,
      "59899": true,
      "59900": true,
      "59901": true,
      "59902": true,
      "59903": true,
      "59904": true,
      "59905": true,
      "59906": true,
      "59907": true,
      "59908": true,
      "59909": true,
      "59910": true,
      "59911": true,
      "59912": true,
      "59913": true,
      "59914": true,
      "59915": true,
      "59916": true,
      "59917": true,
      "59918": true,
      "59919": true
    },
    "COTIJA": {
      "59940": true,
      "59941": true,
      "59942": true,
      "59943": true,
      "59944": true,
      "59945": true,
      "59946": true,
      "59947": true,
      "59948": true,
      "59949": true,
      "59950": true,
      "59951": true,
      "59952": true,
      "59953": true,
      "59954": true
    },
    "TOCUMBO": {
      "59960": true,
      "59961": true,
      "59962": true,
      "59963": true,
      "59964": true,
      "59965": true,
      "59970": true,
      "59971": true,
      "59972": true,
      "59973": true
    },
    "TINGUINDIN": {
      "59980": true,
      "59981": true,
      "59982": true,
      "59983": true,
      "59984": true,
      "59985": true,
      "59986": true,
      "59987": true,
      "59988": true,
      "59989": true,
      "59990": true,
      "59991": true,
      "59992": true,
      "59993": true,
      "59994": true,
      "59995": true,
      "59996": true,
      "59997": true,
      "59998": true,
      "59999": true
    },
    "URUAPAN": {
      "60000": true,
      "60001": true,
      "60002": true,
      "60003": true,
      "60004": true,
      "60005": true,
      "60006": true,
      "60007": true,
      "60008": true,
      "60009": true,
      "60010": true,
      "60011": true,
      "60012": true,
      "60013": true,
      "60014": true,
      "60015": true,
      "60016": true,
      "60017": true,
      "60018": true,
      "60019": true,
      "60020": true,
      "60021": true,
      "60022": true,
      "60023": true,
      "60024": true,
      "60025": true,
      "60026": true,
      "60027": true,
      "60028": true,
      "60029": true,
      "60030": true,
      "60031": true,
      "60032": true,
      "60033": true,
      "60034": true,
      "60035": true,
      "60036": true,
      "60037": true,
      "60038": true,
      "60039": true,
      "60040": true,
      "60041": true,
      "60042": true,
      "60043": true,
      "60044": true,
      "60045": true,
      "60046": true,
      "60047": true,
      "60048": true,
      "60049": true,
      "60050": true,
      "60051": true,
      "60052": true,
      "60053": true,
      "60054": true,
      "60055": true,
      "60056": true,
      "60057": true,
      "60058": true,
      "60059": true,
      "60060": true,
      "60061": true,
      "60062": true,
      "60063": true,
      "60064": true,
      "60065": true,
      "60066": true,
      "60067": true,
      "60068": true,
      "60069": true,
      "60070": true,
      "60071": true,
      "60072": true,
      "60073": true,
      "60074": true,
      "60075": true,
      "60076": true,
      "60077": true,
      "60078": true,
      "60079": true,
      "60080": true,
      "60081": true,
      "60082": true,
      "60083": true,
      "60084": true,
      "60085": true,
      "60086": true,
      "60087": true,
      "60088": true,
      "60089": true,
      "60090": true,
      "60091": true,
      "60092": true,
      "60093": true,
      "60094": true,
      "60095": true,
      "60096": true,
      "60097": true,
      "60098": true,
      "60099": true,
      "60100": true,
      "60101": true,
      "60102": true,
      "60103": true,
      "60104": true,
      "60105": true,
      "60106": true,
      "60107": true,
      "60108": true,
      "60109": true,
      "60110": true,
      "60111": true,
      "60112": true,
      "60113": true,
      "60114": true,
      "60115": true,
      "60116": true,
      "60117": true,
      "60118": true,
      "60119": true,
      "60120": true,
      "60121": true,
      "60122": true,
      "60123": true,
      "60124": true,
      "60125": true,
      "60126": true,
      "60127": true,
      "60128": true,
      "60129": true,
      "60130": true,
      "60131": true,
      "60132": true,
      "60133": true,
      "60134": true,
      "60135": true,
      "60136": true,
      "60137": true,
      "60138": true,
      "60139": true,
      "60140": true,
      "60141": true,
      "60142": true,
      "60143": true,
      "60144": true,
      "60145": true,
      "60146": true,
      "60147": true,
      "60148": true,
      "60149": true,
      "60150": true,
      "60151": true,
      "60152": true,
      "60153": true,
      "60154": true,
      "60155": true,
      "60156": true,
      "60157": true,
      "60158": true,
      "60159": true,
      "60160": true,
      "60161": true,
      "60162": true,
      "60163": true,
      "60164": true,
      "60165": true,
      "60166": true,
      "60167": true,
      "60168": true,
      "60169": true,
      "60170": true,
      "60171": true,
      "60172": true,
      "60173": true,
      "60174": true,
      "60175": true,
      "60176": true,
      "60177": true,
      "60178": true,
      "60179": true,
      "60180": true,
      "60181": true,
      "60182": true,
      "60183": true,
      "60184": true,
      "60185": true,
      "60186": true,
      "60187": true,
      "60188": true,
      "60189": true,
      "60190": true,
      "60191": true,
      "60192": true,
      "60193": true,
      "60194": true,
      "60195": true,
      "60196": true,
      "60197": true,
      "60198": true,
      "60199": true,
      "60200": true,
      "60201": true,
      "60202": true,
      "60203": true,
      "60204": true,
      "60205": true,
      "60206": true,
      "60207": true,
      "60208": true,
      "60209": true,
      "60210": true,
      "60211": true,
      "60212": true,
      "60213": true,
      "60214": true,
      "60215": true,
      "60216": true,
      "60217": true,
      "60218": true,
      "60219": true,
      "60220": true,
      "60221": true,
      "60222": true,
      "60223": true,
      "60224": true,
      "60225": true,
      "60226": true,
      "60227": true,
      "60228": true,
      "60229": true,
      "60230": true,
      "60231": true,
      "60232": true,
      "60233": true,
      "60234": true,
      "60235": true,
      "60236": true,
      "60237": true,
      "60238": true,
      "60239": true
    },
    "PARACHO": {
      "60250": true,
      "60251": true,
      "60252": true,
      "60253": true,
      "60254": true,
      "60255": true,
      "60256": true,
      "60257": true,
      "60258": true,
      "60259": true,
      "60260": true,
      "60261": true,
      "60262": true,
      "60263": true,
      "60264": true,
      "60265": true,
      "60266": true,
      "60267": true,
      "60268": true,
      "60269": true
    },
    "CHERAN": {
      "60270": true,
      "60271": true,
      "60272": true,
      "60273": true,
      "60274": true,
      "60275": true,
      "60276": true,
      "60277": true,
      "60278": true,
      "60279": true
    },
    "NAHUATZEN": {
      "60280": true,
      "60281": true,
      "60282": true,
      "60285": true,
      "60286": true,
      "60287": true,
      "60288": true,
      "60289": true
    },
    "TINGAMBATO": {
      "60290": true,
      "60291": true,
      "60292": true,
      "60293": true,
      "60294": true,
      "60295": true,
      "60296": true
    },
    "LOS REYES": {
      "60300": true,
      "60301": true,
      "60302": true,
      "60303": true,
      "60304": true,
      "60305": true,
      "60306": true,
      "60307": true,
      "60308": true,
      "60309": true,
      "60310": true,
      "60311": true,
      "60312": true,
      "60313": true,
      "60314": true,
      "60315": true,
      "60316": true,
      "60317": true,
      "60318": true,
      "60319": true,
      "60320": true,
      "60321": true,
      "60322": true,
      "60323": true,
      "60324": true,
      "60325": true,
      "60326": true,
      "60327": true,
      "60328": true,
      "60329": true,
      "60330": true,
      "60331": true,
      "60332": true,
      "60333": true,
      "60334": true,
      "60335": true,
      "60336": true,
      "60337": true,
      "60338": true,
      "60339": true,
      "60340": true,
      "60341": true,
      "60342": true,
      "60343": true,
      "60344": true,
      "60345": true,
      "60346": true,
      "60347": true,
      "60348": true,
      "60349": true,
      "60350": true,
      "60351": true,
      "60352": true,
      "60353": true,
      "60354": true,
      "60355": true,
      "60356": true,
      "60357": true,
      "60358": true,
      "60359": true,
      "60360": true,
      "60361": true,
      "60362": true,
      "60363": true,
      "60364": true,
      "60365": true,
      "60366": true,
      "60367": true,
      "60368": true,
      "60369": true,
      "60370": true,
      "60371": true,
      "60372": true,
      "60373": true,
      "60374": true,
      "60375": true,
      "60376": true,
      "60377": true,
      "60378": true,
      "60379": true,
      "60380": true,
      "60381": true,
      "60382": true,
      "60383": true,
      "60384": true,
      "60385": true,
      "60386": true,
      "60387": true,
      "60388": true,
      "60389": true,
      "60390": true,
      "60391": true,
      "60392": true,
      "60393": true,
      "60394": true,
      "60395": true,
      "60396": true,
      "60397": true,
      "60398": true,
      "60399": true,
      "60400": true,
      "60401": true,
      "60402": true,
      "60403": true,
      "60404": true,
      "60405": true,
      "60406": true,
      "60407": true,
      "60408": true,
      "60409": true,
      "60413": true,
      "60414": true,
      "60415": true,
      "60416": true,
      "60417": true,
      "60418": true,
      "60419": true,
      "60420": true,
      "60421": true,
      "60422": true,
      "60423": true,
      "60424": true,
      "60425": true,
      "60426": true,
      "60427": true,
      "60428": true,
      "60429": true,
      "60430": true,
      "60431": true,
      "60432": true,
      "60433": true
    },
    "PERIBAN": {
      "60440": true,
      "60441": true,
      "60442": true,
      "60443": true,
      "60444": true,
      "60445": true,
      "60446": true,
      "60447": true,
      "60448": true,
      "60449": true,
      "60450": true,
      "60451": true,
      "60452": true,
      "60453": true,
      "60454": true,
      "60455": true,
      "60456": true,
      "60457": true,
      "60458": true,
      "60459": true
    },
    "TANCITARO": {
      "60460": true,
      "60461": true,
      "60462": true,
      "60463": true,
      "60464": true,
      "60465": true,
      "60466": true,
      "60467": true,
      "60468": true,
      "60469": true,
      "60473": true,
      "60474": true,
      "60476": true,
      "60477": true,
      "60478": true,
      "60479": true,
      "60480": true,
      "60481": true,
      "60482": true,
      "60483": true,
      "60484": true,
      "60485": true,
      "60486": true,
      "60487": true,
      "60488": true,
      "60489": true
    },
    "NUEVO PARANGARICUTIRO": {
      "60490": true,
      "60491": true,
      "60492": true,
      "60493": true,
      "60494": true,
      "60495": true
    },
    "BUENAVISTA": {
      "60500": true,
      "60501": true,
      "60502": true,
      "60503": true,
      "60504": true,
      "60505": true,
      "60506": true,
      "60507": true,
      "60508": true,
      "60509": true,
      "60510": true,
      "60511": true,
      "60512": true,
      "60513": true,
      "60514": true,
      "60515": true,
      "60516": true,
      "60517": true,
      "60518": true,
      "60519": true,
      "60520": true,
      "60521": true,
      "60522": true,
      "60525": true,
      "60526": true,
      "60527": true,
      "60528": true,
      "60529": true,
      "60530": true,
      "60531": true,
      "60532": true,
      "60533": true,
      "60534": true,
      "60535": true,
      "60536": true
    },
    "TEPALCATEPEC": {
      "60540": true,
      "60541": true,
      "60542": true,
      "60543": true,
      "60544": true,
      "60545": true,
      "60546": true,
      "60547": true,
      "60548": true,
      "60549": true,
      "60550": true,
      "60551": true,
      "60552": true,
      "60553": true,
      "60555": true,
      "60560": true,
      "60561": true,
      "60562": true,
      "60564": true,
      "60565": true,
      "60566": true,
      "60567": true,
      "60568": true,
      "60569": true
    },
    "APATZINGAN": {
      "60600": true,
      "60601": true,
      "60602": true,
      "60603": true,
      "60604": true,
      "60605": true,
      "60606": true,
      "60607": true,
      "60608": true,
      "60609": true,
      "60610": true,
      "60611": true,
      "60612": true,
      "60613": true,
      "60614": true,
      "60615": true,
      "60616": true,
      "60617": true,
      "60618": true,
      "60619": true,
      "60620": true,
      "60621": true,
      "60622": true,
      "60623": true,
      "60624": true,
      "60625": true,
      "60626": true,
      "60627": true,
      "60628": true,
      "60629": true,
      "60630": true,
      "60631": true,
      "60632": true,
      "60633": true,
      "60634": true,
      "60635": true,
      "60636": true,
      "60637": true,
      "60638": true,
      "60639": true,
      "60640": true,
      "60641": true,
      "60642": true,
      "60643": true,
      "60644": true,
      "60645": true,
      "60646": true,
      "60647": true,
      "60648": true,
      "60649": true,
      "60650": true,
      "60651": true,
      "60652": true,
      "60653": true,
      "60654": true,
      "60656": true,
      "60657": true,
      "60658": true,
      "60659": true,
      "60660": true,
      "60661": true,
      "60662": true,
      "60663": true,
      "60664": true,
      "60665": true,
      "60666": true,
      "60667": true,
      "60668": true,
      "60669": true,
      "60670": true,
      "60671": true,
      "60672": true,
      "60673": true,
      "60674": true,
      "60675": true,
      "60676": true,
      "60677": true,
      "60678": true,
      "60679": true,
      "60680": true,
      "60681": true,
      "60682": true,
      "60683": true,
      "60684": true,
      "60685": true,
      "60686": true,
      "60687": true,
      "60688": true,
      "60689": true,
      "60690": true,
      "60691": true,
      "60692": true,
      "60693": true,
      "60694": true,
      "60695": true,
      "60696": true,
      "60697": true,
      "60698": true,
      "60699": true,
      "60700": true,
      "60701": true,
      "60702": true,
      "60703": true,
      "60704": true,
      "60705": true,
      "60706": true,
      "60707": true,
      "60708": true,
      "60709": true,
      "60710": true,
      "60711": true,
      "60712": true,
      "60713": true,
      "60714": true,
      "60715": true,
      "60716": true,
      "60717": true,
      "60718": true,
      "60719": true,
      "60720": true,
      "60721": true,
      "60722": true,
      "60723": true,
      "60725": true,
      "60730": true,
      "60731": true,
      "60732": true,
      "60733": true,
      "60740": true,
      "60741": true,
      "60742": true,
      "60743": true,
      "60744": true,
      "60745": true,
      "60746": true,
      "60747": true,
      "60748": true,
      "60749": true,
      "60753": true,
      "60754": true,
      "60755": true
    },
    "COALCOMAN DE VAZQUEZ PALLARES": {
      "60840": true,
      "60841": true,
      "60842": true,
      "60843": true,
      "60845": true,
      "60856": true,
      "60857": true,
      "60858": true,
      "60859": true,
      "60860": true,
      "60861": true,
      "60862": true,
      "60866": true
    },
    "ARTEAGA": {
      "60920": true,
      "60921": true,
      "60922": true,
      "60923": true,
      "60926": true,
      "60929": true,
      "60932": true,
      "60934": true,
      "60940": true,
      "60941": true,
      "60942": true,
      "60943": true,
      "60944": true,
      "60945": true,
      "60946": true,
      "60947": true
    },
    "LAZARO CARDENAS": {
      "60950": true,
      "60951": true,
      "60952": true,
      "60953": true,
      "60954": true,
      "60955": true,
      "60956": true,
      "60957": true,
      "60958": true,
      "60959": true,
      "60967": true,
      "60970": true,
      "60971": true,
      "60972": true,
      "60980": true,
      "60981": true,
      "60982": true,
      "60983": true,
      "60984": true,
      "60985": true,
      "60986": true,
      "60987": true,
      "60990": true,
      "60991": true,
      "60992": true,
      "60993": true,
      "60994": true,
      "60995": true,
      "60996": true,
      "60997": true,
      "60998": true,
      "60999": true
    },
    "CONTEPEC": {
      "61020": true,
      "61021": true,
      "61022": true,
      "61023": true,
      "61024": true,
      "61025": true,
      "61026": true,
      "61027": true,
      "61028": true,
      "61029": true,
      "61030": true,
      "61031": true,
      "61032": true,
      "61033": true,
      "61034": true,
      "61035": true,
      "61036": true,
      "61037": true,
      "61038": true,
      "61039": true,
      "61040": true,
      "61041": true,
      "61042": true,
      "61043": true,
      "61044": true,
      "61045": true,
      "61046": true,
      "61047": true,
      "61048": true,
      "61049": true,
      "61050": true,
      "61051": true,
      "61052": true,
      "61053": true,
      "61054": true,
      "61055": true,
      "61056": true,
      "61057": true,
      "61058": true,
      "61059": true
    },
    "TLALPUJAHUA": {
      "61060": true,
      "61061": true,
      "61062": true,
      "61063": true,
      "61064": true,
      "61065": true,
      "61066": true,
      "61067": true,
      "61068": true,
      "61069": true,
      "61070": true,
      "61071": true,
      "61072": true,
      "61073": true,
      "61074": true,
      "61075": true,
      "61076": true,
      "61077": true,
      "61078": true,
      "61079": true,
      "61080": true,
      "61081": true,
      "61082": true,
      "61083": true,
      "61084": true,
      "61085": true,
      "61086": true,
      "61087": true,
      "61088": true,
      "61089": true,
      "61090": true,
      "61091": true,
      "61092": true,
      "61093": true,
      "61094": true,
      "61095": true,
      "61096": true,
      "61097": true,
      "61098": true,
      "61099": true
    },
    "HIDALGO": {
      "61100": true,
      "61101": true,
      "61102": true,
      "61103": true,
      "61104": true,
      "61105": true,
      "61106": true,
      "61107": true,
      "61108": true,
      "61109": true,
      "61110": true,
      "61111": true,
      "61112": true,
      "61113": true,
      "61114": true,
      "61115": true,
      "61116": true,
      "61117": true,
      "61118": true,
      "61119": true,
      "61120": true,
      "61121": true,
      "61122": true,
      "61123": true,
      "61124": true,
      "61125": true,
      "61126": true,
      "61127": true,
      "61128": true,
      "61129": true,
      "61130": true,
      "61131": true,
      "61132": true,
      "61133": true,
      "61134": true,
      "61135": true,
      "61136": true,
      "61137": true,
      "61138": true,
      "61139": true,
      "61140": true,
      "61141": true,
      "61142": true,
      "61143": true,
      "61144": true,
      "61145": true,
      "61146": true,
      "61147": true,
      "61148": true,
      "61149": true,
      "61150": true,
      "61151": true,
      "61152": true,
      "61153": true,
      "61154": true,
      "61155": true,
      "61156": true,
      "61157": true,
      "61158": true,
      "61159": true,
      "61160": true,
      "61161": true,
      "61162": true,
      "61163": true,
      "61164": true,
      "61165": true,
      "61166": true,
      "61167": true,
      "61168": true,
      "61169": true,
      "61170": true,
      "61171": true,
      "61172": true,
      "61173": true,
      "61174": true,
      "61175": true,
      "61176": true,
      "61177": true,
      "61178": true,
      "61179": true,
      "61180": true,
      "61181": true,
      "61182": true,
      "61183": true,
      "61184": true,
      "61185": true,
      "61186": true,
      "61187": true,
      "61188": true,
      "61189": true,
      "61190": true,
      "61191": true,
      "61192": true,
      "61193": true,
      "61194": true,
      "61196": true,
      "61197": true,
      "61198": true,
      "61199": true,
      "61200": true,
      "61201": true,
      "61202": true,
      "61203": true,
      "61205": true,
      "61206": true,
      "61207": true,
      "61208": true,
      "61209": true,
      "61210": true,
      "61211": true,
      "61212": true,
      "61213": true,
      "61214": true,
      "61215": true,
      "61216": true,
      "61217": true,
      "61218": true,
      "61219": true,
      "61223": true,
      "61224": true,
      "61225": true,
      "61226": true,
      "61228": true,
      "61229": true,
      "61230": true,
      "61231": true,
      "61232": true,
      "61233": true,
      "61234": true,
      "61235": true,
      "61236": true,
      "61237": true,
      "61238": true,
      "61239": true,
      "61240": true,
      "61241": true,
      "61243": true,
      "61244": true,
      "61245": true,
      "61247": true,
      "61248": true,
      "61249": true
    },
    "MARAVATIO": {
      "61250": true,
      "61251": true,
      "61252": true,
      "61253": true,
      "61254": true,
      "61255": true,
      "61256": true,
      "61257": true,
      "61258": true,
      "61259": true,
      "61260": true,
      "61261": true,
      "61262": true,
      "61263": true,
      "61264": true,
      "61265": true,
      "61266": true,
      "61267": true,
      "61268": true,
      "61269": true,
      "61274": true,
      "61276": true,
      "61277": true,
      "61278": true
    },
    "IRIMBO": {
      "61280": true,
      "61281": true,
      "61282": true,
      "61283": true,
      "61284": true,
      "61285": true,
      "61286": true,
      "61287": true,
      "61288": true,
      "61289": true
    },
    "SENGUIO": {
      "61290": true,
      "61291": true,
      "61292": true,
      "61293": true,
      "61295": true,
      "61296": true,
      "61297": true,
      "61298": true,
      "61299": true
    },
    "CHARO": {
      "61300": true,
      "61301": true,
      "61302": true,
      "61303": true,
      "61304": true,
      "61305": true,
      "61306": true,
      "61307": true,
      "61308": true,
      "61309": true,
      "61310": true,
      "61311": true,
      "61312": true,
      "61313": true,
      "61314": true,
      "61315": true,
      "61316": true,
      "61317": true,
      "61318": true,
      "61319": true,
      "61320": true,
      "61321": true,
      "61322": true,
      "61323": true,
      "61324": true,
      "61325": true,
      "61326": true,
      "61327": true
    },
    "TZITZIO": {
      "61336": true,
      "61340": true,
      "61341": true,
      "61342": true,
      "61343": true,
      "61345": true,
      "61346": true,
      "61347": true,
      "61348": true,
      "61349": true,
      "61350": true,
      "61351": true,
      "61352": true,
      "61358": true,
      "61359": true,
      "61360": true,
      "61361": true,
      "61362": true,
      "61363": true,
      "61364": true,
      "61365": true,
      "61367": true
    },
    "ANGANGUEO": {
      "61410": true,
      "61411": true,
      "61412": true,
      "61413": true,
      "61414": true,
      "61415": true,
      "61416": true,
      "61417": true,
      "61418": true,
      "61419": true
    },
    "JUNGAPEO": {
      "61470": true,
      "61471": true,
      "61472": true,
      "61473": true,
      "61474": true,
      "61475": true,
      "61476": true,
      "61477": true,
      "61478": true,
      "61479": true,
      "61480": true,
      "61481": true,
      "61482": true,
      "61483": true,
      "61484": true,
      "61485": true,
      "61486": true,
      "61487": true,
      "61488": true,
      "61489": true,
      "61493": true,
      "61494": true,
      "61495": true,
      "61496": true,
      "61497": true,
      "61498": true,
      "61499": true
    },
    "ZITACUARO": {
      "61500": true,
      "61501": true,
      "61502": true,
      "61503": true,
      "61504": true,
      "61505": true,
      "61506": true,
      "61507": true,
      "61508": true,
      "61509": true,
      "61510": true,
      "61511": true,
      "61512": true,
      "61513": true,
      "61514": true,
      "61515": true,
      "61516": true,
      "61517": true,
      "61518": true,
      "61519": true,
      "61520": true,
      "61521": true,
      "61522": true,
      "61523": true,
      "61524": true,
      "61525": true,
      "61526": true,
      "61527": true,
      "61528": true,
      "61529": true,
      "61530": true,
      "61531": true,
      "61532": true,
      "61533": true,
      "61534": true,
      "61535": true,
      "61536": true,
      "61537": true,
      "61538": true,
      "61539": true
    },
    "PATZCUARO": {
      "61600": true,
      "61601": true,
      "61602": true,
      "61603": true,
      "61604": true,
      "61605": true,
      "61606": true,
      "61607": true,
      "61608": true,
      "61609": true,
      "61610": true,
      "61611": true,
      "61612": true,
      "61613": true,
      "61614": true,
      "61615": true,
      "61616": true,
      "61617": true,
      "61618": true,
      "61619": true,
      "61620": true,
      "61621": true,
      "61622": true,
      "61623": true,
      "61624": true,
      "61625": true,
      "61626": true
    },
    "ERONGARICUARO": {
      "61630": true,
      "61631": true,
      "61632": true,
      "61633": true,
      "61634": true,
      "61635": true,
      "61636": true,
      "61637": true,
      "61638": true,
      "61639": true
    },
    "HUIRAMBA": {
      "61640": true,
      "61641": true,
      "61642": true,
      "61643": true,
      "61644": true,
      "61645": true,
      "61646": true,
      "61647": true,
      "61648": true,
      "61649": true
    },
    "TACAMBARO": {
      "61650": true,
      "61651": true,
      "61652": true,
      "61653": true,
      "61654": true,
      "61655": true,
      "61656": true,
      "61657": true,
      "61658": true,
      "61659": true,
      "61660": true,
      "61661": true,
      "61662": true,
      "61663": true,
      "61664": true,
      "61665": true,
      "61670": true,
      "61671": true,
      "61672": true,
      "61673": true,
      "61674": true,
      "61677": true,
      "61678": true,
      "61679": true
    },
    "ZIRACUARETIRO": {
      "61700": true,
      "61701": true,
      "61702": true,
      "61703": true,
      "61704": true,
      "61705": true,
      "61706": true,
      "61707": true,
      "61708": true,
      "61709": true
    },
    "TARETAN": {
      "61710": true,
      "61711": true,
      "61712": true,
      "61713": true,
      "61714": true,
      "61715": true,
      "61716": true,
      "61717": true,
      "61718": true,
      "61719": true,
      "61720": true,
      "61721": true,
      "61722": true,
      "61723": true,
      "61724": true,
      "61725": true,
      "61726": true,
      "61727": true,
      "61728": true,
      "61729": true
    },
    "GABRIEL ZAMORA": {
      "61730": true,
      "61731": true,
      "61732": true,
      "61733": true,
      "61734": true,
      "61735": true,
      "61736": true,
      "61737": true,
      "61738": true,
      "61739": true,
      "61740": true,
      "61741": true,
      "61742": true,
      "61743": true,
      "61744": true,
      "61745": true,
      "61746": true,
      "61747": true,
      "61748": true,
      "61749": true
    },
    "NUEVO URECHO": {
      "61750": true,
      "61751": true,
      "61752": true,
      "61753": true,
      "61754": true,
      "61755": true,
      "61756": true,
      "61757": true,
      "61758": true,
      "61759": true
    },
    "MUGICA": {
      "61760": true,
      "61761": true,
      "61762": true,
      "61763": true,
      "61770": true,
      "61771": true,
      "61772": true,
      "61790": true,
      "61791": true,
      "61792": true
    },
    "SALVADOR ESCALANTE": {
      "61800": true,
      "61801": true,
      "61802": true,
      "61803": true,
      "61804": true,
      "61805": true,
      "61806": true,
      "61807": true,
      "61808": true,
      "61809": true,
      "61810": true,
      "61811": true,
      "61812": true,
      "61815": true,
      "61816": true,
      "61820": true,
      "61821": true,
      "61822": true,
      "61823": true,
      "61824": true,
      "61825": true,
      "61826": true,
      "61827": true,
      "61828": true,
      "61829": true
    },
    "ARIO": {
      "61830": true,
      "61831": true,
      "61832": true,
      "61834": true,
      "61836": true,
      "61837": true,
      "61838": true,
      "61845": true,
      "61846": true,
      "61847": true,
      "61848": true,
      "61849": true
    },
    "LA HUACANA": {
      "61850": true,
      "61851": true,
      "61852": true,
      "61853": true,
      "61854": true,
      "61855": true,
      "61856": true,
      "61863": true,
      "61865": true,
      "61866": true,
      "61867": true,
      "61870": true,
      "61871": true,
      "61872": true,
      "61874": true,
      "61877": true,
      "61878": true,
      "61879": true
    },
    "HUETAMO": {
      "61940": true,
      "61941": true,
      "61942": true,
      "61943": true,
      "61944": true,
      "61945": true,
      "61946": true,
      "61947": true,
      "61948": true,
      "61949": true,
      "61950": true,
      "61951": true,
      "61956": true,
      "61957": true,
      "61958": true,
      "61959": true,
      "61960": true,
      "61961": true,
      "61962": true,
      "61969": true,
      "61970": true,
      "61971": true,
      "61972": true,
      "61973": true,
      "61974": true,
      "61975": true,
      "61976": true,
      "61977": true,
      "61978": true,
      "61979": true
    }
  },
  "MORELOS": {
    "CUERNAVACA": {
      "62000": true,
      "62001": true,
      "62002": true,
      "62003": true,
      "62004": true,
      "62005": true,
      "62006": true,
      "62007": true,
      "62008": true,
      "62009": true,
      "62010": true,
      "62011": true,
      "62012": true,
      "62013": true,
      "62014": true,
      "62015": true,
      "62016": true,
      "62017": true,
      "62018": true,
      "62019": true,
      "62020": true,
      "62021": true,
      "62022": true,
      "62023": true,
      "62024": true,
      "62025": true,
      "62026": true,
      "62027": true,
      "62028": true,
      "62029": true,
      "62030": true,
      "62031": true,
      "62032": true,
      "62033": true,
      "62034": true,
      "62035": true,
      "62036": true,
      "62037": true,
      "62038": true,
      "62039": true,
      "62040": true,
      "62041": true,
      "62042": true,
      "62043": true,
      "62044": true,
      "62045": true,
      "62046": true,
      "62047": true,
      "62048": true,
      "62049": true,
      "62050": true,
      "62051": true,
      "62052": true,
      "62053": true,
      "62054": true,
      "62055": true,
      "62056": true,
      "62057": true,
      "62058": true,
      "62059": true,
      "62060": true,
      "62061": true,
      "62062": true,
      "62063": true,
      "62064": true,
      "62065": true,
      "62066": true,
      "62067": true,
      "62068": true,
      "62069": true,
      "62070": true,
      "62071": true,
      "62072": true,
      "62073": true,
      "62074": true,
      "62075": true,
      "62076": true,
      "62077": true,
      "62078": true,
      "62079": true,
      "62080": true,
      "62081": true,
      "62082": true,
      "62083": true,
      "62084": true,
      "62085": true,
      "62086": true,
      "62087": true,
      "62088": true,
      "62089": true,
      "62090": true,
      "62091": true,
      "62092": true,
      "62093": true,
      "62094": true,
      "62095": true,
      "62096": true,
      "62097": true,
      "62098": true,
      "62099": true,
      "62100": true,
      "62101": true,
      "62102": true,
      "62103": true,
      "62104": true,
      "62105": true,
      "62106": true,
      "62107": true,
      "62108": true,
      "62109": true,
      "62110": true,
      "62111": true,
      "62112": true,
      "62113": true,
      "62114": true,
      "62115": true,
      "62116": true,
      "62117": true,
      "62118": true,
      "62119": true,
      "62120": true,
      "62121": true,
      "62122": true,
      "62123": true,
      "62124": true,
      "62125": true,
      "62126": true,
      "62127": true,
      "62128": true,
      "62129": true,
      "62130": true,
      "62131": true,
      "62132": true,
      "62133": true,
      "62134": true,
      "62135": true,
      "62136": true,
      "62137": true,
      "62138": true,
      "62139": true,
      "62140": true,
      "62141": true,
      "62142": true,
      "62143": true,
      "62144": true,
      "62145": true,
      "62146": true,
      "62147": true,
      "62148": true,
      "62149": true,
      "62150": true,
      "62151": true,
      "62152": true,
      "62153": true,
      "62154": true,
      "62155": true,
      "62156": true,
      "62157": true,
      "62158": true,
      "62159": true,
      "62160": true,
      "62161": true,
      "62162": true,
      "62163": true,
      "62164": true,
      "62165": true,
      "62166": true,
      "62167": true,
      "62168": true,
      "62169": true,
      "62170": true,
      "62171": true,
      "62172": true,
      "62173": true,
      "62174": true,
      "62175": true,
      "62176": true,
      "62177": true,
      "62178": true,
      "62179": true,
      "62180": true,
      "62181": true,
      "62182": true,
      "62183": true,
      "62184": true,
      "62185": true,
      "62186": true,
      "62187": true,
      "62188": true,
      "62189": true,
      "62190": true,
      "62191": true,
      "62192": true,
      "62193": true,
      "62194": true,
      "62195": true,
      "62196": true,
      "62197": true,
      "62198": true,
      "62199": true,
      "62200": true,
      "62201": true,
      "62202": true,
      "62203": true,
      "62204": true,
      "62205": true,
      "62206": true,
      "62207": true,
      "62208": true,
      "62209": true,
      "62210": true,
      "62211": true,
      "62212": true,
      "62213": true,
      "62214": true,
      "62215": true,
      "62216": true,
      "62217": true,
      "62218": true,
      "62219": true,
      "62220": true,
      "62221": true,
      "62222": true,
      "62223": true,
      "62224": true,
      "62225": true,
      "62226": true,
      "62227": true,
      "62228": true,
      "62229": true,
      "62230": true,
      "62231": true,
      "62232": true,
      "62233": true,
      "62234": true,
      "62235": true,
      "62236": true,
      "62237": true,
      "62238": true,
      "62239": true,
      "62240": true,
      "62241": true,
      "62242": true,
      "62243": true,
      "62244": true,
      "62245": true,
      "62246": true,
      "62247": true,
      "62248": true,
      "62249": true,
      "62250": true,
      "62251": true,
      "62252": true,
      "62253": true,
      "62254": true,
      "62255": true,
      "62256": true,
      "62257": true,
      "62258": true,
      "62259": true,
      "62260": true,
      "62261": true,
      "62262": true,
      "62263": true,
      "62264": true,
      "62265": true,
      "62266": true,
      "62267": true,
      "62268": true,
      "62269": true,
      "62270": true,
      "62271": true,
      "62272": true,
      "62273": true,
      "62274": true,
      "62275": true,
      "62276": true,
      "62277": true,
      "62278": true,
      "62279": true,
      "62280": true,
      "62281": true,
      "62282": true,
      "62283": true,
      "62284": true,
      "62285": true,
      "62286": true,
      "62287": true,
      "62288": true,
      "62289": true,
      "62290": true,
      "62291": true,
      "62292": true,
      "62293": true,
      "62294": true,
      "62295": true,
      "62296": true,
      "62297": true,
      "62298": true,
      "62299": true,
      "62300": true,
      "62301": true,
      "62302": true,
      "62303": true,
      "62304": true,
      "62305": true,
      "62306": true,
      "62307": true,
      "62308": true,
      "62309": true,
      "62310": true,
      "62311": true,
      "62312": true,
      "62313": true,
      "62314": true,
      "62315": true,
      "62316": true,
      "62317": true,
      "62318": true,
      "62319": true,
      "62320": true,
      "62321": true,
      "62322": true,
      "62323": true,
      "62324": true,
      "62325": true,
      "62326": true,
      "62327": true,
      "62328": true,
      "62329": true,
      "62330": true,
      "62331": true,
      "62332": true,
      "62333": true,
      "62334": true,
      "62335": true,
      "62336": true,
      "62337": true,
      "62338": true,
      "62339": true,
      "62340": true,
      "62341": true,
      "62342": true,
      "62343": true,
      "62344": true,
      "62345": true,
      "62346": true,
      "62347": true,
      "62348": true,
      "62349": true,
      "62350": true,
      "62351": true,
      "62352": true,
      "62353": true,
      "62354": true,
      "62355": true,
      "62356": true,
      "62357": true,
      "62358": true,
      "62359": true,
      "62360": true,
      "62361": true,
      "62362": true,
      "62363": true,
      "62364": true,
      "62365": true,
      "62366": true,
      "62367": true,
      "62368": true,
      "62369": true,
      "62370": true,
      "62371": true,
      "62372": true,
      "62373": true,
      "62374": true,
      "62375": true,
      "62376": true,
      "62377": true,
      "62378": true,
      "62379": true,
      "62380": true,
      "62381": true,
      "62382": true,
      "62383": true,
      "62384": true,
      "62385": true,
      "62386": true,
      "62387": true,
      "62388": true,
      "62389": true,
      "62390": true,
      "62391": true,
      "62392": true,
      "62393": true,
      "62394": true,
      "62395": true,
      "62396": true,
      "62397": true,
      "62398": true,
      "62399": true,
      "62400": true,
      "62401": true,
      "62402": true,
      "62403": true,
      "62404": true,
      "62405": true,
      "62406": true,
      "62407": true,
      "62408": true,
      "62409": true,
      "62410": true,
      "62411": true,
      "62412": true,
      "62413": true,
      "62414": true,
      "62415": true,
      "62416": true,
      "62417": true,
      "62418": true,
      "62419": true,
      "62420": true,
      "62421": true,
      "62422": true,
      "62423": true,
      "62424": true,
      "62425": true,
      "62426": true,
      "62427": true,
      "62428": true,
      "62429": true,
      "62430": true,
      "62431": true,
      "62432": true,
      "62433": true,
      "62434": true,
      "62435": true,
      "62436": true,
      "62437": true,
      "62438": true,
      "62439": true,
      "62440": true,
      "62441": true,
      "62442": true,
      "62443": true,
      "62444": true,
      "62445": true,
      "62446": true,
      "62447": true,
      "62448": true,
      "62449": true,
      "62450": true,
      "62451": true,
      "62452": true,
      "62453": true,
      "62454": true,
      "62455": true,
      "62456": true,
      "62457": true,
      "62458": true,
      "62459": true,
      "62460": true,
      "62461": true,
      "62462": true,
      "62463": true,
      "62464": true,
      "62465": true,
      "62466": true,
      "62467": true,
      "62468": true,
      "62469": true,
      "62470": true,
      "62471": true,
      "62472": true,
      "62473": true,
      "62474": true,
      "62475": true,
      "62476": true,
      "62477": true,
      "62478": true,
      "62479": true,
      "62480": true,
      "62481": true,
      "62482": true,
      "62483": true,
      "62484": true,
      "62485": true,
      "62486": true,
      "62487": true,
      "62488": true,
      "62489": true,
      "62490": true,
      "62491": true,
      "62492": true,
      "62493": true,
      "62494": true,
      "62495": true,
      "62496": true,
      "62497": true,
      "62498": true,
      "62499": true,
      "62500": true,
      "62501": true,
      "62502": true,
      "62503": true,
      "62504": true,
      "62505": true,
      "62506": true,
      "62507": true,
      "62508": true,
      "62509": true
    },
    "HUITZILAC": {
      "62510": true,
      "62511": true,
      "62512": true,
      "62513": true,
      "62514": true,
      "62515": true,
      "62516": true,
      "62517": true,
      "62518": true,
      "62519": true
    },
    "TEPOZTLAN": {
      "62520": true,
      "62521": true,
      "62522": true,
      "62523": true,
      "62524": true,
      "62525": true,
      "62526": true,
      "62527": true,
      "62528": true,
      "62529": true
    },
    "TLALNEPANTLA": {
      "62530": true,
      "62531": true,
      "62532": true,
      "62533": true,
      "62534": true,
      "62535": true,
      "62536": true,
      "62537": true,
      "62538": true,
      "62539": true
    },
    "TLAYACAPAN": {
      "62540": true,
      "62541": true,
      "62542": true,
      "62543": true,
      "62544": true,
      "62545": true,
      "62546": true,
      "62547": true,
      "62548": true,
      "62549": true
    },
    "JIUTEPEC": {
      "62550": true,
      "62551": true,
      "62552": true,
      "62553": true,
      "62554": true,
      "62555": true,
      "62556": true,
      "62557": true,
      "62558": true,
      "62559": true,
      "62560": true,
      "62561": true,
      "62562": true,
      "62563": true,
      "62564": true,
      "62565": true,
      "62566": true,
      "62567": true,
      "62568": true,
      "62569": true,
      "62570": true,
      "62571": true,
      "62572": true,
      "62573": true,
      "62574": true,
      "62575": true,
      "62576": true,
      "62577": true,
      "62578": true,
      "62579": true
    },
    "TEMIXCO": {
      "62580": true,
      "62581": true,
      "62582": true,
      "62583": true,
      "62584": true,
      "62585": true,
      "62586": true,
      "62587": true,
      "62588": true,
      "62589": true,
      "62590": true,
      "62591": true,
      "62592": true,
      "62593": true,
      "62594": true,
      "62595": true,
      "62596": true,
      "62597": true,
      "62598": true,
      "62599": true
    },
    "MIACATLAN": {
      "62600": true,
      "62601": true,
      "62602": true,
      "62603": true,
      "62604": true,
      "62605": true,
      "62607": true,
      "62608": true,
      "62609": true
    },
    "COATETELCO": {
      "62606": true
    },
    "COATLAN DEL RIO": {
      "62610": true,
      "62611": true,
      "62612": true,
      "62613": true,
      "62614": true,
      "62615": true,
      "62616": true,
      "62617": true,
      "62618": true,
      "62619": true
    },
    "TETECALA": {
      "62620": true,
      "62621": true,
      "62622": true,
      "62623": true,
      "62624": true,
      "62625": true,
      "62626": true,
      "62627": true,
      "62628": true,
      "62629": true
    },
    "MAZATEPEC": {
      "62630": true,
      "62631": true,
      "62632": true,
      "62633": true,
      "62634": true,
      "62635": true,
      "62636": true,
      "62637": true,
      "62638": true,
      "62639": true
    },
    "AMACUZAC": {
      "62640": true,
      "62641": true,
      "62642": true,
      "62643": true,
      "62644": true,
      "62645": true,
      "62646": true,
      "62647": true,
      "62648": true,
      "62649": true,
      "62650": true,
      "62651": true,
      "62652": true,
      "62653": true,
      "62654": true,
      "62655": true,
      "62656": true,
      "62657": true,
      "62658": true,
      "62659": true
    },
    "PUENTE DE IXTLA": {
      "62660": true,
      "62661": true,
      "62662": true,
      "62663": true,
      "62664": true,
      "62665": true,
      "62666": true,
      "62667": true,
      "62668": true,
      "62669": true,
      "62670": true,
      "62671": true,
      "62672": true,
      "62673": true,
      "62674": true,
      "62675": true,
      "62676": true,
      "62677": true,
      "62678": true,
      "62679": true,
      "62690": true,
      "62691": true,
      "62692": true,
      "62693": true,
      "62695": true,
      "62697": true,
      "62698": true,
      "62699": true
    },
    "XOXOCOTLA": {
      "62680": true,
      "62681": true,
      "62682": true,
      "62683": true,
      "62684": true,
      "62685": true,
      "62686": true,
      "62687": true,
      "62688": true,
      "62689": true
    },
    "AYALA": {
      "62700": true,
      "62701": true,
      "62702": true,
      "62703": true,
      "62704": true,
      "62705": true,
      "62706": true,
      "62707": true,
      "62708": true,
      "62709": true,
      "62710": true,
      "62711": true,
      "62712": true,
      "62713": true,
      "62714": true,
      "62715": true,
      "62716": true,
      "62717": true,
      "62718": true,
      "62719": true,
      "62720": true,
      "62721": true,
      "62722": true,
      "62723": true,
      "62724": true,
      "62725": true,
      "62726": true,
      "62727": true,
      "62728": true,
      "62729": true
    },
    "YAUTEPEC": {
      "62730": true,
      "62731": true,
      "62732": true,
      "62733": true,
      "62734": true,
      "62735": true,
      "62736": true,
      "62737": true,
      "62738": true,
      "62739": true
    },
    "CUAUTLA": {
      "62740": true,
      "62741": true,
      "62742": true,
      "62743": true,
      "62744": true,
      "62745": true,
      "62746": true,
      "62747": true,
      "62748": true,
      "62749": true,
      "62750": true,
      "62751": true,
      "62752": true,
      "62753": true,
      "62754": true,
      "62755": true,
      "62756": true,
      "62757": true,
      "62758": true,
      "62759": true
    },
    "EMILIANO ZAPATA": {
      "62760": true,
      "62761": true,
      "62762": true,
      "62763": true,
      "62764": true,
      "62765": true,
      "62766": true,
      "62767": true,
      "62768": true,
      "62769": true
    },
    "TLALTIZAPAN DE ZAPATA": {
      "62770": true,
      "62771": true,
      "62772": true,
      "62773": true,
      "62774": true,
      "62776": true,
      "62777": true,
      "62778": true,
      "62779": true
    },
    "ZACATEPEC": {
      "62780": true,
      "62781": true,
      "62782": true,
      "62783": true,
      "62784": true,
      "62785": true,
      "62786": true,
      "62787": true,
      "62788": true,
      "62789": true
    },
    "XOCHITEPEC": {
      "62790": true,
      "62791": true,
      "62792": true,
      "62793": true,
      "62794": true,
      "62795": true,
      "62796": true,
      "62797": true,
      "62798": true,
      "62799": true
    },
    "TETELA DEL VOLCAN": {
      "62800": true,
      "62801": true,
      "62802": true,
      "62803": true,
      "62804": true,
      "62805": true,
      "62806": true,
      "62807": true,
      "62808": true,
      "62809": true
    },
    "HUEYAPAN": {
      "62810": true,
      "62811": true,
      "62812": true,
      "62813": true,
      "62814": true,
      "62815": true,
      "62816": true,
      "62817": true,
      "62818": true,
      "62819": true
    },
    "YECAPIXTLA": {
      "62820": true,
      "62821": true,
      "62822": true,
      "62823": true,
      "62824": true,
      "62825": true,
      "62826": true,
      "62827": true,
      "62828": true,
      "62829": true
    },
    "TOTOLAPAN": {
      "62830": true,
      "62831": true,
      "62832": true,
      "62834": true,
      "62835": true,
      "62836": true,
      "62837": true,
      "62838": true,
      "62839": true
    },
    "ATLATLAHUCAN": {
      "62840": true,
      "62841": true,
      "62842": true,
      "62845": true,
      "62846": true,
      "62847": true,
      "62848": true,
      "62849": true
    },
    "OCUITUCO": {
      "62850": true,
      "62851": true,
      "62852": true,
      "62853": true,
      "62854": true,
      "62855": true,
      "62856": true,
      "62857": true,
      "62858": true,
      "62859": true,
      "62860": true,
      "62861": true,
      "62862": true,
      "62863": true,
      "62864": true,
      "62865": true,
      "62866": true,
      "62867": true,
      "62868": true,
      "62869": true
    },
    "TEMOAC": {
      "62870": true,
      "62871": true,
      "62872": true,
      "62873": true,
      "62874": true,
      "62875": true,
      "62876": true,
      "62877": true,
      "62878": true,
      "62879": true,
      "62880": true,
      "62881": true,
      "62882": true,
      "62883": true,
      "62884": true,
      "62885": true,
      "62886": true,
      "62887": true,
      "62888": true,
      "62889": true
    },
    "ZACUALPAN": {
      "62890": true,
      "62891": true,
      "62892": true,
      "62893": true,
      "62894": true,
      "62895": true,
      "62896": true,
      "62897": true,
      "62898": true,
      "62899": true
    },
    "JOJUTLA": {
      "62900": true,
      "62901": true,
      "62902": true,
      "62903": true,
      "62904": true,
      "62905": true,
      "62906": true,
      "62907": true,
      "62908": true,
      "62909": true,
      "62910": true,
      "62911": true,
      "62912": true,
      "62913": true,
      "62914": true,
      "62915": true,
      "62917": true,
      "62918": true,
      "62919": true
    },
    "TEPALCINGO": {
      "62920": true,
      "62921": true,
      "62922": true,
      "62923": true,
      "62924": true,
      "62925": true,
      "62926": true,
      "62927": true,
      "62928": true,
      "62929": true
    },
    "JONACATEPEC DE LEANDRO VALLE": {
      "62930": true,
      "62931": true,
      "62932": true,
      "62933": true,
      "62934": true,
      "62935": true,
      "62936": true,
      "62937": true,
      "62938": true,
      "62939": true,
      "62940": true,
      "62941": true,
      "62942": true,
      "62943": true,
      "62944": true,
      "62945": true,
      "62946": true,
      "62947": true,
      "62948": true,
      "62949": true
    },
    "AXOCHIAPAN": {
      "62950": true,
      "62951": true,
      "62952": true,
      "62953": true,
      "62954": true,
      "62955": true,
      "62956": true,
      "62957": true,
      "62958": true,
      "62959": true,
      "62960": true,
      "62961": true,
      "62962": true,
      "62963": true,
      "62964": true,
      "62965": true,
      "62966": true,
      "62967": true,
      "62968": true,
      "62969": true
    },
    "JANTETELCO": {
      "62970": true,
      "62971": true,
      "62972": true,
      "62973": true,
      "62974": true,
      "62975": true,
      "62976": true,
      "62977": true,
      "62978": true,
      "62979": true
    },
    "TLAQUILTENANGO": {
      "62980": true,
      "62981": true,
      "62982": true,
      "62983": true,
      "62984": true,
      "62985": true,
      "62986": true,
      "62987": true,
      "62988": true,
      "62989": true
    }
  },
  "NAYARIT": {
    "TEPIC": {
      "63000": true,
      "63001": true,
      "63002": true,
      "63003": true,
      "63004": true,
      "63005": true,
      "63006": true,
      "63007": true,
      "63008": true,
      "63009": true,
      "63010": true,
      "63011": true,
      "63012": true,
      "63013": true,
      "63014": true,
      "63015": true,
      "63016": true,
      "63017": true,
      "63018": true,
      "63019": true,
      "63020": true,
      "63021": true,
      "63022": true,
      "63023": true,
      "63024": true,
      "63025": true,
      "63026": true,
      "63027": true,
      "63028": true,
      "63029": true,
      "63030": true,
      "63031": true,
      "63032": true,
      "63033": true,
      "63034": true,
      "63035": true,
      "63036": true,
      "63037": true,
      "63038": true,
      "63039": true,
      "63040": true,
      "63041": true,
      "63042": true,
      "63043": true,
      "63044": true,
      "63045": true,
      "63046": true,
      "63047": true,
      "63048": true,
      "63049": true,
      "63050": true,
      "63051": true,
      "63052": true,
      "63053": true,
      "63054": true,
      "63055": true,
      "63056": true,
      "63057": true,
      "63058": true,
      "63059": true,
      "63060": true,
      "63061": true,
      "63062": true,
      "63063": true,
      "63064": true,
      "63065": true,
      "63066": true,
      "63067": true,
      "63068": true,
      "63069": true,
      "63070": true,
      "63071": true,
      "63072": true,
      "63073": true,
      "63074": true,
      "63075": true,
      "63076": true,
      "63077": true,
      "63078": true,
      "63079": true,
      "63080": true,
      "63081": true,
      "63082": true,
      "63083": true,
      "63084": true,
      "63085": true,
      "63086": true,
      "63087": true,
      "63088": true,
      "63089": true,
      "63090": true,
      "63091": true,
      "63092": true,
      "63093": true,
      "63094": true,
      "63095": true,
      "63096": true,
      "63097": true,
      "63098": true,
      "63099": true,
      "63100": true,
      "63101": true,
      "63102": true,
      "63103": true,
      "63104": true,
      "63105": true,
      "63106": true,
      "63107": true,
      "63108": true,
      "63109": true,
      "63110": true,
      "63111": true,
      "63112": true,
      "63113": true,
      "63114": true,
      "63115": true,
      "63116": true,
      "63117": true,
      "63118": true,
      "63119": true,
      "63120": true,
      "63121": true,
      "63122": true,
      "63123": true,
      "63124": true,
      "63125": true,
      "63126": true,
      "63127": true,
      "63128": true,
      "63129": true,
      "63130": true,
      "63131": true,
      "63132": true,
      "63133": true,
      "63134": true,
      "63135": true,
      "63136": true,
      "63137": true,
      "63138": true,
      "63139": true,
      "63140": true,
      "63141": true,
      "63142": true,
      "63143": true,
      "63144": true,
      "63145": true,
      "63146": true,
      "63147": true,
      "63148": true,
      "63149": true,
      "63150": true,
      "63151": true,
      "63152": true,
      "63153": true,
      "63154": true,
      "63155": true,
      "63156": true,
      "63157": true,
      "63158": true,
      "63159": true,
      "63160": true,
      "63161": true,
      "63162": true,
      "63163": true,
      "63164": true,
      "63165": true,
      "63166": true,
      "63167": true,
      "63168": true,
      "63169": true,
      "63170": true,
      "63171": true,
      "63172": true,
      "63173": true,
      "63174": true,
      "63175": true,
      "63176": true,
      "63177": true,
      "63178": true,
      "63179": true,
      "63180": true,
      "63181": true,
      "63182": true,
      "63183": true,
      "63184": true,
      "63185": true,
      "63186": true,
      "63187": true,
      "63188": true,
      "63189": true,
      "63190": true,
      "63191": true,
      "63192": true,
      "63193": true,
      "63194": true,
      "63195": true,
      "63196": true,
      "63197": true,
      "63198": true,
      "63199": true,
      "63500": true,
      "63501": true,
      "63502": true,
      "63503": true,
      "63504": true,
      "63505": true,
      "63506": true,
      "63507": true,
      "63508": true,
      "63509": true,
      "63510": true,
      "63511": true,
      "63512": true,
      "63513": true,
      "63514": true,
      "63515": true,
      "63516": true,
      "63517": true,
      "63518": true,
      "63519": true,
      "63520": true,
      "63521": true,
      "63522": true,
      "63523": true,
      "63524": true,
      "63525": true,
      "63526": true,
      "63527": true,
      "63528": true,
      "63529": true
    },
    "TUXPAN": {
      "63200": true,
      "63201": true,
      "63202": true,
      "63203": true,
      "63204": true,
      "63205": true,
      "63206": true,
      "63207": true,
      "63208": true,
      "63209": true,
      "63210": true,
      "63211": true,
      "63212": true,
      "63213": true,
      "63214": true,
      "63215": true,
      "63216": true,
      "63217": true,
      "63218": true,
      "63219": true,
      "63220": true,
      "63221": true,
      "63222": true,
      "63223": true,
      "63224": true,
      "63225": true,
      "63226": true,
      "63227": true,
      "63228": true,
      "63229": true,
      "63230": true,
      "63231": true,
      "63232": true,
      "63233": true,
      "63234": true,
      "63235": true,
      "63236": true,
      "63237": true,
      "63238": true,
      "63239": true,
      "63240": true,
      "63241": true,
      "63242": true,
      "63243": true,
      "63244": true,
      "63245": true,
      "63246": true,
      "63247": true,
      "63248": true,
      "63249": true,
      "63250": true,
      "63251": true,
      "63252": true,
      "63253": true,
      "63254": true,
      "63255": true,
      "63256": true,
      "63257": true,
      "63258": true,
      "63259": true,
      "63260": true,
      "63261": true,
      "63262": true,
      "63263": true,
      "63264": true,
      "63265": true,
      "63266": true,
      "63267": true,
      "63268": true,
      "63269": true,
      "63270": true,
      "63271": true,
      "63272": true,
      "63273": true,
      "63274": true,
      "63275": true,
      "63276": true,
      "63277": true,
      "63278": true,
      "63279": true,
      "63280": true,
      "63281": true,
      "63282": true,
      "63283": true,
      "63284": true,
      "63285": true,
      "63286": true,
      "63287": true,
      "63288": true,
      "63289": true,
      "63290": true,
      "63291": true,
      "63292": true,
      "63293": true,
      "63294": true,
      "63295": true,
      "63296": true,
      "63297": true,
      "63298": true,
      "63299": true,
      "63660": true,
      "63661": true,
      "63662": true,
      "63663": true,
      "63664": true,
      "63665": true,
      "63666": true,
      "63667": true,
      "63668": true,
      "63669": true
    },
    "SANTIAGO IXCUINTLA": {
      "63300": true,
      "63301": true,
      "63302": true,
      "63303": true,
      "63304": true,
      "63305": true,
      "63306": true,
      "63307": true,
      "63308": true,
      "63309": true,
      "63310": true,
      "63311": true,
      "63312": true,
      "63313": true,
      "63314": true,
      "63315": true,
      "63316": true,
      "63317": true,
      "63318": true,
      "63319": true,
      "63320": true,
      "63321": true,
      "63322": true,
      "63323": true,
      "63324": true,
      "63325": true,
      "63326": true,
      "63327": true,
      "63328": true,
      "63329": true,
      "63330": true,
      "63331": true,
      "63332": true,
      "63333": true,
      "63334": true,
      "63335": true,
      "63336": true,
      "63337": true,
      "63338": true,
      "63339": true,
      "63340": true,
      "63341": true,
      "63342": true,
      "63343": true,
      "63344": true,
      "63345": true,
      "63346": true,
      "63347": true,
      "63348": true,
      "63349": true,
      "63350": true,
      "63351": true,
      "63352": true,
      "63353": true,
      "63354": true,
      "63355": true,
      "63356": true,
      "63357": true,
      "63358": true,
      "63359": true,
      "63360": true,
      "63361": true,
      "63362": true,
      "63363": true,
      "63364": true,
      "63365": true,
      "63366": true,
      "63367": true,
      "63368": true,
      "63369": true,
      "63370": true,
      "63371": true,
      "63372": true,
      "63373": true,
      "63374": true,
      "63375": true,
      "63376": true,
      "63377": true,
      "63378": true,
      "63379": true,
      "63380": true,
      "63381": true,
      "63382": true,
      "63383": true,
      "63384": true,
      "63385": true,
      "63386": true,
      "63387": true,
      "63388": true,
      "63389": true,
      "63390": true,
      "63391": true,
      "63392": true,
      "63393": true,
      "63394": true,
      "63395": true,
      "63396": true,
      "63397": true,
      "63398": true,
      "63399": true,
      "63550": true,
      "63551": true,
      "63552": true,
      "63553": true,
      "63554": true,
      "63555": true,
      "63556": true,
      "63557": true,
      "63558": true,
      "63559": true,
      "63565": true,
      "63566": true,
      "63567": true,
      "63570": true,
      "63571": true,
      "63572": true,
      "63575": true,
      "63576": true,
      "63577": true,
      "63579": true
    },
    "ACAPONETA": {
      "63400": true,
      "63401": true,
      "63402": true,
      "63403": true,
      "63405": true,
      "63406": true,
      "63408": true,
      "63409": true,
      "63410": true,
      "63411": true,
      "63412": true,
      "63413": true,
      "63414": true,
      "63416": true,
      "63417": true,
      "63418": true,
      "63419": true,
      "63420": true,
      "63421": true,
      "63422": true,
      "63423": true,
      "63425": true,
      "63429": true,
      "63430": true,
      "63431": true,
      "63432": true,
      "63433": true,
      "63434": true,
      "63435": true,
      "63436": true,
      "63437": true,
      "63438": true,
      "63439": true
    },
    "RUIZ": {
      "63600": true,
      "63601": true,
      "63602": true,
      "63603": true,
      "63604": true,
      "63605": true,
      "63606": true,
      "63607": true,
      "63608": true,
      "63609": true,
      "63610": true,
      "63611": true,
      "63612": true,
      "63613": true,
      "63616": true,
      "63617": true,
      "63620": true,
      "63621": true,
      "63622": true,
      "63623": true,
      "63624": true,
      "63625": true,
      "63626": true,
      "63627": true,
      "63628": true,
      "63629": true
    },
    "COMPOSTELA": {
      "63700": true,
      "63701": true,
      "63702": true,
      "63703": true,
      "63704": true,
      "63705": true,
      "63708": true,
      "63709": true,
      "63710": true,
      "63711": true,
      "63712": true,
      "63713": true,
      "63714": true,
      "63715": true,
      "63716": true,
      "63717": true,
      "63718": true,
      "63719": true,
      "63720": true,
      "63721": true,
      "63722": true,
      "63723": true,
      "63724": true,
      "63725": true
    },
    "XALISCO": {
      "63780": true,
      "63781": true,
      "63782": true,
      "63783": true,
      "63784": true,
      "63785": true,
      "63786": true,
      "63787": true,
      "63788": true,
      "63789": true,
      "63790": true,
      "63791": true,
      "63792": true,
      "63793": true,
      "63794": true,
      "63795": true,
      "63796": true,
      "63797": true,
      "63798": true,
      "63799": true
    },
    "SAN PEDRO LAGUNILLAS": {
      "63800": true,
      "63801": true,
      "63802": true,
      "63803": true,
      "63804": true,
      "63805": true,
      "63806": true,
      "63807": true,
      "63808": true,
      "63810": true,
      "63811": true,
      "63812": true,
      "63813": true,
      "63814": true,
      "63815": true,
      "63816": true,
      "63817": true,
      "63818": true,
      "63819": true,
      "63820": true,
      "63821": true,
      "63822": true,
      "63823": true,
      "63824": true,
      "63825": true,
      "63826": true,
      "63827": true,
      "63828": true,
      "63829": true
    },
    "SANTA MARIA DEL ORO": {
      "63830": true,
      "63831": true,
      "63832": true,
      "63833": true,
      "63834": true,
      "63835": true,
      "63836": true,
      "63837": true,
      "63838": true,
      "63839": true,
      "63840": true,
      "63841": true,
      "63842": true,
      "63843": true,
      "63844": true,
      "63845": true,
      "63846": true,
      "63847": true,
      "63848": true,
      "63849": true,
      "63850": true,
      "63851": true,
      "63852": true,
      "63853": true,
      "63856": true,
      "63857": true,
      "63858": true,
      "63859": true,
      "63860": true,
      "63861": true,
      "63862": true,
      "63863": true,
      "63864": true,
      "63865": true,
      "63866": true,
      "63867": true,
      "63868": true,
      "63869": true,
      "63870": true,
      "63871": true,
      "63872": true,
      "63873": true,
      "63874": true,
      "63875": true,
      "63876": true,
      "63877": true,
      "63878": true,
      "63879": true
    },
    "JALA": {
      "63880": true,
      "63881": true,
      "63882": true,
      "63883": true,
      "63884": true,
      "63885": true,
      "63890": true,
      "63891": true,
      "63892": true,
      "63893": true,
      "63894": true,
      "63895": true,
      "63896": true,
      "63897": true,
      "63898": true,
      "63899": true
    },
    "AHUACATLAN": {
      "63900": true,
      "63901": true,
      "63902": true,
      "63903": true,
      "63904": true,
      "63905": true,
      "63906": true,
      "63907": true,
      "63908": true,
      "63909": true,
      "63910": true,
      "63911": true,
      "63912": true,
      "63913": true,
      "63914": true,
      "63915": true,
      "63916": true,
      "63917": true,
      "63918": true,
      "63919": true,
      "63920": true,
      "63921": true,
      "63922": true,
      "63923": true,
      "63924": true,
      "63925": true,
      "63926": true,
      "63927": true,
      "63928": true,
      "63929": true,
      "63938": true,
      "63939": true
    },
    "IXTLAN DEL RIO": {
      "63940": true,
      "63941": true,
      "63942": true,
      "63943": true,
      "63944": true,
      "63946": true,
      "63950": true,
      "63951": true,
      "63952": true,
      "63953": true,
      "63954": true,
      "63955": true,
      "63956": true,
      "63957": true,
      "63958": true,
      "63959": true
    },
    "AMATLAN DE CANAS": {
      "63960": true,
      "63961": true,
      "63962": true,
      "63963": true,
      "63964": true,
      "63965": true,
      "63966": true,
      "63967": true,
      "63970": true,
      "63971": true,
      "63972": true,
      "63973": true,
      "63974": true,
      "63975": true,
      "63976": true,
      "63977": true,
      "63978": true,
      "63979": true,
      "63980": true,
      "63981": true,
      "63982": true,
      "63983": true,
      "63984": true,
      "63985": true,
      "63986": true,
      "63987": true,
      "63988": true,
      "63989": true,
      "63990": true,
      "63991": true,
      "63992": true,
      "63993": true,
      "63994": true,
      "63995": true,
      "63996": true,
      "63997": true,
      "63998": true,
      "63999": true
    }
  },
  "NUEVO LEÓN": {
    "MONTERREY": {
      "64000": true,
      "64001": true,
      "64002": true,
      "64003": true,
      "64004": true,
      "64005": true,
      "64006": true,
      "64007": true,
      "64008": true,
      "64009": true,
      "64010": true,
      "64011": true,
      "64012": true,
      "64013": true,
      "64014": true,
      "64015": true,
      "64016": true,
      "64017": true,
      "64018": true,
      "64019": true,
      "64020": true,
      "64021": true,
      "64022": true,
      "64023": true,
      "64024": true,
      "64025": true,
      "64026": true,
      "64027": true,
      "64028": true,
      "64029": true,
      "64030": true,
      "64031": true,
      "64032": true,
      "64033": true,
      "64034": true,
      "64035": true,
      "64036": true,
      "64037": true,
      "64038": true,
      "64039": true,
      "64040": true,
      "64041": true,
      "64042": true,
      "64043": true,
      "64044": true,
      "64045": true,
      "64046": true,
      "64047": true,
      "64048": true,
      "64049": true,
      "64050": true,
      "64051": true,
      "64052": true,
      "64053": true,
      "64054": true,
      "64055": true,
      "64056": true,
      "64057": true,
      "64058": true,
      "64059": true,
      "64060": true,
      "64061": true,
      "64062": true,
      "64063": true,
      "64064": true,
      "64065": true,
      "64066": true,
      "64067": true,
      "64068": true,
      "64069": true,
      "64070": true,
      "64071": true,
      "64072": true,
      "64073": true,
      "64074": true,
      "64075": true,
      "64076": true,
      "64077": true,
      "64078": true,
      "64079": true,
      "64080": true,
      "64081": true,
      "64082": true,
      "64083": true,
      "64084": true,
      "64085": true,
      "64086": true,
      "64087": true,
      "64088": true,
      "64089": true,
      "64090": true,
      "64091": true,
      "64092": true,
      "64093": true,
      "64094": true,
      "64095": true,
      "64096": true,
      "64097": true,
      "64098": true,
      "64099": true,
      "64100": true,
      "64101": true,
      "64102": true,
      "64103": true,
      "64104": true,
      "64105": true,
      "64106": true,
      "64107": true,
      "64108": true,
      "64109": true,
      "64110": true,
      "64111": true,
      "64112": true,
      "64113": true,
      "64114": true,
      "64115": true,
      "64116": true,
      "64117": true,
      "64118": true,
      "64119": true,
      "64120": true,
      "64121": true,
      "64122": true,
      "64123": true,
      "64124": true,
      "64125": true,
      "64126": true,
      "64127": true,
      "64128": true,
      "64129": true,
      "64130": true,
      "64131": true,
      "64132": true,
      "64133": true,
      "64134": true,
      "64135": true,
      "64136": true,
      "64137": true,
      "64138": true,
      "64139": true,
      "64140": true,
      "64141": true,
      "64142": true,
      "64143": true,
      "64144": true,
      "64145": true,
      "64146": true,
      "64147": true,
      "64148": true,
      "64149": true,
      "64150": true,
      "64151": true,
      "64152": true,
      "64153": true,
      "64154": true,
      "64155": true,
      "64156": true,
      "64157": true,
      "64158": true,
      "64159": true,
      "64160": true,
      "64161": true,
      "64162": true,
      "64163": true,
      "64164": true,
      "64165": true,
      "64166": true,
      "64167": true,
      "64168": true,
      "64169": true,
      "64170": true,
      "64171": true,
      "64172": true,
      "64173": true,
      "64174": true,
      "64175": true,
      "64176": true,
      "64177": true,
      "64178": true,
      "64179": true,
      "64180": true,
      "64181": true,
      "64182": true,
      "64183": true,
      "64184": true,
      "64185": true,
      "64186": true,
      "64187": true,
      "64188": true,
      "64189": true,
      "64190": true,
      "64191": true,
      "64192": true,
      "64193": true,
      "64194": true,
      "64195": true,
      "64196": true,
      "64197": true,
      "64198": true,
      "64199": true,
      "64200": true,
      "64201": true,
      "64202": true,
      "64203": true,
      "64204": true,
      "64205": true,
      "64206": true,
      "64207": true,
      "64208": true,
      "64209": true,
      "64210": true,
      "64211": true,
      "64212": true,
      "64213": true,
      "64214": true,
      "64215": true,
      "64216": true,
      "64217": true,
      "64218": true,
      "64219": true,
      "64220": true,
      "64221": true,
      "64222": true,
      "64223": true,
      "64224": true,
      "64225": true,
      "64226": true,
      "64227": true,
      "64228": true,
      "64229": true,
      "64230": true,
      "64231": true,
      "64232": true,
      "64233": true,
      "64234": true,
      "64235": true,
      "64236": true,
      "64237": true,
      "64238": true,
      "64239": true,
      "64240": true,
      "64241": true,
      "64242": true,
      "64243": true,
      "64244": true,
      "64245": true,
      "64246": true,
      "64247": true,
      "64248": true,
      "64249": true,
      "64250": true,
      "64251": true,
      "64252": true,
      "64253": true,
      "64254": true,
      "64255": true,
      "64256": true,
      "64257": true,
      "64258": true,
      "64259": true,
      "64260": true,
      "64261": true,
      "64262": true,
      "64263": true,
      "64264": true,
      "64265": true,
      "64266": true,
      "64267": true,
      "64268": true,
      "64269": true,
      "64270": true,
      "64271": true,
      "64272": true,
      "64273": true,
      "64274": true,
      "64275": true,
      "64276": true,
      "64277": true,
      "64278": true,
      "64279": true,
      "64280": true,
      "64281": true,
      "64282": true,
      "64283": true,
      "64284": true,
      "64285": true,
      "64286": true,
      "64287": true,
      "64288": true,
      "64289": true,
      "64290": true,
      "64291": true,
      "64292": true,
      "64293": true,
      "64294": true,
      "64295": true,
      "64296": true,
      "64297": true,
      "64298": true,
      "64299": true,
      "64300": true,
      "64301": true,
      "64302": true,
      "64303": true,
      "64304": true,
      "64305": true,
      "64306": true,
      "64307": true,
      "64308": true,
      "64309": true,
      "64310": true,
      "64311": true,
      "64312": true,
      "64313": true,
      "64314": true,
      "64315": true,
      "64316": true,
      "64317": true,
      "64318": true,
      "64319": true,
      "64320": true,
      "64321": true,
      "64322": true,
      "64323": true,
      "64324": true,
      "64325": true,
      "64326": true,
      "64327": true,
      "64328": true,
      "64329": true,
      "64330": true,
      "64331": true,
      "64332": true,
      "64333": true,
      "64334": true,
      "64335": true,
      "64336": true,
      "64337": true,
      "64338": true,
      "64339": true,
      "64340": true,
      "64341": true,
      "64342": true,
      "64343": true,
      "64344": true,
      "64345": true,
      "64346": true,
      "64347": true,
      "64348": true,
      "64349": true,
      "64350": true,
      "64351": true,
      "64352": true,
      "64353": true,
      "64354": true,
      "64355": true,
      "64356": true,
      "64357": true,
      "64358": true,
      "64359": true,
      "64360": true,
      "64361": true,
      "64362": true,
      "64363": true,
      "64364": true,
      "64365": true,
      "64366": true,
      "64367": true,
      "64368": true,
      "64369": true,
      "64370": true,
      "64371": true,
      "64372": true,
      "64373": true,
      "64374": true,
      "64375": true,
      "64376": true,
      "64377": true,
      "64378": true,
      "64379": true,
      "64380": true,
      "64381": true,
      "64382": true,
      "64383": true,
      "64384": true,
      "64385": true,
      "64386": true,
      "64387": true,
      "64388": true,
      "64389": true,
      "64390": true,
      "64391": true,
      "64392": true,
      "64393": true,
      "64394": true,
      "64395": true,
      "64396": true,
      "64397": true,
      "64398": true,
      "64399": true,
      "64400": true,
      "64401": true,
      "64402": true,
      "64403": true,
      "64404": true,
      "64405": true,
      "64406": true,
      "64407": true,
      "64408": true,
      "64409": true,
      "64410": true,
      "64411": true,
      "64412": true,
      "64413": true,
      "64414": true,
      "64415": true,
      "64416": true,
      "64417": true,
      "64418": true,
      "64419": true,
      "64420": true,
      "64421": true,
      "64422": true,
      "64423": true,
      "64424": true,
      "64425": true,
      "64426": true,
      "64427": true,
      "64428": true,
      "64429": true,
      "64430": true,
      "64431": true,
      "64432": true,
      "64433": true,
      "64434": true,
      "64435": true,
      "64436": true,
      "64437": true,
      "64438": true,
      "64439": true,
      "64440": true,
      "64441": true,
      "64442": true,
      "64443": true,
      "64444": true,
      "64445": true,
      "64446": true,
      "64447": true,
      "64448": true,
      "64449": true,
      "64450": true,
      "64451": true,
      "64452": true,
      "64453": true,
      "64454": true,
      "64455": true,
      "64456": true,
      "64457": true,
      "64458": true,
      "64459": true,
      "64460": true,
      "64461": true,
      "64462": true,
      "64463": true,
      "64464": true,
      "64465": true,
      "64466": true,
      "64467": true,
      "64468": true,
      "64469": true,
      "64470": true,
      "64471": true,
      "64472": true,
      "64473": true,
      "64474": true,
      "64475": true,
      "64476": true,
      "64477": true,
      "64478": true,
      "64479": true,
      "64480": true,
      "64481": true,
      "64482": true,
      "64483": true,
      "64484": true,
      "64485": true,
      "64486": true,
      "64487": true,
      "64488": true,
      "64489": true,
      "64490": true,
      "64491": true,
      "64492": true,
      "64493": true,
      "64494": true,
      "64495": true,
      "64496": true,
      "64497": true,
      "64498": true,
      "64499": true,
      "64500": true,
      "64501": true,
      "64502": true,
      "64503": true,
      "64504": true,
      "64505": true,
      "64506": true,
      "64507": true,
      "64508": true,
      "64509": true,
      "64510": true,
      "64511": true,
      "64512": true,
      "64513": true,
      "64514": true,
      "64515": true,
      "64516": true,
      "64517": true,
      "64518": true,
      "64519": true,
      "64520": true,
      "64521": true,
      "64522": true,
      "64523": true,
      "64524": true,
      "64525": true,
      "64526": true,
      "64527": true,
      "64528": true,
      "64529": true,
      "64530": true,
      "64531": true,
      "64532": true,
      "64533": true,
      "64534": true,
      "64535": true,
      "64536": true,
      "64537": true,
      "64538": true,
      "64539": true,
      "64540": true,
      "64541": true,
      "64542": true,
      "64543": true,
      "64544": true,
      "64545": true,
      "64546": true,
      "64547": true,
      "64548": true,
      "64549": true,
      "64550": true,
      "64551": true,
      "64552": true,
      "64553": true,
      "64554": true,
      "64555": true,
      "64556": true,
      "64557": true,
      "64558": true,
      "64559": true,
      "64560": true,
      "64561": true,
      "64562": true,
      "64563": true,
      "64564": true,
      "64565": true,
      "64566": true,
      "64567": true,
      "64568": true,
      "64569": true,
      "64570": true,
      "64571": true,
      "64572": true,
      "64573": true,
      "64574": true,
      "64575": true,
      "64576": true,
      "64577": true,
      "64578": true,
      "64579": true,
      "64580": true,
      "64581": true,
      "64582": true,
      "64583": true,
      "64584": true,
      "64585": true,
      "64586": true,
      "64587": true,
      "64588": true,
      "64589": true,
      "64590": true,
      "64591": true,
      "64592": true,
      "64593": true,
      "64594": true,
      "64595": true,
      "64596": true,
      "64597": true,
      "64598": true,
      "64599": true,
      "64600": true,
      "64601": true,
      "64602": true,
      "64603": true,
      "64604": true,
      "64605": true,
      "64606": true,
      "64607": true,
      "64608": true,
      "64609": true,
      "64610": true,
      "64611": true,
      "64612": true,
      "64613": true,
      "64614": true,
      "64615": true,
      "64616": true,
      "64617": true,
      "64618": true,
      "64619": true,
      "64620": true,
      "64621": true,
      "64622": true,
      "64623": true,
      "64624": true,
      "64625": true,
      "64626": true,
      "64627": true,
      "64628": true,
      "64629": true,
      "64630": true,
      "64631": true,
      "64632": true,
      "64633": true,
      "64634": true,
      "64635": true,
      "64636": true,
      "64637": true,
      "64638": true,
      "64639": true,
      "64640": true,
      "64641": true,
      "64642": true,
      "64643": true,
      "64644": true,
      "64645": true,
      "64646": true,
      "64647": true,
      "64648": true,
      "64649": true,
      "64650": true,
      "64651": true,
      "64652": true,
      "64653": true,
      "64654": true,
      "64655": true,
      "64656": true,
      "64657": true,
      "64658": true,
      "64659": true,
      "64660": true,
      "64661": true,
      "64662": true,
      "64663": true,
      "64664": true,
      "64665": true,
      "64666": true,
      "64667": true,
      "64668": true,
      "64669": true,
      "64670": true,
      "64671": true,
      "64672": true,
      "64673": true,
      "64674": true,
      "64675": true,
      "64676": true,
      "64677": true,
      "64678": true,
      "64679": true,
      "64680": true,
      "64681": true,
      "64682": true,
      "64683": true,
      "64684": true,
      "64685": true,
      "64686": true,
      "64687": true,
      "64688": true,
      "64689": true,
      "64690": true,
      "64691": true,
      "64692": true,
      "64693": true,
      "64694": true,
      "64695": true,
      "64696": true,
      "64697": true,
      "64698": true,
      "64699": true,
      "64700": true,
      "64701": true,
      "64702": true,
      "64703": true,
      "64704": true,
      "64705": true,
      "64706": true,
      "64707": true,
      "64708": true,
      "64709": true,
      "64710": true,
      "64711": true,
      "64712": true,
      "64713": true,
      "64714": true,
      "64715": true,
      "64716": true,
      "64717": true,
      "64718": true,
      "64719": true,
      "64720": true,
      "64721": true,
      "64722": true,
      "64723": true,
      "64724": true,
      "64725": true,
      "64726": true,
      "64727": true,
      "64728": true,
      "64729": true,
      "64730": true,
      "64731": true,
      "64732": true,
      "64733": true,
      "64734": true,
      "64735": true,
      "64736": true,
      "64737": true,
      "64738": true,
      "64739": true,
      "64740": true,
      "64741": true,
      "64742": true,
      "64743": true,
      "64744": true,
      "64745": true,
      "64746": true,
      "64747": true,
      "64748": true,
      "64749": true,
      "64750": true,
      "64751": true,
      "64752": true,
      "64753": true,
      "64754": true,
      "64755": true,
      "64756": true,
      "64757": true,
      "64758": true,
      "64759": true,
      "64760": true,
      "64761": true,
      "64762": true,
      "64763": true,
      "64764": true,
      "64765": true,
      "64766": true,
      "64767": true,
      "64768": true,
      "64769": true,
      "64770": true,
      "64771": true,
      "64772": true,
      "64773": true,
      "64774": true,
      "64775": true,
      "64776": true,
      "64777": true,
      "64778": true,
      "64779": true,
      "64780": true,
      "64781": true,
      "64782": true,
      "64783": true,
      "64784": true,
      "64785": true,
      "64786": true,
      "64787": true,
      "64788": true,
      "64789": true,
      "64790": true,
      "64791": true,
      "64792": true,
      "64793": true,
      "64794": true,
      "64795": true,
      "64796": true,
      "64797": true,
      "64798": true,
      "64799": true,
      "64800": true,
      "64801": true,
      "64802": true,
      "64803": true,
      "64804": true,
      "64805": true,
      "64806": true,
      "64807": true,
      "64808": true,
      "64809": true,
      "64810": true,
      "64811": true,
      "64812": true,
      "64813": true,
      "64814": true,
      "64815": true,
      "64816": true,
      "64817": true,
      "64818": true,
      "64819": true,
      "64820": true,
      "64821": true,
      "64822": true,
      "64823": true,
      "64824": true,
      "64825": true,
      "64826": true,
      "64827": true,
      "64828": true,
      "64829": true,
      "64830": true,
      "64831": true,
      "64832": true,
      "64833": true,
      "64834": true,
      "64835": true,
      "64836": true,
      "64837": true,
      "64838": true,
      "64839": true,
      "64840": true,
      "64841": true,
      "64842": true,
      "64843": true,
      "64844": true,
      "64845": true,
      "64846": true,
      "64847": true,
      "64848": true,
      "64849": true,
      "64850": true,
      "64851": true,
      "64852": true,
      "64853": true,
      "64854": true,
      "64855": true,
      "64856": true,
      "64857": true,
      "64858": true,
      "64859": true,
      "64860": true,
      "64861": true,
      "64862": true,
      "64863": true,
      "64864": true,
      "64865": true,
      "64866": true,
      "64867": true,
      "64868": true,
      "64869": true,
      "64870": true,
      "64871": true,
      "64872": true,
      "64873": true,
      "64874": true,
      "64875": true,
      "64876": true,
      "64877": true,
      "64878": true,
      "64879": true,
      "64880": true,
      "64881": true,
      "64882": true,
      "64883": true,
      "64884": true,
      "64885": true,
      "64886": true,
      "64887": true,
      "64888": true,
      "64889": true,
      "64890": true,
      "64891": true,
      "64892": true,
      "64893": true,
      "64894": true,
      "64895": true,
      "64896": true,
      "64897": true,
      "64898": true,
      "64899": true,
      "64900": true,
      "64901": true,
      "64902": true,
      "64903": true,
      "64904": true,
      "64905": true,
      "64906": true,
      "64907": true,
      "64908": true,
      "64909": true,
      "64910": true,
      "64911": true,
      "64912": true,
      "64913": true,
      "64914": true,
      "64915": true,
      "64916": true,
      "64917": true,
      "64918": true,
      "64919": true,
      "64920": true,
      "64921": true,
      "64922": true,
      "64923": true,
      "64924": true,
      "64925": true,
      "64926": true,
      "64927": true,
      "64928": true,
      "64929": true,
      "64930": true,
      "64931": true,
      "64932": true,
      "64933": true,
      "64934": true,
      "64935": true,
      "64936": true,
      "64937": true,
      "64938": true,
      "64939": true,
      "64940": true,
      "64941": true,
      "64942": true,
      "64943": true,
      "64944": true,
      "64945": true,
      "64946": true,
      "64947": true,
      "64948": true,
      "64949": true,
      "64950": true,
      "64951": true,
      "64952": true,
      "64953": true,
      "64954": true,
      "64955": true,
      "64956": true,
      "64957": true,
      "64958": true,
      "64959": true,
      "64960": true,
      "64961": true,
      "64962": true,
      "64963": true,
      "64964": true,
      "64965": true,
      "64966": true,
      "64967": true,
      "64968": true,
      "64969": true,
      "64970": true,
      "64971": true,
      "64972": true,
      "64973": true,
      "64974": true,
      "64975": true,
      "64976": true,
      "64977": true,
      "64978": true,
      "64979": true,
      "64980": true,
      "64981": true,
      "64982": true,
      "64983": true,
      "64984": true,
      "64985": true,
      "64986": true,
      "64987": true,
      "64988": true,
      "64989": true,
      "64990": true,
      "64991": true,
      "64992": true,
      "64993": true,
      "64994": true,
      "64995": true,
      "64996": true,
      "64997": true,
      "64998": true,
      "64999": true
    },
    "MINA": {
      "65100": true,
      "65101": true,
      "65102": true,
      "65103": true,
      "65104": true,
      "65105": true,
      "65106": true,
      "65107": true,
      "65108": true,
      "65109": true,
      "65116": true,
      "65117": true
    },
    "SABINAS HIDALGO": {
      "65200": true,
      "65201": true,
      "65202": true,
      "65203": true,
      "65204": true,
      "65205": true,
      "65206": true,
      "65207": true,
      "65208": true,
      "65209": true,
      "65210": true,
      "65211": true,
      "65212": true,
      "65213": true,
      "65214": true,
      "65215": true,
      "65216": true,
      "65217": true,
      "65218": true,
      "65219": true,
      "65220": true,
      "65221": true,
      "65222": true,
      "65223": true,
      "65224": true,
      "65225": true,
      "65226": true,
      "65227": true,
      "65228": true,
      "65229": true,
      "65230": true,
      "65231": true,
      "65232": true,
      "65233": true,
      "65234": true,
      "65235": true,
      "65236": true,
      "65237": true,
      "65238": true,
      "65239": true,
      "65240": true,
      "65241": true,
      "65242": true,
      "65243": true,
      "65244": true,
      "65245": true,
      "65246": true,
      "65247": true,
      "65248": true,
      "65249": true,
      "65250": true,
      "65251": true,
      "65252": true,
      "65253": true,
      "65254": true,
      "65255": true,
      "65256": true,
      "65257": true,
      "65258": true,
      "65259": true,
      "65260": true,
      "65261": true,
      "65262": true,
      "65263": true,
      "65264": true,
      "65265": true,
      "65266": true,
      "65267": true,
      "65268": true,
      "65269": true,
      "65270": true,
      "65271": true,
      "65272": true,
      "65273": true,
      "65274": true,
      "65275": true,
      "65276": true,
      "65277": true,
      "65278": true,
      "65279": true,
      "65280": true,
      "65281": true,
      "65282": true,
      "65283": true,
      "65284": true,
      "65285": true,
      "65286": true,
      "65287": true,
      "65288": true,
      "65289": true,
      "65290": true,
      "65291": true,
      "65292": true,
      "65293": true,
      "65294": true,
      "65295": true,
      "65296": true,
      "65297": true,
      "65298": true,
      "65299": true,
      "65300": true,
      "65301": true,
      "65302": true,
      "65303": true,
      "65304": true,
      "65305": true,
      "65306": true,
      "65307": true,
      "65308": true,
      "65309": true,
      "65310": true,
      "65311": true,
      "65312": true,
      "65313": true,
      "65314": true,
      "65315": true,
      "65316": true,
      "65317": true,
      "65318": true,
      "65319": true,
      "65320": true,
      "65321": true,
      "65322": true,
      "65323": true,
      "65324": true,
      "65325": true,
      "65326": true,
      "65327": true,
      "65328": true,
      "65329": true,
      "65330": true,
      "65331": true,
      "65332": true,
      "65333": true,
      "65334": true,
      "65335": true,
      "65336": true,
      "65337": true,
      "65338": true,
      "65339": true,
      "65340": true,
      "65341": true,
      "65342": true,
      "65343": true,
      "65344": true,
      "65345": true,
      "65346": true,
      "65347": true,
      "65348": true,
      "65349": true
    },
    "VILLALDAMA": {
      "65350": true,
      "65351": true,
      "65352": true,
      "65353": true,
      "65354": true,
      "65355": true,
      "65356": true,
      "65357": true,
      "65358": true,
      "65359": true,
      "65360": true,
      "65361": true,
      "65362": true,
      "65363": true,
      "65364": true,
      "65365": true,
      "65366": true,
      "65367": true,
      "65368": true,
      "65369": true,
      "65370": true,
      "65371": true,
      "65372": true,
      "65373": true,
      "65374": true,
      "65375": true,
      "65376": true,
      "65377": true,
      "65378": true,
      "65379": true,
      "65380": true,
      "65381": true,
      "65382": true,
      "65383": true,
      "65384": true,
      "65385": true,
      "65386": true,
      "65387": true,
      "65388": true,
      "65389": true,
      "65390": true,
      "65391": true,
      "65392": true,
      "65393": true,
      "65394": true,
      "65395": true,
      "65396": true,
      "65397": true,
      "65398": true,
      "65399": true
    },
    "SALINAS VICTORIA": {
      "65500": true,
      "65501": true,
      "65502": true,
      "65503": true,
      "65504": true,
      "65505": true,
      "65506": true,
      "65507": true,
      "65508": true,
      "65509": true,
      "65510": true,
      "65511": true,
      "65512": true,
      "65513": true,
      "65514": true,
      "65515": true,
      "65516": true,
      "65517": true,
      "65518": true,
      "65519": true,
      "65526": true,
      "65527": true,
      "65537": true,
      "65538": true,
      "65539": true,
      "65540": true,
      "65541": true,
      "65542": true,
      "65546": true,
      "65548": true,
      "65549": true
    },
    "CIENEGA DE FLORES": {
      "65550": true,
      "65551": true,
      "65552": true,
      "65553": true,
      "65554": true,
      "65555": true,
      "65556": true,
      "65557": true,
      "65558": true,
      "65559": true,
      "65560": true,
      "65561": true,
      "65562": true,
      "65563": true,
      "65564": true,
      "65565": true,
      "65566": true,
      "65567": true,
      "65568": true,
      "65569": true,
      "65570": true,
      "65571": true,
      "65572": true,
      "65573": true,
      "65574": true,
      "65575": true,
      "65576": true,
      "65577": true,
      "65578": true,
      "65579": true,
      "65580": true,
      "65581": true,
      "65582": true,
      "65583": true,
      "65584": true,
      "65585": true,
      "65586": true,
      "65587": true,
      "65588": true,
      "65589": true,
      "65590": true,
      "65591": true,
      "65592": true,
      "65593": true,
      "65594": true,
      "65595": true,
      "65596": true,
      "65597": true,
      "65598": true,
      "65599": true
    },
    "HIDALGO": {
      "65600": true,
      "65601": true,
      "65602": true,
      "65603": true,
      "65604": true,
      "65605": true,
      "65606": true,
      "65607": true,
      "65608": true,
      "65609": true,
      "65610": true,
      "65611": true,
      "65612": true,
      "65613": true,
      "65614": true,
      "65615": true,
      "65616": true,
      "65617": true,
      "65618": true,
      "65619": true,
      "65620": true,
      "65621": true,
      "65622": true,
      "65623": true,
      "65624": true,
      "65625": true,
      "65626": true,
      "65627": true,
      "65628": true,
      "65629": true,
      "65630": true,
      "65631": true,
      "65632": true,
      "65633": true,
      "65634": true,
      "65635": true,
      "65636": true,
      "65637": true,
      "65638": true,
      "65639": true,
      "65640": true,
      "65641": true,
      "65642": true,
      "65643": true,
      "65644": true,
      "65645": true,
      "65646": true,
      "65647": true,
      "65648": true,
      "65649": true
    },
    "ABASOLO": {
      "65650": true,
      "65651": true,
      "65652": true,
      "65653": true,
      "65654": true,
      "65655": true,
      "65656": true,
      "65657": true,
      "65658": true,
      "65659": true,
      "65660": true,
      "65661": true,
      "65662": true,
      "65663": true,
      "65664": true,
      "65665": true,
      "65666": true,
      "65667": true,
      "65668": true,
      "65669": true,
      "65670": true,
      "65671": true,
      "65672": true,
      "65673": true,
      "65674": true,
      "65675": true,
      "65676": true,
      "65677": true,
      "65678": true,
      "65679": true,
      "65680": true,
      "65681": true,
      "65682": true,
      "65683": true,
      "65684": true,
      "65685": true,
      "65686": true,
      "65687": true,
      "65688": true,
      "65689": true,
      "65690": true,
      "65691": true,
      "65692": true,
      "65693": true,
      "65694": true,
      "65695": true,
      "65696": true,
      "65697": true,
      "65698": true,
      "65699": true
    },
    "HIGUERAS": {
      "65700": true,
      "65701": true,
      "65702": true,
      "65703": true,
      "65704": true,
      "65705": true,
      "65706": true,
      "65707": true,
      "65708": true,
      "65709": true,
      "65710": true,
      "65711": true,
      "65712": true,
      "65713": true,
      "65714": true,
      "65715": true,
      "65716": true,
      "65717": true,
      "65718": true,
      "65719": true,
      "65720": true,
      "65721": true,
      "65722": true,
      "65723": true,
      "65724": true,
      "65725": true,
      "65726": true,
      "65727": true,
      "65728": true,
      "65729": true,
      "65730": true,
      "65731": true,
      "65732": true,
      "65733": true,
      "65734": true,
      "65735": true,
      "65736": true,
      "65737": true,
      "65738": true,
      "65739": true,
      "65740": true,
      "65741": true,
      "65742": true,
      "65743": true,
      "65744": true,
      "65745": true,
      "65746": true,
      "65747": true,
      "65748": true,
      "65749": true
    },
    "GENERAL ZUAZUA": {
      "65750": true,
      "65751": true,
      "65752": true,
      "65753": true,
      "65754": true,
      "65755": true,
      "65756": true,
      "65757": true,
      "65758": true,
      "65759": true,
      "65760": true,
      "65761": true,
      "65762": true,
      "65763": true,
      "65764": true,
      "65765": true,
      "65766": true,
      "65767": true,
      "65768": true,
      "65769": true,
      "65770": true,
      "65771": true,
      "65772": true,
      "65773": true,
      "65774": true,
      "65775": true,
      "65776": true,
      "65777": true,
      "65778": true,
      "65779": true,
      "65780": true,
      "65781": true,
      "65782": true,
      "65783": true,
      "65784": true,
      "65785": true,
      "65786": true,
      "65787": true,
      "65788": true,
      "65789": true,
      "65790": true,
      "65791": true,
      "65792": true,
      "65793": true,
      "65794": true,
      "65795": true,
      "65796": true,
      "65797": true,
      "65798": true,
      "65799": true
    },
    "CERRALVO": {
      "65900": true,
      "65901": true,
      "65902": true,
      "65903": true,
      "65904": true,
      "65905": true,
      "65906": true,
      "65907": true,
      "65908": true,
      "65909": true,
      "65910": true,
      "65911": true,
      "65912": true,
      "65913": true,
      "65914": true,
      "65915": true,
      "65916": true,
      "65917": true,
      "65918": true,
      "65919": true,
      "65920": true,
      "65921": true,
      "65922": true,
      "65923": true,
      "65924": true,
      "65925": true,
      "65926": true,
      "65927": true,
      "65928": true,
      "65929": true,
      "65930": true,
      "65931": true,
      "65932": true,
      "65933": true,
      "65934": true,
      "65935": true,
      "65936": true,
      "65937": true,
      "65938": true,
      "65939": true,
      "65940": true,
      "65941": true,
      "65942": true,
      "65943": true,
      "65944": true,
      "65945": true,
      "65946": true,
      "65947": true,
      "65948": true,
      "65949": true
    },
    "MELCHOR OCAMPO": {
      "65950": true,
      "65951": true,
      "65952": true,
      "65953": true,
      "65954": true,
      "65955": true,
      "65956": true,
      "65957": true,
      "65958": true,
      "65959": true,
      "65960": true,
      "65961": true,
      "65962": true,
      "65963": true,
      "65964": true,
      "65965": true,
      "65966": true,
      "65967": true,
      "65968": true,
      "65969": true,
      "65970": true,
      "65971": true,
      "65972": true,
      "65973": true,
      "65974": true,
      "65975": true,
      "65976": true,
      "65977": true,
      "65978": true,
      "65979": true,
      "65980": true,
      "65981": true,
      "65982": true,
      "65983": true,
      "65984": true,
      "65985": true,
      "65986": true,
      "65987": true,
      "65988": true,
      "65989": true,
      "65990": true,
      "65991": true,
      "65992": true,
      "65993": true,
      "65994": true,
      "65995": true,
      "65996": true,
      "65997": true,
      "65998": true,
      "65999": true
    },
    "GARCÍA": {
      "66000": true,
      "66001": true,
      "66002": true,
      "66003": true,
      "66004": true,
      "66005": true,
      "66006": true,
      "66007": true,
      "66008": true,
      "66009": true,
      "66010": true,
      "66011": true,
      "66012": true,
      "66013": true,
      "66014": true,
      "66015": true,
      "66016": true,
      "66017": true,
      "66018": true,
      "66019": true,
      "66020": true,
      "66021": true,
      "66022": true,
      "66023": true,
      "66024": true,
      "66025": true,
      "66026": true,
      "66027": true,
      "66028": true,
      "66029": true,
      "66030": true,
      "66031": true,
      "66032": true,
      "66033": true,
      "66034": true,
      "66035": true,
      "66036": true,
      "66037": true,
      "66038": true,
      "66039": true
    },
    "GENERAL ESCOBEDO": {
      "66050": true,
      "66051": true,
      "66052": true,
      "66053": true,
      "66054": true,
      "66055": true,
      "66056": true,
      "66057": true,
      "66058": true,
      "66059": true,
      "66060": true,
      "66061": true,
      "66062": true,
      "66063": true,
      "66064": true,
      "66065": true,
      "66066": true,
      "66067": true,
      "66068": true,
      "66069": true,
      "66070": true,
      "66071": true,
      "66072": true,
      "66073": true,
      "66074": true,
      "66075": true,
      "66076": true,
      "66077": true,
      "66078": true,
      "66079": true,
      "66080": true,
      "66081": true,
      "66082": true,
      "66083": true,
      "66084": true,
      "66085": true,
      "66086": true,
      "66087": true,
      "66088": true,
      "66089": true,
      "66090": true,
      "66091": true,
      "66092": true,
      "66093": true,
      "66094": true,
      "66095": true,
      "66096": true,
      "66097": true,
      "66098": true,
      "66099": true
    },
    "SANTA CATARINA": {
      "66100": true,
      "66101": true,
      "66102": true,
      "66103": true,
      "66104": true,
      "66105": true,
      "66106": true,
      "66107": true,
      "66108": true,
      "66109": true,
      "66110": true,
      "66111": true,
      "66112": true,
      "66113": true,
      "66114": true,
      "66115": true,
      "66116": true,
      "66117": true,
      "66118": true,
      "66119": true,
      "66120": true,
      "66121": true,
      "66122": true,
      "66123": true,
      "66124": true,
      "66125": true,
      "66126": true,
      "66127": true,
      "66128": true,
      "66129": true,
      "66130": true,
      "66131": true,
      "66132": true,
      "66133": true,
      "66134": true,
      "66135": true,
      "66136": true,
      "66137": true,
      "66138": true,
      "66139": true,
      "66140": true,
      "66141": true,
      "66142": true,
      "66143": true,
      "66144": true,
      "66145": true,
      "66146": true,
      "66147": true,
      "66148": true,
      "66149": true,
      "66150": true,
      "66151": true,
      "66152": true,
      "66153": true,
      "66154": true,
      "66155": true,
      "66156": true,
      "66157": true,
      "66158": true,
      "66159": true,
      "66160": true,
      "66161": true,
      "66162": true,
      "66163": true,
      "66164": true,
      "66165": true,
      "66166": true,
      "66167": true,
      "66168": true,
      "66169": true,
      "66170": true,
      "66171": true,
      "66172": true,
      "66173": true,
      "66174": true,
      "66175": true,
      "66176": true,
      "66177": true,
      "66178": true,
      "66179": true,
      "66180": true,
      "66181": true,
      "66182": true,
      "66183": true,
      "66184": true,
      "66185": true,
      "66186": true,
      "66187": true,
      "66188": true,
      "66189": true,
      "66190": true,
      "66191": true,
      "66192": true,
      "66193": true,
      "66194": true,
      "66195": true,
      "66196": true,
      "66197": true,
      "66198": true,
      "66199": true,
      "66350": true,
      "66351": true,
      "66352": true,
      "66353": true,
      "66354": true,
      "66355": true,
      "66356": true,
      "66357": true,
      "66358": true,
      "66359": true,
      "66360": true,
      "66361": true,
      "66362": true,
      "66363": true,
      "66364": true,
      "66365": true,
      "66366": true,
      "66367": true,
      "66368": true,
      "66369": true,
      "66370": true,
      "66371": true,
      "66372": true,
      "66373": true,
      "66374": true,
      "66375": true,
      "66376": true,
      "66377": true,
      "66378": true,
      "66379": true,
      "66380": true,
      "66381": true,
      "66382": true,
      "66383": true,
      "66384": true,
      "66385": true,
      "66386": true,
      "66387": true,
      "66388": true,
      "66389": true,
      "66390": true,
      "66391": true,
      "66392": true,
      "66393": true,
      "66394": true,
      "66395": true,
      "66396": true,
      "66397": true,
      "66398": true,
      "66399": true
    },
    "SAN PEDRO GARZA GARCIA": {
      "66200": true,
      "66201": true,
      "66202": true,
      "66203": true,
      "66204": true,
      "66205": true,
      "66206": true,
      "66207": true,
      "66208": true,
      "66209": true,
      "66210": true,
      "66211": true,
      "66212": true,
      "66213": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66221": true,
      "66222": true,
      "66223": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66229": true,
      "66230": true,
      "66231": true,
      "66232": true,
      "66233": true,
      "66234": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66241": true,
      "66242": true,
      "66243": true,
      "66244": true,
      "66245": true,
      "66246": true,
      "66247": true,
      "66248": true,
      "66249": true,
      "66250": true,
      "66251": true,
      "66252": true,
      "66253": true,
      "66254": true,
      "66255": true,
      "66256": true,
      "66257": true,
      "66258": true,
      "66259": true,
      "66260": true,
      "66261": true,
      "66262": true,
      "66263": true,
      "66264": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66269": true,
      "66270": true,
      "66271": true,
      "66272": true,
      "66273": true,
      "66274": true,
      "66275": true,
      "66276": true,
      "66277": true,
      "66278": true,
      "66279": true,
      "66280": true,
      "66281": true,
      "66282": true,
      "66283": true,
      "66284": true,
      "66285": true,
      "66286": true,
      "66287": true,
      "66288": true,
      "66289": true,
      "66290": true,
      "66291": true,
      "66292": true,
      "66293": true,
      "66294": true,
      "66295": true,
      "66296": true,
      "66297": true,
      "66298": true,
      "66299": true,
      "66300": true,
      "66301": true,
      "66302": true,
      "66303": true,
      "66304": true,
      "66305": true,
      "66306": true,
      "66307": true,
      "66308": true,
      "66309": true,
      "66310": true,
      "66311": true,
      "66312": true,
      "66313": true,
      "66314": true,
      "66315": true,
      "66316": true,
      "66317": true,
      "66318": true,
      "66319": true,
      "66320": true,
      "66321": true,
      "66322": true,
      "66323": true,
      "66324": true,
      "66325": true,
      "66326": true,
      "66327": true,
      "66328": true,
      "66329": true,
      "66330": true,
      "66331": true,
      "66332": true,
      "66333": true,
      "66334": true,
      "66335": true,
      "66336": true,
      "66337": true,
      "66338": true,
      "66339": true,
      "66340": true,
      "66341": true,
      "66342": true,
      "66343": true,
      "66344": true,
      "66345": true,
      "66346": true,
      "66347": true,
      "66348": true,
      "66349": true
    },
    "SAN NICOLAS DE LOS GARZA": {
      "66400": true,
      "66401": true,
      "66402": true,
      "66403": true,
      "66404": true,
      "66405": true,
      "66406": true,
      "66407": true,
      "66408": true,
      "66409": true,
      "66410": true,
      "66411": true,
      "66412": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66416": true,
      "66417": true,
      "66418": true,
      "66419": true,
      "66420": true,
      "66421": true,
      "66422": true,
      "66423": true,
      "66424": true,
      "66425": true,
      "66426": true,
      "66427": true,
      "66428": true,
      "66429": true,
      "66430": true,
      "66431": true,
      "66432": true,
      "66433": true,
      "66434": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66439": true,
      "66440": true,
      "66441": true,
      "66442": true,
      "66443": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66451": true,
      "66452": true,
      "66453": true,
      "66454": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66459": true,
      "66460": true,
      "66461": true,
      "66462": true,
      "66463": true,
      "66464": true,
      "66465": true,
      "66466": true,
      "66467": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66471": true,
      "66472": true,
      "66473": true,
      "66474": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66481": true,
      "66482": true,
      "66483": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66487": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66491": true,
      "66492": true,
      "66493": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66497": true,
      "66498": true,
      "66499": true,
      "66500": true,
      "66501": true,
      "66502": true,
      "66503": true,
      "66504": true,
      "66505": true,
      "66506": true,
      "66507": true,
      "66508": true,
      "66509": true,
      "66510": true,
      "66511": true,
      "66512": true,
      "66513": true,
      "66514": true,
      "66515": true,
      "66516": true,
      "66517": true,
      "66518": true,
      "66519": true,
      "66520": true,
      "66521": true,
      "66522": true,
      "66523": true,
      "66524": true,
      "66525": true,
      "66526": true,
      "66527": true,
      "66528": true,
      "66529": true,
      "66530": true,
      "66531": true,
      "66532": true,
      "66533": true,
      "66534": true,
      "66535": true,
      "66536": true,
      "66537": true,
      "66538": true,
      "66539": true,
      "66540": true,
      "66541": true,
      "66542": true,
      "66543": true,
      "66544": true,
      "66545": true,
      "66546": true,
      "66547": true,
      "66548": true,
      "66549": true
    },
    "EL CARMEN": {
      "66550": true,
      "66551": true,
      "66552": true,
      "66553": true,
      "66554": true,
      "66555": true,
      "66556": true,
      "66557": true,
      "66558": true,
      "66559": true,
      "66560": true,
      "66561": true,
      "66562": true,
      "66563": true,
      "66564": true,
      "66565": true,
      "66566": true,
      "66567": true,
      "66568": true,
      "66569": true,
      "66570": true,
      "66571": true,
      "66572": true,
      "66573": true,
      "66574": true,
      "66575": true,
      "66576": true,
      "66577": true,
      "66578": true,
      "66579": true,
      "66580": true,
      "66581": true,
      "66582": true,
      "66583": true,
      "66584": true,
      "66585": true,
      "66586": true,
      "66587": true,
      "66588": true,
      "66589": true,
      "66590": true,
      "66591": true,
      "66592": true,
      "66593": true,
      "66594": true,
      "66595": true,
      "66596": true,
      "66597": true,
      "66598": true,
      "66599": true
    },
    "APODACA": {
      "66600": true,
      "66601": true,
      "66602": true,
      "66603": true,
      "66604": true,
      "66605": true,
      "66606": true,
      "66607": true,
      "66608": true,
      "66609": true,
      "66610": true,
      "66611": true,
      "66612": true,
      "66613": true,
      "66614": true,
      "66615": true,
      "66616": true,
      "66617": true,
      "66618": true,
      "66619": true,
      "66620": true,
      "66621": true,
      "66622": true,
      "66623": true,
      "66624": true,
      "66625": true,
      "66626": true,
      "66627": true,
      "66628": true,
      "66629": true,
      "66630": true,
      "66631": true,
      "66632": true,
      "66633": true,
      "66634": true,
      "66635": true,
      "66636": true,
      "66637": true,
      "66638": true,
      "66639": true,
      "66640": true,
      "66641": true,
      "66642": true,
      "66643": true,
      "66644": true,
      "66645": true,
      "66646": true,
      "66647": true,
      "66648": true,
      "66649": true
    },
    "PESQUERIA": {
      "66650": true,
      "66651": true,
      "66652": true,
      "66653": true,
      "66654": true,
      "66655": true,
      "66656": true,
      "66657": true,
      "66658": true,
      "66659": true,
      "66660": true,
      "66661": true,
      "66662": true,
      "66663": true,
      "66664": true,
      "66665": true,
      "66666": true,
      "66667": true,
      "66668": true,
      "66669": true,
      "66670": true,
      "66671": true,
      "66672": true,
      "66673": true,
      "66674": true,
      "66675": true,
      "66676": true,
      "66677": true,
      "66678": true
    },
    "MARIN": {
      "66700": true,
      "66701": true,
      "66702": true,
      "66703": true,
      "66704": true,
      "66705": true,
      "66706": true,
      "66707": true,
      "66708": true,
      "66709": true,
      "66710": true,
      "66711": true,
      "66712": true,
      "66713": true,
      "66714": true,
      "66715": true,
      "66716": true,
      "66717": true,
      "66718": true,
      "66719": true,
      "66720": true,
      "66721": true,
      "66722": true,
      "66723": true,
      "66724": true,
      "66725": true,
      "66726": true,
      "66727": true,
      "66728": true,
      "66729": true,
      "66730": true,
      "66731": true,
      "66732": true,
      "66733": true,
      "66734": true,
      "66735": true,
      "66736": true,
      "66737": true,
      "66738": true,
      "66739": true,
      "66740": true,
      "66741": true,
      "66742": true,
      "66743": true,
      "66744": true,
      "66745": true,
      "66746": true,
      "66747": true,
      "66748": true,
      "66749": true
    },
    "DOCTOR GONZALEZ": {
      "66750": true,
      "66751": true,
      "66752": true,
      "66753": true,
      "66754": true,
      "66755": true,
      "66756": true,
      "66757": true,
      "66758": true,
      "66759": true,
      "66765": true,
      "66766": true,
      "66767": true,
      "66768": true,
      "66769": true,
      "66770": true,
      "66771": true,
      "66772": true,
      "66773": true,
      "66774": true,
      "66775": true,
      "66776": true,
      "66777": true,
      "66778": true,
      "66779": true,
      "66780": true,
      "66781": true,
      "66782": true
    },
    "LOS RAMONES": {
      "66800": true,
      "66801": true,
      "66802": true,
      "66803": true,
      "66804": true,
      "66805": true,
      "66806": true,
      "66807": true,
      "66808": true,
      "66809": true,
      "66810": true,
      "66811": true,
      "66812": true,
      "66813": true,
      "66814": true,
      "66815": true,
      "66816": true,
      "66817": true,
      "66818": true,
      "66819": true,
      "66820": true,
      "66821": true,
      "66822": true,
      "66823": true,
      "66824": true,
      "66825": true,
      "66826": true,
      "66827": true,
      "66828": true,
      "66829": true,
      "66830": true,
      "66831": true,
      "66832": true,
      "66833": true,
      "66834": true,
      "66835": true,
      "66836": true,
      "66837": true,
      "66838": true,
      "66839": true,
      "66840": true,
      "66841": true,
      "66842": true,
      "66843": true,
      "66844": true,
      "66845": true,
      "66846": true,
      "66847": true
    },
    "GENERAL BRAVO": {
      "67000": true,
      "67001": true,
      "67002": true,
      "67003": true,
      "67004": true,
      "67005": true,
      "67006": true,
      "67007": true,
      "67008": true,
      "67009": true,
      "67012": true,
      "67013": true,
      "67014": true,
      "67015": true,
      "67016": true,
      "67017": true,
      "67018": true,
      "67019": true,
      "67020": true,
      "67021": true,
      "67022": true,
      "67023": true,
      "67024": true,
      "67025": true,
      "67026": true,
      "67027": true,
      "67028": true,
      "67029": true
    },
    "CHINA": {
      "67050": true,
      "67051": true,
      "67052": true,
      "67053": true,
      "67054": true,
      "67055": true,
      "67056": true,
      "67057": true,
      "67058": true,
      "67059": true,
      "67060": true,
      "67061": true,
      "67062": true,
      "67063": true,
      "67064": true,
      "67065": true,
      "67066": true,
      "67067": true,
      "67068": true,
      "67069": true,
      "67070": true,
      "67071": true,
      "67072": true,
      "67073": true,
      "67074": true,
      "67075": true,
      "67076": true,
      "67077": true,
      "67078": true,
      "67079": true,
      "67080": true,
      "67081": true,
      "67082": true,
      "67083": true,
      "67084": true,
      "67085": true,
      "67086": true
    },
    "GUADALUPE": {
      "67100": true,
      "67101": true,
      "67102": true,
      "67103": true,
      "67104": true,
      "67105": true,
      "67106": true,
      "67107": true,
      "67108": true,
      "67109": true,
      "67110": true,
      "67111": true,
      "67112": true,
      "67113": true,
      "67114": true,
      "67115": true,
      "67116": true,
      "67117": true,
      "67118": true,
      "67119": true,
      "67120": true,
      "67121": true,
      "67122": true,
      "67123": true,
      "67124": true,
      "67125": true,
      "67126": true,
      "67127": true,
      "67128": true,
      "67129": true,
      "67130": true,
      "67131": true,
      "67132": true,
      "67133": true,
      "67134": true,
      "67135": true,
      "67136": true,
      "67137": true,
      "67138": true,
      "67139": true,
      "67140": true,
      "67141": true,
      "67142": true,
      "67143": true,
      "67144": true,
      "67145": true,
      "67146": true,
      "67147": true,
      "67148": true,
      "67149": true,
      "67150": true,
      "67151": true,
      "67152": true,
      "67153": true,
      "67154": true,
      "67155": true,
      "67156": true,
      "67157": true,
      "67158": true,
      "67159": true,
      "67160": true,
      "67161": true,
      "67162": true,
      "67163": true,
      "67164": true,
      "67165": true,
      "67166": true,
      "67167": true,
      "67168": true,
      "67169": true,
      "67170": true,
      "67171": true,
      "67172": true,
      "67173": true,
      "67174": true,
      "67175": true,
      "67176": true,
      "67177": true,
      "67178": true,
      "67179": true,
      "67180": true,
      "67181": true,
      "67182": true,
      "67183": true,
      "67184": true,
      "67185": true,
      "67186": true,
      "67187": true,
      "67188": true,
      "67189": true,
      "67190": true,
      "67191": true,
      "67192": true,
      "67193": true,
      "67194": true,
      "67195": true,
      "67196": true,
      "67197": true,
      "67198": true,
      "67199": true,
      "67200": true,
      "67201": true,
      "67202": true,
      "67203": true,
      "67204": true,
      "67205": true,
      "67206": true,
      "67207": true,
      "67208": true,
      "67209": true,
      "67210": true,
      "67211": true,
      "67212": true,
      "67213": true,
      "67214": true,
      "67215": true,
      "67216": true,
      "67217": true,
      "67218": true,
      "67219": true,
      "67220": true,
      "67221": true,
      "67222": true,
      "67223": true,
      "67224": true,
      "67225": true,
      "67226": true,
      "67227": true,
      "67228": true,
      "67229": true,
      "67230": true,
      "67231": true,
      "67232": true,
      "67233": true,
      "67234": true,
      "67235": true,
      "67236": true,
      "67237": true,
      "67238": true,
      "67239": true,
      "67240": true,
      "67241": true,
      "67242": true,
      "67243": true,
      "67244": true,
      "67245": true,
      "67246": true,
      "67247": true,
      "67248": true,
      "67249": true
    },
    "JUÁREZ": {
      "67250": true,
      "67251": true,
      "67252": true,
      "67253": true,
      "67254": true,
      "67255": true,
      "67256": true,
      "67257": true,
      "67258": true,
      "67259": true,
      "67260": true,
      "67261": true,
      "67262": true,
      "67263": true,
      "67264": true,
      "67265": true,
      "67266": true,
      "67267": true,
      "67268": true,
      "67269": true,
      "67270": true,
      "67271": true,
      "67272": true,
      "67273": true,
      "67274": true,
      "67275": true,
      "67276": true,
      "67277": true,
      "67278": true,
      "67279": true,
      "67280": true,
      "67281": true,
      "67282": true,
      "67283": true,
      "67284": true,
      "67285": true,
      "67286": true,
      "67287": true,
      "67288": true,
      "67289": true,
      "67290": true,
      "67291": true,
      "67292": true,
      "67293": true,
      "67294": true,
      "67295": true,
      "67296": true,
      "67297": true,
      "67298": true,
      "67299": true
    },
    "SANTIAGO": {
      "67300": true,
      "67301": true,
      "67302": true,
      "67303": true,
      "67307": true,
      "67308": true,
      "67309": true,
      "67310": true,
      "67311": true,
      "67312": true,
      "67313": true,
      "67314": true,
      "67315": true,
      "67316": true,
      "67317": true,
      "67318": true,
      "67319": true,
      "67320": true,
      "67321": true,
      "67322": true,
      "67323": true,
      "67324": true,
      "67325": true,
      "67326": true,
      "67327": true,
      "67328": true,
      "67329": true,
      "67330": true,
      "67331": true,
      "67332": true,
      "67333": true,
      "67340": true,
      "67341": true,
      "67342": true,
      "67343": true,
      "67344": true,
      "67345": true,
      "67346": true,
      "67347": true,
      "67348": true,
      "67349": true
    },
    "ALLENDE": {
      "67350": true,
      "67351": true,
      "67352": true,
      "67353": true,
      "67354": true,
      "67355": true,
      "67356": true,
      "67357": true,
      "67358": true,
      "67359": true,
      "67360": true,
      "67361": true,
      "67362": true,
      "67363": true,
      "67364": true,
      "67365": true,
      "67366": true,
      "67367": true,
      "67368": true,
      "67369": true,
      "67370": true,
      "67371": true,
      "67372": true,
      "67373": true,
      "67374": true,
      "67375": true,
      "67376": true,
      "67377": true,
      "67378": true,
      "67379": true,
      "67380": true,
      "67381": true,
      "67382": true,
      "67383": true,
      "67384": true,
      "67385": true,
      "67386": true,
      "67387": true,
      "67388": true,
      "67389": true,
      "67390": true,
      "67391": true,
      "67392": true,
      "67393": true,
      "67394": true,
      "67395": true,
      "67396": true,
      "67397": true,
      "67398": true,
      "67399": true
    },
    "GENERAL TERAN": {
      "67400": true,
      "67401": true,
      "67402": true,
      "67403": true,
      "67404": true,
      "67405": true,
      "67406": true,
      "67407": true,
      "67408": true,
      "67409": true,
      "67410": true,
      "67411": true,
      "67412": true,
      "67413": true,
      "67415": true,
      "67416": true,
      "67417": true,
      "67418": true,
      "67419": true,
      "67420": true,
      "67421": true,
      "67422": true,
      "67430": true,
      "67431": true,
      "67432": true,
      "67433": true,
      "67434": true,
      "67435": true,
      "67436": true,
      "67437": true,
      "67438": true,
      "67439": true,
      "67440": true,
      "67441": true,
      "67442": true,
      "67443": true,
      "67444": true,
      "67445": true,
      "67446": true,
      "67447": true,
      "67448": true,
      "67449": true,
      "67450": true
    },
    "CADEREYTA JIMENEZ": {
      "67451": true,
      "67452": true,
      "67453": true,
      "67454": true,
      "67455": true,
      "67456": true,
      "67457": true,
      "67458": true,
      "67459": true,
      "67462": true,
      "67463": true,
      "67464": true,
      "67467": true,
      "67468": true,
      "67469": true,
      "67470": true,
      "67471": true,
      "67472": true,
      "67473": true,
      "67474": true,
      "67475": true,
      "67476": true,
      "67477": true,
      "67478": true,
      "67479": true,
      "67480": true,
      "67481": true,
      "67482": true,
      "67483": true,
      "67484": true,
      "67485": true,
      "67486": true,
      "67487": true,
      "67488": true,
      "67489": true,
      "67492": true,
      "67499": true
    },
    "MONTEMORELOS": {
      "67500": true,
      "67501": true,
      "67502": true,
      "67503": true,
      "67504": true,
      "67505": true,
      "67506": true,
      "67507": true,
      "67508": true,
      "67509": true,
      "67510": true,
      "67511": true,
      "67512": true,
      "67513": true,
      "67514": true,
      "67515": true,
      "67516": true,
      "67517": true,
      "67518": true,
      "67519": true,
      "67520": true,
      "67521": true,
      "67522": true,
      "67523": true,
      "67524": true,
      "67525": true,
      "67526": true,
      "67527": true,
      "67528": true,
      "67529": true,
      "67530": true,
      "67531": true,
      "67532": true,
      "67533": true,
      "67534": true,
      "67535": true,
      "67536": true,
      "67537": true,
      "67538": true,
      "67539": true,
      "67540": true,
      "67541": true,
      "67542": true,
      "67543": true,
      "67544": true,
      "67545": true,
      "67546": true,
      "67547": true,
      "67548": true,
      "67549": true,
      "67550": true,
      "67551": true,
      "67552": true,
      "67553": true,
      "67554": true,
      "67555": true,
      "67556": true,
      "67557": true,
      "67558": true,
      "67559": true,
      "67560": true,
      "67561": true,
      "67562": true,
      "67563": true,
      "67564": true,
      "67565": true,
      "67566": true,
      "67567": true,
      "67568": true,
      "67569": true,
      "67570": true,
      "67571": true,
      "67572": true,
      "67573": true,
      "67574": true,
      "67575": true,
      "67576": true,
      "67577": true,
      "67578": true,
      "67579": true,
      "67580": true,
      "67581": true,
      "67582": true,
      "67583": true,
      "67584": true,
      "67585": true,
      "67586": true,
      "67587": true,
      "67588": true,
      "67589": true,
      "67590": true,
      "67591": true,
      "67592": true,
      "67593": true,
      "67594": true,
      "67595": true,
      "67596": true,
      "67597": true,
      "67598": true,
      "67599": true,
      "67600": true,
      "67601": true,
      "67602": true,
      "67603": true,
      "67604": true,
      "67605": true,
      "67606": true,
      "67607": true,
      "67608": true,
      "67609": true,
      "67610": true,
      "67611": true,
      "67612": true,
      "67613": true,
      "67614": true,
      "67615": true,
      "67616": true,
      "67617": true,
      "67618": true,
      "67619": true,
      "67620": true,
      "67621": true,
      "67622": true,
      "67623": true,
      "67624": true,
      "67625": true,
      "67626": true,
      "67627": true,
      "67628": true,
      "67629": true,
      "67630": true,
      "67631": true,
      "67632": true,
      "67633": true,
      "67634": true,
      "67635": true,
      "67636": true,
      "67640": true,
      "67641": true,
      "67642": true,
      "67643": true,
      "67644": true,
      "67645": true,
      "67646": true,
      "67647": true,
      "67648": true,
      "67649": true
    },
    "LINARES": {
      "67700": true,
      "67701": true,
      "67702": true,
      "67703": true,
      "67704": true,
      "67705": true,
      "67706": true,
      "67707": true,
      "67708": true,
      "67709": true,
      "67710": true,
      "67711": true,
      "67712": true,
      "67713": true,
      "67714": true,
      "67715": true,
      "67716": true,
      "67717": true,
      "67718": true,
      "67719": true,
      "67720": true,
      "67721": true,
      "67722": true,
      "67723": true,
      "67724": true,
      "67725": true,
      "67726": true,
      "67727": true,
      "67728": true,
      "67729": true,
      "67730": true,
      "67731": true,
      "67732": true,
      "67733": true,
      "67734": true,
      "67735": true,
      "67736": true,
      "67737": true,
      "67738": true,
      "67739": true,
      "67740": true,
      "67741": true,
      "67742": true,
      "67743": true,
      "67744": true,
      "67745": true,
      "67746": true,
      "67747": true,
      "67748": true,
      "67749": true,
      "67750": true,
      "67751": true,
      "67752": true,
      "67753": true,
      "67754": true,
      "67755": true,
      "67756": true,
      "67757": true,
      "67758": true,
      "67759": true,
      "67760": true,
      "67761": true,
      "67762": true,
      "67763": true,
      "67764": true,
      "67765": true,
      "67766": true,
      "67767": true,
      "67768": true,
      "67769": true,
      "67770": true,
      "67771": true,
      "67772": true,
      "67773": true,
      "67774": true,
      "67775": true,
      "67776": true,
      "67777": true,
      "67778": true,
      "67779": true,
      "67780": true,
      "67781": true,
      "67782": true,
      "67783": true,
      "67784": true,
      "67785": true,
      "67786": true,
      "67787": true,
      "67788": true,
      "67789": true,
      "67790": true,
      "67791": true,
      "67792": true,
      "67793": true,
      "67794": true,
      "67795": true,
      "67796": true,
      "67797": true,
      "67798": true,
      "67799": true,
      "67802": true,
      "67803": true,
      "67804": true,
      "67805": true,
      "67806": true,
      "67807": true,
      "67808": true,
      "67824": true,
      "67825": true,
      "67826": true,
      "67827": true
    },
    "HUALAHUISES": {
      "67880": true,
      "67881": true,
      "67882": true,
      "67883": true,
      "67884": true,
      "67885": true,
      "67886": true,
      "67887": true,
      "67888": true,
      "67889": true,
      "67890": true,
      "67891": true,
      "67892": true,
      "67893": true,
      "67894": true,
      "67895": true,
      "67896": true,
      "67897": true,
      "67898": true,
      "67899": true
    }
  },
  "OAXACA": {
    "OAXACA DE JUAREZ": {
      "68000": true,
      "68001": true,
      "68002": true,
      "68003": true,
      "68004": true,
      "68005": true,
      "68006": true,
      "68007": true,
      "68008": true,
      "68009": true,
      "68010": true,
      "68011": true,
      "68012": true,
      "68013": true,
      "68014": true,
      "68015": true,
      "68016": true,
      "68017": true,
      "68018": true,
      "68019": true,
      "68020": true,
      "68021": true,
      "68022": true,
      "68023": true,
      "68024": true,
      "68025": true,
      "68026": true,
      "68027": true,
      "68028": true,
      "68029": true,
      "68030": true,
      "68031": true,
      "68032": true,
      "68033": true,
      "68034": true,
      "68035": true,
      "68036": true,
      "68037": true,
      "68038": true,
      "68039": true,
      "68040": true,
      "68041": true,
      "68042": true,
      "68043": true,
      "68044": true,
      "68045": true,
      "68046": true,
      "68047": true,
      "68048": true,
      "68049": true,
      "68050": true,
      "68051": true,
      "68052": true,
      "68053": true,
      "68054": true,
      "68055": true,
      "68056": true,
      "68057": true,
      "68058": true,
      "68059": true,
      "68060": true,
      "68061": true,
      "68062": true,
      "68063": true,
      "68064": true,
      "68065": true,
      "68066": true,
      "68067": true,
      "68068": true,
      "68069": true,
      "68070": true,
      "68071": true,
      "68072": true,
      "68073": true,
      "68074": true,
      "68075": true,
      "68076": true,
      "68077": true,
      "68078": true,
      "68079": true,
      "68080": true,
      "68081": true,
      "68082": true,
      "68083": true,
      "68084": true,
      "68085": true,
      "68086": true,
      "68087": true,
      "68088": true,
      "68089": true,
      "68090": true,
      "68091": true,
      "68092": true,
      "68093": true,
      "68094": true,
      "68095": true,
      "68096": true,
      "68097": true,
      "68098": true,
      "68099": true,
      "68100": true,
      "68101": true,
      "68102": true,
      "68103": true,
      "68104": true,
      "68105": true,
      "68106": true,
      "68107": true,
      "68108": true,
      "68109": true,
      "68110": true,
      "68111": true,
      "68112": true,
      "68113": true,
      "68114": true,
      "68115": true,
      "68116": true,
      "68117": true,
      "68118": true,
      "68119": true,
      "68120": true,
      "68121": true,
      "68122": true,
      "68123": true,
      "68124": true,
      "68125": true,
      "68126": true,
      "68127": true,
      "68128": true,
      "68129": true,
      "68130": true,
      "68131": true,
      "68132": true,
      "68133": true,
      "68134": true,
      "68135": true,
      "68136": true,
      "68137": true,
      "68138": true,
      "68139": true,
      "68140": true,
      "68141": true,
      "68142": true,
      "68143": true,
      "68144": true,
      "68145": true,
      "68146": true,
      "68147": true,
      "68148": true,
      "68149": true,
      "68150": true,
      "68151": true,
      "68152": true,
      "68153": true,
      "68154": true,
      "68155": true,
      "68156": true,
      "68157": true,
      "68158": true,
      "68159": true,
      "68160": true,
      "68161": true,
      "68162": true,
      "68163": true,
      "68164": true,
      "68165": true,
      "68166": true,
      "68167": true,
      "68168": true,
      "68169": true,
      "68170": true,
      "68171": true,
      "68172": true,
      "68173": true,
      "68174": true,
      "68175": true,
      "68176": true,
      "68177": true,
      "68178": true,
      "68179": true,
      "68180": true,
      "68181": true,
      "68182": true,
      "68183": true,
      "68184": true,
      "68185": true,
      "68186": true,
      "68187": true,
      "68188": true,
      "68189": true,
      "68190": true,
      "68191": true,
      "68192": true,
      "68193": true,
      "68194": true,
      "68195": true,
      "68196": true,
      "68197": true,
      "68198": true,
      "68199": true,
      "68274": true,
      "68275": true,
      "68276": true,
      "68277": true,
      "68278": true,
      "68279": true,
      "68280": true,
      "68281": true,
      "68282": true,
      "68283": true,
      "68284": true
    },
    "TLALIXTAC DE CABRERA": {
      "68270": true,
      "68271": true,
      "68272": true
    },
    "SAN JACINTO AMILPAS": {
      "68285": true,
      "68286": true
    },
    "SAN ANDRES HUAYAPAM": {
      "68287": true,
      "68288": true,
      "68289": true
    },
    "SAN AGUSTIN YATARENI": {
      "68290": true,
      "68291": true,
      "68292": true
    },
    "SANTA MARIA DEL TULE": {
      "68297": true,
      "68298": true,
      "68299": true
    },
    "SANTA MARIA ATZOMPA": {
      "71220": true,
      "71221": true,
      "71222": true,
      "71223": true
    },
    "SANTA CRUZ AMILPAS": {
      "71226": true,
      "71227": true,
      "71228": true,
      "71229": true
    },
    "SANTA CRUZ XOXOCOTLAN": {
      "71230": true,
      "71231": true,
      "71232": true,
      "71233": true,
      "71234": true,
      "71235": true,
      "71236": true,
      "71237": true,
      "71238": true,
      "71239": true
    },
    "SANTA LUCIA DEL CAMINO": {
      "71240": true,
      "71241": true,
      "71242": true,
      "71243": true,
      "71244": true,
      "71245": true
    },
    "SAN ANTONIO DE LA CAL": {
      "71256": true
    },
    "SAN SEBASTIAN TUTLA": {
      "71320": true,
      "71321": true,
      "71322": true,
      "71323": true,
      "71324": true,
      "71325": true
    }
  },
  "PUEBLA": {
    "PUEBLA": {
      "72000": true,
      "72010": true,
      "72020": true,
      "72023": true,
      "72029": true,
      "72030": true,
      "72040": true,
      "72044": true,
      "72045": true,
      "72050": true,
      "72060": true,
      "72062": true,
      "72070": true,
      "72080": true,
      "72089": true,
      "72090": true,
      "72094": true,
      "72110": true,
      "72114": true,
      "72115": true,
      "72120": true,
      "72124": true,
      "72127": true,
      "72130": true,
      "72135": true,
      "72140": true,
      "72150": true,
      "72154": true,
      "72160": true,
      "72170": true,
      "72176": true,
      "72180": true,
      "72189": true,
      "72190": true,
      "72193": true,
      "72194": true,
      "72200": true,
      "72210": true,
      "72220": true,
      "72223": true,
      "72225": true,
      "72228": true,
      "72230": true,
      "72240": true,
      "72243": true,
      "72250": true,
      "72260": true,
      "72266": true,
      "72267": true,
      "72270": true,
      "72280": true,
      "72290": true,
      "72300": true,
      "72303": true,
      "72304": true,
      "72307": true,
      "72308": true,
      "72309": true,
      "72310": true,
      "72314": true,
      "72320": true,
      "72330": true,
      "72340": true,
      "72350": true,
      "72359": true,
      "72360": true,
      "72365": true,
      "72370": true,
      "72373": true,
      "72377": true,
      "72380": true,
      "72390": true,
      "72400": true,
      "72403": true,
      "72410": true,
      "72420": true,
      "72423": true,
      "72424": true,
      "72425": true,
      "72430": true,
      "72440": true,
      "72450": true,
      "72453": true,
      "72456": true,
      "72459": true,
      "72460": true,
      "72464": true,
      "72468": true,
      "72470": true,
      "72474": true,
      "72477": true,
      "72478": true,
      "72480": true,
      "72482": true,
      "72483": true,
      "72484": true,
      "72490": true,
      "72492": true,
      "72494": true,
      "72496": true,
      "72498": true,
      "72500": true,
      "72501": true,
      "72503": true,
      "72504": true,
      "72505": true,
      "72510": true,
      "72520": true,
      "72523": true,
      "72530": true,
      "72532": true,
      "72533": true,
      "72534": true,
      "72538": true,
      "72540": true,
      "72543": true,
      "72550": true,
      "72560": true,
      "72564": true,
      "72565": true,
      "72567": true,
      "72570": true,
      "72573": true,
      "72574": true,
      "72575": true,
      "72580": true,
      "72582": true,
      "72583": true,
      "72584": true,
      "72587": true,
      "72589": true,
      "72590": true,
      "72592": true,
      "72593": true,
      "72594": true
    },
    "JUAN C. BONILLA": {
      "72640": true,
      "72669": true
    },
    "CORONANGO": {
      "72670": true,
      "72680": true,
      "72683": true,
      "72685": true
    },
    "CUAUTLANCINGO": {
      "72700": true,
      "72702": true,
      "72703": true,
      "72704": true,
      "72705": true,
      "72706": true,
      "72707": true,
      "72720": true,
      "72723": true,
      "72724": true,
      "72730": true,
      "72733": true,
      "72735": true
    },
    "SAN PEDRO CHOLULA": {
      "72750": true,
      "72754": true,
      "72755": true,
      "72757": true,
      "72760": true,
      "72762": true,
      "72764": true,
      "72765": true,
      "72766": true,
      "72767": true,
      "72768": true,
      "72770": true,
      "72772": true,
      "72774": true,
      "72775": true,
      "72776": true,
      "72777": true,
      "72778": true
    },
    "SAN ANDRÉS CHOLULA": {
      "72803": true,
      "72805": true,
      "72810": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72817": true,
      "72819": true,
      "72820": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72828": true,
      "72830": true,
      "72833": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72840": true,
      "72843": true,
      "72846": true
    }
  },
  "SAN LUIS POTOSÍ": {
    "SAN LUIS POTOSI": {
      "78000": true,
      "78001": true,
      "78002": true,
      "78003": true,
      "78004": true,
      "78005": true,
      "78006": true,
      "78007": true,
      "78008": true,
      "78009": true,
      "78010": true,
      "78011": true,
      "78012": true,
      "78013": true,
      "78014": true,
      "78015": true,
      "78016": true,
      "78017": true,
      "78018": true,
      "78019": true,
      "78020": true,
      "78021": true,
      "78022": true,
      "78023": true,
      "78024": true,
      "78025": true,
      "78026": true,
      "78027": true,
      "78028": true,
      "78029": true,
      "78030": true,
      "78031": true,
      "78032": true,
      "78033": true,
      "78034": true,
      "78035": true,
      "78036": true,
      "78037": true,
      "78038": true,
      "78039": true,
      "78040": true,
      "78041": true,
      "78042": true,
      "78043": true,
      "78044": true,
      "78045": true,
      "78046": true,
      "78047": true,
      "78048": true,
      "78049": true,
      "78050": true,
      "78051": true,
      "78052": true,
      "78053": true,
      "78054": true,
      "78055": true,
      "78056": true,
      "78057": true,
      "78058": true,
      "78059": true,
      "78060": true,
      "78061": true,
      "78062": true,
      "78063": true,
      "78064": true,
      "78065": true,
      "78066": true,
      "78067": true,
      "78068": true,
      "78069": true,
      "78070": true,
      "78071": true,
      "78072": true,
      "78073": true,
      "78074": true,
      "78075": true,
      "78076": true,
      "78077": true,
      "78078": true,
      "78079": true,
      "78080": true,
      "78081": true,
      "78082": true,
      "78083": true,
      "78084": true,
      "78085": true,
      "78086": true,
      "78087": true,
      "78088": true,
      "78089": true,
      "78090": true,
      "78091": true,
      "78092": true,
      "78093": true,
      "78094": true,
      "78095": true,
      "78096": true,
      "78097": true,
      "78098": true,
      "78099": true,
      "78100": true,
      "78101": true,
      "78102": true,
      "78103": true,
      "78104": true,
      "78105": true,
      "78106": true,
      "78107": true,
      "78108": true,
      "78109": true,
      "78110": true,
      "78111": true,
      "78112": true,
      "78113": true,
      "78114": true,
      "78115": true,
      "78116": true,
      "78117": true,
      "78118": true,
      "78119": true,
      "78120": true,
      "78121": true,
      "78122": true,
      "78123": true,
      "78124": true,
      "78125": true,
      "78126": true,
      "78127": true,
      "78128": true,
      "78129": true,
      "78130": true,
      "78131": true,
      "78132": true,
      "78133": true,
      "78134": true,
      "78135": true,
      "78136": true,
      "78137": true,
      "78138": true,
      "78139": true,
      "78140": true,
      "78141": true,
      "78142": true,
      "78143": true,
      "78144": true,
      "78145": true,
      "78146": true,
      "78147": true,
      "78148": true,
      "78149": true,
      "78150": true,
      "78151": true,
      "78152": true,
      "78153": true,
      "78154": true,
      "78155": true,
      "78156": true,
      "78157": true,
      "78158": true,
      "78159": true,
      "78160": true,
      "78161": true,
      "78162": true,
      "78163": true,
      "78164": true,
      "78165": true,
      "78166": true,
      "78167": true,
      "78168": true,
      "78169": true,
      "78170": true,
      "78171": true,
      "78172": true,
      "78173": true,
      "78174": true,
      "78175": true,
      "78176": true,
      "78177": true,
      "78178": true,
      "78179": true,
      "78180": true,
      "78181": true,
      "78182": true,
      "78183": true,
      "78184": true,
      "78185": true,
      "78186": true,
      "78187": true,
      "78188": true,
      "78189": true,
      "78190": true,
      "78191": true,
      "78192": true,
      "78193": true,
      "78194": true,
      "78195": true,
      "78196": true,
      "78197": true,
      "78198": true,
      "78199": true,
      "78200": true,
      "78201": true,
      "78202": true,
      "78203": true,
      "78204": true,
      "78205": true,
      "78206": true,
      "78207": true,
      "78208": true,
      "78209": true,
      "78210": true,
      "78211": true,
      "78212": true,
      "78213": true,
      "78214": true,
      "78215": true,
      "78216": true,
      "78217": true,
      "78218": true,
      "78219": true,
      "78220": true,
      "78221": true,
      "78222": true,
      "78223": true,
      "78224": true,
      "78225": true,
      "78226": true,
      "78227": true,
      "78228": true,
      "78229": true,
      "78230": true,
      "78231": true,
      "78232": true,
      "78233": true,
      "78234": true,
      "78235": true,
      "78236": true,
      "78237": true,
      "78238": true,
      "78239": true,
      "78240": true,
      "78241": true,
      "78242": true,
      "78243": true,
      "78244": true,
      "78245": true,
      "78246": true,
      "78247": true,
      "78248": true,
      "78249": true,
      "78250": true,
      "78251": true,
      "78252": true,
      "78253": true,
      "78254": true,
      "78255": true,
      "78256": true,
      "78257": true,
      "78258": true,
      "78259": true,
      "78260": true,
      "78261": true,
      "78262": true,
      "78263": true,
      "78264": true,
      "78265": true,
      "78266": true,
      "78267": true,
      "78268": true,
      "78269": true,
      "78270": true,
      "78271": true,
      "78272": true,
      "78273": true,
      "78274": true,
      "78275": true,
      "78276": true,
      "78277": true,
      "78278": true,
      "78279": true,
      "78280": true,
      "78281": true,
      "78282": true,
      "78283": true,
      "78284": true,
      "78285": true,
      "78286": true,
      "78287": true,
      "78288": true,
      "78289": true,
      "78290": true,
      "78291": true,
      "78292": true,
      "78293": true,
      "78294": true,
      "78295": true,
      "78296": true,
      "78297": true,
      "78298": true,
      "78299": true,
      "78300": true,
      "78301": true,
      "78302": true,
      "78303": true,
      "78304": true,
      "78305": true,
      "78306": true,
      "78307": true,
      "78308": true,
      "78309": true,
      "78310": true,
      "78311": true,
      "78312": true,
      "78313": true,
      "78314": true,
      "78315": true,
      "78316": true,
      "78317": true,
      "78318": true,
      "78319": true,
      "78320": true,
      "78321": true,
      "78322": true,
      "78323": true,
      "78324": true,
      "78325": true,
      "78326": true,
      "78327": true,
      "78328": true,
      "78329": true,
      "78330": true,
      "78331": true,
      "78332": true,
      "78333": true,
      "78334": true,
      "78335": true,
      "78336": true,
      "78337": true,
      "78338": true,
      "78339": true,
      "78340": true,
      "78341": true,
      "78342": true,
      "78343": true,
      "78344": true,
      "78345": true,
      "78346": true,
      "78347": true,
      "78348": true,
      "78349": true,
      "78350": true,
      "78351": true,
      "78352": true,
      "78353": true,
      "78354": true,
      "78355": true,
      "78356": true,
      "78357": true,
      "78358": true,
      "78359": true,
      "78360": true,
      "78361": true,
      "78362": true,
      "78363": true,
      "78364": true,
      "78365": true,
      "78366": true,
      "78367": true,
      "78368": true,
      "78369": true,
      "78370": true,
      "78371": true,
      "78372": true,
      "78373": true,
      "78374": true,
      "78375": true,
      "78376": true,
      "78377": true,
      "78378": true,
      "78379": true,
      "78380": true,
      "78381": true,
      "78382": true,
      "78383": true,
      "78384": true,
      "78385": true,
      "78386": true,
      "78387": true,
      "78388": true,
      "78389": true,
      "78390": true,
      "78391": true,
      "78392": true,
      "78393": true,
      "78394": true,
      "78395": true,
      "78396": true,
      "78397": true,
      "78398": true,
      "78399": true,
      "78400": true,
      "78401": true,
      "78402": true,
      "78406": true,
      "78413": true,
      "78414": true,
      "78415": true,
      "78418": true,
      "78419": true,
      "78420": true,
      "78421": true,
      "78422": true,
      "78423": true,
      "78424": true,
      "78425": true,
      "78426": true,
      "78427": true,
      "78428": true,
      "78429": true
    },
    "SOLEDAD DE GRACIANO SÁNCHEZ": {
      "78430": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true
    },
    "SOLEDAD DE GRACIANO SANCHEZ": {
      "78430": true,
      "78431": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true,
      "78439": true
    },
    "CERRO DE SAN PEDRO": {
      "78440": true,
      "78441": true,
      "78442": true,
      "78443": true,
      "78444": true,
      "78445": true,
      "78446": true,
      "78447": true,
      "78448": true,
      "78449": true
    },
    "AHUALULCO": {
      "78450": true,
      "78451": true,
      "78452": true,
      "78455": true,
      "78456": true,
      "78457": true,
      "78458": true,
      "78459": true
    },
    "MEXQUITIC DE CARMONA": {
      "78463": true,
      "78464": true,
      "78465": true,
      "78466": true,
      "78467": true,
      "78468": true,
      "78469": true,
      "78470": true,
      "78471": true,
      "78472": true,
      "78473": true,
      "78476": true,
      "78480": true,
      "78481": true,
      "78482": true,
      "78483": true,
      "78484": true,
      "78485": true,
      "78486": true,
      "78487": true,
      "78488": true,
      "78489": true
    },
    "VILLA DE ARRIAGA": {
      "78490": true,
      "78491": true,
      "78492": true,
      "78493": true,
      "78495": true,
      "78496": true,
      "78497": true,
      "78498": true,
      "78499": true
    },
    "CEDRAL": {
      "78520": true,
      "78521": true,
      "78522": true,
      "78523": true,
      "78524": true,
      "78525": true,
      "78526": true,
      "78527": true,
      "78528": true,
      "78529": true,
      "78530": true,
      "78531": true,
      "78532": true,
      "78536": true,
      "78537": true,
      "78538": true,
      "78539": true
    },
    "CHARCAS": {
      "78570": true,
      "78571": true,
      "78572": true,
      "78573": true,
      "78574": true,
      "78575": true,
      "78576": true,
      "78577": true,
      "78583": true,
      "78584": true,
      "78586": true,
      "78590": true,
      "78591": true,
      "78592": true,
      "78593": true,
      "78594": true,
      "78595": true,
      "78596": true,
      "78597": true,
      "78598": true,
      "78599": true
    },
    "SALINAS": {
      "78600": true,
      "78601": true,
      "78604": true,
      "78605": true,
      "78606": true,
      "78607": true,
      "78608": true,
      "78609": true,
      "78610": true,
      "78611": true,
      "78620": true,
      "78621": true,
      "78622": true,
      "78623": true,
      "78624": true,
      "78625": true,
      "78626": true,
      "78627": true,
      "78628": true,
      "78629": true
    },
    "SANTO DOMINGO": {
      "78630": true,
      "78631": true,
      "78632": true,
      "78634": true,
      "78635": true,
      "78637": true,
      "78639": true,
      "78640": true,
      "78641": true,
      "78642": true,
      "78643": true,
      "78649": true,
      "78650": true,
      "78651": true,
      "78652": true,
      "78653": true,
      "78654": true,
      "78655": true,
      "78656": true,
      "78657": true,
      "78658": true,
      "78659": true
    },
    "MATEHUALA": {
      "78700": true,
      "78701": true,
      "78702": true,
      "78703": true,
      "78704": true,
      "78705": true,
      "78706": true,
      "78707": true,
      "78708": true,
      "78709": true,
      "78710": true,
      "78711": true,
      "78712": true,
      "78713": true,
      "78714": true,
      "78715": true,
      "78716": true,
      "78717": true,
      "78718": true,
      "78719": true,
      "78720": true,
      "78721": true,
      "78722": true,
      "78723": true,
      "78724": true,
      "78725": true,
      "78726": true,
      "78727": true,
      "78728": true,
      "78729": true,
      "78730": true,
      "78731": true,
      "78732": true,
      "78733": true,
      "78734": true,
      "78735": true,
      "78736": true,
      "78737": true,
      "78738": true,
      "78739": true,
      "78740": true,
      "78741": true,
      "78742": true,
      "78743": true,
      "78744": true,
      "78745": true,
      "78746": true,
      "78747": true,
      "78748": true,
      "78749": true,
      "78750": true,
      "78751": true,
      "78752": true,
      "78753": true,
      "78754": true,
      "78755": true,
      "78756": true,
      "78757": true,
      "78758": true,
      "78759": true,
      "78760": true,
      "78761": true,
      "78762": true,
      "78763": true,
      "78764": true,
      "78765": true,
      "78766": true,
      "78767": true,
      "78768": true,
      "78769": true,
      "78770": true,
      "78771": true,
      "78772": true,
      "78773": true,
      "78774": true,
      "78775": true,
      "78776": true,
      "78777": true,
      "78778": true,
      "78779": true,
      "78780": true,
      "78781": true,
      "78782": true,
      "78783": true,
      "78784": true,
      "78785": true,
      "78786": true,
      "78787": true,
      "78788": true,
      "78789": true,
      "78790": true,
      "78791": true,
      "78792": true,
      "78796": true,
      "78797": true,
      "78798": true,
      "78799": true,
      "78800": true,
      "78801": true,
      "78802": true,
      "78803": true,
      "78804": true,
      "78805": true,
      "78806": true,
      "78807": true,
      "78810": true,
      "78811": true,
      "78812": true,
      "78813": true,
      "78814": true,
      "78815": true,
      "78816": true,
      "78817": true,
      "78818": true,
      "78819": true,
      "78821": true
    },
    "GUADALCAZAR": {
      "78880": true,
      "78881": true,
      "78882": true,
      "78884": true,
      "78885": true,
      "78893": true,
      "78897": true,
      "78898": true,
      "78899": true
    },
    "MOCTEZUMA": {
      "78900": true,
      "78901": true,
      "78902": true,
      "78903": true,
      "78904": true,
      "78905": true,
      "78906": true,
      "78907": true,
      "78908": true,
      "78910": true,
      "78914": true,
      "78915": true,
      "78916": true,
      "78917": true,
      "78919": true
    },
    "VENADO": {
      "78920": true,
      "78921": true,
      "78922": true,
      "78923": true,
      "78924": true,
      "78925": true,
      "78926": true,
      "78927": true,
      "78928": true,
      "78929": true,
      "78933": true,
      "78934": true,
      "78935": true,
      "78936": true,
      "78937": true,
      "78938": true,
      "78939": true
    },
    "VILLA DE ARISTA": {
      "78940": true,
      "78941": true,
      "78942": true,
      "78943": true,
      "78944": true,
      "78945": true,
      "78946": true,
      "78947": true,
      "78948": true,
      "78949": true,
      "78950": true,
      "78951": true,
      "78952": true,
      "78953": true,
      "78954": true,
      "78955": true,
      "78956": true,
      "78957": true
    },
    "VILLA HIDALGO": {
      "78960": true,
      "78961": true,
      "78962": true,
      "78963": true,
      "78964": true,
      "78965": true,
      "78966": true,
      "78967": true,
      "78968": true,
      "78969": true,
      "78970": true,
      "78971": true,
      "78972": true,
      "78973": true
    },
    "ARMADILLO DE LOS INFANTE": {
      "78980": true,
      "78981": true,
      "78982": true,
      "78984": true,
      "78985": true,
      "78986": true,
      "78987": true,
      "78988": true,
      "78989": true,
      "78990": true,
      "78991": true,
      "78992": true,
      "78993": true,
      "78994": true,
      "78995": true,
      "78996": true,
      "78997": true,
      "78998": true,
      "78999": true
    },
    "CIUDAD VALLES": {
      "79000": true,
      "79001": true,
      "79002": true,
      "79003": true,
      "79004": true,
      "79005": true,
      "79006": true,
      "79007": true,
      "79008": true,
      "79009": true,
      "79010": true,
      "79011": true,
      "79012": true,
      "79013": true,
      "79014": true,
      "79015": true,
      "79016": true,
      "79017": true,
      "79018": true,
      "79019": true,
      "79020": true,
      "79021": true,
      "79022": true,
      "79023": true,
      "79024": true,
      "79025": true,
      "79026": true,
      "79027": true,
      "79028": true,
      "79029": true,
      "79030": true,
      "79031": true,
      "79032": true,
      "79033": true,
      "79034": true,
      "79035": true,
      "79036": true,
      "79037": true,
      "79038": true,
      "79039": true,
      "79040": true,
      "79041": true,
      "79042": true,
      "79043": true,
      "79044": true,
      "79045": true,
      "79046": true,
      "79047": true,
      "79048": true,
      "79049": true,
      "79050": true,
      "79051": true,
      "79052": true,
      "79053": true,
      "79054": true,
      "79055": true,
      "79056": true,
      "79057": true,
      "79058": true,
      "79059": true,
      "79060": true,
      "79061": true,
      "79062": true,
      "79063": true,
      "79064": true,
      "79065": true,
      "79066": true,
      "79067": true,
      "79068": true,
      "79069": true,
      "79070": true,
      "79071": true,
      "79072": true,
      "79073": true,
      "79074": true,
      "79075": true,
      "79076": true,
      "79077": true,
      "79078": true,
      "79079": true,
      "79080": true,
      "79081": true,
      "79082": true,
      "79083": true,
      "79084": true,
      "79085": true,
      "79086": true,
      "79087": true,
      "79088": true,
      "79089": true,
      "79090": true,
      "79091": true,
      "79092": true,
      "79093": true,
      "79094": true,
      "79095": true,
      "79096": true,
      "79097": true,
      "79098": true,
      "79099": true,
      "79246": true,
      "79247": true,
      "79248": true,
      "79249": true,
      "79250": true,
      "79251": true,
      "79252": true,
      "79253": true,
      "79254": true,
      "79255": true,
      "79256": true,
      "79257": true,
      "79258": true,
      "79259": true,
      "79260": true,
      "79261": true,
      "79262": true,
      "79263": true,
      "79264": true,
      "79265": true,
      "79266": true,
      "79267": true,
      "79268": true,
      "79269": true,
      "79270": true,
      "79271": true,
      "79272": true,
      "79273": true,
      "79274": true,
      "79275": true,
      "79276": true,
      "79277": true,
      "79278": true,
      "79279": true,
      "79286": true,
      "79287": true,
      "79288": true,
      "79289": true
    },
    "EBANO": {
      "79100": true,
      "79101": true,
      "79102": true,
      "79103": true,
      "79104": true,
      "79105": true,
      "79106": true,
      "79107": true,
      "79108": true,
      "79109": true,
      "79110": true,
      "79111": true,
      "79112": true,
      "79113": true,
      "79114": true,
      "79115": true,
      "79116": true,
      "79117": true,
      "79118": true,
      "79119": true,
      "79120": true,
      "79121": true,
      "79122": true,
      "79123": true,
      "79124": true,
      "79125": true,
      "79126": true,
      "79127": true,
      "79128": true,
      "79129": true,
      "79130": true,
      "79131": true,
      "79132": true,
      "79133": true,
      "79134": true,
      "79135": true,
      "79136": true,
      "79137": true,
      "79138": true,
      "79139": true,
      "79140": true,
      "79141": true,
      "79142": true,
      "79143": true,
      "79144": true,
      "79145": true,
      "79146": true,
      "79147": true,
      "79148": true,
      "79149": true,
      "79150": true,
      "79151": true,
      "79152": true,
      "79153": true,
      "79154": true,
      "79155": true,
      "79156": true,
      "79157": true,
      "79158": true,
      "79159": true,
      "79160": true,
      "79161": true,
      "79162": true,
      "79163": true,
      "79164": true,
      "79165": true,
      "79166": true,
      "79167": true,
      "79168": true,
      "79169": true,
      "79170": true,
      "79171": true,
      "79172": true,
      "79173": true,
      "79174": true,
      "79175": true,
      "79176": true,
      "79177": true,
      "79178": true,
      "79179": true,
      "79180": true,
      "79181": true,
      "79182": true,
      "79183": true,
      "79184": true,
      "79185": true,
      "79186": true,
      "79187": true,
      "79188": true,
      "79189": true,
      "79190": true,
      "79191": true,
      "79192": true,
      "79193": true,
      "79194": true,
      "79195": true,
      "79196": true,
      "79197": true,
      "79198": true,
      "79199": true,
      "79293": true,
      "79296": true
    },
    "TAMUIN": {
      "79200": true,
      "79201": true,
      "79202": true,
      "79203": true,
      "79204": true,
      "79205": true,
      "79206": true,
      "79207": true,
      "79208": true,
      "79209": true,
      "79210": true,
      "79211": true,
      "79212": true,
      "79213": true,
      "79214": true,
      "79217": true,
      "79219": true,
      "79220": true,
      "79221": true,
      "79222": true,
      "79223": true,
      "79224": true,
      "79225": true,
      "79226": true,
      "79227": true,
      "79228": true,
      "79229": true
    },
    "CARDENAS": {
      "79380": true,
      "79381": true,
      "79382": true,
      "79383": true,
      "79384": true,
      "79385": true,
      "79386": true,
      "79387": true,
      "79388": true,
      "79389": true,
      "79390": true,
      "79391": true,
      "79392": true,
      "79393": true,
      "79394": true,
      "79395": true,
      "79397": true,
      "79398": true,
      "79399": true
    },
    "CERRITOS": {
      "79400": true,
      "79406": true,
      "79407": true,
      "79408": true,
      "79409": true,
      "79420": true,
      "79421": true,
      "79422": true,
      "79423": true,
      "79424": true,
      "79425": true,
      "79426": true,
      "79427": true,
      "79428": true,
      "79430": true,
      "79431": true,
      "79433": true,
      "79435": true,
      "79436": true,
      "79440": true,
      "79441": true,
      "79442": true,
      "79443": true,
      "79444": true,
      "79445": true,
      "79446": true,
      "79447": true,
      "79448": true,
      "79449": true
    },
    "SAN NICOLAS TOLENTINO": {
      "79480": true,
      "79481": true,
      "79482": true,
      "79483": true,
      "79484": true,
      "79485": true,
      "79486": true,
      "79490": true,
      "79491": true,
      "79492": true
    },
    "VILLA DE REYES": {
      "79500": true,
      "79501": true,
      "79502": true,
      "79503": true,
      "79504": true,
      "79505": true,
      "79506": true,
      "79507": true,
      "79510": true,
      "79513": true,
      "79514": true,
      "79515": true,
      "79516": true,
      "79517": true,
      "79518": true,
      "79519": true,
      "79521": true,
      "79522": true,
      "79523": true,
      "79524": true,
      "79525": true,
      "79526": true,
      "79527": true,
      "79528": true,
      "79529": true,
      "79530": true,
      "79531": true,
      "79532": true,
      "79533": true,
      "79534": true,
      "79535": true,
      "79536": true,
      "79537": true,
      "79538": true,
      "79539": true
    },
    "ZARAGOZA": {
      "79540": true,
      "79541": true,
      "79542": true,
      "79543": true,
      "79544": true,
      "79545": true,
      "79546": true,
      "79547": true,
      "79548": true,
      "79549": true,
      "79554": true,
      "79555": true,
      "79556": true,
      "79557": true,
      "79558": true,
      "79559": true
    },
    "SANTA MARIA DEL RIO": {
      "79560": true,
      "79561": true,
      "79562": true,
      "79563": true,
      "79564": true,
      "79565": true,
      "79566": true,
      "79567": true,
      "79568": true,
      "79581": true,
      "79582": true,
      "79583": true
    },
    "TIERRA NUEVA": {
      "79590": true,
      "79591": true,
      "79592": true,
      "79593": true,
      "79594": true,
      "79595": true,
      "79596": true
    },
    "RIOVERDE": {
      "79600": true,
      "79601": true,
      "79602": true,
      "79604": true,
      "79610": true,
      "79611": true,
      "79612": true,
      "79613": true,
      "79614": true,
      "79615": true,
      "79616": true,
      "79617": true,
      "79618": true,
      "79619": true,
      "79620": true,
      "79621": true,
      "79622": true,
      "79623": true,
      "79624": true,
      "79625": true,
      "79626": true,
      "79627": true,
      "79628": true,
      "79629": true,
      "79630": true,
      "79631": true,
      "79632": true,
      "79633": true,
      "79636": true,
      "79640": true,
      "79641": true,
      "79642": true,
      "79645": true
    },
    "CIUDAD FERNANDEZ": {
      "79650": true,
      "79651": true,
      "79652": true,
      "79653": true,
      "79654": true,
      "79655": true,
      "79657": true,
      "79658": true,
      "79659": true,
      "79660": true,
      "79661": true,
      "79662": true,
      "79676": true
    },
    "SAN VICENTE TANCUAYALAB": {
      "79820": true,
      "79821": true,
      "79823": true,
      "79824": true,
      "79825": true
    },
    "TANQUIAN DE ESCOBEDO": {
      "79840": true,
      "79841": true,
      "79842": true,
      "79843": true,
      "79844": true,
      "79845": true,
      "79846": true,
      "79847": true,
      "79848": true,
      "79849": true
    },
    "XILITLA": {
      "79900": true,
      "79901": true,
      "79902": true,
      "79903": true,
      "79904": true,
      "79905": true,
      "79906": true,
      "79907": true,
      "79908": true,
      "79909": true,
      "79910": true,
      "79911": true,
      "79912": true,
      "79913": true,
      "79914": true,
      "79915": true,
      "79916": true,
      "79917": true,
      "79918": true,
      "79919": true,
      "79920": true,
      "79921": true,
      "79922": true,
      "79923": true,
      "79924": true,
      "79925": true,
      "79926": true,
      "79927": true,
      "79928": true,
      "79929": true
    },
    "TAMAZUNCHALE": {
      "79960": true,
      "79961": true,
      "79980": true,
      "79981": true,
      "79982": true,
      "79983": true,
      "79985": true,
      "79986": true,
      "79987": true,
      "79988": true,
      "79989": true,
      "79991": true,
      "79992": true,
      "79993": true,
      "79994": true,
      "79995": true,
      "79996": true,
      "79997": true,
      "79998": true,
      "79999": true
    }
  },
  "SINALOA": {
    "CULIACÁN": {
      "80000": true,
      "80010": true,
      "80013": true,
      "80014": true,
      "80015": true,
      "80016": true,
      "80017": true,
      "80018": true,
      "80019": true,
      "80020": true,
      "80025": true,
      "80026": true,
      "80027": true,
      "80028": true,
      "80029": true,
      "80030": true,
      "80034": true,
      "80040": true,
      "80050": true,
      "80054": true,
      "80055": true,
      "80058": true,
      "80059": true,
      "80060": true,
      "80063": true,
      "80064": true,
      "80065": true,
      "80070": true,
      "80080": true,
      "80088": true,
      "80090": true,
      "80093": true,
      "80100": true,
      "80103": true,
      "80104": true,
      "80105": true,
      "80106": true,
      "80107": true,
      "80109": true,
      "80110": true,
      "80120": true,
      "80128": true,
      "80130": true,
      "80135": true,
      "80139": true,
      "80140": true,
      "80143": true,
      "80144": true,
      "80145": true,
      "80150": true,
      "80155": true,
      "80159": true,
      "80160": true,
      "80170": true,
      "80176": true,
      "80177": true,
      "80178": true,
      "80179": true,
      "80180": true,
      "80184": true,
      "80189": true,
      "80190": true,
      "80194": true,
      "80197": true,
      "80199": true,
      "80200": true,
      "80210": true,
      "80220": true,
      "80225": true,
      "80227": true,
      "80228": true,
      "80230": true,
      "80240": true,
      "80246": true,
      "80247": true,
      "80248": true,
      "80249": true,
      "80250": true,
      "80260": true,
      "80270": true,
      "80279": true,
      "80280": true,
      "80290": true,
      "80294": true,
      "80295": true,
      "80296": true,
      "80297": true,
      "80298": true,
      "80299": true,
      "80308": true
    },
    "MAZATLÁN": {
      "82000": true,
      "82010": true,
      "82013": true,
      "82014": true,
      "82015": true,
      "82016": true,
      "82017": true,
      "82018": true,
      "82019": true,
      "82020": true,
      "82028": true,
      "82030": true,
      "82035": true,
      "82037": true,
      "82038": true,
      "82040": true,
      "82043": true,
      "82047": true,
      "82050": true,
      "82059": true,
      "82060": true,
      "82070": true,
      "82080": true,
      "82089": true,
      "82090": true,
      "82099": true,
      "82100": true,
      "82102": true,
      "82103": true,
      "82110": true,
      "82112": true,
      "82113": true,
      "82118": true,
      "82120": true,
      "82123": true,
      "82124": true,
      "82125": true,
      "82126": true,
      "82127": true,
      "82128": true,
      "82129": true,
      "82130": true,
      "82132": true,
      "82133": true,
      "82134": true,
      "82136": true,
      "82137": true,
      "82138": true,
      "82139": true,
      "82140": true,
      "82143": true,
      "82144": true,
      "82146": true,
      "82147": true,
      "82148": true,
      "82149": true,
      "82150": true,
      "82153": true,
      "82154": true,
      "82155": true,
      "82156": true,
      "82157": true,
      "82158": true,
      "82159": true,
      "82160": true,
      "82163": true,
      "82164": true,
      "82165": true,
      "82170": true,
      "82180": true,
      "82183": true,
      "82185": true,
      "82186": true,
      "82187": true,
      "82188": true,
      "82190": true,
      "82195": true,
      "82197": true,
      "82198": true,
      "82199": true
    }
  },
  "SONORA": {
    "HERMOSILLO": {
      "83000": true,
      "83001": true,
      "83002": true,
      "83003": true,
      "83004": true,
      "83005": true,
      "83006": true,
      "83007": true,
      "83008": true,
      "83009": true,
      "83010": true,
      "83011": true,
      "83012": true,
      "83013": true,
      "83014": true,
      "83015": true,
      "83016": true,
      "83017": true,
      "83018": true,
      "83019": true,
      "83020": true,
      "83021": true,
      "83022": true,
      "83023": true,
      "83024": true,
      "83025": true,
      "83026": true,
      "83027": true,
      "83028": true,
      "83029": true,
      "83030": true,
      "83031": true,
      "83032": true,
      "83033": true,
      "83034": true,
      "83035": true,
      "83036": true,
      "83037": true,
      "83038": true,
      "83039": true,
      "83040": true,
      "83041": true,
      "83042": true,
      "83043": true,
      "83044": true,
      "83045": true,
      "83046": true,
      "83047": true,
      "83048": true,
      "83049": true,
      "83050": true,
      "83051": true,
      "83052": true,
      "83053": true,
      "83054": true,
      "83055": true,
      "83056": true,
      "83057": true,
      "83058": true,
      "83059": true,
      "83060": true,
      "83061": true,
      "83062": true,
      "83063": true,
      "83064": true,
      "83065": true,
      "83066": true,
      "83067": true,
      "83068": true,
      "83069": true,
      "83070": true,
      "83071": true,
      "83072": true,
      "83073": true,
      "83074": true,
      "83075": true,
      "83076": true,
      "83077": true,
      "83078": true,
      "83079": true,
      "83080": true,
      "83081": true,
      "83082": true,
      "83083": true,
      "83084": true,
      "83085": true,
      "83086": true,
      "83087": true,
      "83088": true,
      "83089": true,
      "83090": true,
      "83091": true,
      "83092": true,
      "83093": true,
      "83094": true,
      "83095": true,
      "83096": true,
      "83097": true,
      "83098": true,
      "83099": true,
      "83100": true,
      "83101": true,
      "83102": true,
      "83103": true,
      "83104": true,
      "83105": true,
      "83106": true,
      "83107": true,
      "83108": true,
      "83109": true,
      "83110": true,
      "83111": true,
      "83112": true,
      "83113": true,
      "83114": true,
      "83115": true,
      "83116": true,
      "83117": true,
      "83118": true,
      "83119": true,
      "83120": true,
      "83121": true,
      "83122": true,
      "83123": true,
      "83124": true,
      "83125": true,
      "83126": true,
      "83127": true,
      "83128": true,
      "83129": true,
      "83130": true,
      "83131": true,
      "83132": true,
      "83133": true,
      "83134": true,
      "83135": true,
      "83136": true,
      "83137": true,
      "83138": true,
      "83139": true,
      "83140": true,
      "83141": true,
      "83142": true,
      "83143": true,
      "83144": true,
      "83145": true,
      "83146": true,
      "83147": true,
      "83148": true,
      "83149": true,
      "83150": true,
      "83151": true,
      "83152": true,
      "83153": true,
      "83154": true,
      "83155": true,
      "83156": true,
      "83157": true,
      "83158": true,
      "83159": true,
      "83160": true,
      "83161": true,
      "83162": true,
      "83163": true,
      "83164": true,
      "83165": true,
      "83166": true,
      "83167": true,
      "83168": true,
      "83169": true,
      "83170": true,
      "83171": true,
      "83172": true,
      "83173": true,
      "83174": true,
      "83175": true,
      "83176": true,
      "83177": true,
      "83178": true,
      "83179": true,
      "83180": true,
      "83181": true,
      "83182": true,
      "83183": true,
      "83184": true,
      "83185": true,
      "83186": true,
      "83187": true,
      "83188": true,
      "83189": true,
      "83190": true,
      "83191": true,
      "83192": true,
      "83193": true,
      "83194": true,
      "83195": true,
      "83196": true,
      "83197": true,
      "83198": true,
      "83199": true,
      "83200": true,
      "83201": true,
      "83202": true,
      "83203": true,
      "83204": true,
      "83205": true,
      "83206": true,
      "83207": true,
      "83208": true,
      "83209": true,
      "83210": true,
      "83211": true,
      "83212": true,
      "83213": true,
      "83214": true,
      "83215": true,
      "83216": true,
      "83217": true,
      "83218": true,
      "83219": true,
      "83220": true,
      "83221": true,
      "83222": true,
      "83223": true,
      "83224": true,
      "83225": true,
      "83226": true,
      "83227": true,
      "83228": true,
      "83229": true,
      "83230": true,
      "83231": true,
      "83232": true,
      "83233": true,
      "83234": true,
      "83235": true,
      "83236": true,
      "83237": true,
      "83238": true,
      "83239": true,
      "83240": true,
      "83241": true,
      "83242": true,
      "83243": true,
      "83244": true,
      "83245": true,
      "83246": true,
      "83247": true,
      "83248": true,
      "83249": true,
      "83250": true,
      "83251": true,
      "83252": true,
      "83253": true,
      "83254": true,
      "83255": true,
      "83256": true,
      "83257": true,
      "83258": true,
      "83259": true,
      "83260": true,
      "83261": true,
      "83262": true,
      "83263": true,
      "83264": true,
      "83265": true,
      "83266": true,
      "83267": true,
      "83268": true,
      "83269": true,
      "83270": true,
      "83271": true,
      "83272": true,
      "83273": true,
      "83274": true,
      "83275": true,
      "83276": true,
      "83277": true,
      "83278": true,
      "83279": true,
      "83280": true,
      "83281": true,
      "83282": true,
      "83283": true,
      "83284": true,
      "83285": true,
      "83286": true,
      "83287": true,
      "83288": true,
      "83289": true,
      "83290": true,
      "83291": true,
      "83292": true,
      "83293": true,
      "83294": true,
      "83295": true,
      "83296": true,
      "83297": true,
      "83298": true,
      "83299": true,
      "83300": true,
      "83301": true,
      "83302": true,
      "83303": true,
      "83304": true,
      "83305": true,
      "83306": true,
      "83307": true,
      "83308": true,
      "83309": true,
      "83310": true,
      "83311": true,
      "83312": true,
      "83313": true,
      "83314": true,
      "83315": true,
      "83316": true,
      "83317": true,
      "83318": true,
      "83319": true,
      "83320": true,
      "83321": true,
      "83322": true,
      "83323": true,
      "83324": true,
      "83325": true,
      "83326": true,
      "83327": true,
      "83328": true,
      "83329": true,
      "83330": true,
      "83331": true,
      "83332": true,
      "83333": true,
      "83334": true,
      "83335": true,
      "83336": true,
      "83337": true,
      "83338": true,
      "83339": true,
      "83340": true,
      "83341": true,
      "83342": true,
      "83343": true,
      "83344": true,
      "83345": true,
      "83346": true,
      "83347": true,
      "83348": true,
      "83349": true,
      "83350": true,
      "83351": true,
      "83352": true,
      "83353": true,
      "83354": true,
      "83355": true,
      "83356": true,
      "83357": true,
      "83358": true,
      "83359": true
    },
    "SAN MIGUEL DE HORCASITAS": {
      "83360": true,
      "83361": true,
      "83362": true,
      "83365": true,
      "83366": true,
      "83367": true,
      "83368": true,
      "83369": true,
      "83373": true,
      "83374": true,
      "83375": true,
      "83376": true,
      "83377": true,
      "83378": true,
      "83379": true
    },
    "CARBO": {
      "83380": true,
      "83381": true,
      "83382": true,
      "83383": true,
      "83384": true,
      "83385": true,
      "83386": true,
      "83387": true,
      "83388": true,
      "83389": true,
      "83393": true,
      "83394": true,
      "83395": true,
      "83396": true,
      "83398": true,
      "83399": true
    },
    "SAN LUIS RIO COLORADO": {
      "83400": true,
      "83401": true,
      "83402": true,
      "83403": true,
      "83404": true,
      "83405": true,
      "83406": true,
      "83407": true,
      "83408": true,
      "83409": true,
      "83410": true,
      "83411": true,
      "83412": true,
      "83413": true,
      "83414": true,
      "83415": true,
      "83416": true,
      "83417": true,
      "83418": true,
      "83419": true,
      "83420": true,
      "83421": true,
      "83422": true,
      "83423": true,
      "83424": true,
      "83425": true,
      "83426": true,
      "83427": true,
      "83428": true,
      "83429": true,
      "83430": true,
      "83431": true,
      "83432": true,
      "83433": true,
      "83434": true,
      "83435": true,
      "83436": true,
      "83437": true,
      "83438": true,
      "83439": true,
      "83440": true,
      "83441": true,
      "83442": true,
      "83443": true,
      "83444": true,
      "83445": true,
      "83446": true,
      "83447": true,
      "83448": true,
      "83449": true,
      "83450": true,
      "83451": true,
      "83452": true,
      "83453": true,
      "83454": true,
      "83455": true,
      "83456": true,
      "83457": true,
      "83458": true,
      "83459": true,
      "83460": true,
      "83461": true,
      "83462": true,
      "83463": true,
      "83464": true,
      "83465": true,
      "83466": true,
      "83467": true,
      "83468": true,
      "83469": true,
      "83470": true,
      "83471": true,
      "83472": true,
      "83473": true,
      "83474": true,
      "83475": true,
      "83476": true,
      "83477": true,
      "83478": true,
      "83479": true,
      "83480": true,
      "83481": true,
      "83482": true,
      "83483": true,
      "83484": true,
      "83485": true,
      "83486": true,
      "83487": true,
      "83488": true,
      "83489": true,
      "83490": true,
      "83491": true,
      "83492": true,
      "83493": true,
      "83494": true,
      "83495": true,
      "83496": true,
      "83497": true,
      "83498": true,
      "83499": true,
      "83500": true,
      "83501": true,
      "83502": true,
      "83503": true,
      "83504": true,
      "83505": true,
      "83506": true,
      "83507": true,
      "83508": true,
      "83509": true,
      "83513": true,
      "83515": true,
      "83516": true,
      "83517": true,
      "83518": true,
      "83519": true
    },
    "CABORCA": {
      "83600": true,
      "83601": true,
      "83602": true,
      "83603": true,
      "83604": true,
      "83605": true,
      "83606": true,
      "83607": true,
      "83608": true,
      "83609": true,
      "83610": true,
      "83611": true,
      "83612": true,
      "83613": true,
      "83614": true,
      "83615": true,
      "83616": true,
      "83617": true,
      "83618": true,
      "83619": true,
      "83620": true,
      "83621": true,
      "83622": true,
      "83623": true,
      "83624": true,
      "83625": true,
      "83626": true,
      "83627": true,
      "83628": true,
      "83629": true,
      "83630": true,
      "83631": true,
      "83632": true,
      "83633": true,
      "83634": true,
      "83635": true,
      "83636": true,
      "83637": true,
      "83638": true,
      "83639": true,
      "83640": true,
      "83641": true,
      "83642": true,
      "83643": true,
      "83644": true,
      "83645": true,
      "83646": true,
      "83647": true,
      "83648": true,
      "83649": true,
      "83650": true,
      "83651": true,
      "83652": true,
      "83653": true,
      "83654": true,
      "83655": true,
      "83656": true,
      "83657": true,
      "83658": true,
      "83659": true,
      "83660": true,
      "83661": true,
      "83662": true,
      "83663": true,
      "83664": true,
      "83665": true,
      "83666": true,
      "83667": true,
      "83668": true,
      "83669": true,
      "83670": true,
      "83671": true,
      "83672": true,
      "83673": true,
      "83674": true,
      "83675": true,
      "83676": true,
      "83677": true,
      "83678": true,
      "83679": true,
      "83680": true,
      "83681": true,
      "83682": true,
      "83683": true,
      "83684": true,
      "83685": true,
      "83686": true,
      "83687": true,
      "83688": true,
      "83689": true,
      "83690": true,
      "83691": true,
      "83692": true,
      "83693": true,
      "83694": true,
      "83695": true,
      "83696": true,
      "83697": true,
      "83698": true,
      "83699": true,
      "83700": true,
      "83701": true,
      "83702": true,
      "83703": true,
      "83704": true,
      "83705": true,
      "83723": true,
      "83727": true,
      "83728": true,
      "83729": true
    },
    "NOGALES": {
      "84000": true,
      "84001": true,
      "84002": true,
      "84003": true,
      "84004": true,
      "84005": true,
      "84006": true,
      "84007": true,
      "84008": true,
      "84009": true,
      "84010": true,
      "84011": true,
      "84012": true,
      "84013": true,
      "84014": true,
      "84015": true,
      "84016": true,
      "84017": true,
      "84018": true,
      "84019": true,
      "84020": true,
      "84021": true,
      "84022": true,
      "84023": true,
      "84024": true,
      "84025": true,
      "84026": true,
      "84027": true,
      "84028": true,
      "84029": true,
      "84030": true,
      "84031": true,
      "84032": true,
      "84033": true,
      "84034": true,
      "84035": true,
      "84036": true,
      "84037": true,
      "84038": true,
      "84039": true,
      "84040": true,
      "84041": true,
      "84042": true,
      "84043": true,
      "84044": true,
      "84045": true,
      "84046": true,
      "84047": true,
      "84048": true,
      "84049": true,
      "84050": true,
      "84051": true,
      "84052": true,
      "84053": true,
      "84054": true,
      "84055": true,
      "84056": true,
      "84057": true,
      "84058": true,
      "84059": true,
      "84060": true,
      "84061": true,
      "84062": true,
      "84063": true,
      "84064": true,
      "84065": true,
      "84066": true,
      "84067": true,
      "84068": true,
      "84069": true,
      "84070": true,
      "84071": true,
      "84072": true,
      "84073": true,
      "84074": true,
      "84075": true,
      "84076": true,
      "84077": true,
      "84078": true,
      "84079": true,
      "84080": true,
      "84081": true,
      "84082": true,
      "84083": true,
      "84084": true,
      "84085": true,
      "84086": true,
      "84087": true,
      "84088": true,
      "84089": true,
      "84090": true,
      "84091": true,
      "84092": true,
      "84093": true,
      "84094": true,
      "84095": true,
      "84096": true,
      "84097": true,
      "84098": true,
      "84099": true,
      "84100": true,
      "84101": true,
      "84102": true,
      "84103": true,
      "84105": true,
      "84107": true,
      "84113": true,
      "84114": true,
      "84115": true
    },
    "MAGDALENA": {
      "84160": true,
      "84161": true,
      "84162": true,
      "84163": true,
      "84164": true,
      "84165": true,
      "84166": true,
      "84167": true,
      "84168": true,
      "84169": true,
      "84170": true,
      "84171": true,
      "84172": true,
      "84173": true,
      "84175": true
    },
    "CANANEA": {
      "84620": true,
      "84621": true,
      "84622": true,
      "84623": true,
      "84624": true,
      "84625": true,
      "84626": true,
      "84627": true,
      "84628": true,
      "84629": true,
      "84630": true,
      "84631": true,
      "84632": true,
      "84633": true,
      "84635": true,
      "84636": true
    },
    "CAJEME": {
      "85000": true,
      "85001": true,
      "85002": true,
      "85003": true,
      "85004": true,
      "85005": true,
      "85006": true,
      "85007": true,
      "85008": true,
      "85009": true,
      "85010": true,
      "85011": true,
      "85012": true,
      "85013": true,
      "85014": true,
      "85015": true,
      "85016": true,
      "85017": true,
      "85018": true,
      "85019": true,
      "85020": true,
      "85021": true,
      "85022": true,
      "85023": true,
      "85024": true,
      "85025": true,
      "85026": true,
      "85027": true,
      "85028": true,
      "85029": true,
      "85030": true,
      "85031": true,
      "85032": true,
      "85033": true,
      "85034": true,
      "85035": true,
      "85036": true,
      "85037": true,
      "85038": true,
      "85039": true,
      "85040": true,
      "85041": true,
      "85042": true,
      "85043": true,
      "85044": true,
      "85045": true,
      "85046": true,
      "85047": true,
      "85048": true,
      "85049": true,
      "85050": true,
      "85051": true,
      "85052": true,
      "85053": true,
      "85054": true,
      "85055": true,
      "85056": true,
      "85057": true,
      "85058": true,
      "85059": true,
      "85060": true,
      "85061": true,
      "85062": true,
      "85063": true,
      "85064": true,
      "85065": true,
      "85066": true,
      "85067": true,
      "85068": true,
      "85069": true,
      "85070": true,
      "85071": true,
      "85072": true,
      "85073": true,
      "85074": true,
      "85075": true,
      "85076": true,
      "85077": true,
      "85078": true,
      "85079": true,
      "85080": true,
      "85081": true,
      "85082": true,
      "85083": true,
      "85084": true,
      "85085": true,
      "85086": true,
      "85087": true,
      "85088": true,
      "85089": true,
      "85090": true,
      "85091": true,
      "85092": true,
      "85093": true,
      "85094": true,
      "85095": true,
      "85096": true,
      "85097": true,
      "85098": true,
      "85099": true,
      "85100": true,
      "85101": true,
      "85102": true,
      "85103": true,
      "85104": true,
      "85105": true,
      "85106": true,
      "85107": true,
      "85108": true,
      "85109": true,
      "85110": true,
      "85111": true,
      "85112": true,
      "85113": true,
      "85114": true,
      "85115": true,
      "85116": true,
      "85117": true,
      "85118": true,
      "85119": true,
      "85120": true,
      "85121": true,
      "85122": true,
      "85123": true,
      "85124": true,
      "85125": true,
      "85126": true,
      "85127": true,
      "85128": true,
      "85129": true,
      "85130": true,
      "85131": true,
      "85132": true,
      "85133": true,
      "85134": true,
      "85135": true,
      "85136": true,
      "85137": true,
      "85138": true,
      "85139": true,
      "85140": true,
      "85141": true,
      "85142": true,
      "85143": true,
      "85144": true,
      "85145": true,
      "85146": true,
      "85147": true,
      "85148": true,
      "85149": true,
      "85150": true,
      "85151": true,
      "85152": true,
      "85153": true,
      "85154": true,
      "85155": true,
      "85156": true,
      "85157": true,
      "85158": true,
      "85159": true,
      "85160": true,
      "85161": true,
      "85162": true,
      "85163": true,
      "85164": true,
      "85165": true,
      "85166": true,
      "85167": true,
      "85168": true,
      "85169": true,
      "85170": true,
      "85171": true,
      "85172": true,
      "85173": true,
      "85174": true,
      "85175": true,
      "85176": true,
      "85177": true,
      "85178": true,
      "85179": true,
      "85180": true,
      "85181": true,
      "85182": true,
      "85183": true,
      "85184": true,
      "85185": true,
      "85186": true,
      "85187": true,
      "85188": true,
      "85189": true,
      "85190": true,
      "85191": true,
      "85192": true,
      "85193": true,
      "85194": true,
      "85195": true,
      "85196": true,
      "85197": true,
      "85198": true,
      "85199": true,
      "85200": true,
      "85201": true,
      "85202": true,
      "85203": true,
      "85204": true,
      "85210": true,
      "85211": true,
      "85215": true,
      "85216": true,
      "85218": true,
      "85219": true
    },
    "NAVOJOA": {
      "85224": true,
      "85225": true,
      "85226": true,
      "85228": true,
      "85229": true,
      "85230": true,
      "85231": true,
      "85235": true,
      "85238": true,
      "85239": true,
      "85800": true,
      "85801": true,
      "85802": true,
      "85803": true,
      "85804": true,
      "85805": true,
      "85806": true,
      "85807": true,
      "85808": true,
      "85809": true,
      "85810": true,
      "85811": true,
      "85812": true,
      "85813": true,
      "85814": true,
      "85815": true,
      "85816": true,
      "85817": true,
      "85818": true,
      "85819": true,
      "85820": true,
      "85821": true,
      "85822": true,
      "85823": true,
      "85824": true,
      "85825": true,
      "85826": true,
      "85827": true,
      "85828": true,
      "85829": true,
      "85830": true,
      "85831": true,
      "85832": true,
      "85833": true,
      "85834": true,
      "85835": true,
      "85836": true,
      "85837": true,
      "85838": true,
      "85839": true,
      "85840": true,
      "85841": true,
      "85842": true,
      "85843": true,
      "85844": true,
      "85845": true,
      "85846": true,
      "85847": true,
      "85848": true,
      "85849": true,
      "85850": true,
      "85851": true,
      "85852": true,
      "85853": true,
      "85854": true,
      "85855": true,
      "85856": true,
      "85857": true,
      "85858": true,
      "85859": true,
      "85860": true,
      "85861": true,
      "85862": true,
      "85863": true,
      "85864": true,
      "85865": true,
      "85866": true,
      "85867": true,
      "85868": true,
      "85869": true,
      "85870": true,
      "85871": true,
      "85872": true,
      "85873": true,
      "85874": true,
      "85875": true,
      "85876": true,
      "85877": true,
      "85878": true,
      "85879": true,
      "85880": true,
      "85881": true,
      "85882": true,
      "85883": true,
      "85884": true,
      "85885": true,
      "85886": true,
      "85887": true,
      "85888": true,
      "85889": true,
      "85890": true,
      "85891": true,
      "85892": true,
      "85893": true,
      "85894": true,
      "85895": true,
      "85896": true,
      "85897": true,
      "85898": true,
      "85899": true
    },
    "HUATABAMPO": {
      "85240": true,
      "85241": true,
      "85242": true,
      "85243": true,
      "85244": true,
      "85245": true,
      "85246": true,
      "85247": true,
      "85248": true,
      "85249": true,
      "85251": true,
      "85900": true,
      "85901": true,
      "85902": true,
      "85903": true,
      "85904": true,
      "85905": true,
      "85906": true,
      "85907": true,
      "85908": true,
      "85909": true,
      "85910": true,
      "85911": true,
      "85912": true,
      "85913": true,
      "85914": true,
      "85915": true,
      "85916": true,
      "85917": true,
      "85918": true,
      "85919": true,
      "85920": true,
      "85921": true,
      "85922": true,
      "85923": true,
      "85924": true,
      "85925": true,
      "85926": true,
      "85927": true,
      "85928": true,
      "85929": true,
      "85930": true,
      "85931": true,
      "85932": true,
      "85933": true,
      "85934": true,
      "85935": true,
      "85936": true,
      "85937": true,
      "85938": true,
      "85939": true,
      "85940": true,
      "85941": true,
      "85942": true,
      "85943": true,
      "85944": true,
      "85945": true,
      "85946": true,
      "85947": true,
      "85948": true,
      "85949": true,
      "85950": true,
      "85951": true,
      "85952": true,
      "85953": true,
      "85954": true,
      "85955": true,
      "85956": true,
      "85957": true,
      "85958": true,
      "85959": true,
      "85960": true,
      "85961": true,
      "85962": true,
      "85963": true,
      "85964": true,
      "85965": true,
      "85966": true,
      "85967": true,
      "85968": true,
      "85969": true,
      "85970": true,
      "85971": true,
      "85972": true,
      "85973": true,
      "85974": true,
      "85975": true,
      "85976": true,
      "85977": true,
      "85978": true,
      "85979": true,
      "85980": true,
      "85981": true,
      "85982": true,
      "85983": true,
      "85984": true,
      "85985": true,
      "85986": true,
      "85987": true,
      "85988": true,
      "85989": true,
      "85990": true,
      "85991": true,
      "85992": true,
      "85993": true,
      "85994": true,
      "85995": true,
      "85996": true,
      "85997": true,
      "85998": true,
      "85999": true
    },
    "BACUM": {
      "85260": true,
      "85261": true,
      "85262": true,
      "85263": true,
      "85264": true,
      "85265": true,
      "85266": true,
      "85267": true,
      "85268": true,
      "85269": true,
      "85270": true,
      "85271": true,
      "85272": true,
      "85273": true,
      "85274": true,
      "85275": true,
      "85276": true
    },
    "ETCHOJOA": {
      "85280": true,
      "85281": true,
      "85282": true,
      "85285": true,
      "85286": true,
      "85287": true
    },
    "BENITO JUÁREZ": {
      "85290": true,
      "85291": true,
      "85292": true,
      "85293": true,
      "85294": true,
      "85295": true,
      "85296": true,
      "85297": true,
      "85298": true,
      "85299": true
    },
    "EMPALME": {
      "85300": true,
      "85301": true,
      "85302": true,
      "85303": true,
      "85304": true,
      "85305": true,
      "85306": true,
      "85307": true,
      "85308": true,
      "85309": true,
      "85310": true,
      "85311": true,
      "85312": true,
      "85313": true,
      "85314": true,
      "85315": true,
      "85316": true,
      "85317": true,
      "85318": true,
      "85319": true,
      "85320": true,
      "85321": true,
      "85322": true,
      "85323": true,
      "85324": true,
      "85325": true,
      "85326": true,
      "85327": true,
      "85328": true,
      "85329": true,
      "85330": true,
      "85331": true,
      "85332": true,
      "85333": true,
      "85334": true,
      "85335": true,
      "85336": true,
      "85337": true,
      "85338": true,
      "85339": true,
      "85340": true,
      "85341": true,
      "85342": true,
      "85343": true,
      "85344": true,
      "85345": true,
      "85346": true,
      "85347": true,
      "85348": true,
      "85349": true,
      "85350": true,
      "85351": true,
      "85352": true,
      "85353": true,
      "85354": true,
      "85355": true,
      "85356": true,
      "85357": true,
      "85358": true,
      "85359": true,
      "85360": true,
      "85361": true,
      "85362": true,
      "85363": true,
      "85364": true,
      "85365": true,
      "85366": true,
      "85367": true,
      "85368": true,
      "85369": true,
      "85370": true,
      "85371": true,
      "85372": true,
      "85373": true,
      "85374": true,
      "85375": true,
      "85376": true,
      "85377": true,
      "85378": true,
      "85379": true,
      "85380": true,
      "85381": true,
      "85382": true,
      "85383": true,
      "85384": true,
      "85385": true,
      "85386": true,
      "85387": true,
      "85388": true,
      "85389": true,
      "85390": true,
      "85391": true,
      "85392": true,
      "85393": true,
      "85394": true,
      "85395": true,
      "85396": true,
      "85397": true,
      "85398": true,
      "85399": true,
      "85520": true,
      "85521": true,
      "85522": true,
      "85523": true,
      "85524": true,
      "85526": true,
      "85527": true,
      "85528": true,
      "85529": true,
      "85530": true,
      "85531": true,
      "85532": true,
      "85533": true,
      "85534": true,
      "85535": true,
      "85536": true
    },
    "GUAYMAS": {
      "85400": true,
      "85401": true,
      "85402": true,
      "85403": true,
      "85404": true,
      "85405": true,
      "85406": true,
      "85407": true,
      "85408": true,
      "85409": true,
      "85410": true,
      "85411": true,
      "85412": true,
      "85413": true,
      "85414": true,
      "85415": true,
      "85416": true,
      "85417": true,
      "85418": true,
      "85419": true,
      "85420": true,
      "85421": true,
      "85422": true,
      "85423": true,
      "85424": true,
      "85425": true,
      "85426": true,
      "85427": true,
      "85428": true,
      "85429": true,
      "85430": true,
      "85431": true,
      "85432": true,
      "85433": true,
      "85434": true,
      "85435": true,
      "85436": true,
      "85437": true,
      "85438": true,
      "85439": true,
      "85440": true,
      "85441": true,
      "85442": true,
      "85443": true,
      "85444": true,
      "85445": true,
      "85446": true,
      "85447": true,
      "85448": true,
      "85449": true,
      "85450": true,
      "85451": true,
      "85452": true,
      "85453": true,
      "85454": true,
      "85455": true,
      "85456": true,
      "85457": true,
      "85458": true,
      "85459": true,
      "85460": true,
      "85461": true,
      "85462": true,
      "85463": true,
      "85464": true,
      "85465": true,
      "85466": true,
      "85467": true,
      "85468": true,
      "85469": true,
      "85470": true,
      "85471": true,
      "85472": true,
      "85473": true,
      "85474": true,
      "85475": true,
      "85476": true,
      "85477": true,
      "85478": true,
      "85479": true,
      "85480": true,
      "85481": true,
      "85482": true,
      "85483": true,
      "85484": true,
      "85485": true,
      "85486": true,
      "85487": true,
      "85488": true,
      "85489": true,
      "85490": true,
      "85491": true,
      "85492": true,
      "85493": true,
      "85494": true,
      "85495": true,
      "85496": true,
      "85497": true,
      "85498": true,
      "85499": true,
      "85500": true,
      "85501": true,
      "85502": true,
      "85503": true,
      "85504": true,
      "85505": true,
      "85506": true,
      "85510": true,
      "85511": true,
      "85512": true
    },
    "SAN IGNACIO RIO MUERTO": {
      "85514": true,
      "85515": true,
      "85516": true,
      "85517": true
    },
    "LA COLORADA": {
      "85540": true,
      "85541": true,
      "85542": true,
      "85543": true,
      "85544": true,
      "85545": true,
      "85546": true,
      "85547": true,
      "85548": true
    },
    "MAZATAN": {
      "85560": true,
      "85561": true,
      "85562": true,
      "85563": true,
      "85564": true,
      "85565": true,
      "85566": true,
      "85567": true,
      "85568": true,
      "85569": true,
      "85570": true,
      "85571": true,
      "85572": true,
      "85573": true,
      "85574": true,
      "85575": true,
      "85576": true,
      "85577": true,
      "85578": true,
      "85579": true
    }
  },
  "TAMAULIPAS": {
    "VICTORIA": {
      "87000": true,
      "87001": true,
      "87002": true,
      "87003": true,
      "87004": true,
      "87005": true,
      "87006": true,
      "87007": true,
      "87008": true,
      "87009": true,
      "87010": true,
      "87011": true,
      "87012": true,
      "87013": true,
      "87014": true,
      "87015": true,
      "87016": true,
      "87017": true,
      "87018": true,
      "87019": true,
      "87020": true,
      "87021": true,
      "87022": true,
      "87023": true,
      "87024": true,
      "87025": true,
      "87026": true,
      "87027": true,
      "87028": true,
      "87029": true,
      "87030": true,
      "87031": true,
      "87032": true,
      "87033": true,
      "87034": true,
      "87035": true,
      "87036": true,
      "87037": true,
      "87038": true,
      "87039": true,
      "87040": true,
      "87041": true,
      "87042": true,
      "87043": true,
      "87044": true,
      "87045": true,
      "87046": true,
      "87047": true,
      "87048": true,
      "87049": true,
      "87050": true,
      "87051": true,
      "87052": true,
      "87053": true,
      "87054": true,
      "87055": true,
      "87056": true,
      "87057": true,
      "87058": true,
      "87059": true,
      "87060": true,
      "87061": true,
      "87062": true,
      "87063": true,
      "87064": true,
      "87065": true,
      "87066": true,
      "87067": true,
      "87068": true,
      "87069": true,
      "87070": true,
      "87071": true,
      "87072": true,
      "87073": true,
      "87074": true,
      "87075": true,
      "87076": true,
      "87077": true,
      "87078": true,
      "87079": true,
      "87080": true,
      "87081": true,
      "87082": true,
      "87083": true,
      "87084": true,
      "87085": true,
      "87086": true,
      "87087": true,
      "87088": true,
      "87089": true,
      "87090": true,
      "87091": true,
      "87092": true,
      "87093": true,
      "87094": true,
      "87095": true,
      "87096": true,
      "87097": true,
      "87098": true,
      "87099": true,
      "87100": true,
      "87101": true,
      "87102": true,
      "87103": true,
      "87104": true,
      "87105": true,
      "87106": true,
      "87107": true,
      "87108": true,
      "87109": true,
      "87110": true,
      "87111": true,
      "87112": true,
      "87113": true,
      "87114": true,
      "87115": true,
      "87116": true,
      "87117": true,
      "87118": true,
      "87119": true,
      "87120": true,
      "87121": true,
      "87122": true,
      "87123": true,
      "87124": true,
      "87125": true,
      "87126": true,
      "87127": true,
      "87128": true,
      "87129": true,
      "87130": true,
      "87131": true,
      "87132": true,
      "87133": true,
      "87134": true,
      "87135": true,
      "87136": true,
      "87137": true,
      "87138": true,
      "87139": true,
      "87140": true,
      "87141": true,
      "87142": true,
      "87143": true,
      "87144": true,
      "87145": true,
      "87146": true,
      "87147": true,
      "87148": true,
      "87149": true,
      "87150": true,
      "87151": true,
      "87152": true,
      "87153": true,
      "87154": true,
      "87155": true,
      "87156": true,
      "87157": true,
      "87158": true,
      "87159": true,
      "87160": true,
      "87161": true,
      "87162": true,
      "87163": true,
      "87164": true,
      "87165": true,
      "87166": true,
      "87167": true,
      "87168": true,
      "87169": true,
      "87170": true,
      "87171": true,
      "87172": true,
      "87173": true,
      "87174": true,
      "87175": true,
      "87176": true,
      "87177": true,
      "87178": true,
      "87179": true,
      "87180": true,
      "87181": true,
      "87182": true,
      "87183": true,
      "87184": true,
      "87185": true,
      "87186": true,
      "87187": true,
      "87188": true,
      "87189": true,
      "87190": true,
      "87191": true,
      "87192": true,
      "87193": true,
      "87194": true,
      "87195": true,
      "87196": true,
      "87197": true,
      "87198": true,
      "87199": true,
      "87260": true,
      "87261": true,
      "87262": true,
      "87263": true,
      "87264": true,
      "87265": true,
      "87266": true,
      "87267": true,
      "87268": true,
      "87269": true,
      "87270": true,
      "87271": true,
      "87272": true,
      "87273": true,
      "87274": true,
      "87275": true,
      "87276": true,
      "87277": true,
      "87278": true,
      "87279": true,
      "87280": true,
      "87281": true,
      "87282": true,
      "87283": true,
      "87284": true,
      "87285": true,
      "87286": true,
      "87287": true,
      "87288": true,
      "87289": true,
      "87290": true,
      "87291": true,
      "87292": true,
      "87293": true,
      "87294": true,
      "87295": true,
      "87296": true,
      "87297": true,
      "87298": true,
      "87299": true
    },
    "LLERA": {
      "87200": true,
      "87201": true,
      "87202": true,
      "87205": true,
      "87206": true,
      "87207": true,
      "87209": true,
      "87210": true,
      "87212": true,
      "87213": true,
      "87215": true,
      "87216": true,
      "87217": true,
      "87218": true,
      "87219": true,
      "87220": true,
      "87221": true,
      "87222": true
    },
    "CASAS": {
      "87250": true,
      "87251": true,
      "87252": true,
      "87254": true,
      "87258": true,
      "87259": true
    },
    "MATAMOROS": {
      "87300": true,
      "87301": true,
      "87302": true,
      "87303": true,
      "87304": true,
      "87305": true,
      "87306": true,
      "87307": true,
      "87308": true,
      "87309": true,
      "87310": true,
      "87311": true,
      "87312": true,
      "87313": true,
      "87314": true,
      "87315": true,
      "87316": true,
      "87317": true,
      "87318": true,
      "87319": true,
      "87320": true,
      "87321": true,
      "87322": true,
      "87323": true,
      "87324": true,
      "87325": true,
      "87326": true,
      "87327": true,
      "87328": true,
      "87329": true,
      "87330": true,
      "87331": true,
      "87332": true,
      "87333": true,
      "87334": true,
      "87335": true,
      "87336": true,
      "87337": true,
      "87338": true,
      "87339": true,
      "87340": true,
      "87341": true,
      "87342": true,
      "87343": true,
      "87344": true,
      "87345": true,
      "87346": true,
      "87347": true,
      "87348": true,
      "87349": true,
      "87350": true,
      "87351": true,
      "87352": true,
      "87353": true,
      "87354": true,
      "87355": true,
      "87356": true,
      "87357": true,
      "87358": true,
      "87359": true,
      "87360": true,
      "87361": true,
      "87362": true,
      "87363": true,
      "87364": true,
      "87365": true,
      "87366": true,
      "87367": true,
      "87368": true,
      "87369": true,
      "87370": true,
      "87371": true,
      "87372": true,
      "87373": true,
      "87374": true,
      "87375": true,
      "87376": true,
      "87377": true,
      "87378": true,
      "87379": true,
      "87380": true,
      "87381": true,
      "87382": true,
      "87383": true,
      "87384": true,
      "87385": true,
      "87386": true,
      "87387": true,
      "87388": true,
      "87389": true,
      "87390": true,
      "87391": true,
      "87392": true,
      "87393": true,
      "87394": true,
      "87395": true,
      "87396": true,
      "87397": true,
      "87398": true,
      "87399": true,
      "87400": true,
      "87401": true,
      "87402": true,
      "87403": true,
      "87404": true,
      "87405": true,
      "87406": true,
      "87407": true,
      "87408": true,
      "87409": true,
      "87410": true,
      "87411": true,
      "87412": true,
      "87413": true,
      "87414": true,
      "87415": true,
      "87416": true,
      "87417": true,
      "87418": true,
      "87419": true,
      "87420": true,
      "87421": true,
      "87422": true,
      "87423": true,
      "87424": true,
      "87425": true,
      "87426": true,
      "87427": true,
      "87428": true,
      "87429": true,
      "87430": true,
      "87431": true,
      "87432": true,
      "87433": true,
      "87434": true,
      "87435": true,
      "87436": true,
      "87437": true,
      "87438": true,
      "87439": true,
      "87440": true,
      "87441": true,
      "87442": true,
      "87443": true,
      "87444": true,
      "87445": true,
      "87446": true,
      "87447": true,
      "87448": true,
      "87449": true,
      "87450": true,
      "87451": true,
      "87452": true,
      "87453": true,
      "87454": true,
      "87455": true,
      "87456": true,
      "87457": true,
      "87458": true,
      "87459": true,
      "87460": true,
      "87461": true,
      "87462": true,
      "87463": true,
      "87464": true,
      "87465": true,
      "87466": true,
      "87467": true,
      "87468": true,
      "87469": true,
      "87470": true,
      "87471": true,
      "87472": true,
      "87473": true,
      "87474": true,
      "87475": true,
      "87476": true,
      "87477": true,
      "87478": true,
      "87479": true,
      "87480": true,
      "87481": true,
      "87482": true,
      "87483": true,
      "87484": true,
      "87485": true,
      "87486": true,
      "87487": true,
      "87488": true,
      "87489": true,
      "87490": true,
      "87491": true,
      "87492": true,
      "87493": true,
      "87494": true,
      "87495": true,
      "87496": true,
      "87497": true,
      "87498": true,
      "87499": true,
      "87540": true,
      "87541": true,
      "87542": true,
      "87543": true,
      "87544": true,
      "87545": true,
      "87546": true,
      "87547": true,
      "87548": true,
      "87549": true,
      "87550": true,
      "87551": true,
      "87552": true,
      "87553": true,
      "87554": true,
      "87555": true,
      "87556": true,
      "87557": true,
      "87558": true,
      "87559": true,
      "87560": true,
      "87561": true,
      "87562": true,
      "87563": true,
      "87564": true,
      "87565": true,
      "87566": true,
      "87567": true,
      "87568": true,
      "87569": true,
      "87570": true,
      "87571": true,
      "87572": true,
      "87573": true,
      "87574": true,
      "87575": true,
      "87576": true,
      "87577": true,
      "87578": true,
      "87579": true,
      "87580": true,
      "87581": true,
      "87582": true,
      "87583": true,
      "87584": true,
      "87585": true,
      "87586": true,
      "87587": true,
      "87588": true,
      "87589": true,
      "87590": true,
      "87591": true,
      "87592": true,
      "87593": true,
      "87594": true,
      "87595": true,
      "87596": true,
      "87597": true,
      "87598": true,
      "87599": true
    },
    "VALLE HERMOSO": {
      "87500": true,
      "87501": true,
      "87502": true,
      "87503": true,
      "87504": true,
      "87505": true,
      "87506": true,
      "87507": true,
      "87508": true,
      "87509": true,
      "87510": true,
      "87511": true,
      "87520": true,
      "87521": true,
      "87522": true,
      "87523": true,
      "87524": true,
      "87525": true,
      "87526": true,
      "87527": true,
      "87528": true,
      "87529": true,
      "87530": true,
      "87531": true,
      "87532": true,
      "87533": true,
      "87534": true,
      "87535": true,
      "87536": true,
      "87537": true,
      "87538": true,
      "87539": true
    },
    "SAN FERNANDO": {
      "87600": true,
      "87601": true,
      "87602": true,
      "87603": true,
      "87604": true,
      "87605": true,
      "87606": true,
      "87607": true,
      "87608": true,
      "87609": true,
      "87610": true,
      "87611": true,
      "87616": true,
      "87619": true,
      "87620": true,
      "87621": true,
      "87625": true,
      "87628": true,
      "87629": true,
      "87630": true,
      "87631": true,
      "87632": true,
      "87633": true,
      "87634": true,
      "87635": true
    },
    "SOTO LA MARINA": {
      "87670": true,
      "87671": true,
      "87672": true,
      "87675": true,
      "87678": true,
      "87690": true,
      "87691": true,
      "87692": true,
      "87693": true
    },
    "JIMENEZ": {
      "87700": true,
      "87701": true,
      "87702": true,
      "87703": true,
      "87704": true,
      "87705": true,
      "87706": true,
      "87707": true,
      "87708": true,
      "87710": true,
      "87711": true,
      "87712": true,
      "87720": true,
      "87721": true,
      "87722": true,
      "87723": true,
      "87724": true,
      "87725": true,
      "87726": true,
      "87727": true,
      "87728": true,
      "87729": true
    },
    "ABASOLO": {
      "87760": true,
      "87761": true,
      "87762": true,
      "87763": true,
      "87764": true,
      "87765": true,
      "87766": true,
      "87767": true,
      "87769": true,
      "87770": true,
      "87771": true,
      "87772": true,
      "87773": true,
      "87774": true,
      "87775": true,
      "87776": true,
      "87777": true,
      "87778": true,
      "87779": true
    },
    "PADILLA": {
      "87780": true,
      "87781": true,
      "87782": true,
      "87783": true,
      "87784": true,
      "87785": true,
      "87786": true,
      "87787": true,
      "87788": true,
      "87789": true,
      "87790": true,
      "87791": true,
      "87792": true,
      "87794": true,
      "87795": true,
      "87796": true,
      "87797": true,
      "87798": true,
      "87799": true
    },
    "HIDALGO": {
      "87800": true,
      "87801": true,
      "87802": true,
      "87803": true,
      "87804": true,
      "87805": true,
      "87806": true,
      "87807": true,
      "87808": true,
      "87809": true,
      "87810": true,
      "87811": true,
      "87812": true,
      "87816": true,
      "87817": true,
      "87818": true,
      "87819": true,
      "87822": true,
      "87823": true,
      "87824": true,
      "87825": true,
      "87826": true,
      "87827": true,
      "87828": true,
      "87829": true,
      "87830": true,
      "87834": true,
      "87835": true,
      "87836": true,
      "87837": true,
      "87838": true,
      "87839": true,
      "87843": true
    },
    "TULA": {
      "87900": true,
      "87901": true,
      "87902": true,
      "87904": true,
      "87906": true,
      "87907": true,
      "87908": true,
      "87909": true,
      "87911": true,
      "87912": true,
      "87913": true,
      "87914": true,
      "87915": true,
      "87916": true,
      "87917": true,
      "87918": true,
      "87919": true,
      "87920": true,
      "87921": true,
      "87928": true,
      "87929": true
    },
    "JAUMAVE": {
      "87930": true,
      "87931": true,
      "87932": true,
      "87933": true,
      "87934": true,
      "87936": true,
      "87937": true,
      "87939": true,
      "87940": true,
      "87941": true,
      "87942": true,
      "87943": true,
      "87944": true,
      "87945": true,
      "87946": true,
      "87947": true,
      "87948": true,
      "87949": true
    },
    "PALMILLAS": {
      "87970": true,
      "87971": true,
      "87972": true,
      "87973": true,
      "87974": true,
      "87975": true,
      "87976": true,
      "87977": true,
      "87978": true,
      "87979": true
    },
    "NUEVO LAREDO": {
      "88000": true,
      "88001": true,
      "88002": true,
      "88003": true,
      "88004": true,
      "88005": true,
      "88006": true,
      "88007": true,
      "88008": true,
      "88009": true,
      "88010": true,
      "88011": true,
      "88012": true,
      "88013": true,
      "88014": true,
      "88015": true,
      "88016": true,
      "88017": true,
      "88018": true,
      "88019": true,
      "88020": true,
      "88021": true,
      "88022": true,
      "88023": true,
      "88024": true,
      "88025": true,
      "88026": true,
      "88027": true,
      "88028": true,
      "88029": true,
      "88030": true,
      "88031": true,
      "88032": true,
      "88033": true,
      "88034": true,
      "88035": true,
      "88036": true,
      "88037": true,
      "88038": true,
      "88039": true,
      "88040": true,
      "88041": true,
      "88042": true,
      "88043": true,
      "88044": true,
      "88045": true,
      "88046": true,
      "88047": true,
      "88048": true,
      "88049": true,
      "88050": true,
      "88051": true,
      "88052": true,
      "88053": true,
      "88054": true,
      "88055": true,
      "88056": true,
      "88057": true,
      "88058": true,
      "88059": true,
      "88060": true,
      "88061": true,
      "88062": true,
      "88063": true,
      "88064": true,
      "88065": true,
      "88066": true,
      "88067": true,
      "88068": true,
      "88069": true,
      "88070": true,
      "88071": true,
      "88072": true,
      "88073": true,
      "88074": true,
      "88075": true,
      "88076": true,
      "88077": true,
      "88078": true,
      "88079": true,
      "88080": true,
      "88081": true,
      "88082": true,
      "88083": true,
      "88084": true,
      "88085": true,
      "88086": true,
      "88087": true,
      "88088": true,
      "88089": true,
      "88090": true,
      "88091": true,
      "88092": true,
      "88093": true,
      "88094": true,
      "88095": true,
      "88096": true,
      "88097": true,
      "88098": true,
      "88099": true,
      "88100": true,
      "88101": true,
      "88102": true,
      "88103": true,
      "88104": true,
      "88105": true,
      "88106": true,
      "88107": true,
      "88108": true,
      "88109": true,
      "88110": true,
      "88111": true,
      "88112": true,
      "88113": true,
      "88114": true,
      "88115": true,
      "88116": true,
      "88117": true,
      "88118": true,
      "88119": true,
      "88120": true,
      "88121": true,
      "88122": true,
      "88123": true,
      "88124": true,
      "88125": true,
      "88126": true,
      "88127": true,
      "88128": true,
      "88129": true,
      "88130": true,
      "88131": true,
      "88132": true,
      "88133": true,
      "88134": true,
      "88135": true,
      "88136": true,
      "88137": true,
      "88138": true,
      "88139": true,
      "88140": true,
      "88141": true,
      "88142": true,
      "88143": true,
      "88144": true,
      "88145": true,
      "88146": true,
      "88147": true,
      "88148": true,
      "88149": true,
      "88150": true,
      "88151": true,
      "88152": true,
      "88153": true,
      "88154": true,
      "88155": true,
      "88156": true,
      "88157": true,
      "88158": true,
      "88159": true,
      "88160": true,
      "88161": true,
      "88162": true,
      "88163": true,
      "88164": true,
      "88165": true,
      "88166": true,
      "88167": true,
      "88168": true,
      "88169": true,
      "88170": true,
      "88171": true,
      "88172": true,
      "88173": true,
      "88174": true,
      "88175": true,
      "88176": true,
      "88177": true,
      "88178": true,
      "88179": true,
      "88180": true,
      "88181": true,
      "88182": true,
      "88183": true,
      "88184": true,
      "88185": true,
      "88186": true,
      "88187": true,
      "88188": true,
      "88189": true,
      "88190": true,
      "88191": true,
      "88192": true,
      "88193": true,
      "88194": true,
      "88195": true,
      "88196": true,
      "88197": true,
      "88198": true,
      "88199": true,
      "88200": true,
      "88201": true,
      "88202": true,
      "88203": true,
      "88204": true,
      "88205": true,
      "88206": true,
      "88207": true,
      "88208": true,
      "88209": true,
      "88210": true,
      "88211": true,
      "88212": true,
      "88213": true,
      "88214": true,
      "88215": true,
      "88216": true,
      "88217": true,
      "88218": true,
      "88219": true,
      "88220": true,
      "88221": true,
      "88222": true,
      "88223": true,
      "88224": true,
      "88225": true,
      "88226": true,
      "88227": true,
      "88228": true,
      "88229": true,
      "88230": true,
      "88231": true,
      "88232": true,
      "88233": true,
      "88234": true,
      "88235": true,
      "88236": true,
      "88237": true,
      "88238": true,
      "88239": true,
      "88240": true,
      "88241": true,
      "88242": true,
      "88243": true,
      "88244": true,
      "88245": true,
      "88246": true,
      "88247": true,
      "88248": true,
      "88249": true,
      "88250": true,
      "88251": true,
      "88252": true,
      "88253": true,
      "88254": true,
      "88255": true,
      "88256": true,
      "88257": true,
      "88258": true,
      "88259": true,
      "88260": true,
      "88261": true,
      "88262": true,
      "88263": true,
      "88264": true,
      "88265": true,
      "88266": true,
      "88267": true,
      "88268": true,
      "88269": true,
      "88270": true,
      "88271": true,
      "88272": true,
      "88273": true,
      "88274": true,
      "88275": true,
      "88276": true,
      "88277": true,
      "88278": true,
      "88279": true,
      "88280": true,
      "88281": true,
      "88282": true,
      "88283": true,
      "88284": true,
      "88285": true,
      "88286": true,
      "88287": true,
      "88288": true,
      "88289": true,
      "88290": true,
      "88291": true,
      "88292": true,
      "88293": true,
      "88294": true,
      "88295": true,
      "88296": true,
      "88297": true,
      "88298": true,
      "88299": true,
      "88350": true,
      "88351": true,
      "88352": true,
      "88353": true,
      "88354": true,
      "88355": true,
      "88356": true,
      "88357": true,
      "88358": true,
      "88359": true,
      "88360": true,
      "88361": true,
      "88362": true,
      "88363": true,
      "88364": true,
      "88365": true,
      "88366": true,
      "88367": true,
      "88368": true,
      "88369": true
    },
    "MIGUEL ALEMAN": {
      "88300": true,
      "88301": true,
      "88302": true,
      "88303": true,
      "88304": true,
      "88305": true,
      "88306": true,
      "88307": true,
      "88308": true,
      "88309": true,
      "88310": true,
      "88311": true,
      "88312": true,
      "88313": true,
      "88314": true,
      "88315": true,
      "88316": true,
      "88317": true,
      "88318": true,
      "88319": true,
      "88320": true,
      "88321": true,
      "88322": true,
      "88323": true,
      "88324": true,
      "88325": true,
      "88326": true,
      "88327": true,
      "88328": true,
      "88329": true,
      "88338": true,
      "88339": true
    },
    "GUSTAVO DIAZ ORDAZ": {
      "88400": true,
      "88401": true,
      "88402": true,
      "88403": true,
      "88404": true,
      "88405": true,
      "88406": true,
      "88407": true,
      "88408": true,
      "88409": true,
      "88410": true,
      "88411": true,
      "88412": true,
      "88413": true,
      "88414": true,
      "88415": true,
      "88416": true,
      "88417": true,
      "88418": true,
      "88419": true,
      "88425": true,
      "88426": true,
      "88427": true,
      "88428": true,
      "88429": true,
      "88430": true,
      "88431": true,
      "88432": true,
      "88433": true,
      "88434": true,
      "88435": true,
      "88436": true,
      "88437": true,
      "88438": true,
      "88439": true
    },
    "CAMARGO": {
      "88440": true,
      "88441": true,
      "88442": true,
      "88443": true,
      "88444": true,
      "88445": true,
      "88446": true,
      "88447": true,
      "88448": true,
      "88449": true,
      "88450": true,
      "88451": true,
      "88452": true,
      "88453": true,
      "88454": true,
      "88455": true,
      "88456": true,
      "88457": true,
      "88458": true,
      "88459": true,
      "88460": true,
      "88461": true,
      "88462": true,
      "88463": true,
      "88464": true,
      "88465": true,
      "88466": true,
      "88467": true,
      "88468": true,
      "88470": true,
      "88471": true,
      "88472": true,
      "88473": true,
      "88474": true,
      "88475": true,
      "88476": true,
      "88477": true,
      "88478": true,
      "88479": true,
      "88490": true,
      "88491": true,
      "88492": true,
      "88493": true,
      "88494": true,
      "88495": true,
      "88496": true,
      "88497": true,
      "88498": true,
      "88499": true
    },
    "REYNOSA": {
      "88500": true,
      "88501": true,
      "88502": true,
      "88503": true,
      "88504": true,
      "88505": true,
      "88506": true,
      "88507": true,
      "88508": true,
      "88509": true,
      "88510": true,
      "88511": true,
      "88512": true,
      "88513": true,
      "88514": true,
      "88515": true,
      "88516": true,
      "88517": true,
      "88518": true,
      "88519": true,
      "88520": true,
      "88521": true,
      "88522": true,
      "88523": true,
      "88524": true,
      "88525": true,
      "88526": true,
      "88527": true,
      "88528": true,
      "88529": true,
      "88530": true,
      "88531": true,
      "88532": true,
      "88533": true,
      "88534": true,
      "88535": true,
      "88536": true,
      "88537": true,
      "88538": true,
      "88539": true,
      "88540": true,
      "88541": true,
      "88542": true,
      "88543": true,
      "88544": true,
      "88545": true,
      "88546": true,
      "88547": true,
      "88548": true,
      "88549": true,
      "88550": true,
      "88551": true,
      "88552": true,
      "88553": true,
      "88554": true,
      "88555": true,
      "88556": true,
      "88557": true,
      "88558": true,
      "88559": true,
      "88560": true,
      "88561": true,
      "88562": true,
      "88563": true,
      "88564": true,
      "88565": true,
      "88566": true,
      "88567": true,
      "88568": true,
      "88569": true,
      "88570": true,
      "88571": true,
      "88572": true,
      "88573": true,
      "88574": true,
      "88575": true,
      "88576": true,
      "88577": true,
      "88578": true,
      "88579": true,
      "88580": true,
      "88581": true,
      "88582": true,
      "88583": true,
      "88584": true,
      "88585": true,
      "88586": true,
      "88587": true,
      "88588": true,
      "88589": true,
      "88590": true,
      "88591": true,
      "88592": true,
      "88593": true,
      "88594": true,
      "88595": true,
      "88596": true,
      "88597": true,
      "88598": true,
      "88599": true,
      "88600": true,
      "88601": true,
      "88602": true,
      "88603": true,
      "88604": true,
      "88605": true,
      "88606": true,
      "88607": true,
      "88608": true,
      "88609": true,
      "88610": true,
      "88611": true,
      "88612": true,
      "88613": true,
      "88614": true,
      "88615": true,
      "88616": true,
      "88617": true,
      "88618": true,
      "88619": true,
      "88620": true,
      "88621": true,
      "88622": true,
      "88623": true,
      "88624": true,
      "88625": true,
      "88626": true,
      "88627": true,
      "88628": true,
      "88629": true,
      "88630": true,
      "88631": true,
      "88632": true,
      "88633": true,
      "88634": true,
      "88635": true,
      "88636": true,
      "88637": true,
      "88638": true,
      "88639": true,
      "88640": true,
      "88641": true,
      "88642": true,
      "88643": true,
      "88644": true,
      "88645": true,
      "88646": true,
      "88647": true,
      "88648": true,
      "88649": true,
      "88650": true,
      "88651": true,
      "88652": true,
      "88653": true,
      "88654": true,
      "88655": true,
      "88656": true,
      "88657": true,
      "88658": true,
      "88659": true,
      "88660": true,
      "88661": true,
      "88662": true,
      "88663": true,
      "88664": true,
      "88665": true,
      "88666": true,
      "88667": true,
      "88668": true,
      "88669": true,
      "88670": true,
      "88671": true,
      "88672": true,
      "88673": true,
      "88674": true,
      "88675": true,
      "88676": true,
      "88677": true,
      "88678": true,
      "88679": true,
      "88680": true,
      "88681": true,
      "88682": true,
      "88683": true,
      "88684": true,
      "88685": true,
      "88686": true,
      "88687": true,
      "88688": true,
      "88689": true,
      "88690": true,
      "88691": true,
      "88692": true,
      "88693": true,
      "88694": true,
      "88695": true,
      "88696": true,
      "88697": true,
      "88698": true,
      "88699": true,
      "88700": true,
      "88701": true,
      "88702": true,
      "88703": true,
      "88704": true,
      "88705": true,
      "88706": true,
      "88707": true,
      "88708": true,
      "88709": true,
      "88710": true,
      "88711": true,
      "88712": true,
      "88713": true,
      "88714": true,
      "88715": true,
      "88716": true,
      "88717": true,
      "88718": true,
      "88719": true,
      "88720": true,
      "88721": true,
      "88722": true,
      "88723": true,
      "88724": true,
      "88725": true,
      "88726": true,
      "88727": true,
      "88728": true,
      "88729": true,
      "88730": true,
      "88731": true,
      "88732": true,
      "88733": true,
      "88734": true,
      "88735": true,
      "88736": true,
      "88737": true,
      "88738": true,
      "88739": true,
      "88740": true,
      "88741": true,
      "88742": true,
      "88743": true,
      "88744": true,
      "88745": true,
      "88746": true,
      "88747": true,
      "88748": true,
      "88749": true,
      "88750": true,
      "88751": true,
      "88752": true,
      "88753": true,
      "88754": true,
      "88755": true,
      "88756": true,
      "88757": true,
      "88758": true,
      "88759": true,
      "88760": true,
      "88761": true,
      "88762": true,
      "88763": true,
      "88764": true,
      "88765": true,
      "88766": true,
      "88767": true,
      "88768": true,
      "88769": true,
      "88770": true,
      "88771": true,
      "88772": true,
      "88773": true,
      "88774": true,
      "88775": true,
      "88776": true,
      "88777": true,
      "88778": true,
      "88779": true,
      "88780": true,
      "88781": true,
      "88782": true,
      "88783": true,
      "88784": true,
      "88785": true,
      "88786": true,
      "88787": true,
      "88788": true,
      "88789": true,
      "88790": true,
      "88791": true,
      "88792": true,
      "88793": true,
      "88794": true,
      "88795": true,
      "88796": true,
      "88797": true,
      "88798": true,
      "88799": true,
      "88850": true,
      "88851": true,
      "88852": true,
      "88853": true,
      "88854": true,
      "88855": true,
      "88856": true,
      "88857": true,
      "88858": true,
      "88859": true,
      "88860": true,
      "88861": true,
      "88862": true,
      "88863": true,
      "88864": true,
      "88865": true,
      "88866": true,
      "88867": true,
      "88868": true,
      "88869": true,
      "88870": true,
      "88871": true,
      "88872": true,
      "88873": true,
      "88874": true,
      "88875": true,
      "88876": true,
      "88877": true,
      "88878": true,
      "88879": true
    },
    "RIO BRAVO": {
      "88800": true,
      "88801": true,
      "88802": true,
      "88803": true,
      "88804": true,
      "88805": true,
      "88806": true,
      "88807": true,
      "88809": true,
      "88810": true,
      "88811": true,
      "88812": true,
      "88813": true,
      "88814": true,
      "88815": true,
      "88816": true,
      "88817": true,
      "88818": true,
      "88900": true,
      "88901": true,
      "88902": true,
      "88903": true,
      "88904": true,
      "88905": true,
      "88906": true,
      "88907": true,
      "88908": true,
      "88909": true,
      "88910": true,
      "88911": true,
      "88912": true,
      "88913": true,
      "88914": true,
      "88915": true,
      "88916": true,
      "88917": true,
      "88918": true,
      "88919": true,
      "88920": true,
      "88921": true,
      "88922": true,
      "88923": true,
      "88924": true,
      "88925": true,
      "88926": true,
      "88927": true,
      "88928": true,
      "88929": true,
      "88930": true,
      "88931": true,
      "88932": true,
      "88933": true,
      "88934": true,
      "88935": true,
      "88936": true,
      "88937": true,
      "88938": true,
      "88939": true,
      "88940": true,
      "88941": true,
      "88942": true,
      "88943": true,
      "88944": true,
      "88945": true,
      "88946": true,
      "88947": true,
      "88948": true,
      "88949": true,
      "88950": true,
      "88951": true,
      "88952": true,
      "88953": true,
      "88954": true,
      "88955": true,
      "88956": true,
      "88957": true,
      "88958": true,
      "88959": true,
      "88960": true,
      "88961": true,
      "88962": true,
      "88963": true,
      "88964": true,
      "88965": true,
      "88966": true,
      "88967": true,
      "88968": true,
      "88969": true,
      "88970": true,
      "88971": true,
      "88972": true,
      "88973": true,
      "88974": true,
      "88975": true,
      "88976": true,
      "88977": true,
      "88978": true,
      "88979": true,
      "88980": true,
      "88981": true,
      "88982": true,
      "88983": true,
      "88984": true,
      "88985": true,
      "88986": true,
      "88987": true,
      "88988": true,
      "88989": true,
      "88990": true,
      "88991": true,
      "88992": true,
      "88993": true,
      "88994": true,
      "88995": true,
      "88996": true,
      "88997": true,
      "88998": true,
      "88999": true
    },
    "TAMPICO": {
      "89000": true,
      "89001": true,
      "89002": true,
      "89003": true,
      "89004": true,
      "89005": true,
      "89006": true,
      "89007": true,
      "89008": true,
      "89009": true,
      "89010": true,
      "89011": true,
      "89012": true,
      "89013": true,
      "89014": true,
      "89015": true,
      "89016": true,
      "89017": true,
      "89018": true,
      "89019": true,
      "89020": true,
      "89021": true,
      "89022": true,
      "89023": true,
      "89024": true,
      "89025": true,
      "89026": true,
      "89027": true,
      "89028": true,
      "89029": true,
      "89030": true,
      "89031": true,
      "89032": true,
      "89033": true,
      "89034": true,
      "89035": true,
      "89036": true,
      "89037": true,
      "89038": true,
      "89039": true,
      "89040": true,
      "89041": true,
      "89042": true,
      "89043": true,
      "89044": true,
      "89045": true,
      "89046": true,
      "89047": true,
      "89048": true,
      "89049": true,
      "89050": true,
      "89051": true,
      "89052": true,
      "89053": true,
      "89054": true,
      "89055": true,
      "89056": true,
      "89057": true,
      "89058": true,
      "89059": true,
      "89060": true,
      "89061": true,
      "89062": true,
      "89063": true,
      "89064": true,
      "89065": true,
      "89066": true,
      "89067": true,
      "89068": true,
      "89069": true,
      "89070": true,
      "89071": true,
      "89072": true,
      "89073": true,
      "89074": true,
      "89075": true,
      "89076": true,
      "89077": true,
      "89078": true,
      "89079": true,
      "89080": true,
      "89081": true,
      "89082": true,
      "89083": true,
      "89084": true,
      "89085": true,
      "89086": true,
      "89087": true,
      "89088": true,
      "89089": true,
      "89090": true,
      "89091": true,
      "89092": true,
      "89093": true,
      "89094": true,
      "89095": true,
      "89096": true,
      "89097": true,
      "89098": true,
      "89099": true,
      "89100": true,
      "89101": true,
      "89102": true,
      "89103": true,
      "89104": true,
      "89105": true,
      "89106": true,
      "89107": true,
      "89108": true,
      "89109": true,
      "89110": true,
      "89111": true,
      "89112": true,
      "89113": true,
      "89114": true,
      "89115": true,
      "89116": true,
      "89117": true,
      "89118": true,
      "89119": true,
      "89120": true,
      "89121": true,
      "89122": true,
      "89123": true,
      "89124": true,
      "89125": true,
      "89126": true,
      "89127": true,
      "89128": true,
      "89129": true,
      "89130": true,
      "89131": true,
      "89132": true,
      "89133": true,
      "89134": true,
      "89135": true,
      "89136": true,
      "89137": true,
      "89138": true,
      "89139": true,
      "89140": true,
      "89141": true,
      "89142": true,
      "89143": true,
      "89144": true,
      "89145": true,
      "89146": true,
      "89147": true,
      "89148": true,
      "89149": true,
      "89150": true,
      "89151": true,
      "89152": true,
      "89153": true,
      "89154": true,
      "89155": true,
      "89156": true,
      "89157": true,
      "89158": true,
      "89159": true,
      "89160": true,
      "89161": true,
      "89162": true,
      "89163": true,
      "89164": true,
      "89165": true,
      "89166": true,
      "89167": true,
      "89168": true,
      "89169": true,
      "89170": true,
      "89171": true,
      "89172": true,
      "89173": true,
      "89174": true,
      "89175": true,
      "89176": true,
      "89177": true,
      "89178": true,
      "89179": true,
      "89180": true,
      "89181": true,
      "89182": true,
      "89183": true,
      "89184": true,
      "89185": true,
      "89186": true,
      "89187": true,
      "89188": true,
      "89189": true,
      "89190": true,
      "89191": true,
      "89192": true,
      "89193": true,
      "89194": true,
      "89195": true,
      "89196": true,
      "89197": true,
      "89198": true,
      "89199": true,
      "89200": true,
      "89201": true,
      "89202": true,
      "89203": true,
      "89204": true,
      "89205": true,
      "89206": true,
      "89207": true,
      "89208": true,
      "89209": true,
      "89210": true,
      "89211": true,
      "89212": true,
      "89213": true,
      "89214": true,
      "89215": true,
      "89216": true,
      "89217": true,
      "89218": true,
      "89219": true,
      "89220": true,
      "89221": true,
      "89222": true,
      "89223": true,
      "89224": true,
      "89225": true,
      "89226": true,
      "89227": true,
      "89228": true,
      "89229": true,
      "89230": true,
      "89231": true,
      "89232": true,
      "89233": true,
      "89234": true,
      "89235": true,
      "89236": true,
      "89237": true,
      "89238": true,
      "89239": true,
      "89240": true,
      "89241": true,
      "89242": true,
      "89243": true,
      "89244": true,
      "89245": true,
      "89246": true,
      "89247": true,
      "89248": true,
      "89249": true,
      "89250": true,
      "89251": true,
      "89252": true,
      "89253": true,
      "89254": true,
      "89255": true,
      "89256": true,
      "89257": true,
      "89258": true,
      "89259": true,
      "89260": true,
      "89261": true,
      "89262": true,
      "89263": true,
      "89264": true,
      "89265": true,
      "89266": true,
      "89267": true,
      "89268": true,
      "89269": true,
      "89270": true,
      "89271": true,
      "89272": true,
      "89273": true,
      "89274": true,
      "89275": true,
      "89276": true,
      "89277": true,
      "89278": true,
      "89279": true,
      "89280": true,
      "89281": true,
      "89282": true,
      "89283": true,
      "89284": true,
      "89285": true,
      "89286": true,
      "89287": true,
      "89288": true,
      "89289": true,
      "89290": true,
      "89291": true,
      "89292": true,
      "89293": true,
      "89294": true,
      "89295": true,
      "89296": true,
      "89297": true,
      "89298": true,
      "89299": true,
      "89300": true,
      "89301": true,
      "89302": true,
      "89303": true,
      "89304": true,
      "89305": true,
      "89306": true,
      "89307": true,
      "89308": true,
      "89309": true,
      "89310": true,
      "89311": true,
      "89312": true,
      "89313": true,
      "89314": true,
      "89315": true,
      "89316": true,
      "89317": true,
      "89318": true,
      "89319": true,
      "89320": true,
      "89321": true,
      "89322": true,
      "89323": true,
      "89324": true,
      "89325": true,
      "89326": true,
      "89327": true,
      "89328": true,
      "89329": true,
      "89330": true,
      "89331": true,
      "89332": true,
      "89333": true,
      "89334": true,
      "89335": true,
      "89336": true,
      "89337": true,
      "89338": true,
      "89339": true,
      "89340": true,
      "89341": true,
      "89342": true,
      "89343": true,
      "89344": true,
      "89345": true,
      "89346": true,
      "89347": true,
      "89348": true,
      "89349": true,
      "89350": true,
      "89351": true,
      "89352": true,
      "89353": true,
      "89354": true,
      "89355": true,
      "89356": true,
      "89357": true,
      "89358": true,
      "89359": true,
      "89360": true,
      "89361": true,
      "89362": true,
      "89363": true,
      "89364": true,
      "89365": true,
      "89366": true,
      "89367": true,
      "89368": true,
      "89369": true,
      "89370": true,
      "89371": true,
      "89372": true,
      "89373": true,
      "89374": true,
      "89375": true,
      "89376": true,
      "89377": true,
      "89378": true,
      "89379": true,
      "89380": true,
      "89381": true,
      "89382": true,
      "89383": true,
      "89384": true,
      "89385": true,
      "89386": true,
      "89387": true,
      "89388": true,
      "89389": true,
      "89390": true,
      "89391": true,
      "89392": true,
      "89393": true,
      "89394": true,
      "89395": true,
      "89396": true,
      "89397": true,
      "89398": true,
      "89399": true
    },
    "CIUDAD MADERO": {
      "89400": true,
      "89401": true,
      "89402": true,
      "89403": true,
      "89404": true,
      "89405": true,
      "89406": true,
      "89407": true,
      "89408": true,
      "89409": true,
      "89410": true,
      "89411": true,
      "89412": true,
      "89413": true,
      "89414": true,
      "89415": true,
      "89416": true,
      "89417": true,
      "89418": true,
      "89419": true,
      "89420": true,
      "89421": true,
      "89422": true,
      "89423": true,
      "89424": true,
      "89425": true,
      "89426": true,
      "89427": true,
      "89428": true,
      "89429": true,
      "89430": true,
      "89431": true,
      "89432": true,
      "89433": true,
      "89434": true,
      "89435": true,
      "89436": true,
      "89437": true,
      "89438": true,
      "89439": true,
      "89440": true,
      "89441": true,
      "89442": true,
      "89443": true,
      "89444": true,
      "89445": true,
      "89446": true,
      "89447": true,
      "89448": true,
      "89449": true,
      "89450": true,
      "89451": true,
      "89452": true,
      "89453": true,
      "89454": true,
      "89455": true,
      "89456": true,
      "89457": true,
      "89458": true,
      "89459": true,
      "89460": true,
      "89461": true,
      "89462": true,
      "89463": true,
      "89464": true,
      "89465": true,
      "89466": true,
      "89467": true,
      "89468": true,
      "89469": true,
      "89470": true,
      "89471": true,
      "89472": true,
      "89473": true,
      "89474": true,
      "89475": true,
      "89476": true,
      "89477": true,
      "89478": true,
      "89479": true,
      "89480": true,
      "89481": true,
      "89482": true,
      "89483": true,
      "89484": true,
      "89485": true,
      "89486": true,
      "89487": true,
      "89488": true,
      "89489": true,
      "89490": true,
      "89491": true,
      "89492": true,
      "89493": true,
      "89494": true,
      "89495": true,
      "89496": true,
      "89497": true,
      "89498": true,
      "89499": true,
      "89500": true,
      "89501": true,
      "89502": true,
      "89503": true,
      "89504": true,
      "89505": true,
      "89506": true,
      "89507": true,
      "89508": true,
      "89509": true,
      "89510": true,
      "89511": true,
      "89512": true,
      "89513": true,
      "89514": true,
      "89515": true,
      "89516": true,
      "89517": true,
      "89518": true,
      "89519": true,
      "89520": true,
      "89521": true,
      "89522": true,
      "89523": true,
      "89524": true,
      "89525": true,
      "89526": true,
      "89527": true,
      "89528": true,
      "89529": true,
      "89530": true,
      "89531": true,
      "89532": true,
      "89533": true,
      "89534": true,
      "89535": true,
      "89536": true,
      "89537": true,
      "89538": true,
      "89539": true,
      "89540": true,
      "89541": true,
      "89542": true,
      "89543": true,
      "89544": true,
      "89545": true,
      "89546": true,
      "89547": true,
      "89548": true,
      "89549": true,
      "89550": true,
      "89551": true,
      "89552": true,
      "89553": true,
      "89554": true,
      "89555": true,
      "89556": true,
      "89557": true,
      "89558": true,
      "89559": true,
      "89560": true,
      "89561": true,
      "89562": true,
      "89563": true,
      "89564": true,
      "89565": true,
      "89566": true,
      "89567": true,
      "89568": true,
      "89569": true,
      "89570": true,
      "89571": true,
      "89572": true,
      "89573": true,
      "89574": true,
      "89575": true,
      "89576": true,
      "89577": true,
      "89578": true,
      "89579": true,
      "89580": true,
      "89581": true,
      "89582": true,
      "89583": true,
      "89584": true,
      "89585": true,
      "89586": true,
      "89587": true,
      "89588": true,
      "89589": true,
      "89590": true,
      "89591": true,
      "89592": true,
      "89593": true,
      "89594": true,
      "89595": true,
      "89596": true,
      "89597": true,
      "89598": true,
      "89599": true
    },
    "ALTAMIRA": {
      "89600": true,
      "89601": true,
      "89602": true,
      "89603": true,
      "89604": true,
      "89605": true,
      "89606": true,
      "89607": true,
      "89608": true,
      "89609": true,
      "89610": true,
      "89611": true,
      "89612": true,
      "89613": true,
      "89614": true,
      "89615": true,
      "89616": true,
      "89617": true,
      "89618": true,
      "89619": true,
      "89620": true,
      "89621": true,
      "89622": true,
      "89623": true,
      "89624": true,
      "89625": true,
      "89626": true,
      "89627": true,
      "89628": true,
      "89629": true,
      "89630": true,
      "89631": true,
      "89632": true,
      "89633": true,
      "89634": true,
      "89635": true,
      "89636": true,
      "89637": true,
      "89638": true,
      "89639": true,
      "89640": true,
      "89641": true,
      "89642": true,
      "89643": true,
      "89644": true,
      "89645": true,
      "89646": true,
      "89647": true,
      "89648": true,
      "89649": true,
      "89650": true,
      "89651": true,
      "89652": true,
      "89653": true,
      "89654": true,
      "89655": true,
      "89656": true,
      "89657": true,
      "89658": true,
      "89659": true,
      "89660": true,
      "89661": true,
      "89662": true,
      "89663": true,
      "89664": true,
      "89665": true,
      "89666": true,
      "89667": true,
      "89668": true,
      "89669": true
    },
    "ALDAMA": {
      "89670": true,
      "89671": true,
      "89672": true,
      "89673": true,
      "89674": true,
      "89675": true,
      "89676": true
    },
    "GONZALEZ": {
      "89700": true,
      "89701": true,
      "89702": true,
      "89703": true,
      "89705": true,
      "89706": true,
      "89707": true,
      "89708": true,
      "89709": true,
      "89710": true,
      "89711": true,
      "89712": true,
      "89713": true,
      "89714": true,
      "89715": true,
      "89716": true,
      "89717": true,
      "89718": true,
      "89719": true,
      "89730": true,
      "89731": true,
      "89732": true,
      "89733": true,
      "89734": true,
      "89736": true,
      "89737": true,
      "89738": true,
      "89739": true,
      "89744": true,
      "89745": true,
      "89746": true,
      "89747": true,
      "89748": true,
      "89749": true
    },
    "XICOTENCATL": {
      "89750": true,
      "89751": true,
      "89752": true,
      "89753": true,
      "89754": true,
      "89755": true,
      "89756": true,
      "89757": true,
      "89758": true,
      "89759": true,
      "89760": true,
      "89761": true,
      "89762": true,
      "89763": true,
      "89764": true,
      "89765": true,
      "89766": true,
      "89774": true,
      "89775": true,
      "89776": true,
      "89777": true
    },
    "EL MANTE": {
      "89800": true,
      "89801": true,
      "89802": true,
      "89803": true,
      "89804": true,
      "89805": true,
      "89806": true,
      "89807": true,
      "89808": true,
      "89809": true,
      "89810": true,
      "89811": true,
      "89812": true,
      "89813": true,
      "89814": true,
      "89815": true,
      "89816": true,
      "89817": true,
      "89818": true,
      "89819": true,
      "89820": true,
      "89821": true,
      "89822": true,
      "89823": true,
      "89824": true,
      "89825": true,
      "89826": true,
      "89827": true,
      "89828": true,
      "89829": true,
      "89830": true,
      "89831": true,
      "89832": true,
      "89833": true,
      "89834": true,
      "89835": true,
      "89836": true,
      "89837": true,
      "89838": true,
      "89839": true,
      "89840": true,
      "89841": true,
      "89842": true,
      "89843": true,
      "89844": true,
      "89845": true,
      "89846": true,
      "89847": true,
      "89848": true,
      "89849": true,
      "89850": true,
      "89851": true,
      "89852": true,
      "89853": true,
      "89854": true,
      "89855": true,
      "89856": true,
      "89857": true,
      "89858": true,
      "89859": true,
      "89860": true,
      "89861": true,
      "89862": true,
      "89863": true,
      "89864": true,
      "89865": true,
      "89866": true,
      "89867": true,
      "89868": true,
      "89869": true,
      "89870": true,
      "89871": true,
      "89872": true,
      "89873": true,
      "89874": true,
      "89875": true,
      "89876": true,
      "89877": true,
      "89878": true,
      "89879": true,
      "89880": true,
      "89881": true,
      "89882": true,
      "89883": true,
      "89884": true,
      "89885": true,
      "89886": true,
      "89887": true,
      "89888": true,
      "89889": true,
      "89890": true,
      "89891": true,
      "89892": true,
      "89893": true,
      "89894": true,
      "89895": true,
      "89896": true,
      "89897": true,
      "89898": true,
      "89899": true,
      "89900": true,
      "89901": true,
      "89902": true,
      "89903": true,
      "89904": true,
      "89905": true,
      "89906": true,
      "89907": true,
      "89908": true,
      "89909": true,
      "89910": true,
      "89911": true,
      "89912": true,
      "89913": true,
      "89914": true,
      "89915": true,
      "89916": true,
      "89918": true,
      "89919": true,
      "89920": true,
      "89921": true,
      "89922": true,
      "89923": true,
      "89924": true,
      "89925": true,
      "89926": true,
      "89927": true,
      "89929": true,
      "89930": true,
      "89931": true,
      "89932": true,
      "89933": true,
      "89934": true,
      "89935": true,
      "89936": true,
      "89937": true,
      "89938": true,
      "89939": true,
      "89940": true,
      "89941": true,
      "89942": true,
      "89943": true,
      "89944": true,
      "89950": true,
      "89951": true,
      "89952": true,
      "89953": true,
      "89954": true,
      "89955": true
    }
  },
  "TLAXCALA": {
    "TLAXCALA": {
      "90000": true,
      "90001": true,
      "90002": true,
      "90003": true,
      "90004": true,
      "90005": true,
      "90006": true,
      "90007": true,
      "90008": true,
      "90009": true,
      "90010": true,
      "90011": true,
      "90012": true,
      "90013": true,
      "90014": true,
      "90015": true,
      "90016": true,
      "90017": true,
      "90018": true,
      "90019": true,
      "90020": true,
      "90021": true,
      "90022": true,
      "90023": true,
      "90024": true,
      "90025": true,
      "90026": true,
      "90027": true,
      "90028": true,
      "90029": true,
      "90030": true,
      "90031": true,
      "90032": true,
      "90033": true,
      "90034": true,
      "90035": true,
      "90036": true,
      "90037": true,
      "90038": true,
      "90039": true,
      "90040": true,
      "90041": true,
      "90042": true,
      "90043": true,
      "90044": true,
      "90045": true,
      "90046": true,
      "90047": true,
      "90048": true,
      "90049": true,
      "90050": true,
      "90051": true,
      "90052": true,
      "90053": true,
      "90054": true,
      "90055": true,
      "90056": true,
      "90057": true,
      "90058": true,
      "90059": true,
      "90060": true,
      "90061": true,
      "90062": true,
      "90063": true,
      "90064": true,
      "90065": true,
      "90066": true,
      "90067": true,
      "90068": true,
      "90069": true,
      "90070": true,
      "90071": true,
      "90072": true,
      "90073": true,
      "90074": true,
      "90075": true,
      "90076": true,
      "90077": true,
      "90078": true,
      "90079": true,
      "90080": true,
      "90081": true,
      "90082": true,
      "90083": true,
      "90084": true,
      "90085": true,
      "90086": true,
      "90087": true,
      "90088": true,
      "90089": true,
      "90090": true,
      "90091": true,
      "90092": true,
      "90093": true,
      "90094": true,
      "90095": true,
      "90096": true,
      "90097": true,
      "90098": true,
      "90099": true,
      "90100": true,
      "90101": true,
      "90102": true,
      "90103": true,
      "90104": true,
      "90105": true,
      "90106": true,
      "90107": true,
      "90108": true,
      "90109": true,
      "90110": true,
      "90111": true,
      "90112": true,
      "90113": true,
      "90114": true,
      "90115": true,
      "90116": true,
      "90117": true,
      "90118": true,
      "90119": true
    },
    "APIZACO": {
      "90300": true,
      "90301": true,
      "90302": true,
      "90303": true,
      "90304": true,
      "90305": true,
      "90306": true,
      "90307": true,
      "90308": true,
      "90309": true,
      "90310": true,
      "90311": true,
      "90312": true,
      "90313": true,
      "90314": true,
      "90315": true,
      "90316": true,
      "90317": true,
      "90318": true,
      "90319": true,
      "90320": true,
      "90321": true,
      "90322": true,
      "90323": true,
      "90324": true,
      "90325": true,
      "90326": true,
      "90327": true,
      "90328": true,
      "90329": true,
      "90330": true,
      "90331": true,
      "90332": true,
      "90333": true,
      "90334": true,
      "90335": true,
      "90336": true,
      "90337": true,
      "90338": true,
      "90339": true,
      "90340": true,
      "90341": true,
      "90342": true,
      "90343": true,
      "90344": true,
      "90345": true,
      "90346": true,
      "90347": true,
      "90348": true,
      "90349": true,
      "90350": true,
      "90351": true,
      "90352": true,
      "90353": true,
      "90354": true,
      "90355": true,
      "90356": true,
      "90357": true,
      "90358": true,
      "90359": true,
      "90360": true,
      "90361": true,
      "90362": true,
      "90363": true,
      "90364": true,
      "90365": true,
      "90366": true,
      "90367": true,
      "90368": true,
      "90369": true,
      "90370": true,
      "90371": true,
      "90372": true,
      "90373": true,
      "90374": true,
      "90375": true,
      "90376": true,
      "90377": true,
      "90378": true,
      "90379": true,
      "90380": true,
      "90381": true,
      "90382": true,
      "90383": true,
      "90384": true,
      "90385": true,
      "90386": true,
      "90387": true,
      "90388": true,
      "90389": true,
      "90390": true,
      "90391": true,
      "90392": true,
      "90393": true,
      "90394": true,
      "90395": true,
      "90396": true,
      "90397": true,
      "90398": true,
      "90399": true,
      "90400": true,
      "90401": true,
      "90402": true,
      "90403": true,
      "90404": true,
      "90405": true,
      "90406": true,
      "90407": true,
      "90408": true,
      "90409": true
    },
    "XALOZTOC": {
      "90460": true,
      "90461": true,
      "90462": true,
      "90463": true,
      "90464": true,
      "90465": true,
      "90466": true,
      "90467": true,
      "90468": true,
      "90469": true,
      "90470": true,
      "90471": true,
      "90472": true,
      "90473": true,
      "90474": true,
      "90475": true,
      "90476": true,
      "90477": true,
      "90478": true,
      "90479": true
    }
  },
  "VERACRUZ DE IGNACIO DE LA LLAVE": {
    "XALAPA": {
      "91000": true,
      "91001": true,
      "91002": true,
      "91003": true,
      "91004": true,
      "91005": true,
      "91006": true,
      "91007": true,
      "91008": true,
      "91009": true,
      "91010": true,
      "91011": true,
      "91012": true,
      "91013": true,
      "91014": true,
      "91015": true,
      "91016": true,
      "91017": true,
      "91018": true,
      "91019": true,
      "91020": true,
      "91021": true,
      "91022": true,
      "91023": true,
      "91024": true,
      "91025": true,
      "91026": true,
      "91027": true,
      "91028": true,
      "91029": true,
      "91030": true,
      "91031": true,
      "91032": true,
      "91033": true,
      "91034": true,
      "91035": true,
      "91036": true,
      "91037": true,
      "91038": true,
      "91039": true,
      "91040": true,
      "91041": true,
      "91042": true,
      "91043": true,
      "91044": true,
      "91045": true,
      "91046": true,
      "91047": true,
      "91048": true,
      "91049": true,
      "91050": true,
      "91051": true,
      "91052": true,
      "91053": true,
      "91054": true,
      "91055": true,
      "91056": true,
      "91057": true,
      "91058": true,
      "91059": true,
      "91060": true,
      "91061": true,
      "91062": true,
      "91063": true,
      "91064": true,
      "91065": true,
      "91066": true,
      "91067": true,
      "91068": true,
      "91069": true,
      "91070": true,
      "91071": true,
      "91072": true,
      "91073": true,
      "91074": true,
      "91075": true,
      "91076": true,
      "91077": true,
      "91078": true,
      "91079": true,
      "91080": true,
      "91081": true,
      "91082": true,
      "91083": true,
      "91084": true,
      "91085": true,
      "91086": true,
      "91087": true,
      "91088": true,
      "91089": true,
      "91090": true,
      "91091": true,
      "91092": true,
      "91093": true,
      "91094": true,
      "91095": true,
      "91096": true,
      "91097": true,
      "91098": true,
      "91099": true,
      "91100": true,
      "91101": true,
      "91102": true,
      "91103": true,
      "91104": true,
      "91105": true,
      "91106": true,
      "91107": true,
      "91108": true,
      "91109": true,
      "91110": true,
      "91111": true,
      "91112": true,
      "91113": true,
      "91114": true,
      "91115": true,
      "91116": true,
      "91117": true,
      "91118": true,
      "91119": true,
      "91120": true,
      "91121": true,
      "91122": true,
      "91123": true,
      "91124": true,
      "91125": true,
      "91126": true,
      "91127": true,
      "91128": true,
      "91129": true,
      "91130": true,
      "91131": true,
      "91132": true,
      "91133": true,
      "91134": true,
      "91135": true,
      "91136": true,
      "91137": true,
      "91138": true,
      "91139": true,
      "91140": true,
      "91141": true,
      "91142": true,
      "91143": true,
      "91144": true,
      "91145": true,
      "91146": true,
      "91147": true,
      "91148": true,
      "91149": true,
      "91150": true,
      "91151": true,
      "91152": true,
      "91153": true,
      "91154": true,
      "91155": true,
      "91156": true,
      "91157": true,
      "91158": true,
      "91159": true,
      "91160": true,
      "91161": true,
      "91162": true,
      "91163": true,
      "91164": true,
      "91165": true,
      "91166": true,
      "91167": true,
      "91168": true,
      "91169": true,
      "91170": true,
      "91171": true,
      "91172": true,
      "91173": true,
      "91174": true,
      "91175": true,
      "91176": true,
      "91177": true,
      "91178": true,
      "91179": true,
      "91180": true,
      "91181": true,
      "91182": true,
      "91183": true,
      "91184": true,
      "91185": true,
      "91186": true,
      "91187": true,
      "91188": true,
      "91189": true,
      "91190": true,
      "91191": true,
      "91192": true,
      "91193": true,
      "91194": true,
      "91195": true,
      "91196": true,
      "91197": true,
      "91198": true,
      "91199": true,
      "91200": true,
      "91201": true,
      "91202": true,
      "91203": true,
      "91204": true,
      "91205": true,
      "91206": true,
      "91207": true,
      "91208": true,
      "91209": true,
      "91210": true,
      "91211": true,
      "91212": true,
      "91213": true,
      "91214": true,
      "91215": true,
      "91216": true,
      "91217": true,
      "91218": true,
      "91219": true,
      "91220": true,
      "91221": true,
      "91222": true,
      "91223": true,
      "91224": true,
      "91225": true,
      "91226": true,
      "91227": true,
      "91228": true,
      "91229": true
    },
    "TLALNELHUAYOCAN": {
      "91230": true,
      "91231": true,
      "91232": true,
      "91233": true,
      "91234": true,
      "91235": true,
      "91236": true,
      "91237": true,
      "91238": true,
      "91239": true
    },
    "XICO": {
      "91240": true,
      "91241": true,
      "91242": true,
      "91244": true,
      "91245": true,
      "91247": true,
      "91248": true,
      "91249": true
    },
    "IXHUACAN DE LOS REYES": {
      "91250": true,
      "91251": true,
      "91252": true,
      "91254": true,
      "91255": true,
      "91256": true,
      "91257": true,
      "91258": true,
      "91259": true
    },
    "AYAHUALULCO": {
      "91260": true,
      "91261": true,
      "91262": true,
      "91263": true,
      "91264": true,
      "91265": true,
      "91266": true,
      "91267": true,
      "91268": true,
      "91269": true
    },
    "BANDERILLA": {
      "91300": true,
      "91301": true,
      "91302": true,
      "91303": true,
      "91304": true,
      "91305": true,
      "91306": true,
      "91307": true,
      "91308": true,
      "91309": true,
      "91310": true,
      "91311": true,
      "91312": true,
      "91313": true,
      "91314": true
    },
    "RAFAEL LUCIO": {
      "91315": true,
      "91316": true,
      "91317": true,
      "91318": true,
      "91319": true
    },
    "ACAJETE": {
      "91320": true,
      "91321": true,
      "91322": true,
      "91323": true,
      "91324": true,
      "91325": true,
      "91326": true,
      "91327": true,
      "91328": true,
      "91329": true
    },
    "VILLA ALDAMA": {
      "91340": true,
      "91341": true,
      "91342": true,
      "91343": true,
      "91344": true,
      "91345": true,
      "91346": true,
      "91347": true,
      "91348": true,
      "91349": true
    },
    "TLACOLULAN": {
      "91350": true,
      "91351": true,
      "91352": true,
      "91353": true,
      "91354": true,
      "91355": true,
      "91356": true,
      "91357": true,
      "91358": true,
      "91359": true
    },
    "TONAYAN": {
      "91360": true,
      "91361": true,
      "91362": true,
      "91363": true,
      "91364": true,
      "91365": true,
      "91366": true,
      "91367": true,
      "91368": true,
      "91369": true
    },
    "COACOATZINTLA": {
      "91370": true,
      "91371": true,
      "91372": true,
      "91373": true,
      "91374": true,
      "91375": true,
      "91376": true,
      "91377": true,
      "91378": true,
      "91379": true
    },
    "JILOTEPEC": {
      "91380": true,
      "91381": true,
      "91382": true,
      "91383": true,
      "91384": true,
      "91385": true,
      "91386": true,
      "91389": true,
      "91390": true,
      "91391": true,
      "91392": true,
      "91393": true,
      "91394": true,
      "91395": true,
      "91396": true,
      "91397": true,
      "91398": true,
      "91399": true
    },
    "MIAHUATLAN": {
      "91410": true,
      "91411": true,
      "91412": true,
      "91413": true,
      "91414": true,
      "91415": true,
      "91416": true,
      "91417": true,
      "91418": true,
      "91419": true
    },
    "TEPETLAN": {
      "91430": true,
      "91431": true,
      "91432": true,
      "91433": true,
      "91434": true,
      "91436": true,
      "91437": true,
      "91438": true,
      "91439": true
    },
    "JUCHIQUE DE FERRER": {
      "91440": true,
      "91441": true,
      "91442": true,
      "91443": true,
      "91444": true,
      "91445": true,
      "91446": true,
      "91447": true,
      "91448": true,
      "91449": true,
      "91451": true,
      "91452": true,
      "91453": true,
      "91454": true,
      "91455": true,
      "91456": true,
      "91457": true,
      "91458": true,
      "91459": true
    },
    "COATEPEC": {
      "91500": true,
      "91501": true,
      "91502": true,
      "91503": true,
      "91504": true,
      "91505": true,
      "91506": true,
      "91507": true,
      "91508": true,
      "91509": true,
      "91510": true,
      "91511": true,
      "91512": true,
      "91513": true,
      "91514": true,
      "91515": true,
      "91516": true,
      "91517": true,
      "91518": true,
      "91519": true,
      "91520": true,
      "91521": true,
      "91522": true,
      "91523": true,
      "91524": true,
      "91525": true,
      "91526": true,
      "91527": true,
      "91528": true,
      "91529": true,
      "91530": true,
      "91531": true,
      "91532": true,
      "91533": true,
      "91534": true,
      "91535": true,
      "91536": true,
      "91537": true,
      "91538": true,
      "91539": true,
      "91540": true,
      "91541": true,
      "91542": true,
      "91543": true,
      "91544": true,
      "91545": true,
      "91546": true,
      "91547": true,
      "91548": true,
      "91549": true,
      "91550": true,
      "91551": true,
      "91552": true,
      "91553": true,
      "91554": true,
      "91555": true,
      "91556": true,
      "91557": true,
      "91558": true,
      "91559": true,
      "91560": true,
      "91561": true,
      "91562": true,
      "91563": true,
      "91564": true,
      "91565": true,
      "91566": true,
      "91567": true,
      "91568": true,
      "91569": true,
      "91570": true,
      "91571": true,
      "91572": true,
      "91573": true,
      "91574": true,
      "91575": true,
      "91576": true,
      "91577": true,
      "91578": true,
      "91579": true,
      "91580": true,
      "91581": true,
      "91582": true,
      "91583": true,
      "91584": true,
      "91585": true,
      "91586": true,
      "91587": true,
      "91588": true,
      "91589": true,
      "91590": true,
      "91591": true,
      "91592": true,
      "91593": true,
      "91594": true,
      "91595": true,
      "91596": true,
      "91597": true,
      "91598": true,
      "91599": true,
      "91600": true,
      "91601": true,
      "91602": true,
      "91603": true,
      "91604": true,
      "91605": true,
      "91606": true,
      "91607": true,
      "91608": true,
      "91609": true,
      "91610": true,
      "91611": true,
      "91612": true,
      "91613": true,
      "91614": true
    },
    "TEOCELO": {
      "91615": true,
      "91616": true,
      "91617": true,
      "91618": true,
      "91619": true
    },
    "COSAUTLAN DE CARVAJAL": {
      "91620": true,
      "91621": true,
      "91622": true,
      "91623": true,
      "91624": true,
      "91625": true,
      "91626": true,
      "91627": true,
      "91628": true,
      "91629": true
    },
    "APAZAPAN": {
      "91645": true,
      "91646": true,
      "91647": true,
      "91648": true,
      "91649": true
    },
    "PASO DE OVEJAS": {
      "91670": true,
      "91671": true,
      "91672": true,
      "91673": true,
      "91674": true,
      "91675": true,
      "91676": true,
      "91677": true,
      "91678": true,
      "91679": true
    },
    "LA ANTIGUA": {
      "91680": true,
      "91681": true,
      "91682": true,
      "91683": true,
      "91684": true,
      "91685": true,
      "91686": true,
      "91687": true,
      "91688": true,
      "91689": true
    },
    "VERACRUZ": {
      "91690": true,
      "91691": true,
      "91692": true,
      "91693": true,
      "91694": true,
      "91695": true,
      "91696": true,
      "91697": true,
      "91698": true,
      "91699": true,
      "91700": true,
      "91701": true,
      "91702": true,
      "91703": true,
      "91704": true,
      "91705": true,
      "91706": true,
      "91707": true,
      "91708": true,
      "91709": true,
      "91710": true,
      "91711": true,
      "91712": true,
      "91713": true,
      "91714": true,
      "91715": true,
      "91716": true,
      "91717": true,
      "91718": true,
      "91719": true,
      "91720": true,
      "91721": true,
      "91722": true,
      "91723": true,
      "91724": true,
      "91725": true,
      "91726": true,
      "91727": true,
      "91728": true,
      "91729": true,
      "91730": true,
      "91731": true,
      "91732": true,
      "91733": true,
      "91734": true,
      "91735": true,
      "91736": true,
      "91737": true,
      "91738": true,
      "91739": true,
      "91740": true,
      "91741": true,
      "91742": true,
      "91743": true,
      "91744": true,
      "91745": true,
      "91746": true,
      "91747": true,
      "91748": true,
      "91749": true,
      "91750": true,
      "91751": true,
      "91752": true,
      "91753": true,
      "91754": true,
      "91755": true,
      "91756": true,
      "91757": true,
      "91758": true,
      "91759": true,
      "91760": true,
      "91761": true,
      "91762": true,
      "91763": true,
      "91764": true,
      "91765": true,
      "91766": true,
      "91767": true,
      "91768": true,
      "91769": true,
      "91770": true,
      "91771": true,
      "91772": true,
      "91773": true,
      "91774": true,
      "91775": true,
      "91776": true,
      "91777": true,
      "91778": true,
      "91779": true,
      "91780": true,
      "91781": true,
      "91782": true,
      "91783": true,
      "91784": true,
      "91785": true,
      "91786": true,
      "91787": true,
      "91788": true,
      "91789": true,
      "91790": true,
      "91791": true,
      "91792": true,
      "91793": true,
      "91794": true,
      "91795": true,
      "91796": true,
      "91797": true,
      "91798": true,
      "91799": true,
      "91800": true,
      "91801": true,
      "91802": true,
      "91803": true,
      "91804": true,
      "91805": true,
      "91806": true,
      "91807": true,
      "91808": true,
      "91809": true,
      "91810": true,
      "91811": true,
      "91812": true,
      "91813": true,
      "91814": true,
      "91815": true,
      "91816": true,
      "91817": true,
      "91818": true,
      "91819": true,
      "91820": true,
      "91821": true,
      "91822": true,
      "91823": true,
      "91824": true,
      "91825": true,
      "91826": true,
      "91827": true,
      "91828": true,
      "91829": true,
      "91830": true,
      "91831": true,
      "91832": true,
      "91833": true,
      "91834": true,
      "91835": true,
      "91836": true,
      "91837": true,
      "91838": true,
      "91839": true,
      "91840": true,
      "91841": true,
      "91842": true,
      "91843": true,
      "91844": true,
      "91845": true,
      "91846": true,
      "91847": true,
      "91848": true,
      "91849": true,
      "91850": true,
      "91851": true,
      "91852": true,
      "91853": true,
      "91854": true,
      "91855": true,
      "91856": true,
      "91857": true,
      "91858": true,
      "91859": true,
      "91860": true,
      "91861": true,
      "91862": true,
      "91863": true,
      "91864": true,
      "91865": true,
      "91866": true,
      "91867": true,
      "91868": true,
      "91869": true,
      "91870": true,
      "91871": true,
      "91872": true,
      "91873": true,
      "91874": true,
      "91875": true,
      "91876": true,
      "91877": true,
      "91878": true,
      "91879": true,
      "91880": true,
      "91881": true,
      "91882": true,
      "91883": true,
      "91884": true,
      "91885": true,
      "91886": true,
      "91887": true,
      "91888": true,
      "91889": true,
      "91890": true,
      "91891": true,
      "91892": true,
      "91893": true,
      "91894": true,
      "91895": true,
      "91896": true,
      "91897": true,
      "91898": true,
      "91899": true,
      "91900": true,
      "91901": true,
      "91902": true,
      "91903": true,
      "91904": true,
      "91905": true,
      "91906": true,
      "91907": true,
      "91908": true,
      "91909": true,
      "91910": true,
      "91911": true,
      "91912": true,
      "91913": true,
      "91915": true,
      "91916": true,
      "91917": true,
      "91918": true,
      "91919": true,
      "91920": true,
      "91921": true,
      "91922": true,
      "91923": true,
      "91924": true,
      "91925": true,
      "91926": true,
      "91927": true,
      "91928": true,
      "91929": true,
      "91930": true,
      "91931": true,
      "91932": true,
      "91933": true,
      "91934": true,
      "91935": true,
      "91936": true,
      "91937": true,
      "91938": true,
      "91939": true,
      "91940": true,
      "91941": true,
      "91942": true,
      "91943": true,
      "91944": true,
      "91945": true,
      "91946": true,
      "91947": true,
      "91948": true,
      "91949": true,
      "91950": true,
      "91951": true,
      "91952": true,
      "91953": true,
      "91954": true,
      "91955": true,
      "91956": true,
      "91957": true,
      "91958": true,
      "91959": true,
      "91960": true,
      "91961": true,
      "91962": true,
      "91963": true,
      "91964": true,
      "91965": true,
      "91966": true,
      "91967": true,
      "91968": true,
      "91969": true,
      "91970": true,
      "91971": true,
      "91972": true,
      "91973": true,
      "91974": true,
      "91975": true,
      "91976": true,
      "91977": true,
      "91978": true,
      "91979": true,
      "91980": true,
      "91981": true,
      "91982": true,
      "91983": true,
      "91984": true,
      "91985": true,
      "91986": true,
      "91987": true,
      "91988": true,
      "91989": true,
      "91990": true,
      "91991": true,
      "91992": true,
      "91993": true,
      "91994": true,
      "91995": true,
      "91996": true,
      "91997": true,
      "91998": true,
      "91999": true
    },
    "PANUCO": {
      "92000": true,
      "92001": true,
      "92002": true,
      "92003": true,
      "92004": true,
      "92005": true,
      "92009": true,
      "92010": true,
      "92011": true,
      "92012": true,
      "92015": true,
      "92017": true,
      "92018": true,
      "92020": true,
      "92021": true,
      "92023": true,
      "92025": true,
      "92026": true,
      "93990": true,
      "93991": true,
      "93992": true,
      "93993": true,
      "93994": true,
      "93995": true,
      "93996": true,
      "93997": true,
      "93998": true,
      "93999": true
    },
    "PUEBLO VIEJO": {
      "92030": true,
      "92031": true,
      "92032": true,
      "92033": true,
      "92034": true,
      "92035": true,
      "92036": true,
      "92037": true,
      "92038": true,
      "92039": true
    },
    "TAMPICO ALTO": {
      "92040": true,
      "92041": true,
      "92042": true,
      "92044": true,
      "92045": true,
      "92046": true,
      "92050": true,
      "92051": true,
      "92052": true,
      "92053": true,
      "92054": true,
      "92055": true,
      "92056": true,
      "92057": true,
      "92058": true,
      "92059": true
    },
    "TANTOYUCA": {
      "92100": true,
      "92101": true,
      "92102": true,
      "92103": true,
      "92104": true,
      "92105": true,
      "92106": true,
      "92108": true,
      "92109": true,
      "92110": true,
      "92111": true,
      "92112": true,
      "92113": true,
      "92114": true,
      "92115": true,
      "92116": true,
      "92117": true,
      "92118": true,
      "92119": true,
      "92120": true,
      "92121": true,
      "92122": true,
      "92123": true,
      "92124": true,
      "92125": true,
      "92126": true,
      "92127": true,
      "92128": true,
      "92129": true
    },
    "NARANJOS AMATLAN": {
      "92300": true,
      "92301": true,
      "92302": true,
      "92303": true,
      "92304": true,
      "92305": true,
      "92306": true,
      "92307": true,
      "92308": true,
      "92309": true,
      "92310": true,
      "92311": true,
      "92312": true,
      "92313": true,
      "92314": true,
      "92315": true,
      "92316": true,
      "92317": true,
      "92318": true,
      "92319": true,
      "92320": true,
      "92321": true,
      "92322": true,
      "92323": true,
      "92324": true,
      "92325": true,
      "92326": true,
      "92327": true,
      "92328": true,
      "92329": true,
      "92330": true,
      "92331": true,
      "92332": true,
      "92333": true,
      "92334": true,
      "92335": true,
      "92336": true,
      "92337": true,
      "92338": true,
      "92339": true,
      "92340": true,
      "92341": true,
      "92342": true,
      "92343": true,
      "92344": true,
      "92345": true,
      "92346": true,
      "92347": true,
      "92348": true,
      "92349": true,
      "92350": true,
      "92351": true,
      "92352": true,
      "92353": true,
      "92354": true,
      "92355": true,
      "92356": true,
      "92357": true,
      "92358": true,
      "92359": true,
      "92360": true,
      "92361": true,
      "92362": true,
      "92363": true,
      "92364": true,
      "92365": true,
      "92366": true,
      "92367": true,
      "92368": true,
      "92369": true,
      "92370": true,
      "92371": true,
      "92372": true,
      "92373": true,
      "92374": true,
      "92375": true,
      "92376": true,
      "92377": true,
      "92378": true,
      "92379": true,
      "92380": true,
      "92381": true,
      "92382": true,
      "92383": true,
      "92384": true,
      "92385": true,
      "92386": true,
      "92387": true,
      "92388": true,
      "92389": true,
      "92390": true,
      "92391": true,
      "92392": true,
      "92393": true,
      "92394": true,
      "92395": true,
      "92396": true,
      "92397": true,
      "92398": true,
      "92399": true,
      "92410": true,
      "92411": true,
      "92412": true,
      "92413": true,
      "92414": true,
      "92415": true,
      "92416": true,
      "92417": true,
      "92418": true,
      "92419": true
    },
    "CERRO AZUL": {
      "92500": true,
      "92501": true,
      "92502": true,
      "92503": true,
      "92504": true,
      "92505": true,
      "92506": true,
      "92507": true,
      "92508": true,
      "92509": true,
      "92510": true,
      "92511": true,
      "92512": true,
      "92513": true,
      "92514": true,
      "92515": true,
      "92516": true,
      "92517": true,
      "92518": true,
      "92519": true,
      "92520": true,
      "92521": true,
      "92522": true,
      "92523": true,
      "92524": true,
      "92525": true,
      "92526": true,
      "92527": true,
      "92528": true,
      "92529": true
    },
    "TEPETZINTLA": {
      "92530": true,
      "92531": true,
      "92532": true,
      "92533": true,
      "92534": true,
      "92535": true,
      "92536": true,
      "92537": true,
      "92538": true,
      "92539": true
    },
    "TAMIAHUA": {
      "92560": true,
      "92561": true,
      "92562": true,
      "92563": true,
      "92570": true,
      "92571": true,
      "92572": true,
      "92573": true,
      "92574": true,
      "92575": true,
      "92576": true,
      "92577": true,
      "92578": true,
      "92579": true,
      "92580": true,
      "92581": true,
      "92584": true,
      "92585": true,
      "92586": true,
      "92587": true,
      "92588": true,
      "92589": true,
      "92590": true,
      "92591": true,
      "92592": true,
      "92593": true,
      "92594": true,
      "92595": true,
      "92596": true,
      "92597": true,
      "92598": true,
      "92599": true
    },
    "ALAMO TEMAPACHE": {
      "92730": true,
      "92731": true,
      "92732": true,
      "92733": true,
      "92734": true,
      "92735": true,
      "92736": true,
      "92737": true,
      "92738": true,
      "92739": true,
      "92740": true,
      "92741": true,
      "92742": true,
      "92743": true,
      "92744": true,
      "92745": true,
      "92750": true,
      "92751": true,
      "92755": true,
      "92760": true,
      "92761": true,
      "92762": true,
      "92763": true,
      "92764": true,
      "92765": true,
      "92766": true,
      "92767": true,
      "92768": true
    },
    "TUXPAN": {
      "92770": true,
      "92771": true,
      "92772": true,
      "92773": true,
      "92774": true,
      "92775": true,
      "92776": true,
      "92777": true,
      "92778": true,
      "92779": true,
      "92780": true,
      "92781": true,
      "92782": true,
      "92783": true,
      "92784": true,
      "92785": true,
      "92786": true,
      "92787": true,
      "92788": true,
      "92789": true,
      "92790": true,
      "92791": true,
      "92792": true,
      "92793": true,
      "92794": true,
      "92795": true,
      "92796": true,
      "92797": true,
      "92798": true,
      "92799": true,
      "92800": true,
      "92801": true,
      "92802": true,
      "92803": true,
      "92804": true,
      "92805": true,
      "92806": true,
      "92807": true,
      "92808": true,
      "92809": true,
      "92810": true,
      "92811": true,
      "92812": true,
      "92813": true,
      "92814": true,
      "92815": true,
      "92816": true,
      "92817": true,
      "92818": true,
      "92819": true,
      "92820": true,
      "92821": true,
      "92822": true,
      "92823": true,
      "92824": true,
      "92825": true,
      "92826": true,
      "92827": true,
      "92828": true,
      "92829": true,
      "92830": true,
      "92831": true,
      "92832": true,
      "92833": true,
      "92834": true,
      "92835": true,
      "92836": true,
      "92837": true,
      "92838": true,
      "92839": true,
      "92840": true,
      "92841": true,
      "92842": true,
      "92843": true,
      "92844": true,
      "92845": true,
      "92846": true,
      "92847": true,
      "92848": true,
      "92849": true,
      "92850": true,
      "92851": true,
      "92852": true,
      "92853": true,
      "92854": true,
      "92855": true,
      "92856": true,
      "92857": true,
      "92858": true,
      "92859": true,
      "92860": true,
      "92861": true,
      "92862": true,
      "92863": true,
      "92864": true,
      "92865": true,
      "92866": true,
      "92867": true,
      "92868": true,
      "92869": true,
      "92870": true,
      "92871": true,
      "92872": true,
      "92873": true,
      "92874": true,
      "92875": true,
      "92876": true,
      "92877": true,
      "92878": true,
      "92879": true,
      "92880": true,
      "92881": true,
      "92882": true,
      "92883": true,
      "92884": true,
      "92885": true,
      "92886": true,
      "92887": true,
      "92888": true,
      "92889": true,
      "92890": true,
      "92891": true,
      "92892": true,
      "92893": true,
      "92894": true,
      "92895": true,
      "92896": true,
      "92897": true,
      "92898": true,
      "92899": true
    },
    "TIHUATLAN": {
      "92900": true,
      "92901": true,
      "92902": true,
      "92903": true,
      "92904": true,
      "92905": true,
      "92906": true,
      "92907": true,
      "92908": true,
      "92909": true,
      "92910": true,
      "92911": true,
      "92912": true,
      "92914": true,
      "92916": true,
      "92917": true,
      "92918": true,
      "92919": true,
      "92920": true,
      "92921": true,
      "92922": true,
      "92925": true,
      "92928": true,
      "92929": true,
      "92930": true,
      "92931": true,
      "92932": true,
      "92933": true,
      "92934": true,
      "92935": true,
      "92936": true,
      "92937": true,
      "92938": true,
      "92939": true
    },
    "CASTILLO DE TEAYO": {
      "92940": true,
      "92941": true,
      "92942": true,
      "92943": true,
      "92944": true,
      "92945": true,
      "92946": true,
      "92947": true,
      "92948": true,
      "92949": true,
      "92950": true,
      "92951": true,
      "92952": true,
      "92953": true,
      "92954": true,
      "92955": true,
      "92956": true,
      "92957": true,
      "92958": true,
      "92959": true,
      "92960": true,
      "92961": true,
      "92962": true,
      "92963": true,
      "92964": true,
      "92965": true,
      "92966": true,
      "92967": true,
      "92968": true,
      "92969": true
    },
    "CAZONES DE HERRERA": {
      "92970": true,
      "92971": true,
      "92972": true,
      "92973": true,
      "92974": true,
      "92975": true,
      "92976": true,
      "92977": true,
      "92978": true,
      "92979": true,
      "92980": true,
      "92981": true,
      "92982": true,
      "92983": true,
      "92984": true,
      "92985": true,
      "92986": true,
      "92987": true,
      "92988": true,
      "92989": true,
      "92990": true,
      "92991": true,
      "92992": true,
      "92993": true,
      "92994": true,
      "92995": true,
      "92996": true,
      "92997": true,
      "92998": true,
      "92999": true
    },
    "ZOZOCOLCO DE HIDALGO": {
      "93000": true,
      "93001": true,
      "93002": true,
      "93003": true,
      "93004": true,
      "93005": true,
      "93006": true,
      "93007": true,
      "93008": true,
      "93009": true,
      "93010": true,
      "93011": true,
      "93012": true,
      "93013": true,
      "93014": true,
      "93015": true,
      "93016": true,
      "93017": true,
      "93018": true,
      "93019": true,
      "93020": true,
      "93021": true,
      "93022": true,
      "93023": true,
      "93024": true,
      "93025": true,
      "93026": true,
      "93027": true,
      "93028": true,
      "93029": true,
      "93030": true,
      "93031": true,
      "93032": true,
      "93033": true,
      "93034": true,
      "93035": true,
      "93036": true,
      "93037": true,
      "93038": true,
      "93039": true
    },
    "COXQUIHUI": {
      "93060": true,
      "93061": true,
      "93062": true,
      "93063": true,
      "93064": true,
      "93065": true,
      "93066": true,
      "93067": true,
      "93068": true,
      "93069": true,
      "93070": true,
      "93071": true,
      "93072": true,
      "93073": true,
      "93074": true,
      "93075": true,
      "93076": true,
      "93077": true,
      "93078": true,
      "93079": true
    },
    "COAHUITLAN": {
      "93120": true,
      "93121": true,
      "93122": true,
      "93123": true,
      "93124": true,
      "93125": true,
      "93126": true,
      "93127": true,
      "93128": true,
      "93129": true,
      "93130": true,
      "93131": true,
      "93132": true,
      "93133": true,
      "93134": true,
      "93135": true,
      "93136": true,
      "93137": true,
      "93138": true,
      "93139": true
    },
    "COYUTLA": {
      "93140": true,
      "93141": true,
      "93142": true,
      "93143": true,
      "93144": true,
      "93145": true,
      "93146": true,
      "93147": true,
      "93148": true,
      "93149": true,
      "93150": true,
      "93151": true,
      "93152": true,
      "93153": true,
      "93154": true,
      "93155": true,
      "93156": true,
      "93157": true,
      "93158": true,
      "93159": true
    },
    "COATZINTLA": {
      "93160": true,
      "93161": true,
      "93162": true,
      "93163": true,
      "93164": true,
      "93165": true,
      "93166": true,
      "93167": true,
      "93168": true,
      "93169": true,
      "93172": true,
      "93173": true,
      "93174": true,
      "93175": true,
      "93176": true,
      "93177": true,
      "93178": true,
      "93179": true
    },
    "ESPINAL": {
      "93180": true,
      "93181": true,
      "93182": true,
      "93183": true,
      "93184": true,
      "93185": true,
      "93186": true,
      "93187": true,
      "93188": true,
      "93189": true,
      "93190": true,
      "93191": true,
      "93192": true,
      "93193": true,
      "93194": true,
      "93195": true,
      "93196": true,
      "93197": true,
      "93198": true
    },
    "POZA RICA DE HIDALGO": {
      "93210": true,
      "93211": true,
      "93212": true,
      "93213": true,
      "93214": true,
      "93215": true,
      "93216": true,
      "93217": true,
      "93218": true,
      "93219": true,
      "93220": true,
      "93221": true,
      "93222": true,
      "93223": true,
      "93224": true,
      "93225": true,
      "93226": true,
      "93227": true,
      "93228": true,
      "93229": true,
      "93230": true,
      "93231": true,
      "93232": true,
      "93233": true,
      "93234": true,
      "93235": true,
      "93236": true,
      "93237": true,
      "93238": true,
      "93239": true,
      "93240": true,
      "93241": true,
      "93242": true,
      "93243": true,
      "93244": true,
      "93245": true,
      "93246": true,
      "93247": true,
      "93248": true,
      "93249": true,
      "93250": true,
      "93251": true,
      "93252": true,
      "93253": true,
      "93254": true,
      "93255": true,
      "93256": true,
      "93257": true,
      "93258": true,
      "93259": true,
      "93260": true,
      "93261": true,
      "93262": true,
      "93263": true,
      "93264": true,
      "93265": true,
      "93266": true,
      "93267": true,
      "93268": true,
      "93269": true,
      "93270": true,
      "93271": true,
      "93272": true,
      "93273": true,
      "93274": true,
      "93275": true,
      "93276": true,
      "93277": true,
      "93278": true,
      "93279": true,
      "93280": true,
      "93281": true,
      "93282": true,
      "93283": true,
      "93284": true,
      "93285": true,
      "93286": true,
      "93287": true,
      "93288": true,
      "93289": true,
      "93290": true,
      "93291": true,
      "93292": true,
      "93293": true,
      "93294": true,
      "93295": true,
      "93296": true,
      "93297": true,
      "93298": true,
      "93299": true,
      "93300": true,
      "93301": true,
      "93302": true,
      "93303": true,
      "93304": true,
      "93305": true,
      "93306": true,
      "93307": true,
      "93308": true,
      "93309": true,
      "93310": true,
      "93311": true,
      "93312": true,
      "93313": true,
      "93314": true,
      "93315": true,
      "93316": true,
      "93317": true,
      "93318": true,
      "93319": true,
      "93320": true,
      "93321": true,
      "93322": true,
      "93323": true,
      "93324": true,
      "93325": true,
      "93326": true,
      "93327": true,
      "93328": true,
      "93329": true,
      "93330": true,
      "93331": true,
      "93332": true,
      "93333": true,
      "93334": true,
      "93335": true,
      "93336": true,
      "93337": true,
      "93338": true,
      "93339": true,
      "93340": true,
      "93341": true,
      "93342": true,
      "93343": true,
      "93344": true,
      "93345": true,
      "93346": true,
      "93347": true,
      "93348": true,
      "93349": true,
      "93350": true,
      "93351": true,
      "93352": true,
      "93353": true,
      "93354": true,
      "93355": true,
      "93356": true,
      "93357": true,
      "93358": true,
      "93359": true,
      "93360": true,
      "93361": true,
      "93362": true,
      "93363": true,
      "93364": true,
      "93365": true,
      "93366": true,
      "93367": true,
      "93368": true,
      "93369": true,
      "93370": true,
      "93371": true,
      "93372": true,
      "93373": true,
      "93374": true,
      "93375": true,
      "93376": true,
      "93377": true,
      "93378": true,
      "93379": true,
      "93380": true,
      "93381": true,
      "93382": true,
      "93383": true,
      "93384": true,
      "93385": true,
      "93386": true,
      "93387": true,
      "93388": true,
      "93389": true,
      "93390": true,
      "93391": true,
      "93392": true,
      "93393": true,
      "93394": true,
      "93395": true,
      "93396": true,
      "93397": true,
      "93398": true,
      "93399": true
    },
    "PAPANTLA": {
      "93400": true,
      "93401": true,
      "93402": true,
      "93403": true,
      "93404": true,
      "93405": true,
      "93406": true,
      "93407": true,
      "93408": true,
      "93409": true,
      "93410": true,
      "93411": true,
      "93412": true,
      "93413": true,
      "93414": true,
      "93415": true,
      "93416": true,
      "93417": true,
      "93418": true,
      "93419": true,
      "93420": true,
      "93421": true,
      "93422": true,
      "93423": true,
      "93424": true,
      "93425": true,
      "93426": true,
      "93427": true,
      "93428": true,
      "93429": true,
      "93430": true,
      "93431": true,
      "93432": true,
      "93433": true,
      "93434": true,
      "93435": true,
      "93436": true,
      "93437": true,
      "93438": true,
      "93439": true,
      "93440": true,
      "93441": true,
      "93442": true,
      "93443": true,
      "93444": true,
      "93445": true,
      "93446": true,
      "93447": true,
      "93448": true,
      "93449": true,
      "93450": true,
      "93451": true,
      "93452": true,
      "93453": true,
      "93454": true,
      "93455": true,
      "93456": true,
      "93457": true,
      "93458": true,
      "93459": true,
      "93460": true,
      "93461": true,
      "93462": true,
      "93463": true,
      "93464": true,
      "93465": true,
      "93466": true,
      "93467": true,
      "93468": true,
      "93469": true,
      "93470": true,
      "93471": true,
      "93472": true,
      "93473": true,
      "93474": true,
      "93475": true,
      "93476": true,
      "93477": true,
      "93478": true,
      "93479": true,
      "93480": true,
      "93481": true,
      "93482": true,
      "93483": true,
      "93484": true,
      "93485": true,
      "93486": true,
      "93487": true,
      "93488": true,
      "93489": true,
      "93490": true,
      "93491": true,
      "93492": true,
      "93493": true,
      "93494": true,
      "93495": true,
      "93496": true,
      "93497": true,
      "93498": true,
      "93499": true,
      "93500": true,
      "93501": true,
      "93502": true,
      "93503": true,
      "93504": true,
      "93505": true,
      "93506": true,
      "93507": true,
      "93508": true,
      "93509": true,
      "93510": true,
      "93511": true,
      "93512": true,
      "93513": true,
      "93514": true,
      "93515": true,
      "93516": true,
      "93517": true,
      "93518": true,
      "93519": true,
      "93520": true,
      "93521": true,
      "93522": true,
      "93523": true,
      "93524": true,
      "93525": true,
      "93526": true,
      "93527": true,
      "93528": true,
      "93529": true,
      "93530": true,
      "93531": true,
      "93532": true,
      "93533": true,
      "93534": true,
      "93535": true,
      "93537": true,
      "93542": true,
      "93543": true,
      "93544": true,
      "93549": true
    },
    "GUTIERREZ ZAMORA": {
      "93550": true,
      "93551": true,
      "93552": true,
      "93553": true,
      "93554": true,
      "93555": true,
      "93556": true,
      "93557": true,
      "93558": true,
      "93559": true,
      "93560": true,
      "93561": true,
      "93562": true,
      "93563": true,
      "93564": true,
      "93565": true,
      "93566": true,
      "93567": true,
      "93568": true,
      "93569": true
    },
    "TECOLUTLA": {
      "93570": true,
      "93575": true,
      "93576": true,
      "93577": true,
      "93578": true,
      "93579": true,
      "93585": true,
      "93586": true,
      "93587": true,
      "93588": true,
      "93589": true,
      "93590": true,
      "93591": true,
      "93592": true,
      "93593": true,
      "93594": true,
      "93595": true,
      "93596": true,
      "93597": true,
      "93598": true,
      "93599": true
    },
    "MARTINEZ DE LA TORRE": {
      "93600": true,
      "93601": true,
      "93602": true,
      "93603": true,
      "93604": true,
      "93605": true,
      "93606": true,
      "93607": true,
      "93608": true,
      "93609": true,
      "93610": true,
      "93611": true,
      "93612": true,
      "93613": true,
      "93614": true,
      "93615": true,
      "93616": true,
      "93617": true,
      "93618": true,
      "93619": true,
      "93633": true,
      "93634": true,
      "93635": true,
      "93638": true,
      "93639": true,
      "93640": true,
      "93641": true,
      "93642": true,
      "93643": true,
      "93644": true,
      "93645": true,
      "93646": true,
      "93647": true,
      "93648": true,
      "93649": true
    },
    "SAN RAFAEL": {
      "93620": true,
      "93621": true,
      "93622": true,
      "93623": true,
      "93624": true,
      "93625": true,
      "93626": true,
      "93627": true,
      "93628": true,
      "93629": true,
      "93630": true,
      "93631": true,
      "93632": true
    },
    "TLAPACOYAN": {
      "93650": true,
      "93651": true,
      "93652": true,
      "93653": true,
      "93654": true,
      "93655": true,
      "93656": true,
      "93657": true,
      "93658": true,
      "93659": true
    },
    "ATZALAN": {
      "93680": true,
      "93681": true,
      "93682": true,
      "93693": true,
      "93695": true,
      "93697": true,
      "93699": true
    },
    "ALTOTONGA": {
      "93700": true,
      "93701": true,
      "93702": true,
      "93703": true,
      "93704": true,
      "93705": true,
      "93706": true,
      "93707": true,
      "93708": true,
      "93709": true,
      "93710": true,
      "93711": true,
      "93712": true,
      "93713": true,
      "93720": true,
      "93721": true,
      "93722": true,
      "93723": true,
      "93724": true,
      "93725": true,
      "93726": true,
      "93727": true,
      "93728": true,
      "93729": true,
      "93730": true,
      "93731": true,
      "93732": true,
      "93733": true,
      "93734": true,
      "93735": true,
      "93736": true,
      "93737": true,
      "93738": true,
      "93739": true
    },
    "LAS MINAS": {
      "93740": true,
      "93741": true,
      "93742": true,
      "93743": true,
      "93744": true,
      "93745": true,
      "93746": true,
      "93747": true,
      "93748": true,
      "93749": true,
      "93750": true,
      "93751": true,
      "93752": true,
      "93753": true,
      "93754": true,
      "93755": true,
      "93756": true,
      "93757": true,
      "93758": true,
      "93759": true
    },
    "TATATILA": {
      "93760": true,
      "93761": true,
      "93762": true,
      "93763": true,
      "93764": true,
      "93765": true,
      "93769": true,
      "93770": true,
      "93771": true,
      "93772": true,
      "93773": true,
      "93774": true,
      "93775": true,
      "93776": true,
      "93777": true,
      "93778": true,
      "93779": true
    },
    "MISANTLA": {
      "93820": true,
      "93821": true,
      "93822": true,
      "93823": true,
      "93824": true,
      "93825": true,
      "93826": true,
      "93827": true,
      "93828": true,
      "93829": true,
      "93834": true,
      "93835": true,
      "93836": true,
      "93837": true,
      "93838": true,
      "93839": true,
      "93843": true,
      "93844": true,
      "93845": true,
      "93846": true,
      "93847": true,
      "93848": true,
      "93849": true,
      "93850": true,
      "93851": true,
      "93852": true,
      "93853": true,
      "93854": true,
      "93855": true,
      "93856": true,
      "93857": true,
      "93858": true,
      "93859": true
    },
    "LANDERO Y COSS": {
      "93860": true,
      "93861": true,
      "93862": true,
      "93863": true,
      "93864": true,
      "93865": true,
      "93866": true,
      "93867": true,
      "93868": true,
      "93869": true,
      "93870": true,
      "93871": true,
      "93872": true,
      "93873": true,
      "93874": true,
      "93875": true,
      "93876": true,
      "93877": true,
      "93878": true,
      "93879": true
    },
    "CHICONQUIACO": {
      "93880": true,
      "93881": true,
      "93883": true,
      "93884": true,
      "93892": true,
      "93894": true,
      "93895": true,
      "93896": true,
      "93897": true
    },
    "YECUATLA": {
      "93900": true,
      "93901": true,
      "93902": true,
      "93903": true,
      "93904": true,
      "93907": true,
      "93908": true,
      "93909": true,
      "93910": true,
      "93911": true,
      "93912": true,
      "93913": true,
      "93914": true,
      "93915": true,
      "93916": true,
      "93917": true,
      "93918": true,
      "93919": true,
      "93920": true,
      "93921": true,
      "93922": true,
      "93923": true,
      "93924": true,
      "93925": true,
      "93926": true,
      "93927": true,
      "93928": true,
      "93929": true,
      "93930": true,
      "93931": true,
      "93932": true,
      "93933": true,
      "93934": true,
      "93935": true,
      "93936": true,
      "93937": true,
      "93938": true,
      "93939": true,
      "93940": true,
      "93941": true,
      "93942": true,
      "93943": true,
      "93944": true,
      "93945": true,
      "93946": true,
      "93947": true,
      "93948": true,
      "93949": true
    },
    "VEGA DE ALATORRE": {
      "93960": true,
      "93961": true,
      "93962": true,
      "93963": true,
      "93964": true,
      "93965": true,
      "93966": true,
      "93967": true,
      "93968": true,
      "93969": true,
      "93970": true,
      "93971": true,
      "93972": true,
      "93973": true,
      "93974": true,
      "93975": true,
      "93976": true,
      "93977": true,
      "93978": true,
      "93979": true,
      "93980": true,
      "93981": true,
      "93982": true,
      "93983": true,
      "93984": true,
      "93985": true
    },
    "JALCOMULCO": {
      "94000": true,
      "94001": true,
      "94002": true,
      "94003": true,
      "94004": true,
      "94005": true,
      "94006": true,
      "94007": true,
      "94008": true,
      "94009": true,
      "94010": true,
      "94011": true,
      "94012": true,
      "94013": true,
      "94014": true,
      "94015": true,
      "94016": true,
      "94017": true,
      "94018": true,
      "94019": true
    },
    "TLALTETELA": {
      "94020": true,
      "94023": true,
      "94024": true,
      "94025": true,
      "94026": true,
      "94027": true,
      "94028": true,
      "94029": true
    },
    "TENAMPA": {
      "94030": true,
      "94031": true,
      "94032": true,
      "94033": true,
      "94034": true,
      "94035": true
    },
    "HUATUSCO": {
      "94100": true,
      "94101": true,
      "94102": true,
      "94103": true,
      "94104": true,
      "94105": true,
      "94106": true,
      "94107": true,
      "94108": true,
      "94109": true,
      "94110": true,
      "94111": true,
      "94112": true,
      "94113": true,
      "94114": true,
      "94115": true,
      "94116": true,
      "94117": true,
      "94118": true,
      "94119": true
    },
    "COSCOMATEPEC": {
      "94140": true,
      "94141": true,
      "94142": true,
      "94143": true,
      "94144": true,
      "94145": true,
      "94146": true,
      "94147": true,
      "94148": true,
      "94149": true
    },
    "ZENTLA": {
      "94220": true,
      "94221": true,
      "94222": true,
      "94223": true,
      "94224": true,
      "94225": true,
      "94226": true,
      "94227": true,
      "94228": true
    },
    "CAMARON DE TEJEDA": {
      "94230": true,
      "94231": true,
      "94232": true,
      "94233": true,
      "94234": true,
      "94235": true,
      "94236": true,
      "94237": true,
      "94238": true,
      "94239": true
    },
    "SOLEDAD DE DOBLADO": {
      "94240": true,
      "94241": true,
      "94242": true,
      "94243": true,
      "94244": true,
      "94245": true,
      "94246": true,
      "94247": true,
      "94248": true,
      "94249": true
    },
    "JAMAPA": {
      "94260": true,
      "94261": true,
      "94262": true,
      "94263": true,
      "94264": true,
      "94265": true,
      "94266": true,
      "94267": true,
      "94268": true,
      "94269": true
    },
    "MEDELLÍN DE BRAVO": {
      "94270": true,
      "94271": true,
      "94272": true,
      "94273": true,
      "94274": true,
      "94275": true,
      "94276": true,
      "94277": true,
      "94278": true,
      "94279": true,
      "94280": true,
      "94281": true,
      "94282": true,
      "94283": true
    },
    "BOCA DEL RÍO": {
      "94285": true,
      "94286": true,
      "94287": true,
      "94288": true,
      "94289": true,
      "94290": true,
      "94291": true,
      "94292": true,
      "94293": true,
      "94294": true,
      "94295": true,
      "94296": true,
      "94297": true,
      "94298": true,
      "94299": true
    },
    "ORIZABA": {
      "94300": true,
      "94301": true,
      "94302": true,
      "94303": true,
      "94304": true,
      "94305": true,
      "94306": true,
      "94307": true,
      "94308": true,
      "94309": true,
      "94310": true,
      "94311": true,
      "94312": true,
      "94313": true,
      "94314": true,
      "94315": true,
      "94316": true,
      "94317": true,
      "94318": true,
      "94319": true,
      "94320": true,
      "94321": true,
      "94322": true,
      "94323": true,
      "94324": true,
      "94325": true,
      "94326": true,
      "94327": true,
      "94328": true,
      "94329": true,
      "94330": true,
      "94331": true,
      "94332": true,
      "94333": true,
      "94334": true,
      "94335": true,
      "94336": true,
      "94337": true,
      "94338": true,
      "94339": true,
      "94340": true,
      "94341": true,
      "94342": true,
      "94343": true,
      "94344": true,
      "94345": true,
      "94346": true,
      "94347": true,
      "94348": true,
      "94349": true,
      "94350": true,
      "94351": true,
      "94352": true,
      "94353": true,
      "94354": true,
      "94355": true,
      "94356": true,
      "94357": true,
      "94358": true,
      "94359": true,
      "94360": true,
      "94361": true,
      "94362": true,
      "94363": true,
      "94364": true,
      "94365": true,
      "94366": true,
      "94367": true,
      "94368": true,
      "94369": true,
      "94370": true,
      "94371": true,
      "94372": true,
      "94373": true,
      "94374": true,
      "94375": true,
      "94376": true,
      "94377": true,
      "94378": true,
      "94379": true,
      "94380": true,
      "94381": true,
      "94382": true,
      "94383": true,
      "94384": true,
      "94385": true,
      "94386": true,
      "94387": true,
      "94388": true,
      "94389": true,
      "94390": true,
      "94391": true,
      "94392": true,
      "94393": true,
      "94394": true,
      "94395": true,
      "94396": true,
      "94397": true,
      "94398": true,
      "94399": true,
      "94400": true,
      "94401": true,
      "94402": true,
      "94403": true,
      "94404": true,
      "94405": true,
      "94406": true,
      "94407": true,
      "94408": true,
      "94409": true
    },
    "MARIANO ESCOBEDO": {
      "94420": true,
      "94421": true,
      "94422": true,
      "94423": true,
      "94424": true,
      "94425": true,
      "94426": true,
      "94427": true
    },
    "IXHUATLANCILLO": {
      "94430": true,
      "94431": true,
      "94432": true,
      "94433": true,
      "94434": true,
      "94435": true,
      "94436": true,
      "94437": true,
      "94438": true,
      "94439": true
    },
    "ATZACAN": {
      "94440": true,
      "94441": true,
      "94442": true,
      "94443": true,
      "94444": true,
      "94445": true,
      "94446": true,
      "94447": true,
      "94448": true,
      "94449": true
    },
    "IXTACZOQUITLAN": {
      "94450": true,
      "94451": true,
      "94452": true,
      "94453": true,
      "94454": true,
      "94455": true,
      "94456": true,
      "94457": true,
      "94458": true,
      "94459": true,
      "94460": true,
      "94461": true,
      "94462": true,
      "94463": true,
      "94464": true,
      "94465": true
    },
    "FORTIN": {
      "94466": true,
      "94467": true,
      "94468": true,
      "94469": true,
      "94470": true,
      "94471": true,
      "94472": true,
      "94473": true,
      "94474": true,
      "94475": true,
      "94476": true,
      "94477": true,
      "94478": true,
      "94479": true
    },
    "CORDOBA": {
      "94480": true,
      "94481": true,
      "94482": true,
      "94483": true,
      "94484": true,
      "94485": true,
      "94486": true,
      "94487": true,
      "94488": true,
      "94489": true,
      "94490": true,
      "94491": true,
      "94492": true,
      "94493": true,
      "94494": true,
      "94495": true,
      "94496": true,
      "94497": true,
      "94498": true,
      "94499": true,
      "94500": true,
      "94501": true,
      "94502": true,
      "94503": true,
      "94504": true,
      "94505": true,
      "94506": true,
      "94507": true,
      "94508": true,
      "94509": true,
      "94510": true,
      "94511": true,
      "94512": true,
      "94513": true,
      "94514": true,
      "94515": true,
      "94516": true,
      "94517": true,
      "94518": true,
      "94519": true,
      "94520": true,
      "94521": true,
      "94522": true,
      "94523": true,
      "94524": true,
      "94525": true,
      "94526": true,
      "94527": true,
      "94528": true,
      "94529": true,
      "94530": true,
      "94531": true,
      "94532": true,
      "94533": true,
      "94534": true,
      "94535": true,
      "94536": true,
      "94537": true,
      "94538": true,
      "94539": true,
      "94540": true,
      "94541": true,
      "94542": true,
      "94543": true,
      "94544": true,
      "94545": true,
      "94546": true,
      "94547": true,
      "94548": true,
      "94549": true,
      "94550": true,
      "94551": true,
      "94552": true,
      "94553": true,
      "94554": true,
      "94555": true,
      "94556": true,
      "94557": true,
      "94558": true,
      "94559": true,
      "94560": true,
      "94561": true,
      "94562": true,
      "94563": true,
      "94564": true,
      "94565": true,
      "94566": true,
      "94567": true,
      "94568": true,
      "94569": true,
      "94570": true,
      "94571": true,
      "94572": true,
      "94573": true,
      "94574": true,
      "94575": true,
      "94576": true,
      "94577": true,
      "94578": true,
      "94579": true,
      "94580": true,
      "94581": true,
      "94582": true,
      "94583": true,
      "94584": true,
      "94585": true,
      "94586": true,
      "94587": true,
      "94588": true,
      "94589": true,
      "94590": true,
      "94591": true,
      "94592": true,
      "94593": true,
      "94594": true,
      "94595": true,
      "94596": true,
      "94597": true,
      "94598": true,
      "94599": true,
      "94600": true,
      "94601": true,
      "94602": true,
      "94603": true,
      "94604": true,
      "94605": true,
      "94606": true,
      "94607": true,
      "94608": true,
      "94609": true,
      "94610": true,
      "94611": true,
      "94612": true,
      "94613": true,
      "94614": true,
      "94615": true,
      "94616": true,
      "94617": true,
      "94618": true,
      "94619": true,
      "94620": true,
      "94621": true,
      "94622": true,
      "94623": true,
      "94624": true,
      "94625": true,
      "94626": true,
      "94627": true,
      "94628": true,
      "94629": true,
      "94630": true,
      "94631": true,
      "94632": true,
      "94633": true,
      "94634": true,
      "94635": true,
      "94636": true,
      "94637": true,
      "94638": true,
      "94639": true,
      "94640": true,
      "94641": true,
      "94642": true,
      "94643": true,
      "94644": true,
      "94645": true,
      "94646": true,
      "94647": true,
      "94648": true,
      "94649": true,
      "94650": true,
      "94651": true,
      "94652": true,
      "94653": true,
      "94654": true,
      "94655": true,
      "94656": true,
      "94657": true,
      "94658": true,
      "94659": true,
      "94660": true,
      "94661": true,
      "94662": true,
      "94663": true,
      "94664": true,
      "94665": true,
      "94666": true,
      "94667": true,
      "94668": true,
      "94669": true,
      "94670": true,
      "94671": true,
      "94672": true,
      "94673": true,
      "94674": true,
      "94675": true,
      "94676": true,
      "94677": true,
      "94678": true,
      "94679": true,
      "94680": true,
      "94681": true,
      "94682": true,
      "94683": true,
      "94684": true,
      "94685": true,
      "94686": true,
      "94687": true,
      "94688": true,
      "94689": true,
      "94690": true,
      "94691": true,
      "94692": true,
      "94693": true,
      "94694": true,
      "94695": true,
      "94696": true,
      "94697": true,
      "94698": true,
      "94699": true
    },
    "NOGALES": {
      "94720": true,
      "94721": true,
      "94722": true,
      "94723": true,
      "94724": true,
      "94725": true,
      "94726": true,
      "94727": true,
      "94728": true,
      "94729": true
    },
    "RIO BLANCO": {
      "94730": true,
      "94731": true,
      "94732": true,
      "94733": true,
      "94734": true,
      "94735": true,
      "94736": true,
      "94737": true,
      "94738": true,
      "94739": true
    },
    "CAMERINO Z. MENDOZA": {
      "94740": true,
      "94741": true,
      "94742": true,
      "94743": true,
      "94744": true,
      "94745": true,
      "94746": true,
      "94747": true,
      "94748": true,
      "94749": true
    },
    "CUITLAHUAC": {
      "94910": true,
      "94911": true,
      "94912": true,
      "94913": true,
      "94914": true,
      "94915": true,
      "94916": true,
      "94917": true,
      "94918": true,
      "94919": true
    },
    "PASO DEL MACHO": {
      "94970": true,
      "94971": true,
      "94972": true,
      "94974": true,
      "94975": true,
      "94976": true,
      "94977": true,
      "94978": true,
      "94979": true
    },
    "CARRILLO PUERTO": {
      "94980": true,
      "94981": true,
      "94982": true,
      "94983": true,
      "94984": true,
      "94985": true,
      "94986": true,
      "94987": true,
      "94988": true,
      "94989": true
    },
    "COTAXTLA": {
      "94990": true,
      "94991": true,
      "94995": true,
      "94996": true,
      "94997": true,
      "94998": true,
      "94999": true
    },
    "TEZONAPA": {
      "95080": true,
      "95081": true,
      "95082": true,
      "95083": true,
      "95085": true,
      "95093": true,
      "95094": true,
      "95095": true,
      "95096": true,
      "95097": true,
      "95098": true,
      "95099": true
    },
    "TIERRA BLANCA": {
      "95100": true,
      "95101": true,
      "95102": true,
      "95103": true,
      "95104": true,
      "95105": true,
      "95106": true,
      "95107": true,
      "95108": true,
      "95109": true,
      "95110": true,
      "95111": true,
      "95112": true,
      "95113": true,
      "95114": true,
      "95115": true,
      "95116": true,
      "95117": true,
      "95118": true,
      "95119": true,
      "95120": true,
      "95121": true,
      "95122": true,
      "95123": true,
      "95124": true,
      "95125": true,
      "95126": true,
      "95127": true,
      "95128": true,
      "95129": true,
      "95130": true,
      "95131": true,
      "95132": true,
      "95133": true,
      "95134": true,
      "95135": true,
      "95136": true,
      "95137": true,
      "95138": true,
      "95139": true,
      "95140": true,
      "95141": true,
      "95142": true,
      "95143": true,
      "95144": true,
      "95145": true,
      "95146": true,
      "95147": true,
      "95148": true,
      "95149": true,
      "95150": true,
      "95151": true,
      "95152": true,
      "95153": true,
      "95154": true,
      "95155": true,
      "95156": true,
      "95157": true,
      "95158": true,
      "95159": true,
      "95160": true,
      "95161": true,
      "95162": true,
      "95163": true,
      "95164": true,
      "95165": true,
      "95166": true,
      "95167": true,
      "95168": true,
      "95169": true,
      "95170": true,
      "95171": true,
      "95172": true,
      "95173": true,
      "95174": true,
      "95175": true,
      "95176": true,
      "95177": true,
      "95178": true,
      "95179": true,
      "95180": true,
      "95181": true,
      "95182": true,
      "95183": true,
      "95184": true,
      "95185": true,
      "95186": true,
      "95187": true,
      "95188": true,
      "95189": true,
      "95190": true,
      "95191": true,
      "95192": true,
      "95193": true,
      "95194": true,
      "95195": true,
      "95196": true,
      "95197": true,
      "95198": true,
      "95199": true,
      "95200": true,
      "95201": true,
      "95202": true,
      "95203": true,
      "95204": true,
      "95205": true,
      "95206": true,
      "95207": true,
      "95208": true,
      "95214": true,
      "95216": true,
      "95217": true,
      "95218": true,
      "95219": true
    },
    "TLALIXCOYAN": {
      "95220": true,
      "95221": true,
      "95222": true,
      "95224": true,
      "95225": true,
      "95226": true,
      "95230": true,
      "95231": true,
      "95232": true,
      "95233": true,
      "95234": true,
      "95235": true,
      "95236": true,
      "95237": true,
      "95238": true,
      "95239": true
    },
    "IGNACIO DE LA LLAVE": {
      "95240": true,
      "95241": true,
      "95242": true,
      "95243": true,
      "95244": true,
      "95246": true,
      "95247": true,
      "95248": true,
      "95249": true
    },
    "ALVARADO": {
      "95259": true,
      "95260": true,
      "95261": true,
      "95262": true,
      "95263": true,
      "95264": true,
      "95266": true,
      "95267": true,
      "95269": true,
      "95270": true,
      "95271": true,
      "95272": true,
      "95273": true,
      "95275": true,
      "95276": true,
      "95277": true,
      "95278": true,
      "95279": true
    },
    "LERDO DE TEJADA": {
      "95280": true,
      "95281": true,
      "95282": true,
      "95283": true,
      "95284": true,
      "95285": true,
      "95286": true,
      "95287": true,
      "95288": true,
      "95289": true,
      "95290": true,
      "95291": true,
      "95292": true,
      "95293": true,
      "95294": true,
      "95295": true,
      "95296": true,
      "95297": true,
      "95298": true,
      "95299": true
    },
    "TRES VALLES": {
      "95300": true,
      "95301": true,
      "95302": true,
      "95303": true,
      "95304": true,
      "95305": true,
      "95306": true,
      "95307": true,
      "95308": true,
      "95309": true,
      "95310": true,
      "95311": true,
      "95312": true,
      "95313": true,
      "95314": true,
      "95315": true,
      "95316": true,
      "95317": true,
      "95318": true,
      "95319": true,
      "95320": true,
      "95321": true,
      "95322": true,
      "95323": true,
      "95324": true,
      "95325": true,
      "95326": true,
      "95327": true,
      "95328": true,
      "95329": true,
      "95350": true,
      "95351": true,
      "95352": true,
      "95353": true,
      "95354": true,
      "95355": true,
      "95356": true,
      "95357": true,
      "95358": true,
      "95359": true,
      "95360": true,
      "95361": true,
      "95362": true,
      "95363": true,
      "95364": true,
      "95365": true,
      "95366": true,
      "95367": true,
      "95368": true,
      "95369": true,
      "95370": true,
      "95371": true,
      "95372": true,
      "95373": true,
      "95374": true,
      "95375": true,
      "95376": true,
      "95377": true,
      "95378": true,
      "95379": true,
      "95380": true,
      "95381": true,
      "95382": true,
      "95383": true,
      "95384": true,
      "95385": true,
      "95386": true,
      "95387": true,
      "95388": true,
      "95389": true
    },
    "TLACOTALPAN": {
      "95460": true,
      "95461": true,
      "95462": true,
      "95463": true,
      "95464": true,
      "95465": true,
      "95466": true,
      "95467": true,
      "95468": true,
      "95469": true
    },
    "ISLA": {
      "95640": true,
      "95641": true,
      "95642": true,
      "95643": true,
      "95644": true,
      "95645": true,
      "95646": true,
      "95647": true,
      "95648": true,
      "95649": true,
      "95650": true,
      "95651": true,
      "95652": true,
      "95653": true,
      "95654": true,
      "95655": true,
      "95656": true,
      "95658": true,
      "95659": true,
      "95660": true,
      "95661": true,
      "95662": true,
      "95663": true,
      "95664": true,
      "95665": true,
      "95666": true,
      "95667": true,
      "95668": true,
      "95669": true
    },
    "SAN ANDRES TUXTLA": {
      "95700": true,
      "95701": true,
      "95702": true,
      "95703": true,
      "95704": true,
      "95705": true,
      "95706": true,
      "95707": true,
      "95708": true,
      "95709": true,
      "95710": true,
      "95711": true,
      "95712": true,
      "95713": true,
      "95714": true,
      "95715": true,
      "95716": true,
      "95717": true,
      "95718": true,
      "95719": true,
      "95720": true,
      "95721": true,
      "95722": true,
      "95723": true,
      "95724": true,
      "95725": true,
      "95726": true,
      "95727": true,
      "95728": true,
      "95729": true,
      "95730": true,
      "95731": true,
      "95732": true,
      "95733": true,
      "95734": true,
      "95735": true,
      "95736": true,
      "95737": true,
      "95738": true,
      "95739": true,
      "95740": true,
      "95741": true,
      "95742": true,
      "95743": true,
      "95744": true,
      "95745": true,
      "95746": true,
      "95747": true,
      "95748": true,
      "95749": true,
      "95750": true,
      "95751": true,
      "95752": true,
      "95753": true,
      "95754": true,
      "95755": true,
      "95756": true,
      "95757": true,
      "95758": true,
      "95759": true,
      "95760": true,
      "95761": true,
      "95762": true,
      "95763": true,
      "95764": true,
      "95765": true,
      "95766": true,
      "95767": true,
      "95768": true,
      "95769": true,
      "95770": true,
      "95771": true,
      "95772": true,
      "95773": true,
      "95774": true,
      "95775": true,
      "95776": true,
      "95777": true,
      "95778": true,
      "95779": true,
      "95780": true,
      "95781": true,
      "95782": true,
      "95783": true,
      "95784": true,
      "95785": true,
      "95786": true,
      "95787": true,
      "95788": true,
      "95789": true,
      "95790": true,
      "95791": true,
      "95792": true,
      "95793": true,
      "95794": true,
      "95795": true,
      "95796": true,
      "95797": true,
      "95798": true,
      "95799": true,
      "95800": true,
      "95801": true,
      "95802": true,
      "95803": true,
      "95804": true,
      "95805": true,
      "95806": true,
      "95807": true,
      "95808": true,
      "95809": true,
      "95810": true,
      "95811": true,
      "95812": true,
      "95813": true,
      "95814": true,
      "95816": true,
      "95821": true,
      "95822": true
    },
    "SANTIAGO TUXTLA": {
      "95830": true,
      "95831": true,
      "95832": true,
      "95833": true,
      "95834": true,
      "95835": true,
      "95839": true
    },
    "ANGEL R. CABADA": {
      "95840": true,
      "95841": true,
      "95842": true,
      "95843": true,
      "95844": true,
      "95845": true,
      "95846": true,
      "95847": true,
      "95848": true,
      "95849": true
    },
    "PAJAPAN": {
      "95960": true,
      "95961": true,
      "95962": true,
      "95963": true,
      "95964": true,
      "95965": true,
      "95966": true,
      "95967": true,
      "95968": true,
      "95969": true,
      "95970": true,
      "95971": true,
      "95972": true,
      "95973": true,
      "95974": true,
      "95975": true,
      "95976": true,
      "95977": true,
      "95978": true,
      "95979": true
    },
    "CHINAMECA": {
      "95980": true,
      "95981": true,
      "95982": true,
      "95983": true,
      "95984": true,
      "95985": true,
      "95986": true,
      "95987": true,
      "95988": true,
      "95989": true,
      "95990": true,
      "95991": true,
      "95992": true,
      "95993": true,
      "95994": true,
      "95995": true,
      "95996": true,
      "95997": true,
      "95998": true,
      "95999": true
    },
    "ACAYUCAN": {
      "96000": true,
      "96001": true,
      "96002": true,
      "96003": true,
      "96004": true,
      "96005": true,
      "96006": true,
      "96007": true,
      "96008": true,
      "96009": true,
      "96010": true,
      "96011": true,
      "96012": true,
      "96013": true,
      "96014": true,
      "96015": true,
      "96016": true,
      "96017": true,
      "96018": true,
      "96019": true,
      "96020": true,
      "96021": true,
      "96022": true,
      "96023": true,
      "96024": true,
      "96025": true,
      "96026": true,
      "96027": true,
      "96028": true,
      "96029": true,
      "96030": true,
      "96031": true,
      "96032": true,
      "96033": true,
      "96034": true,
      "96035": true,
      "96036": true,
      "96037": true,
      "96038": true,
      "96039": true,
      "96040": true,
      "96041": true,
      "96042": true,
      "96043": true,
      "96044": true,
      "96045": true,
      "96046": true,
      "96047": true,
      "96048": true,
      "96049": true,
      "96050": true,
      "96051": true,
      "96052": true,
      "96053": true,
      "96054": true,
      "96055": true,
      "96056": true,
      "96057": true,
      "96058": true,
      "96059": true,
      "96060": true,
      "96061": true,
      "96062": true,
      "96063": true,
      "96064": true,
      "96065": true,
      "96066": true,
      "96067": true,
      "96068": true,
      "96069": true,
      "96070": true,
      "96071": true,
      "96072": true,
      "96073": true,
      "96074": true,
      "96075": true,
      "96076": true,
      "96077": true,
      "96078": true,
      "96079": true,
      "96080": true,
      "96081": true,
      "96082": true,
      "96083": true,
      "96084": true,
      "96085": true,
      "96086": true,
      "96087": true,
      "96088": true,
      "96089": true,
      "96090": true,
      "96091": true,
      "96092": true,
      "96093": true,
      "96094": true,
      "96095": true,
      "96096": true,
      "96097": true,
      "96098": true,
      "96099": true,
      "96100": true,
      "96101": true,
      "96103": true,
      "96104": true,
      "96107": true,
      "96108": true,
      "96109": true,
      "96112": true,
      "96113": true
    },
    "SAN JUAN EVANGELISTA": {
      "96120": true,
      "96121": true,
      "96122": true,
      "96123": true,
      "96124": true,
      "96125": true,
      "96126": true,
      "96127": true,
      "96128": true,
      "96129": true,
      "96130": true,
      "96131": true,
      "96132": true,
      "96133": true,
      "96134": true,
      "96135": true,
      "96136": true,
      "96137": true,
      "96138": true,
      "96139": true,
      "96140": true,
      "96141": true,
      "96142": true,
      "96143": true,
      "96144": true,
      "96146": true
    },
    "SAYULA DE ALEMAN": {
      "96150": true,
      "96151": true,
      "96152": true,
      "96153": true,
      "96154": true
    },
    "OLUTA": {
      "96160": true,
      "96161": true,
      "96162": true,
      "96163": true,
      "96164": true,
      "96165": true,
      "96166": true,
      "96167": true,
      "96168": true,
      "96169": true
    },
    "SOCONUSCO": {
      "96170": true,
      "96171": true,
      "96173": true,
      "96174": true,
      "96175": true,
      "96176": true,
      "96177": true,
      "96178": true,
      "96179": true
    },
    "JALTIPAN": {
      "96200": true,
      "96201": true,
      "96202": true,
      "96203": true,
      "96204": true,
      "96205": true,
      "96206": true,
      "96207": true,
      "96208": true,
      "96209": true,
      "96210": true,
      "96211": true,
      "96212": true,
      "96213": true,
      "96214": true,
      "96215": true,
      "96216": true,
      "96217": true,
      "96218": true,
      "96219": true,
      "96220": true,
      "96221": true,
      "96222": true,
      "96223": true,
      "96224": true,
      "96225": true,
      "96226": true,
      "96227": true,
      "96228": true,
      "96229": true,
      "96230": true,
      "96231": true,
      "96232": true,
      "96233": true,
      "96234": true,
      "96235": true,
      "96236": true,
      "96237": true,
      "96238": true,
      "96239": true,
      "96240": true,
      "96241": true,
      "96242": true,
      "96243": true,
      "96244": true,
      "96245": true,
      "96246": true,
      "96247": true,
      "96248": true,
      "96249": true,
      "96250": true,
      "96251": true,
      "96252": true,
      "96253": true,
      "96254": true,
      "96255": true,
      "96256": true,
      "96257": true,
      "96258": true,
      "96259": true,
      "96260": true,
      "96261": true,
      "96262": true,
      "96263": true,
      "96264": true,
      "96265": true,
      "96266": true,
      "96267": true,
      "96268": true,
      "96269": true,
      "96270": true,
      "96271": true,
      "96272": true,
      "96273": true,
      "96274": true,
      "96275": true,
      "96276": true,
      "96277": true,
      "96278": true,
      "96279": true,
      "96280": true,
      "96281": true,
      "96282": true,
      "96283": true,
      "96284": true,
      "96285": true,
      "96286": true,
      "96287": true,
      "96288": true,
      "96289": true,
      "96290": true,
      "96291": true,
      "96292": true,
      "96293": true,
      "96294": true,
      "96295": true,
      "96296": true,
      "96297": true,
      "96298": true,
      "96299": true,
      "96300": true,
      "96301": true,
      "96302": true,
      "96303": true,
      "96304": true,
      "96305": true,
      "96306": true,
      "96307": true,
      "96308": true,
      "96309": true,
      "96316": true,
      "96317": true
    },
    "ZARAGOZA": {
      "96320": true,
      "96321": true,
      "96322": true,
      "96323": true,
      "96324": true,
      "96325": true,
      "96326": true,
      "96327": true,
      "96328": true,
      "96329": true
    },
    "OTEAPAN": {
      "96330": true,
      "96331": true,
      "96332": true,
      "96333": true,
      "96334": true,
      "96335": true,
      "96336": true,
      "96337": true,
      "96338": true,
      "96339": true
    },
    "COSOLEACAQUE": {
      "96340": true,
      "96341": true,
      "96342": true,
      "96343": true,
      "96344": true,
      "96345": true,
      "96346": true,
      "96347": true,
      "96348": true,
      "96349": true,
      "96350": true,
      "96351": true,
      "96352": true,
      "96353": true,
      "96354": true,
      "96355": true,
      "96356": true,
      "96357": true,
      "96358": true,
      "96359": true
    },
    "NANCHITAL DE LAZARO CARDENAS DEL RIO": {
      "96360": true,
      "96361": true,
      "96362": true,
      "96363": true,
      "96364": true
    },
    "IXHUATLAN DEL SURESTE": {
      "96365": true,
      "96366": true,
      "96367": true,
      "96368": true,
      "96369": true
    },
    "MOLOACAN": {
      "96370": true,
      "96371": true,
      "96372": true,
      "96373": true,
      "96374": true,
      "96375": true,
      "96376": true
    },
    "COATZACOALCOS": {
      "96380": true,
      "96381": true,
      "96382": true,
      "96383": true,
      "96384": true,
      "96385": true,
      "96386": true,
      "96387": true,
      "96388": true,
      "96389": true,
      "96400": true,
      "96401": true,
      "96402": true,
      "96403": true,
      "96404": true,
      "96405": true,
      "96406": true,
      "96407": true,
      "96408": true,
      "96409": true,
      "96410": true,
      "96411": true,
      "96412": true,
      "96413": true,
      "96414": true,
      "96415": true,
      "96416": true,
      "96417": true,
      "96418": true,
      "96419": true,
      "96420": true,
      "96421": true,
      "96422": true,
      "96423": true,
      "96424": true,
      "96425": true,
      "96426": true,
      "96427": true,
      "96428": true,
      "96429": true,
      "96430": true,
      "96431": true,
      "96432": true,
      "96433": true,
      "96434": true,
      "96435": true,
      "96436": true,
      "96437": true,
      "96438": true,
      "96439": true,
      "96440": true,
      "96441": true,
      "96442": true,
      "96443": true,
      "96444": true,
      "96445": true,
      "96446": true,
      "96447": true,
      "96448": true,
      "96449": true,
      "96450": true,
      "96451": true,
      "96452": true,
      "96453": true,
      "96454": true,
      "96455": true,
      "96456": true,
      "96457": true,
      "96458": true,
      "96459": true,
      "96460": true,
      "96461": true,
      "96462": true,
      "96463": true,
      "96464": true,
      "96465": true,
      "96466": true,
      "96467": true,
      "96468": true,
      "96469": true,
      "96470": true,
      "96471": true,
      "96472": true,
      "96473": true,
      "96474": true,
      "96475": true,
      "96476": true,
      "96477": true,
      "96478": true,
      "96479": true,
      "96480": true,
      "96481": true,
      "96482": true,
      "96483": true,
      "96484": true,
      "96485": true,
      "96486": true,
      "96487": true,
      "96488": true,
      "96489": true,
      "96490": true,
      "96491": true,
      "96492": true,
      "96493": true,
      "96494": true,
      "96495": true,
      "96496": true,
      "96497": true,
      "96498": true,
      "96499": true,
      "96500": true,
      "96501": true,
      "96502": true,
      "96503": true,
      "96504": true,
      "96505": true,
      "96506": true,
      "96507": true,
      "96508": true,
      "96509": true,
      "96510": true,
      "96511": true,
      "96512": true,
      "96513": true,
      "96514": true,
      "96515": true,
      "96516": true,
      "96517": true,
      "96518": true,
      "96519": true,
      "96520": true,
      "96521": true,
      "96522": true,
      "96523": true,
      "96524": true,
      "96525": true,
      "96526": true,
      "96527": true,
      "96528": true,
      "96529": true,
      "96530": true,
      "96531": true,
      "96532": true,
      "96533": true,
      "96534": true,
      "96535": true,
      "96536": true,
      "96537": true,
      "96538": true,
      "96539": true,
      "96540": true,
      "96541": true,
      "96542": true,
      "96543": true,
      "96544": true,
      "96545": true,
      "96546": true,
      "96547": true,
      "96548": true,
      "96549": true,
      "96550": true,
      "96551": true,
      "96552": true,
      "96553": true,
      "96554": true,
      "96555": true,
      "96556": true,
      "96557": true,
      "96558": true,
      "96559": true,
      "96560": true,
      "96561": true,
      "96562": true,
      "96563": true,
      "96564": true,
      "96565": true,
      "96566": true,
      "96567": true,
      "96568": true,
      "96569": true,
      "96570": true,
      "96571": true,
      "96572": true,
      "96573": true,
      "96574": true,
      "96575": true,
      "96576": true,
      "96577": true,
      "96578": true,
      "96579": true,
      "96580": true,
      "96581": true,
      "96582": true,
      "96583": true,
      "96584": true,
      "96585": true,
      "96586": true,
      "96587": true,
      "96588": true,
      "96589": true,
      "96590": true,
      "96591": true,
      "96592": true,
      "96593": true,
      "96594": true,
      "96595": true,
      "96596": true,
      "96597": true,
      "96598": true,
      "96599": true
    },
    "AGUA DULCE": {
      "96390": true,
      "96391": true,
      "96392": true,
      "96393": true,
      "96394": true,
      "96395": true,
      "96396": true,
      "96397": true,
      "96398": true,
      "96399": true,
      "96600": true,
      "96601": true,
      "96602": true,
      "96603": true,
      "96604": true,
      "96605": true,
      "96606": true,
      "96607": true,
      "96608": true,
      "96609": true,
      "96610": true,
      "96611": true,
      "96612": true,
      "96613": true,
      "96614": true,
      "96615": true,
      "96616": true,
      "96617": true,
      "96618": true,
      "96619": true,
      "96620": true,
      "96621": true,
      "96622": true,
      "96623": true,
      "96624": true,
      "96625": true,
      "96626": true,
      "96627": true,
      "96628": true,
      "96629": true,
      "96630": true,
      "96631": true,
      "96632": true,
      "96633": true,
      "96634": true,
      "96635": true,
      "96636": true,
      "96637": true,
      "96638": true,
      "96639": true,
      "96640": true,
      "96641": true,
      "96642": true,
      "96643": true,
      "96644": true,
      "96645": true,
      "96646": true,
      "96647": true,
      "96648": true,
      "96649": true,
      "96650": true,
      "96651": true,
      "96652": true,
      "96653": true,
      "96654": true,
      "96655": true,
      "96656": true,
      "96657": true,
      "96658": true,
      "96659": true,
      "96660": true,
      "96661": true,
      "96662": true,
      "96663": true,
      "96664": true,
      "96665": true,
      "96666": true,
      "96667": true,
      "96668": true,
      "96669": true,
      "96670": true,
      "96671": true,
      "96672": true,
      "96673": true,
      "96674": true,
      "96675": true,
      "96676": true,
      "96677": true,
      "96678": true,
      "96679": true,
      "96680": true,
      "96681": true,
      "96682": true,
      "96683": true,
      "96684": true,
      "96685": true,
      "96686": true,
      "96687": true,
      "96688": true,
      "96689": true,
      "96690": true,
      "96691": true,
      "96692": true,
      "96693": true,
      "96694": true,
      "96695": true,
      "96696": true,
      "96697": true,
      "96698": true,
      "96699": true
    },
    "HIDALGOTITLAN": {
      "96930": true,
      "96931": true,
      "96932": true,
      "96933": true,
      "96934": true,
      "96935": true
    },
    "JESUS CARRANZA": {
      "96950": true,
      "96951": true,
      "96952": true,
      "96953": true,
      "96954": true,
      "96955": true,
      "96956": true,
      "96957": true,
      "96958": true,
      "96959": true,
      "96960": true,
      "96961": true,
      "96962": true,
      "96963": true,
      "96965": true,
      "96966": true,
      "96970": true,
      "96971": true,
      "96972": true,
      "96974": true,
      "96978": true,
      "96979": true
    },
    "LAS CHOAPAS": {
      "96980": true,
      "96981": true,
      "96982": true,
      "96983": true,
      "96985": true,
      "96986": true
    }
  },
  "ZACATECAS": {
    "ZACATECAS": {
      "98000": true,
      "98001": true,
      "98002": true,
      "98003": true,
      "98004": true,
      "98005": true,
      "98006": true,
      "98007": true,
      "98008": true,
      "98009": true,
      "98010": true,
      "98011": true,
      "98012": true,
      "98013": true,
      "98014": true,
      "98015": true,
      "98016": true,
      "98017": true,
      "98018": true,
      "98019": true,
      "98020": true,
      "98021": true,
      "98022": true,
      "98023": true,
      "98024": true,
      "98025": true,
      "98026": true,
      "98027": true,
      "98028": true,
      "98029": true,
      "98030": true,
      "98031": true,
      "98032": true,
      "98033": true,
      "98034": true,
      "98035": true,
      "98036": true,
      "98037": true,
      "98038": true,
      "98039": true,
      "98040": true,
      "98041": true,
      "98042": true,
      "98043": true,
      "98044": true,
      "98045": true,
      "98046": true,
      "98047": true,
      "98048": true,
      "98049": true,
      "98050": true,
      "98051": true,
      "98052": true,
      "98053": true,
      "98054": true,
      "98055": true,
      "98056": true,
      "98057": true,
      "98058": true,
      "98059": true,
      "98060": true,
      "98061": true,
      "98062": true,
      "98063": true,
      "98064": true,
      "98065": true,
      "98066": true,
      "98067": true,
      "98068": true,
      "98069": true,
      "98070": true,
      "98071": true,
      "98072": true,
      "98073": true,
      "98074": true,
      "98075": true,
      "98076": true,
      "98077": true,
      "98078": true,
      "98079": true,
      "98080": true,
      "98081": true,
      "98082": true,
      "98083": true,
      "98084": true,
      "98085": true,
      "98086": true,
      "98087": true,
      "98088": true,
      "98089": true,
      "98090": true,
      "98091": true,
      "98092": true,
      "98093": true,
      "98094": true,
      "98095": true,
      "98096": true,
      "98097": true,
      "98098": true,
      "98099": true,
      "98160": true,
      "98161": true,
      "98162": true,
      "98163": true,
      "98164": true,
      "98165": true,
      "98166": true,
      "98167": true,
      "98168": true,
      "98169": true,
      "98170": true,
      "98171": true,
      "98172": true,
      "98173": true,
      "98176": true,
      "98177": true,
      "98178": true,
      "98179": true,
      "98183": true,
      "98185": true
    },
    "MORELOS": {
      "98100": true,
      "98101": true,
      "98102": true,
      "98103": true,
      "98104": true,
      "98105": true,
      "98106": true,
      "98107": true,
      "98108": true,
      "98109": true,
      "98110": true,
      "98111": true,
      "98112": true,
      "98113": true,
      "98114": true,
      "98115": true,
      "98116": true,
      "98117": true,
      "98118": true,
      "98119": true,
      "98120": true,
      "98121": true,
      "98122": true,
      "98123": true,
      "98124": true,
      "98125": true,
      "98126": true,
      "98127": true,
      "98128": true,
      "98129": true,
      "98130": true,
      "98131": true,
      "98132": true,
      "98133": true,
      "98134": true,
      "98135": true,
      "98136": true,
      "98137": true,
      "98138": true,
      "98139": true
    },
    "CONCEPCION DEL ORO": {
      "98200": true,
      "98201": true,
      "98202": true,
      "98203": true,
      "98204": true,
      "98205": true,
      "98206": true,
      "98207": true,
      "98208": true,
      "98209": true,
      "98212": true,
      "98213": true,
      "98214": true,
      "98215": true,
      "98216": true,
      "98217": true,
      "98218": true,
      "98219": true
    },
    "JUAN ALDAMA": {
      "98300": true,
      "98301": true,
      "98302": true,
      "98303": true,
      "98304": true,
      "98305": true,
      "98306": true,
      "98307": true,
      "98308": true,
      "98309": true,
      "98310": true,
      "98311": true,
      "98312": true,
      "98313": true,
      "98314": true,
      "98315": true,
      "98316": true,
      "98317": true,
      "98318": true,
      "98319": true,
      "98320": true,
      "98321": true,
      "98322": true,
      "98323": true,
      "98324": true,
      "98325": true,
      "98326": true,
      "98327": true,
      "98328": true,
      "98329": true
    },
    "RIO GRANDE": {
      "98400": true,
      "98401": true,
      "98402": true,
      "98403": true,
      "98404": true,
      "98405": true,
      "98406": true,
      "98407": true,
      "98408": true,
      "98409": true,
      "98416": true,
      "98417": true,
      "98418": true,
      "98419": true,
      "98420": true,
      "98421": true,
      "98422": true,
      "98423": true,
      "98424": true,
      "98425": true,
      "98426": true,
      "98427": true,
      "98428": true,
      "98429": true
    },
    "VILLA DE COS": {
      "98430": true,
      "98431": true,
      "98432": true,
      "98433": true,
      "98434": true,
      "98436": true,
      "98437": true,
      "98438": true,
      "98439": true,
      "98463": true,
      "98471": true,
      "98472": true,
      "98473": true,
      "98474": true,
      "98475": true,
      "98476": true,
      "98477": true,
      "98478": true,
      "98479": true
    },
    "CANITAS DE FELIPE PESCADOR": {
      "98480": true,
      "98481": true,
      "98482": true,
      "98483": true,
      "98484": true,
      "98485": true,
      "98486": true,
      "98487": true,
      "98488": true,
      "98489": true,
      "98490": true,
      "98491": true,
      "98492": true,
      "98493": true,
      "98494": true,
      "98495": true,
      "98496": true,
      "98497": true,
      "98498": true,
      "98499": true
    },
    "CALERA": {
      "98500": true,
      "98501": true,
      "98502": true,
      "98503": true,
      "98504": true,
      "98505": true,
      "98506": true,
      "98507": true,
      "98508": true,
      "98509": true,
      "98510": true,
      "98511": true,
      "98512": true,
      "98513": true,
      "98514": true,
      "98515": true,
      "98516": true,
      "98517": true,
      "98518": true,
      "98519": true,
      "98520": true,
      "98521": true,
      "98522": true,
      "98523": true,
      "98524": true,
      "98525": true
    },
    "PANUCO": {
      "98540": true,
      "98541": true,
      "98542": true,
      "98543": true,
      "98544": true,
      "98545": true,
      "98546": true,
      "98547": true,
      "98548": true,
      "98549": true,
      "98550": true,
      "98551": true,
      "98552": true,
      "98553": true,
      "98554": true,
      "98555": true,
      "98556": true,
      "98557": true,
      "98558": true,
      "98559": true
    },
    "GENERAL ENRIQUE ESTRADA": {
      "98560": true,
      "98561": true,
      "98562": true,
      "98563": true,
      "98564": true,
      "98565": true,
      "98566": true,
      "98567": true,
      "98568": true,
      "98569": true,
      "98570": true,
      "98571": true,
      "98572": true,
      "98573": true,
      "98574": true,
      "98575": true,
      "98576": true,
      "98577": true,
      "98578": true,
      "98579": true,
      "98580": true,
      "98581": true,
      "98582": true,
      "98583": true,
      "98584": true,
      "98585": true,
      "98586": true,
      "98587": true,
      "98588": true,
      "98589": true,
      "98590": true,
      "98591": true,
      "98592": true,
      "98593": true,
      "98594": true,
      "98595": true,
      "98596": true,
      "98597": true,
      "98598": true,
      "98599": true
    },
    "TRANCOSO": {
      "98640": true,
      "98641": true,
      "98642": true,
      "98643": true,
      "98644": true,
      "98645": true,
      "98647": true,
      "98648": true,
      "98649": true
    },
    "GENARO CODINA": {
      "98660": true,
      "98661": true,
      "98662": true,
      "98663": true,
      "98664": true,
      "98665": true,
      "98666": true,
      "98667": true,
      "98668": true,
      "98669": true,
      "98673": true,
      "98674": true,
      "98675": true,
      "98676": true,
      "98677": true,
      "98678": true,
      "98679": true
    },
    "CUAUHTEMOC": {
      "98680": true,
      "98681": true,
      "98682": true,
      "98683": true,
      "98684": true,
      "98685": true,
      "98686": true,
      "98687": true,
      "98688": true,
      "98689": true,
      "98690": true,
      "98691": true,
      "98692": true,
      "98693": true,
      "98694": true,
      "98695": true,
      "98696": true,
      "98697": true,
      "98698": true,
      "98699": true
    },
    "OJOCALIENTE": {
      "98700": true,
      "98701": true,
      "98702": true,
      "98703": true,
      "98704": true,
      "98706": true,
      "98707": true,
      "98708": true,
      "98709": true,
      "98710": true,
      "98711": true,
      "98712": true,
      "98713": true,
      "98714": true,
      "98715": true,
      "98716": true,
      "98717": true,
      "98718": true,
      "98719": true,
      "98720": true,
      "98721": true,
      "98722": true,
      "98723": true,
      "98724": true,
      "98725": true,
      "98726": true,
      "98727": true,
      "98728": true,
      "98729": true
    },
    "GENERAL PANFILO NATERA": {
      "98730": true,
      "98731": true,
      "98732": true,
      "98733": true,
      "98734": true,
      "98735": true,
      "98736": true,
      "98737": true,
      "98738": true,
      "98739": true,
      "98740": true,
      "98741": true,
      "98742": true,
      "98743": true,
      "98744": true,
      "98745": true,
      "98746": true,
      "98747": true,
      "98748": true,
      "98749": true,
      "98750": true,
      "98751": true,
      "98752": true,
      "98753": true,
      "98754": true,
      "98755": true,
      "98756": true,
      "98757": true,
      "98758": true,
      "98759": true,
      "98760": true,
      "98761": true,
      "98762": true,
      "98763": true,
      "98764": true,
      "98765": true,
      "98766": true,
      "98767": true,
      "98768": true,
      "98769": true
    },
    "LUIS MOYA": {
      "98770": true,
      "98771": true,
      "98772": true,
      "98773": true,
      "98774": true,
      "98775": true,
      "98776": true,
      "98777": true,
      "98778": true,
      "98779": true,
      "98785": true,
      "98786": true,
      "98787": true,
      "98788": true,
      "98789": true,
      "98790": true,
      "98791": true,
      "98792": true,
      "98793": true,
      "98794": true,
      "98795": true,
      "98796": true,
      "98797": true,
      "98798": true,
      "98799": true
    },
    "LORETO": {
      "98800": true,
      "98801": true,
      "98802": true,
      "98803": true,
      "98804": true,
      "98807": true,
      "98808": true,
      "98809": true,
      "98810": true,
      "98811": true,
      "98812": true,
      "98813": true,
      "98814": true,
      "98815": true,
      "98816": true,
      "98817": true,
      "98818": true,
      "98819": true,
      "98820": true,
      "98821": true,
      "98822": true,
      "98823": true,
      "98824": true,
      "98825": true,
      "98826": true,
      "98827": true,
      "98828": true,
      "98829": true,
      "98830": true,
      "98831": true,
      "98832": true,
      "98833": true,
      "98834": true,
      "98835": true,
      "98836": true,
      "98837": true,
      "98838": true,
      "98839": true
    },
    "VILLA GONZALEZ ORTEGA": {
      "98840": true,
      "98841": true,
      "98842": true,
      "98843": true,
      "98844": true,
      "98845": true,
      "98846": true,
      "98847": true,
      "98848": true,
      "98849": true,
      "98850": true,
      "98851": true,
      "98852": true,
      "98853": true,
      "98854": true,
      "98855": true,
      "98856": true,
      "98857": true,
      "98858": true,
      "98859": true,
      "98870": true,
      "98871": true,
      "98872": true,
      "98873": true,
      "98874": true,
      "98875": true,
      "98876": true,
      "98877": true,
      "98878": true,
      "98879": true
    },
    "NORIA DE ANGELES": {
      "98880": true,
      "98881": true,
      "98882": true,
      "98883": true,
      "98884": true,
      "98885": true,
      "98886": true,
      "98887": true,
      "98888": true,
      "98889": true,
      "98890": true,
      "98891": true,
      "98892": true,
      "98893": true,
      "98894": true,
      "98895": true,
      "98896": true,
      "98897": true,
      "98898": true,
      "98899": true
    },
    "VILLA GARCIA": {
      "98900": true,
      "98901": true,
      "98902": true,
      "98903": true,
      "98904": true,
      "98905": true,
      "98906": true,
      "98907": true,
      "98908": true,
      "98909": true,
      "98910": true,
      "98911": true,
      "98912": true,
      "98913": true,
      "98914": true,
      "98915": true,
      "98916": true,
      "98917": true,
      "98918": true,
      "98919": true
    },
    "PINOS": {
      "98920": true,
      "98921": true,
      "98922": true,
      "98923": true,
      "98924": true,
      "98925": true,
      "98926": true,
      "98927": true,
      "98928": true,
      "98929": true,
      "98951": true,
      "98952": true,
      "98953": true,
      "98954": true,
      "98959": true,
      "98960": true,
      "98961": true,
      "98962": true,
      "98963": true,
      "98964": true,
      "98965": true,
      "98966": true,
      "98967": true,
      "98968": true,
      "98969": true,
      "98974": true,
      "98975": true,
      "98976": true,
      "98977": true,
      "98978": true
    },
    "VILLA HIDALGO": {
      "98980": true,
      "98981": true,
      "98982": true,
      "98983": true,
      "98984": true,
      "98985": true,
      "98986": true,
      "98987": true,
      "98988": true,
      "98989": true,
      "98990": true,
      "98991": true,
      "98992": true,
      "98993": true,
      "98994": true,
      "98995": true,
      "98996": true,
      "98997": true,
      "98998": true,
      "98999": true
    },
    "FRESNILLO": {
      "99000": true,
      "99001": true,
      "99002": true,
      "99003": true,
      "99004": true,
      "99005": true,
      "99006": true,
      "99007": true,
      "99008": true,
      "99009": true,
      "99010": true,
      "99011": true,
      "99012": true,
      "99013": true,
      "99014": true,
      "99015": true,
      "99016": true,
      "99017": true,
      "99018": true,
      "99019": true,
      "99020": true,
      "99021": true,
      "99022": true,
      "99023": true,
      "99024": true,
      "99025": true,
      "99026": true,
      "99027": true,
      "99028": true,
      "99029": true,
      "99030": true,
      "99031": true,
      "99032": true,
      "99034": true,
      "99035": true,
      "99036": true,
      "99037": true,
      "99038": true,
      "99039": true,
      "99040": true,
      "99041": true,
      "99042": true,
      "99043": true,
      "99044": true,
      "99045": true,
      "99046": true,
      "99047": true,
      "99048": true,
      "99049": true,
      "99050": true,
      "99051": true,
      "99052": true,
      "99053": true,
      "99054": true,
      "99055": true,
      "99056": true,
      "99057": true,
      "99058": true,
      "99059": true,
      "99060": true,
      "99061": true,
      "99062": true,
      "99063": true,
      "99064": true,
      "99065": true,
      "99066": true,
      "99067": true,
      "99068": true,
      "99069": true,
      "99070": true,
      "99071": true,
      "99072": true,
      "99073": true,
      "99074": true,
      "99075": true,
      "99076": true,
      "99077": true,
      "99078": true,
      "99079": true,
      "99080": true,
      "99081": true,
      "99082": true,
      "99083": true,
      "99084": true,
      "99085": true,
      "99086": true,
      "99087": true,
      "99088": true,
      "99089": true,
      "99090": true,
      "99091": true,
      "99092": true,
      "99093": true,
      "99094": true,
      "99095": true,
      "99096": true,
      "99097": true,
      "99098": true,
      "99099": true,
      "99150": true,
      "99151": true,
      "99152": true,
      "99153": true,
      "99154": true,
      "99158": true,
      "99170": true,
      "99171": true,
      "99172": true,
      "99173": true,
      "99176": true,
      "99185": true,
      "99186": true,
      "99187": true,
      "99188": true,
      "99189": true,
      "99192": true,
      "99194": true
    },
    "SAIN ALTO": {
      "99130": true,
      "99131": true,
      "99132": true,
      "99133": true,
      "99134": true,
      "99135": true,
      "99136": true,
      "99137": true,
      "99138": true,
      "99139": true,
      "99140": true,
      "99143": true,
      "99144": true,
      "99145": true,
      "99146": true,
      "99147": true,
      "99148": true,
      "99149": true
    },
    "VALPARAISO": {
      "99200": true,
      "99201": true,
      "99202": true,
      "99203": true,
      "99204": true,
      "99205": true,
      "99207": true,
      "99215": true,
      "99216": true,
      "99220": true,
      "99221": true,
      "99222": true,
      "99223": true,
      "99224": true,
      "99225": true,
      "99226": true,
      "99227": true,
      "99228": true,
      "99229": true,
      "99230": true,
      "99231": true,
      "99232": true,
      "99233": true,
      "99234": true,
      "99235": true,
      "99236": true,
      "99237": true,
      "99245": true,
      "99250": true,
      "99251": true,
      "99252": true,
      "99253": true,
      "99254": true,
      "99255": true,
      "99256": true,
      "99257": true,
      "99258": true,
      "99259": true
    },
    "JEREZ": {
      "99300": true,
      "99301": true,
      "99302": true,
      "99303": true,
      "99304": true,
      "99305": true,
      "99306": true,
      "99307": true,
      "99308": true,
      "99309": true,
      "99310": true,
      "99311": true,
      "99312": true,
      "99313": true,
      "99314": true,
      "99315": true,
      "99316": true,
      "99317": true,
      "99318": true,
      "99319": true,
      "99320": true,
      "99321": true,
      "99322": true,
      "99323": true,
      "99324": true,
      "99325": true,
      "99326": true,
      "99327": true,
      "99328": true,
      "99329": true,
      "99330": true,
      "99331": true,
      "99332": true,
      "99333": true,
      "99334": true,
      "99335": true,
      "99336": true,
      "99337": true,
      "99338": true,
      "99339": true,
      "99340": true,
      "99341": true,
      "99342": true,
      "99343": true,
      "99344": true,
      "99345": true,
      "99346": true,
      "99347": true,
      "99348": true,
      "99349": true,
      "99350": true,
      "99351": true,
      "99352": true,
      "99353": true,
      "99354": true,
      "99355": true,
      "99356": true,
      "99357": true,
      "99358": true,
      "99359": true,
      "99360": true,
      "99361": true,
      "99362": true,
      "99363": true,
      "99364": true,
      "99365": true,
      "99366": true,
      "99367": true,
      "99368": true,
      "99369": true,
      "99370": true,
      "99371": true,
      "99372": true,
      "99373": true,
      "99374": true,
      "99375": true,
      "99376": true,
      "99377": true,
      "99378": true,
      "99379": true,
      "99380": true,
      "99381": true,
      "99382": true,
      "99383": true,
      "99384": true,
      "99385": true,
      "99386": true,
      "99387": true,
      "99388": true,
      "99389": true,
      "99390": true,
      "99391": true,
      "99392": true,
      "99393": true,
      "99394": true,
      "99395": true,
      "99396": true,
      "99397": true,
      "99398": true,
      "99399": true,
      "99443": true,
      "99444": true,
      "99445": true,
      "99446": true,
      "99447": true,
      "99448": true,
      "99449": true,
      "99450": true,
      "99451": true,
      "99452": true,
      "99453": true,
      "99454": true,
      "99455": true,
      "99456": true,
      "99457": true,
      "99458": true,
      "99459": true,
      "99460": true,
      "99461": true,
      "99462": true,
      "99463": true,
      "99464": true,
      "99465": true,
      "99466": true,
      "99467": true,
      "99468": true,
      "99469": true,
      "99470": true,
      "99476": true,
      "99477": true
    },
    "SUSTICACAN": {
      "99480": true,
      "99481": true,
      "99482": true,
      "99483": true,
      "99484": true,
      "99485": true,
      "99486": true,
      "99487": true,
      "99488": true,
      "99489": true,
      "99490": true,
      "99491": true,
      "99492": true,
      "99493": true,
      "99494": true,
      "99495": true,
      "99496": true,
      "99497": true,
      "99498": true,
      "99499": true
    },
    "VILLANUEVA": {
      "99500": true,
      "99501": true,
      "99502": true,
      "99503": true,
      "99504": true,
      "99505": true,
      "99520": true,
      "99521": true,
      "99522": true,
      "99530": true,
      "99531": true,
      "99532": true,
      "99533": true,
      "99534": true,
      "99535": true,
      "99536": true,
      "99537": true,
      "99538": true,
      "99539": true,
      "99540": true,
      "99541": true,
      "99542": true,
      "99543": true,
      "99544": true,
      "99545": true,
      "99546": true,
      "99547": true,
      "99548": true,
      "99549": true,
      "99550": true,
      "99551": true
    },
    "JALPA": {
      "99600": true,
      "99601": true,
      "99602": true,
      "99603": true,
      "99604": true,
      "99605": true,
      "99606": true,
      "99607": true,
      "99608": true,
      "99609": true,
      "99610": true,
      "99611": true,
      "99612": true,
      "99615": true,
      "99616": true,
      "99617": true,
      "99618": true,
      "99619": true,
      "99620": true,
      "99621": true,
      "99622": true,
      "99623": true,
      "99624": true,
      "99625": true,
      "99626": true,
      "99627": true,
      "99628": true,
      "99629": true
    },
    "TABASCO": {
      "99630": true,
      "99631": true,
      "99632": true,
      "99633": true,
      "99635": true,
      "99636": true,
      "99637": true,
      "99638": true,
      "99639": true,
      "99640": true,
      "99641": true,
      "99642": true,
      "99643": true,
      "99644": true,
      "99645": true,
      "99646": true,
      "99647": true,
      "99648": true,
      "99649": true,
      "99650": true,
      "99651": true,
      "99652": true,
      "99653": true,
      "99654": true,
      "99655": true
    },
    "TLALTENANGO DE SANCHEZ ROMAN": {
      "99700": true,
      "99701": true,
      "99702": true,
      "99703": true,
      "99704": true,
      "99705": true,
      "99706": true,
      "99707": true,
      "99708": true,
      "99709": true,
      "99713": true,
      "99714": true
    },
    "NOCHISTLAN DE MEJIA": {
      "99900": true,
      "99901": true,
      "99902": true,
      "99903": true,
      "99904": true,
      "99905": true,
      "99906": true,
      "99907": true,
      "99908": true,
      "99909": true,
      "99910": true,
      "99911": true,
      "99912": true,
      "99913": true,
      "99914": true,
      "99915": true,
      "99916": true,
      "99917": true,
      "99918": true,
      "99919": true
    },
    "APULCO": {
      "99920": true,
      "99921": true,
      "99922": true,
      "99923": true,
      "99924": true,
      "99925": true,
      "99926": true,
      "99927": true,
      "99928": true,
      "99929": true,
      "99930": true,
      "99931": true,
      "99932": true,
      "99933": true,
      "99934": true,
      "99935": true,
      "99936": true,
      "99937": true,
      "99938": true,
      "99939": true
    },
    "APOZOL": {
      "99940": true,
      "99941": true,
      "99942": true,
      "99943": true,
      "99944": true,
      "99945": true,
      "99946": true,
      "99947": true,
      "99948": true,
      "99949": true,
      "99950": true,
      "99951": true,
      "99952": true,
      "99953": true,
      "99954": true,
      "99955": true,
      "99956": true,
      "99957": true,
      "99958": true,
      "99959": true
    },
    "JUCHIPILA": {
      "99960": true,
      "99961": true,
      "99962": true,
      "99963": true,
      "99964": true,
      "99965": true,
      "99966": true,
      "99967": true,
      "99968": true,
      "99969": true,
      "99970": true,
      "99971": true,
      "99972": true,
      "99973": true,
      "99974": true,
      "99975": true,
      "99976": true,
      "99977": true,
      "99978": true,
      "99979": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}